/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _int4: { input: any; output: any; }
  bigint: { input: any; output: any; }
  date: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "actions" */
export type Actions = {
  __typename?: 'actions';
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  incident?: Maybe<Incidents>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  month_impact_consumption?: Maybe<Scalars['Int']['output']>;
  month_impact_cost?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id?: Maybe<Scalars['String']['output']>;
  params_id?: Maybe<Scalars['Int']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  potential_saving?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['String']['output'];
  recurring?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  site?: Maybe<Sites>;
  site_id?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  time_slots?: Maybe<Scalars['json']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  week_impact_consumption?: Maybe<Scalars['Int']['output']>;
  week_impact_cost?: Maybe<Scalars['Int']['output']>;
  year_impact_consumption?: Maybe<Scalars['Int']['output']>;
  year_impact_cost?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "actions" */
export type ActionsTime_SlotsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "actions" */
export type Actions_Aggregate = {
  __typename?: 'actions_aggregate';
  aggregate?: Maybe<Actions_Aggregate_Fields>;
  nodes: Array<Actions>;
};

/** aggregate fields of "actions" */
export type Actions_Aggregate_Fields = {
  __typename?: 'actions_aggregate_fields';
  avg?: Maybe<Actions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Actions_Max_Fields>;
  min?: Maybe<Actions_Min_Fields>;
  stddev?: Maybe<Actions_Stddev_Fields>;
  stddev_pop?: Maybe<Actions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Actions_Stddev_Samp_Fields>;
  sum?: Maybe<Actions_Sum_Fields>;
  var_pop?: Maybe<Actions_Var_Pop_Fields>;
  var_samp?: Maybe<Actions_Var_Samp_Fields>;
  variance?: Maybe<Actions_Variance_Fields>;
};


/** aggregate fields of "actions" */
export type Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Actions_Avg_Fields = {
  __typename?: 'actions_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "actions". All fields are combined with a logical 'AND'. */
export type Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Actions_Bool_Exp>>;
  _not?: InputMaybe<Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Actions_Bool_Exp>>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incident?: InputMaybe<Incidents_Bool_Exp>;
  incident_id?: InputMaybe<Int_Comparison_Exp>;
  month_impact_consumption?: InputMaybe<Int_Comparison_Exp>;
  month_impact_cost?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<String_Comparison_Exp>;
  params_id?: InputMaybe<Int_Comparison_Exp>;
  period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  potential_saving?: InputMaybe<Int_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  recurring?: InputMaybe<Boolean_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  time_slots?: InputMaybe<Json_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
  week_impact_consumption?: InputMaybe<Int_Comparison_Exp>;
  week_impact_cost?: InputMaybe<Int_Comparison_Exp>;
  year_impact_consumption?: InputMaybe<Int_Comparison_Exp>;
  year_impact_cost?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "actions" */
export enum Actions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActionsPkey = 'actions_pkey'
}

/** input type for incrementing numeric columns in table "actions" */
export type Actions_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  month_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  month_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  params_id?: InputMaybe<Scalars['Int']['input']>;
  potential_saving?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  week_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  week_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  year_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  year_impact_cost?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "actions" */
export type Actions_Insert_Input = {
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<Incidents_Obj_Rel_Insert_Input>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  month_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  month_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  params_id?: InputMaybe<Scalars['Int']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  potential_saving?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time_slots?: InputMaybe<Scalars['json']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  week_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  week_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  year_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  year_impact_cost?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Actions_Max_Fields = {
  __typename?: 'actions_max_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  month_impact_consumption?: Maybe<Scalars['Int']['output']>;
  month_impact_cost?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  params_id?: Maybe<Scalars['Int']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  potential_saving?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  week_impact_consumption?: Maybe<Scalars['Int']['output']>;
  week_impact_cost?: Maybe<Scalars['Int']['output']>;
  year_impact_consumption?: Maybe<Scalars['Int']['output']>;
  year_impact_cost?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Actions_Min_Fields = {
  __typename?: 'actions_min_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  month_impact_consumption?: Maybe<Scalars['Int']['output']>;
  month_impact_cost?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  params_id?: Maybe<Scalars['Int']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  potential_saving?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  week_impact_consumption?: Maybe<Scalars['Int']['output']>;
  week_impact_cost?: Maybe<Scalars['Int']['output']>;
  year_impact_consumption?: Maybe<Scalars['Int']['output']>;
  year_impact_cost?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "actions" */
export type Actions_Mutation_Response = {
  __typename?: 'actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Actions>;
};

/** on_conflict condition type for table "actions" */
export type Actions_On_Conflict = {
  constraint: Actions_Constraint;
  update_columns?: Array<Actions_Update_Column>;
  where?: InputMaybe<Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "actions". */
export type Actions_Order_By = {
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident?: InputMaybe<Incidents_Order_By>;
  incident_id?: InputMaybe<Order_By>;
  month_impact_consumption?: InputMaybe<Order_By>;
  month_impact_cost?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  params_id?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  potential_saving?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  recurring?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  site_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_slots?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  week_impact_consumption?: InputMaybe<Order_By>;
  week_impact_cost?: InputMaybe<Order_By>;
  year_impact_consumption?: InputMaybe<Order_By>;
  year_impact_cost?: InputMaybe<Order_By>;
};

/** primary key columns input for table: actions */
export type Actions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "actions" */
export enum Actions_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id',
  /** column name */
  MonthImpactConsumption = 'month_impact_consumption',
  /** column name */
  MonthImpactCost = 'month_impact_cost',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ParamsId = 'params_id',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PotentialSaving = 'potential_saving',
  /** column name */
  Priority = 'priority',
  /** column name */
  Recurring = 'recurring',
  /** column name */
  Reference = 'reference',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  Status = 'status',
  /** column name */
  TimeSlots = 'time_slots',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  WeekImpactConsumption = 'week_impact_consumption',
  /** column name */
  WeekImpactCost = 'week_impact_cost',
  /** column name */
  YearImpactConsumption = 'year_impact_consumption',
  /** column name */
  YearImpactCost = 'year_impact_cost'
}

/** input type for updating data in table "actions" */
export type Actions_Set_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  month_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  month_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  params_id?: InputMaybe<Scalars['Int']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  potential_saving?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time_slots?: InputMaybe<Scalars['json']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  week_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  week_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  year_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  year_impact_cost?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Actions_Stddev_Fields = {
  __typename?: 'actions_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Actions_Stddev_Pop_Fields = {
  __typename?: 'actions_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Actions_Stddev_Samp_Fields = {
  __typename?: 'actions_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "actions" */
export type Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Actions_Stream_Cursor_Value_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  month_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  month_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  params_id?: InputMaybe<Scalars['Int']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  potential_saving?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time_slots?: InputMaybe<Scalars['json']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  week_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  week_impact_cost?: InputMaybe<Scalars['Int']['input']>;
  year_impact_consumption?: InputMaybe<Scalars['Int']['input']>;
  year_impact_cost?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Actions_Sum_Fields = {
  __typename?: 'actions_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  month_impact_consumption?: Maybe<Scalars['Int']['output']>;
  month_impact_cost?: Maybe<Scalars['Int']['output']>;
  params_id?: Maybe<Scalars['Int']['output']>;
  potential_saving?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  week_impact_consumption?: Maybe<Scalars['Int']['output']>;
  week_impact_cost?: Maybe<Scalars['Int']['output']>;
  year_impact_consumption?: Maybe<Scalars['Int']['output']>;
  year_impact_cost?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "actions" */
export enum Actions_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id',
  /** column name */
  MonthImpactConsumption = 'month_impact_consumption',
  /** column name */
  MonthImpactCost = 'month_impact_cost',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ParamsId = 'params_id',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PotentialSaving = 'potential_saving',
  /** column name */
  Priority = 'priority',
  /** column name */
  Recurring = 'recurring',
  /** column name */
  Reference = 'reference',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  Status = 'status',
  /** column name */
  TimeSlots = 'time_slots',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  WeekImpactConsumption = 'week_impact_consumption',
  /** column name */
  WeekImpactCost = 'week_impact_cost',
  /** column name */
  YearImpactConsumption = 'year_impact_consumption',
  /** column name */
  YearImpactCost = 'year_impact_cost'
}

export type Actions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Actions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Actions_Var_Pop_Fields = {
  __typename?: 'actions_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Actions_Var_Samp_Fields = {
  __typename?: 'actions_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Actions_Variance_Fields = {
  __typename?: 'actions_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  month_impact_consumption?: Maybe<Scalars['Float']['output']>;
  month_impact_cost?: Maybe<Scalars['Float']['output']>;
  params_id?: Maybe<Scalars['Float']['output']>;
  potential_saving?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  week_impact_consumption?: Maybe<Scalars['Float']['output']>;
  week_impact_cost?: Maybe<Scalars['Float']['output']>;
  year_impact_consumption?: Maybe<Scalars['Float']['output']>;
  year_impact_cost?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "alert_types" */
export type Alert_Types = {
  __typename?: 'alert_types';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "alert_types" */
export type Alert_Types_Aggregate = {
  __typename?: 'alert_types_aggregate';
  aggregate?: Maybe<Alert_Types_Aggregate_Fields>;
  nodes: Array<Alert_Types>;
};

/** aggregate fields of "alert_types" */
export type Alert_Types_Aggregate_Fields = {
  __typename?: 'alert_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Alert_Types_Max_Fields>;
  min?: Maybe<Alert_Types_Min_Fields>;
};


/** aggregate fields of "alert_types" */
export type Alert_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alert_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "alert_types". All fields are combined with a logical 'AND'. */
export type Alert_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Alert_Types_Bool_Exp>>;
  _not?: InputMaybe<Alert_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Alert_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "alert_types" */
export enum Alert_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  AlertTypesPkey = 'alert_types_pkey'
}

export enum Alert_Types_Enum {
  Epi = 'EPI',
  OffProduction = 'off_production',
  WeeklyConsumption = 'weekly_consumption'
}

/** Boolean expression to compare columns of type "alert_types_enum". All fields are combined with logical 'AND'. */
export type Alert_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Alert_Types_Enum>;
  _in?: InputMaybe<Array<Alert_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Alert_Types_Enum>;
  _nin?: InputMaybe<Array<Alert_Types_Enum>>;
};

/** input type for inserting data into table "alert_types" */
export type Alert_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Alert_Types_Max_Fields = {
  __typename?: 'alert_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Alert_Types_Min_Fields = {
  __typename?: 'alert_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "alert_types" */
export type Alert_Types_Mutation_Response = {
  __typename?: 'alert_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Alert_Types>;
};

/** on_conflict condition type for table "alert_types" */
export type Alert_Types_On_Conflict = {
  constraint: Alert_Types_Constraint;
  update_columns?: Array<Alert_Types_Update_Column>;
  where?: InputMaybe<Alert_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "alert_types". */
export type Alert_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: alert_types */
export type Alert_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "alert_types" */
export enum Alert_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "alert_types" */
export type Alert_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "alert_types" */
export type Alert_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alert_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alert_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "alert_types" */
export enum Alert_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Alert_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alert_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alert_Types_Bool_Exp;
};

/** columns and relationships of "alert_user" */
export type Alert_User = {
  __typename?: 'alert_user';
  /** An object relationship */
  alert: Alerts;
  alert_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "alert_user" */
export type Alert_User_Aggregate = {
  __typename?: 'alert_user_aggregate';
  aggregate?: Maybe<Alert_User_Aggregate_Fields>;
  nodes: Array<Alert_User>;
};

export type Alert_User_Aggregate_Bool_Exp = {
  count?: InputMaybe<Alert_User_Aggregate_Bool_Exp_Count>;
};

export type Alert_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Alert_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Alert_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "alert_user" */
export type Alert_User_Aggregate_Fields = {
  __typename?: 'alert_user_aggregate_fields';
  avg?: Maybe<Alert_User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Alert_User_Max_Fields>;
  min?: Maybe<Alert_User_Min_Fields>;
  stddev?: Maybe<Alert_User_Stddev_Fields>;
  stddev_pop?: Maybe<Alert_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Alert_User_Stddev_Samp_Fields>;
  sum?: Maybe<Alert_User_Sum_Fields>;
  var_pop?: Maybe<Alert_User_Var_Pop_Fields>;
  var_samp?: Maybe<Alert_User_Var_Samp_Fields>;
  variance?: Maybe<Alert_User_Variance_Fields>;
};


/** aggregate fields of "alert_user" */
export type Alert_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alert_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "alert_user" */
export type Alert_User_Aggregate_Order_By = {
  avg?: InputMaybe<Alert_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Alert_User_Max_Order_By>;
  min?: InputMaybe<Alert_User_Min_Order_By>;
  stddev?: InputMaybe<Alert_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Alert_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Alert_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Alert_User_Sum_Order_By>;
  var_pop?: InputMaybe<Alert_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Alert_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Alert_User_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "alert_user" */
export type Alert_User_Arr_Rel_Insert_Input = {
  data: Array<Alert_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Alert_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Alert_User_Avg_Fields = {
  __typename?: 'alert_user_avg_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "alert_user" */
export type Alert_User_Avg_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "alert_user". All fields are combined with a logical 'AND'. */
export type Alert_User_Bool_Exp = {
  _and?: InputMaybe<Array<Alert_User_Bool_Exp>>;
  _not?: InputMaybe<Alert_User_Bool_Exp>;
  _or?: InputMaybe<Array<Alert_User_Bool_Exp>>;
  alert?: InputMaybe<Alerts_Bool_Exp>;
  alert_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "alert_user" */
export enum Alert_User_Constraint {
  /** unique or primary key constraint on columns "user_id", "alert_id" */
  AlertUserAlertIdUserIdKey = 'alert_user_alert_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  AlertUserPkey = 'alert_user_pkey'
}

/** input type for incrementing numeric columns in table "alert_user" */
export type Alert_User_Inc_Input = {
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "alert_user" */
export type Alert_User_Insert_Input = {
  alert?: InputMaybe<Alerts_Obj_Rel_Insert_Input>;
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Alert_User_Max_Fields = {
  __typename?: 'alert_user_max_fields';
  alert_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "alert_user" */
export type Alert_User_Max_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Alert_User_Min_Fields = {
  __typename?: 'alert_user_min_fields';
  alert_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "alert_user" */
export type Alert_User_Min_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "alert_user" */
export type Alert_User_Mutation_Response = {
  __typename?: 'alert_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Alert_User>;
};

/** on_conflict condition type for table "alert_user" */
export type Alert_User_On_Conflict = {
  constraint: Alert_User_Constraint;
  update_columns?: Array<Alert_User_Update_Column>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};

/** Ordering options when selecting data from "alert_user". */
export type Alert_User_Order_By = {
  alert?: InputMaybe<Alerts_Order_By>;
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: alert_user */
export type Alert_User_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "alert_user" */
export enum Alert_User_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "alert_user" */
export type Alert_User_Set_Input = {
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Alert_User_Stddev_Fields = {
  __typename?: 'alert_user_stddev_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "alert_user" */
export type Alert_User_Stddev_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Alert_User_Stddev_Pop_Fields = {
  __typename?: 'alert_user_stddev_pop_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "alert_user" */
export type Alert_User_Stddev_Pop_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Alert_User_Stddev_Samp_Fields = {
  __typename?: 'alert_user_stddev_samp_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "alert_user" */
export type Alert_User_Stddev_Samp_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "alert_user" */
export type Alert_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alert_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alert_User_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Alert_User_Sum_Fields = {
  __typename?: 'alert_user_sum_fields';
  alert_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "alert_user" */
export type Alert_User_Sum_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "alert_user" */
export enum Alert_User_Update_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Alert_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Alert_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alert_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alert_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Alert_User_Var_Pop_Fields = {
  __typename?: 'alert_user_var_pop_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "alert_user" */
export type Alert_User_Var_Pop_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Alert_User_Var_Samp_Fields = {
  __typename?: 'alert_user_var_samp_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "alert_user" */
export type Alert_User_Var_Samp_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Alert_User_Variance_Fields = {
  __typename?: 'alert_user_variance_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "alert_user" */
export type Alert_User_Variance_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "alerts" */
export type Alerts = {
  __typename?: 'alerts';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by: Scalars['String']['output'];
  /** An array relationship */
  alert_users: Array<Alert_User>;
  /** An aggregate relationship */
  alert_users_aggregate: Alert_User_Aggregate;
  id: Scalars['Int']['output'];
  /** An array relationship */
  incidents: Array<Incidents>;
  /** An aggregate relationship */
  incidents_aggregate: Incidents_Aggregate;
  /** An object relationship */
  meter?: Maybe<Meters>;
  meter_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  params: Scalars['jsonb']['output'];
  type: Alert_Types_Enum;
};


/** columns and relationships of "alerts" */
export type AlertsAlert_UsersArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


/** columns and relationships of "alerts" */
export type AlertsAlert_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


/** columns and relationships of "alerts" */
export type AlertsIncidentsArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


/** columns and relationships of "alerts" */
export type AlertsIncidents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


/** columns and relationships of "alerts" */
export type AlertsParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "alerts" */
export type Alerts_Aggregate = {
  __typename?: 'alerts_aggregate';
  aggregate?: Maybe<Alerts_Aggregate_Fields>;
  nodes: Array<Alerts>;
};

/** aggregate fields of "alerts" */
export type Alerts_Aggregate_Fields = {
  __typename?: 'alerts_aggregate_fields';
  avg?: Maybe<Alerts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Alerts_Max_Fields>;
  min?: Maybe<Alerts_Min_Fields>;
  stddev?: Maybe<Alerts_Stddev_Fields>;
  stddev_pop?: Maybe<Alerts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Alerts_Stddev_Samp_Fields>;
  sum?: Maybe<Alerts_Sum_Fields>;
  var_pop?: Maybe<Alerts_Var_Pop_Fields>;
  var_samp?: Maybe<Alerts_Var_Samp_Fields>;
  variance?: Maybe<Alerts_Variance_Fields>;
};


/** aggregate fields of "alerts" */
export type Alerts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alerts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Alerts_Append_Input = {
  params?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Alerts_Avg_Fields = {
  __typename?: 'alerts_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "alerts". All fields are combined with a logical 'AND'. */
export type Alerts_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Alerts_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  alert_users?: InputMaybe<Alert_User_Bool_Exp>;
  alert_users_aggregate?: InputMaybe<Alert_User_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incidents?: InputMaybe<Incidents_Bool_Exp>;
  incidents_aggregate?: InputMaybe<Incidents_Aggregate_Bool_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  params?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Alert_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "alerts" */
export enum Alerts_Constraint {
  /** unique or primary key constraint on columns "id" */
  AlertsPkey = 'alerts_pkey',
  /** unique or primary key constraint on columns "type", "meter_id" */
  AlertsTypeMeterIdKey = 'alerts_type_meter_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Alerts_Delete_At_Path_Input = {
  params?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Alerts_Delete_Elem_Input = {
  params?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Alerts_Delete_Key_Input = {
  params?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "alerts" */
export type Alerts_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "alerts" */
export type Alerts_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  alert_users?: InputMaybe<Alert_User_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incidents?: InputMaybe<Incidents_Arr_Rel_Insert_Input>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Alert_Types_Enum>;
};

/** aggregate max on columns */
export type Alerts_Max_Fields = {
  __typename?: 'alerts_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Alerts_Min_Fields = {
  __typename?: 'alerts_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "alerts" */
export type Alerts_Mutation_Response = {
  __typename?: 'alerts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Alerts>;
};

/** input type for inserting object relation for remote table "alerts" */
export type Alerts_Obj_Rel_Insert_Input = {
  data: Alerts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Alerts_On_Conflict>;
};

/** on_conflict condition type for table "alerts" */
export type Alerts_On_Conflict = {
  constraint: Alerts_Constraint;
  update_columns?: Array<Alerts_Update_Column>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};

/** Ordering options when selecting data from "alerts". */
export type Alerts_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  alert_users_aggregate?: InputMaybe<Alert_User_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  incidents_aggregate?: InputMaybe<Incidents_Aggregate_Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  params?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: alerts */
export type Alerts_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Alerts_Prepend_Input = {
  params?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "alerts" */
export enum Alerts_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Name = 'name',
  /** column name */
  Params = 'params',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "alerts" */
export type Alerts_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Alert_Types_Enum>;
};

/** aggregate stddev on columns */
export type Alerts_Stddev_Fields = {
  __typename?: 'alerts_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Alerts_Stddev_Pop_Fields = {
  __typename?: 'alerts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Alerts_Stddev_Samp_Fields = {
  __typename?: 'alerts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "alerts" */
export type Alerts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alerts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alerts_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Alert_Types_Enum>;
};

/** aggregate sum on columns */
export type Alerts_Sum_Fields = {
  __typename?: 'alerts_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "alerts" */
export enum Alerts_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Name = 'name',
  /** column name */
  Params = 'params',
  /** column name */
  Type = 'type'
}

export type Alerts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Alerts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Alerts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Alerts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Alerts_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Alerts_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Alerts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alerts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alerts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Alerts_Var_Pop_Fields = {
  __typename?: 'alerts_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Alerts_Var_Samp_Fields = {
  __typename?: 'alerts_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Alerts_Variance_Fields = {
  __typename?: 'alerts_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "area_types" */
export type Area_Types = {
  __typename?: 'area_types';
  value: Scalars['String']['output'];
};

/** aggregated selection of "area_types" */
export type Area_Types_Aggregate = {
  __typename?: 'area_types_aggregate';
  aggregate?: Maybe<Area_Types_Aggregate_Fields>;
  nodes: Array<Area_Types>;
};

/** aggregate fields of "area_types" */
export type Area_Types_Aggregate_Fields = {
  __typename?: 'area_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Area_Types_Max_Fields>;
  min?: Maybe<Area_Types_Min_Fields>;
};


/** aggregate fields of "area_types" */
export type Area_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Area_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "area_types". All fields are combined with a logical 'AND'. */
export type Area_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Area_Types_Bool_Exp>>;
  _not?: InputMaybe<Area_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Area_Types_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "area_types" */
export enum Area_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  AreaTypesPkey = 'area_types_pkey'
}

export enum Area_Types_Enum {
  Factory = 'factory',
  Machine = 'machine',
  Office = 'office',
  Peripheral = 'peripheral',
  Utility = 'utility',
  Workshop = 'workshop'
}

/** Boolean expression to compare columns of type "area_types_enum". All fields are combined with logical 'AND'. */
export type Area_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Area_Types_Enum>;
  _in?: InputMaybe<Array<Area_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Area_Types_Enum>;
  _nin?: InputMaybe<Array<Area_Types_Enum>>;
};

/** input type for inserting data into table "area_types" */
export type Area_Types_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Area_Types_Max_Fields = {
  __typename?: 'area_types_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Area_Types_Min_Fields = {
  __typename?: 'area_types_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "area_types" */
export type Area_Types_Mutation_Response = {
  __typename?: 'area_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Area_Types>;
};

/** on_conflict condition type for table "area_types" */
export type Area_Types_On_Conflict = {
  constraint: Area_Types_Constraint;
  update_columns?: Array<Area_Types_Update_Column>;
  where?: InputMaybe<Area_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "area_types". */
export type Area_Types_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: area_types */
export type Area_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "area_types" */
export enum Area_Types_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "area_types" */
export type Area_Types_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "area_types" */
export type Area_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Area_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Area_Types_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "area_types" */
export enum Area_Types_Update_Column {
  /** column name */
  Value = 'value'
}

export type Area_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Area_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Area_Types_Bool_Exp;
};

/** A part of a site: the whole site, a room, a single machine */
export type Areas = {
  __typename?: 'areas';
  area_type: Area_Types_Enum;
  /** An array relationship */
  children: Array<Areas>;
  /** An aggregate relationship */
  children_aggregate: Areas_Aggregate;
  energy_use_type?: Maybe<Energy_Use_Types_Enum>;
  /** An object relationship */
  fabrication_order_unit?: Maybe<Units>;
  fabrication_order_unit_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  fabrication_orders: Array<Fabrication_Orders>;
  /** An aggregate relationship */
  fabrication_orders_aggregate: Fabrication_Orders_Aggregate;
  id: Scalars['Int']['output'];
  is_fabrication_order_reporting_enabled: Scalars['Boolean']['output'];
  is_production_reporting_enabled: Scalars['Boolean']['output'];
  /** An array relationship */
  meters: Array<Meters>;
  /** An aggregate relationship */
  meters_aggregate: Meters_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  parent?: Maybe<Areas>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  production_reporting_frequency?: Maybe<Production_Reporting_Frequencies_Enum>;
  /** An object relationship */
  production_unit?: Maybe<Units>;
  production_unit_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  productions: Array<Productions>;
  /** An aggregate relationship */
  productions_aggregate: Productions_Aggregate;
  /** An object relationship */
  site: Sites;
  site_id: Scalars['Int']['output'];
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasChildrenArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasFabrication_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Orders_Order_By>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasFabrication_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Orders_Order_By>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasMetersArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasMeters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasProductionsArgs = {
  distinct_on?: InputMaybe<Array<Productions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Productions_Order_By>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};


/** A part of a site: the whole site, a room, a single machine */
export type AreasProductions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Productions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Productions_Order_By>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};

/** aggregated selection of "areas" */
export type Areas_Aggregate = {
  __typename?: 'areas_aggregate';
  aggregate?: Maybe<Areas_Aggregate_Fields>;
  nodes: Array<Areas>;
};

export type Areas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Areas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Areas_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Areas_Aggregate_Bool_Exp_Count>;
};

export type Areas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Areas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Areas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Areas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Areas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Areas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Areas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "areas" */
export type Areas_Aggregate_Fields = {
  __typename?: 'areas_aggregate_fields';
  avg?: Maybe<Areas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Areas_Max_Fields>;
  min?: Maybe<Areas_Min_Fields>;
  stddev?: Maybe<Areas_Stddev_Fields>;
  stddev_pop?: Maybe<Areas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Areas_Stddev_Samp_Fields>;
  sum?: Maybe<Areas_Sum_Fields>;
  var_pop?: Maybe<Areas_Var_Pop_Fields>;
  var_samp?: Maybe<Areas_Var_Samp_Fields>;
  variance?: Maybe<Areas_Variance_Fields>;
};


/** aggregate fields of "areas" */
export type Areas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Areas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "areas" */
export type Areas_Aggregate_Order_By = {
  avg?: InputMaybe<Areas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Areas_Max_Order_By>;
  min?: InputMaybe<Areas_Min_Order_By>;
  stddev?: InputMaybe<Areas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Areas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Areas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Areas_Sum_Order_By>;
  var_pop?: InputMaybe<Areas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Areas_Var_Samp_Order_By>;
  variance?: InputMaybe<Areas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "areas" */
export type Areas_Arr_Rel_Insert_Input = {
  data: Array<Areas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Areas_On_Conflict>;
};

/** aggregate avg on columns */
export type Areas_Avg_Fields = {
  __typename?: 'areas_avg_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "areas" */
export type Areas_Avg_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "areas". All fields are combined with a logical 'AND'. */
export type Areas_Bool_Exp = {
  _and?: InputMaybe<Array<Areas_Bool_Exp>>;
  _not?: InputMaybe<Areas_Bool_Exp>;
  _or?: InputMaybe<Array<Areas_Bool_Exp>>;
  area_type?: InputMaybe<Area_Types_Enum_Comparison_Exp>;
  children?: InputMaybe<Areas_Bool_Exp>;
  children_aggregate?: InputMaybe<Areas_Aggregate_Bool_Exp>;
  energy_use_type?: InputMaybe<Energy_Use_Types_Enum_Comparison_Exp>;
  fabrication_order_unit?: InputMaybe<Units_Bool_Exp>;
  fabrication_order_unit_id?: InputMaybe<Int_Comparison_Exp>;
  fabrication_orders?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  fabrication_orders_aggregate?: InputMaybe<Fabrication_Orders_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_fabrication_order_reporting_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_production_reporting_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  meters?: InputMaybe<Meters_Bool_Exp>;
  meters_aggregate?: InputMaybe<Meters_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Areas_Bool_Exp>;
  parent_id?: InputMaybe<Int_Comparison_Exp>;
  production_reporting_frequency?: InputMaybe<Production_Reporting_Frequencies_Enum_Comparison_Exp>;
  production_unit?: InputMaybe<Units_Bool_Exp>;
  production_unit_id?: InputMaybe<Int_Comparison_Exp>;
  productions?: InputMaybe<Productions_Bool_Exp>;
  productions_aggregate?: InputMaybe<Productions_Aggregate_Bool_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "areas" */
export enum Areas_Constraint {
  /** unique or primary key constraint on columns "id" */
  AreasIdKey = 'areas_id_key',
  /** unique or primary key constraint on columns "id" */
  AreasPkey = 'areas_pkey'
}

/** input type for incrementing numeric columns in table "areas" */
export type Areas_Inc_Input = {
  fabrication_order_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  production_unit_id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "areas" */
export type Areas_Insert_Input = {
  area_type?: InputMaybe<Area_Types_Enum>;
  children?: InputMaybe<Areas_Arr_Rel_Insert_Input>;
  energy_use_type?: InputMaybe<Energy_Use_Types_Enum>;
  fabrication_order_unit?: InputMaybe<Units_Obj_Rel_Insert_Input>;
  fabrication_order_unit_id?: InputMaybe<Scalars['Int']['input']>;
  fabrication_orders?: InputMaybe<Fabrication_Orders_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_fabrication_order_reporting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_production_reporting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  meters?: InputMaybe<Meters_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  production_reporting_frequency?: InputMaybe<Production_Reporting_Frequencies_Enum>;
  production_unit?: InputMaybe<Units_Obj_Rel_Insert_Input>;
  production_unit_id?: InputMaybe<Scalars['Int']['input']>;
  productions?: InputMaybe<Productions_Arr_Rel_Insert_Input>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Areas_Max_Fields = {
  __typename?: 'areas_max_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  production_unit_id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "areas" */
export type Areas_Max_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Areas_Min_Fields = {
  __typename?: 'areas_min_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  production_unit_id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "areas" */
export type Areas_Min_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "areas" */
export type Areas_Mutation_Response = {
  __typename?: 'areas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Areas>;
};

/** input type for inserting object relation for remote table "areas" */
export type Areas_Obj_Rel_Insert_Input = {
  data: Areas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Areas_On_Conflict>;
};

/** on_conflict condition type for table "areas" */
export type Areas_On_Conflict = {
  constraint: Areas_Constraint;
  update_columns?: Array<Areas_Update_Column>;
  where?: InputMaybe<Areas_Bool_Exp>;
};

/** Ordering options when selecting data from "areas". */
export type Areas_Order_By = {
  area_type?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Areas_Aggregate_Order_By>;
  energy_use_type?: InputMaybe<Order_By>;
  fabrication_order_unit?: InputMaybe<Units_Order_By>;
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  fabrication_orders_aggregate?: InputMaybe<Fabrication_Orders_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_fabrication_order_reporting_enabled?: InputMaybe<Order_By>;
  is_production_reporting_enabled?: InputMaybe<Order_By>;
  meters_aggregate?: InputMaybe<Meters_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  parent?: InputMaybe<Areas_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_reporting_frequency?: InputMaybe<Order_By>;
  production_unit?: InputMaybe<Units_Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  productions_aggregate?: InputMaybe<Productions_Aggregate_Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: areas */
export type Areas_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "areas" */
export enum Areas_Select_Column {
  /** column name */
  AreaType = 'area_type',
  /** column name */
  EnergyUseType = 'energy_use_type',
  /** column name */
  FabricationOrderUnitId = 'fabrication_order_unit_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsFabricationOrderReportingEnabled = 'is_fabrication_order_reporting_enabled',
  /** column name */
  IsProductionReportingEnabled = 'is_production_reporting_enabled',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ProductionReportingFrequency = 'production_reporting_frequency',
  /** column name */
  ProductionUnitId = 'production_unit_id',
  /** column name */
  SiteId = 'site_id'
}

/** select "areas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "areas" */
export enum Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsFabricationOrderReportingEnabled = 'is_fabrication_order_reporting_enabled',
  /** column name */
  IsProductionReportingEnabled = 'is_production_reporting_enabled'
}

/** select "areas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "areas" */
export enum Areas_Select_Column_Areas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsFabricationOrderReportingEnabled = 'is_fabrication_order_reporting_enabled',
  /** column name */
  IsProductionReportingEnabled = 'is_production_reporting_enabled'
}

/** input type for updating data in table "areas" */
export type Areas_Set_Input = {
  area_type?: InputMaybe<Area_Types_Enum>;
  energy_use_type?: InputMaybe<Energy_Use_Types_Enum>;
  fabrication_order_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_fabrication_order_reporting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_production_reporting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  production_reporting_frequency?: InputMaybe<Production_Reporting_Frequencies_Enum>;
  production_unit_id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Areas_Stddev_Fields = {
  __typename?: 'areas_stddev_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "areas" */
export type Areas_Stddev_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Areas_Stddev_Pop_Fields = {
  __typename?: 'areas_stddev_pop_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "areas" */
export type Areas_Stddev_Pop_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Areas_Stddev_Samp_Fields = {
  __typename?: 'areas_stddev_samp_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "areas" */
export type Areas_Stddev_Samp_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "areas" */
export type Areas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Areas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Areas_Stream_Cursor_Value_Input = {
  area_type?: InputMaybe<Area_Types_Enum>;
  energy_use_type?: InputMaybe<Energy_Use_Types_Enum>;
  fabrication_order_unit_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_fabrication_order_reporting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_production_reporting_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  production_reporting_frequency?: InputMaybe<Production_Reporting_Frequencies_Enum>;
  production_unit_id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Areas_Sum_Fields = {
  __typename?: 'areas_sum_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  production_unit_id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "areas" */
export type Areas_Sum_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** update columns of table "areas" */
export enum Areas_Update_Column {
  /** column name */
  AreaType = 'area_type',
  /** column name */
  EnergyUseType = 'energy_use_type',
  /** column name */
  FabricationOrderUnitId = 'fabrication_order_unit_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsFabricationOrderReportingEnabled = 'is_fabrication_order_reporting_enabled',
  /** column name */
  IsProductionReportingEnabled = 'is_production_reporting_enabled',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  ProductionReportingFrequency = 'production_reporting_frequency',
  /** column name */
  ProductionUnitId = 'production_unit_id',
  /** column name */
  SiteId = 'site_id'
}

export type Areas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Areas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Areas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Areas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Areas_Var_Pop_Fields = {
  __typename?: 'areas_var_pop_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "areas" */
export type Areas_Var_Pop_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Areas_Var_Samp_Fields = {
  __typename?: 'areas_var_samp_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "areas" */
export type Areas_Var_Samp_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Areas_Variance_Fields = {
  __typename?: 'areas_variance_fields';
  fabrication_order_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  production_unit_id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "areas" */
export type Areas_Variance_Order_By = {
  fabrication_order_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  production_unit_id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "baselines" */
export type Baselines = {
  __typename?: 'baselines';
  adj_r_squared?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  f_pvalue?: Maybe<Scalars['numeric']['output']>;
  f_stat?: Maybe<Scalars['numeric']['output']>;
  finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  model: Scalars['jsonb']['output'];
  params?: Maybe<Scalars['jsonb']['output']>;
  r_squared?: Maybe<Scalars['numeric']['output']>;
  training_end?: Maybe<Scalars['date']['output']>;
  training_start?: Maybe<Scalars['date']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
};


/** columns and relationships of "baselines" */
export type BaselinesModelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "baselines" */
export type BaselinesParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "baselines" */
export type Baselines_Aggregate = {
  __typename?: 'baselines_aggregate';
  aggregate?: Maybe<Baselines_Aggregate_Fields>;
  nodes: Array<Baselines>;
};

/** aggregate fields of "baselines" */
export type Baselines_Aggregate_Fields = {
  __typename?: 'baselines_aggregate_fields';
  avg?: Maybe<Baselines_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Baselines_Max_Fields>;
  min?: Maybe<Baselines_Min_Fields>;
  stddev?: Maybe<Baselines_Stddev_Fields>;
  stddev_pop?: Maybe<Baselines_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Baselines_Stddev_Samp_Fields>;
  sum?: Maybe<Baselines_Sum_Fields>;
  var_pop?: Maybe<Baselines_Var_Pop_Fields>;
  var_samp?: Maybe<Baselines_Var_Samp_Fields>;
  variance?: Maybe<Baselines_Variance_Fields>;
};


/** aggregate fields of "baselines" */
export type Baselines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Baselines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Baselines_Append_Input = {
  model?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Baselines_Avg_Fields = {
  __typename?: 'baselines_avg_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "baselines". All fields are combined with a logical 'AND'. */
export type Baselines_Bool_Exp = {
  _and?: InputMaybe<Array<Baselines_Bool_Exp>>;
  _not?: InputMaybe<Baselines_Bool_Exp>;
  _or?: InputMaybe<Array<Baselines_Bool_Exp>>;
  adj_r_squared?: InputMaybe<Numeric_Comparison_Exp>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  f_pvalue?: InputMaybe<Numeric_Comparison_Exp>;
  f_stat?: InputMaybe<Numeric_Comparison_Exp>;
  finalized_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<Jsonb_Comparison_Exp>;
  params?: InputMaybe<Jsonb_Comparison_Exp>;
  r_squared?: InputMaybe<Numeric_Comparison_Exp>;
  training_end?: InputMaybe<Date_Comparison_Exp>;
  training_start?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "baselines" */
export enum Baselines_Constraint {
  /** unique or primary key constraint on columns "id" */
  BaselinesPkey = 'baselines_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Baselines_Delete_At_Path_Input = {
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  params?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Baselines_Delete_Elem_Input = {
  model?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Baselines_Delete_Key_Input = {
  model?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "baselines" */
export type Baselines_Inc_Input = {
  adj_r_squared?: InputMaybe<Scalars['numeric']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  f_pvalue?: InputMaybe<Scalars['numeric']['input']>;
  f_stat?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  r_squared?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "baselines" */
export type Baselines_Insert_Input = {
  adj_r_squared?: InputMaybe<Scalars['numeric']['input']>;
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  f_pvalue?: InputMaybe<Scalars['numeric']['input']>;
  f_stat?: InputMaybe<Scalars['numeric']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  r_squared?: InputMaybe<Scalars['numeric']['input']>;
  training_end?: InputMaybe<Scalars['date']['input']>;
  training_start?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Baselines_Max_Fields = {
  __typename?: 'baselines_max_fields';
  adj_r_squared?: Maybe<Scalars['numeric']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  f_pvalue?: Maybe<Scalars['numeric']['output']>;
  f_stat?: Maybe<Scalars['numeric']['output']>;
  finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  r_squared?: Maybe<Scalars['numeric']['output']>;
  training_end?: Maybe<Scalars['date']['output']>;
  training_start?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Baselines_Min_Fields = {
  __typename?: 'baselines_min_fields';
  adj_r_squared?: Maybe<Scalars['numeric']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  f_pvalue?: Maybe<Scalars['numeric']['output']>;
  f_stat?: Maybe<Scalars['numeric']['output']>;
  finalized_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  r_squared?: Maybe<Scalars['numeric']['output']>;
  training_end?: Maybe<Scalars['date']['output']>;
  training_start?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "baselines" */
export type Baselines_Mutation_Response = {
  __typename?: 'baselines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Baselines>;
};

/** on_conflict condition type for table "baselines" */
export type Baselines_On_Conflict = {
  constraint: Baselines_Constraint;
  update_columns?: Array<Baselines_Update_Column>;
  where?: InputMaybe<Baselines_Bool_Exp>;
};

/** Ordering options when selecting data from "baselines". */
export type Baselines_Order_By = {
  adj_r_squared?: InputMaybe<Order_By>;
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  f_pvalue?: InputMaybe<Order_By>;
  f_stat?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  params?: InputMaybe<Order_By>;
  r_squared?: InputMaybe<Order_By>;
  training_end?: InputMaybe<Order_By>;
  training_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: baselines */
export type Baselines_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Baselines_Prepend_Input = {
  model?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "baselines" */
export enum Baselines_Select_Column {
  /** column name */
  AdjRSquared = 'adj_r_squared',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FPvalue = 'f_pvalue',
  /** column name */
  FStat = 'f_stat',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Params = 'params',
  /** column name */
  RSquared = 'r_squared',
  /** column name */
  TrainingEnd = 'training_end',
  /** column name */
  TrainingStart = 'training_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "baselines" */
export type Baselines_Set_Input = {
  adj_r_squared?: InputMaybe<Scalars['numeric']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  f_pvalue?: InputMaybe<Scalars['numeric']['input']>;
  f_stat?: InputMaybe<Scalars['numeric']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  r_squared?: InputMaybe<Scalars['numeric']['input']>;
  training_end?: InputMaybe<Scalars['date']['input']>;
  training_start?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Baselines_Stddev_Fields = {
  __typename?: 'baselines_stddev_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Baselines_Stddev_Pop_Fields = {
  __typename?: 'baselines_stddev_pop_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Baselines_Stddev_Samp_Fields = {
  __typename?: 'baselines_stddev_samp_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "baselines" */
export type Baselines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Baselines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Baselines_Stream_Cursor_Value_Input = {
  adj_r_squared?: InputMaybe<Scalars['numeric']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  f_pvalue?: InputMaybe<Scalars['numeric']['input']>;
  f_stat?: InputMaybe<Scalars['numeric']['input']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['jsonb']['input']>;
  params?: InputMaybe<Scalars['jsonb']['input']>;
  r_squared?: InputMaybe<Scalars['numeric']['input']>;
  training_end?: InputMaybe<Scalars['date']['input']>;
  training_start?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Baselines_Sum_Fields = {
  __typename?: 'baselines_sum_fields';
  adj_r_squared?: Maybe<Scalars['numeric']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  f_pvalue?: Maybe<Scalars['numeric']['output']>;
  f_stat?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  r_squared?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "baselines" */
export enum Baselines_Update_Column {
  /** column name */
  AdjRSquared = 'adj_r_squared',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FPvalue = 'f_pvalue',
  /** column name */
  FStat = 'f_stat',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Params = 'params',
  /** column name */
  RSquared = 'r_squared',
  /** column name */
  TrainingEnd = 'training_end',
  /** column name */
  TrainingStart = 'training_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Baselines_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Baselines_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Baselines_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Baselines_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Baselines_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Baselines_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Baselines_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Baselines_Set_Input>;
  /** filter the rows which have to be updated */
  where: Baselines_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Baselines_Var_Pop_Fields = {
  __typename?: 'baselines_var_pop_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Baselines_Var_Samp_Fields = {
  __typename?: 'baselines_var_samp_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Baselines_Variance_Fields = {
  __typename?: 'baselines_variance_fields';
  adj_r_squared?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  f_pvalue?: Maybe<Scalars['Float']['output']>;
  f_stat?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  r_squared?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** clients */
export type Clients = {
  __typename?: 'clients';
  _created_at: Scalars['timestamptz']['output'];
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  firebase_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  sites: Array<Sites>;
  /** An aggregate relationship */
  sites_aggregate: Sites_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** clients */
export type ClientsSitesArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


/** clients */
export type ClientsSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


/** clients */
export type ClientsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** clients */
export type ClientsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "clients" */
export type Clients_Aggregate = {
  __typename?: 'clients_aggregate';
  aggregate?: Maybe<Clients_Aggregate_Fields>;
  nodes: Array<Clients>;
};

/** aggregate fields of "clients" */
export type Clients_Aggregate_Fields = {
  __typename?: 'clients_aggregate_fields';
  avg?: Maybe<Clients_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Clients_Max_Fields>;
  min?: Maybe<Clients_Min_Fields>;
  stddev?: Maybe<Clients_Stddev_Fields>;
  stddev_pop?: Maybe<Clients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Clients_Stddev_Samp_Fields>;
  sum?: Maybe<Clients_Sum_Fields>;
  var_pop?: Maybe<Clients_Var_Pop_Fields>;
  var_samp?: Maybe<Clients_Var_Samp_Fields>;
  variance?: Maybe<Clients_Variance_Fields>;
};


/** aggregate fields of "clients" */
export type Clients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Clients_Avg_Fields = {
  __typename?: 'clients_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "clients". All fields are combined with a logical 'AND'. */
export type Clients_Bool_Exp = {
  _and?: InputMaybe<Array<Clients_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Clients_Bool_Exp>;
  _or?: InputMaybe<Array<Clients_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sites?: InputMaybe<Sites_Bool_Exp>;
  sites_aggregate?: InputMaybe<Sites_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "clients" */
export enum Clients_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientsPkey = 'clients_pkey'
}

/** input type for incrementing numeric columns in table "clients" */
export type Clients_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "clients" */
export type Clients_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sites?: InputMaybe<Sites_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Clients_Max_Fields = {
  __typename?: 'clients_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Clients_Min_Fields = {
  __typename?: 'clients_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "clients" */
export type Clients_Mutation_Response = {
  __typename?: 'clients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Clients>;
};

/** input type for inserting object relation for remote table "clients" */
export type Clients_Obj_Rel_Insert_Input = {
  data: Clients_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Clients_On_Conflict>;
};

/** on_conflict condition type for table "clients" */
export type Clients_On_Conflict = {
  constraint: Clients_Constraint;
  update_columns?: Array<Clients_Update_Column>;
  where?: InputMaybe<Clients_Bool_Exp>;
};

/** Ordering options when selecting data from "clients". */
export type Clients_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sites_aggregate?: InputMaybe<Sites_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: clients */
export type Clients_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "clients" */
export enum Clients_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Active = 'active',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "clients" */
export type Clients_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Clients_Stddev_Fields = {
  __typename?: 'clients_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Clients_Stddev_Pop_Fields = {
  __typename?: 'clients_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Clients_Stddev_Samp_Fields = {
  __typename?: 'clients_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "clients" */
export type Clients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clients_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Clients_Sum_Fields = {
  __typename?: 'clients_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "clients" */
export enum Clients_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Active = 'active',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type Clients_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Clients_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Clients_Var_Pop_Fields = {
  __typename?: 'clients_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Clients_Var_Samp_Fields = {
  __typename?: 'clients_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Clients_Variance_Fields = {
  __typename?: 'clients_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "comments" */
export type Comments = {
  __typename?: 'comments';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  incident: Incidents;
  incident_id: Scalars['Int']['output'];
};

/** aggregated selection of "comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate';
  aggregate?: Maybe<Comments_Aggregate_Fields>;
  nodes: Array<Comments>;
};

export type Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Comments_Aggregate_Bool_Exp_Count>;
};

export type Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields';
  avg?: Maybe<Comments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Comments_Max_Fields>;
  min?: Maybe<Comments_Min_Fields>;
  stddev?: Maybe<Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Comments_Sum_Fields>;
  var_pop?: Maybe<Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Comments_Var_Samp_Fields>;
  variance?: Maybe<Comments_Variance_Fields>;
};


/** aggregate fields of "comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
  stddev?: InputMaybe<Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Comments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** aggregate avg on columns */
export type Comments_Avg_Fields = {
  __typename?: 'comments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "comments" */
export type Comments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incident?: InputMaybe<Incidents_Bool_Exp>;
  incident_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey'
}

/** input type for incrementing numeric columns in table "comments" */
export type Comments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "comments" */
export type Comments_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<Incidents_Obj_Rel_Insert_Input>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments>;
};

/** on_conflict condition type for table "comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint;
  update_columns?: Array<Comments_Update_Column>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident?: InputMaybe<Incidents_Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id'
}

/** input type for updating data in table "comments" */
export type Comments_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Comments_Stddev_Fields = {
  __typename?: 'comments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "comments" */
export type Comments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Comments_Stddev_Pop_Fields = {
  __typename?: 'comments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "comments" */
export type Comments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Comments_Stddev_Samp_Fields = {
  __typename?: 'comments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "comments" */
export type Comments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "comments" */
export type Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Comments_Sum_Fields = {
  __typename?: 'comments_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "comments" */
export type Comments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** update columns of table "comments" */
export enum Comments_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id'
}

export type Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Comments_Var_Pop_Fields = {
  __typename?: 'comments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "comments" */
export type Comments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Comments_Var_Samp_Fields = {
  __typename?: 'comments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "comments" */
export type Comments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Comments_Variance_Fields = {
  __typename?: 'comments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "comments" */
export type Comments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "consumption_by_timestamp" */
export type Consumption_By_Timestamp = {
  __typename?: 'consumption_by_timestamp';
  consumption_kwh: Scalars['numeric']['output'];
  cost: Scalars['numeric']['output'];
  /** An object relationship */
  meter: Meters;
  meter_id: Scalars['Int']['output'];
  power_kw: Scalars['numeric']['output'];
  timestamp: Scalars['timestamp']['output'];
};

/** aggregated selection of "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Aggregate = {
  __typename?: 'consumption_by_timestamp_aggregate';
  aggregate?: Maybe<Consumption_By_Timestamp_Aggregate_Fields>;
  nodes: Array<Consumption_By_Timestamp>;
};

/** aggregate fields of "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Aggregate_Fields = {
  __typename?: 'consumption_by_timestamp_aggregate_fields';
  avg?: Maybe<Consumption_By_Timestamp_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consumption_By_Timestamp_Max_Fields>;
  min?: Maybe<Consumption_By_Timestamp_Min_Fields>;
  stddev?: Maybe<Consumption_By_Timestamp_Stddev_Fields>;
  stddev_pop?: Maybe<Consumption_By_Timestamp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumption_By_Timestamp_Stddev_Samp_Fields>;
  sum?: Maybe<Consumption_By_Timestamp_Sum_Fields>;
  var_pop?: Maybe<Consumption_By_Timestamp_Var_Pop_Fields>;
  var_samp?: Maybe<Consumption_By_Timestamp_Var_Samp_Fields>;
  variance?: Maybe<Consumption_By_Timestamp_Variance_Fields>;
};


/** aggregate fields of "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Consumption_By_Timestamp_Avg_Fields = {
  __typename?: 'consumption_by_timestamp_avg_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "consumption_by_timestamp". All fields are combined with a logical 'AND'. */
export type Consumption_By_Timestamp_Bool_Exp = {
  _and?: InputMaybe<Array<Consumption_By_Timestamp_Bool_Exp>>;
  _not?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
  _or?: InputMaybe<Array<Consumption_By_Timestamp_Bool_Exp>>;
  consumption_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
  power_kw?: InputMaybe<Numeric_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumption_by_timestamp" */
export enum Consumption_By_Timestamp_Constraint {
  /** unique or primary key constraint on columns "timestamp" */
  ConsumptionByTimestampPkey = 'consumption_by_timestamp_pkey',
  /** unique or primary key constraint on columns "timestamp" */
  ConsumptionByTimestampTimestampKey = 'consumption_by_timestamp_timestamp_key'
}

/** input type for incrementing numeric columns in table "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Inc_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Insert_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Consumption_By_Timestamp_Max_Fields = {
  __typename?: 'consumption_by_timestamp_max_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  power_kw?: Maybe<Scalars['numeric']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Consumption_By_Timestamp_Min_Fields = {
  __typename?: 'consumption_by_timestamp_min_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  power_kw?: Maybe<Scalars['numeric']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Mutation_Response = {
  __typename?: 'consumption_by_timestamp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Consumption_By_Timestamp>;
};

/** on_conflict condition type for table "consumption_by_timestamp" */
export type Consumption_By_Timestamp_On_Conflict = {
  constraint: Consumption_By_Timestamp_Constraint;
  update_columns?: Array<Consumption_By_Timestamp_Update_Column>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};

/** Ordering options when selecting data from "consumption_by_timestamp". */
export type Consumption_By_Timestamp_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
  power_kw?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consumption_by_timestamp */
export type Consumption_By_Timestamp_Pk_Columns_Input = {
  timestamp: Scalars['timestamp']['input'];
};

/** select columns of table "consumption_by_timestamp" */
export enum Consumption_By_Timestamp_Select_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  PowerKw = 'power_kw',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Set_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Consumption_By_Timestamp_Stddev_Fields = {
  __typename?: 'consumption_by_timestamp_stddev_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Consumption_By_Timestamp_Stddev_Pop_Fields = {
  __typename?: 'consumption_by_timestamp_stddev_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Consumption_By_Timestamp_Stddev_Samp_Fields = {
  __typename?: 'consumption_by_timestamp_stddev_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "consumption_by_timestamp" */
export type Consumption_By_Timestamp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumption_By_Timestamp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumption_By_Timestamp_Stream_Cursor_Value_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Consumption_By_Timestamp_Sum_Fields = {
  __typename?: 'consumption_by_timestamp_sum_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  power_kw?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "consumption_by_timestamp" */
export enum Consumption_By_Timestamp_Update_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  PowerKw = 'power_kw',
  /** column name */
  Timestamp = 'timestamp'
}

export type Consumption_By_Timestamp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consumption_By_Timestamp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consumption_By_Timestamp_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consumption_By_Timestamp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consumption_By_Timestamp_Var_Pop_Fields = {
  __typename?: 'consumption_by_timestamp_var_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Consumption_By_Timestamp_Var_Samp_Fields = {
  __typename?: 'consumption_by_timestamp_var_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Consumption_By_Timestamp_Variance_Fields = {
  __typename?: 'consumption_by_timestamp_variance_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "consumption.meter_consumption" */
export type Consumption_Meter_Consumption = {
  __typename?: 'consumption_meter_consumption';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  partitioning_timestamp?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "consumption.meter_consumption" */
export type Consumption_Meter_Consumption_Aggregate = {
  __typename?: 'consumption_meter_consumption_aggregate';
  aggregate?: Maybe<Consumption_Meter_Consumption_Aggregate_Fields>;
  nodes: Array<Consumption_Meter_Consumption>;
};

/** aggregate fields of "consumption.meter_consumption" */
export type Consumption_Meter_Consumption_Aggregate_Fields = {
  __typename?: 'consumption_meter_consumption_aggregate_fields';
  avg?: Maybe<Consumption_Meter_Consumption_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consumption_Meter_Consumption_Max_Fields>;
  min?: Maybe<Consumption_Meter_Consumption_Min_Fields>;
  stddev?: Maybe<Consumption_Meter_Consumption_Stddev_Fields>;
  stddev_pop?: Maybe<Consumption_Meter_Consumption_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumption_Meter_Consumption_Stddev_Samp_Fields>;
  sum?: Maybe<Consumption_Meter_Consumption_Sum_Fields>;
  var_pop?: Maybe<Consumption_Meter_Consumption_Var_Pop_Fields>;
  var_samp?: Maybe<Consumption_Meter_Consumption_Var_Samp_Fields>;
  variance?: Maybe<Consumption_Meter_Consumption_Variance_Fields>;
};


/** aggregate fields of "consumption.meter_consumption" */
export type Consumption_Meter_Consumption_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumption_Meter_Consumption_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Consumption_Meter_Consumption_Avg_Fields = {
  __typename?: 'consumption_meter_consumption_avg_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "consumption.meter_consumption". All fields are combined with a logical 'AND'. */
export type Consumption_Meter_Consumption_Bool_Exp = {
  _and?: InputMaybe<Array<Consumption_Meter_Consumption_Bool_Exp>>;
  _not?: InputMaybe<Consumption_Meter_Consumption_Bool_Exp>;
  _or?: InputMaybe<Array<Consumption_Meter_Consumption_Bool_Exp>>;
  consumption_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
  partitioning_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** aggregate max on columns */
export type Consumption_Meter_Consumption_Max_Fields = {
  __typename?: 'consumption_meter_consumption_max_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  partitioning_timestamp?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Consumption_Meter_Consumption_Min_Fields = {
  __typename?: 'consumption_meter_consumption_min_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  partitioning_timestamp?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** Ordering options when selecting data from "consumption.meter_consumption". */
export type Consumption_Meter_Consumption_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  partitioning_timestamp?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** select columns of table "consumption.meter_consumption" */
export enum Consumption_Meter_Consumption_Select_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  End = 'end',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  PartitioningTimestamp = 'partitioning_timestamp',
  /** column name */
  Start = 'start'
}

/** aggregate stddev on columns */
export type Consumption_Meter_Consumption_Stddev_Fields = {
  __typename?: 'consumption_meter_consumption_stddev_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Consumption_Meter_Consumption_Stddev_Pop_Fields = {
  __typename?: 'consumption_meter_consumption_stddev_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Consumption_Meter_Consumption_Stddev_Samp_Fields = {
  __typename?: 'consumption_meter_consumption_stddev_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "consumption_meter_consumption" */
export type Consumption_Meter_Consumption_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumption_Meter_Consumption_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumption_Meter_Consumption_Stream_Cursor_Value_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  partitioning_timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Consumption_Meter_Consumption_Sum_Fields = {
  __typename?: 'consumption_meter_consumption_sum_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Consumption_Meter_Consumption_Var_Pop_Fields = {
  __typename?: 'consumption_meter_consumption_var_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Consumption_Meter_Consumption_Var_Samp_Fields = {
  __typename?: 'consumption_meter_consumption_var_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Consumption_Meter_Consumption_Variance_Fields = {
  __typename?: 'consumption_meter_consumption_variance_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "consumption_reference" */
export type Consumption_Reference = {
  __typename?: 'consumption_reference';
  co2: Scalars['numeric']['output'];
  consumption: Scalars['numeric']['output'];
  cost: Scalars['numeric']['output'];
  deployment_date: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  production?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  site: Sites;
  site_id: Scalars['Int']['output'];
};

/** aggregated selection of "consumption_reference" */
export type Consumption_Reference_Aggregate = {
  __typename?: 'consumption_reference_aggregate';
  aggregate?: Maybe<Consumption_Reference_Aggregate_Fields>;
  nodes: Array<Consumption_Reference>;
};

/** aggregate fields of "consumption_reference" */
export type Consumption_Reference_Aggregate_Fields = {
  __typename?: 'consumption_reference_aggregate_fields';
  avg?: Maybe<Consumption_Reference_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consumption_Reference_Max_Fields>;
  min?: Maybe<Consumption_Reference_Min_Fields>;
  stddev?: Maybe<Consumption_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<Consumption_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumption_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<Consumption_Reference_Sum_Fields>;
  var_pop?: Maybe<Consumption_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<Consumption_Reference_Var_Samp_Fields>;
  variance?: Maybe<Consumption_Reference_Variance_Fields>;
};


/** aggregate fields of "consumption_reference" */
export type Consumption_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumption_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Consumption_Reference_Avg_Fields = {
  __typename?: 'consumption_reference_avg_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "consumption_reference". All fields are combined with a logical 'AND'. */
export type Consumption_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<Consumption_Reference_Bool_Exp>>;
  _not?: InputMaybe<Consumption_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<Consumption_Reference_Bool_Exp>>;
  co2?: InputMaybe<Numeric_Comparison_Exp>;
  consumption?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  deployment_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  production?: InputMaybe<Numeric_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumption_reference" */
export enum Consumption_Reference_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConsumptionReferencePkey = 'consumption_reference_pkey',
  /** unique or primary key constraint on columns "site_id" */
  ConsumptionReferenceSiteIdKey = 'consumption_reference_site_id_key'
}

/** input type for incrementing numeric columns in table "consumption_reference" */
export type Consumption_Reference_Inc_Input = {
  co2?: InputMaybe<Scalars['numeric']['input']>;
  consumption?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  production?: InputMaybe<Scalars['numeric']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "consumption_reference" */
export type Consumption_Reference_Insert_Input = {
  co2?: InputMaybe<Scalars['numeric']['input']>;
  consumption?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  deployment_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  production?: InputMaybe<Scalars['numeric']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Consumption_Reference_Max_Fields = {
  __typename?: 'consumption_reference_max_fields';
  co2?: Maybe<Scalars['numeric']['output']>;
  consumption?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  deployment_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  production?: Maybe<Scalars['numeric']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Consumption_Reference_Min_Fields = {
  __typename?: 'consumption_reference_min_fields';
  co2?: Maybe<Scalars['numeric']['output']>;
  consumption?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  deployment_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  production?: Maybe<Scalars['numeric']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "consumption_reference" */
export type Consumption_Reference_Mutation_Response = {
  __typename?: 'consumption_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Consumption_Reference>;
};

/** input type for inserting object relation for remote table "consumption_reference" */
export type Consumption_Reference_Obj_Rel_Insert_Input = {
  data: Consumption_Reference_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Consumption_Reference_On_Conflict>;
};

/** on_conflict condition type for table "consumption_reference" */
export type Consumption_Reference_On_Conflict = {
  constraint: Consumption_Reference_Constraint;
  update_columns?: Array<Consumption_Reference_Update_Column>;
  where?: InputMaybe<Consumption_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "consumption_reference". */
export type Consumption_Reference_Order_By = {
  co2?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  deployment_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consumption_reference */
export type Consumption_Reference_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "consumption_reference" */
export enum Consumption_Reference_Select_Column {
  /** column name */
  Co2 = 'co2',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cost = 'cost',
  /** column name */
  DeploymentDate = 'deployment_date',
  /** column name */
  Id = 'id',
  /** column name */
  Production = 'production',
  /** column name */
  SiteId = 'site_id'
}

/** input type for updating data in table "consumption_reference" */
export type Consumption_Reference_Set_Input = {
  co2?: InputMaybe<Scalars['numeric']['input']>;
  consumption?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  deployment_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  production?: InputMaybe<Scalars['numeric']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Consumption_Reference_Stddev_Fields = {
  __typename?: 'consumption_reference_stddev_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Consumption_Reference_Stddev_Pop_Fields = {
  __typename?: 'consumption_reference_stddev_pop_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Consumption_Reference_Stddev_Samp_Fields = {
  __typename?: 'consumption_reference_stddev_samp_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "consumption_reference" */
export type Consumption_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumption_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumption_Reference_Stream_Cursor_Value_Input = {
  co2?: InputMaybe<Scalars['numeric']['input']>;
  consumption?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  deployment_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  production?: InputMaybe<Scalars['numeric']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Consumption_Reference_Sum_Fields = {
  __typename?: 'consumption_reference_sum_fields';
  co2?: Maybe<Scalars['numeric']['output']>;
  consumption?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  production?: Maybe<Scalars['numeric']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "consumption_reference" */
export enum Consumption_Reference_Update_Column {
  /** column name */
  Co2 = 'co2',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cost = 'cost',
  /** column name */
  DeploymentDate = 'deployment_date',
  /** column name */
  Id = 'id',
  /** column name */
  Production = 'production',
  /** column name */
  SiteId = 'site_id'
}

export type Consumption_Reference_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consumption_Reference_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consumption_Reference_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consumption_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consumption_Reference_Var_Pop_Fields = {
  __typename?: 'consumption_reference_var_pop_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Consumption_Reference_Var_Samp_Fields = {
  __typename?: 'consumption_reference_var_samp_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Consumption_Reference_Variance_Fields = {
  __typename?: 'consumption_reference_variance_fields';
  co2?: Maybe<Scalars['Float']['output']>;
  consumption?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "consumptions" */
export type Consumptions = {
  __typename?: 'consumptions';
  average_power_kW: Scalars['numeric']['output'];
  end: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter?: Maybe<Meters>;
  meter_id: Scalars['Int']['output'];
  start: Scalars['timestamptz']['output'];
};

/** aggregated selection of "consumptions" */
export type Consumptions_Aggregate = {
  __typename?: 'consumptions_aggregate';
  aggregate?: Maybe<Consumptions_Aggregate_Fields>;
  nodes: Array<Consumptions>;
};

export type Consumptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Consumptions_Aggregate_Bool_Exp_Count>;
};

export type Consumptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consumptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Consumptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "consumptions" */
export type Consumptions_Aggregate_Fields = {
  __typename?: 'consumptions_aggregate_fields';
  avg?: Maybe<Consumptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consumptions_Max_Fields>;
  min?: Maybe<Consumptions_Min_Fields>;
  stddev?: Maybe<Consumptions_Stddev_Fields>;
  stddev_pop?: Maybe<Consumptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumptions_Stddev_Samp_Fields>;
  sum?: Maybe<Consumptions_Sum_Fields>;
  var_pop?: Maybe<Consumptions_Var_Pop_Fields>;
  var_samp?: Maybe<Consumptions_Var_Samp_Fields>;
  variance?: Maybe<Consumptions_Variance_Fields>;
};


/** aggregate fields of "consumptions" */
export type Consumptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "consumptions" */
export type Consumptions_Aggregate_Order_By = {
  avg?: InputMaybe<Consumptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consumptions_Max_Order_By>;
  min?: InputMaybe<Consumptions_Min_Order_By>;
  stddev?: InputMaybe<Consumptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consumptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consumptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consumptions_Sum_Order_By>;
  var_pop?: InputMaybe<Consumptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consumptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Consumptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "consumptions" */
export type Consumptions_Arr_Rel_Insert_Input = {
  data: Array<Consumptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Consumptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Consumptions_Avg_Fields = {
  __typename?: 'consumptions_avg_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "consumptions" */
export type Consumptions_Avg_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "consumptions". All fields are combined with a logical 'AND'. */
export type Consumptions_Bool_Exp = {
  _and?: InputMaybe<Array<Consumptions_Bool_Exp>>;
  _not?: InputMaybe<Consumptions_Bool_Exp>;
  _or?: InputMaybe<Array<Consumptions_Bool_Exp>>;
  average_power_kW?: InputMaybe<Numeric_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumptions" */
export enum Consumptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConsumptionsPkey = 'consumptions_pkey'
}

/** input type for incrementing numeric columns in table "consumptions" */
export type Consumptions_Inc_Input = {
  average_power_kW?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "consumptions" */
export type Consumptions_Insert_Input = {
  average_power_kW?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Consumptions_Max_Fields = {
  __typename?: 'consumptions_max_fields';
  average_power_kW?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "consumptions" */
export type Consumptions_Max_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consumptions_Min_Fields = {
  __typename?: 'consumptions_min_fields';
  average_power_kW?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "consumptions" */
export type Consumptions_Min_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "consumptions" */
export type Consumptions_Mutation_Response = {
  __typename?: 'consumptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Consumptions>;
};

/** on_conflict condition type for table "consumptions" */
export type Consumptions_On_Conflict = {
  constraint: Consumptions_Constraint;
  update_columns?: Array<Consumptions_Update_Column>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};

/** Ordering options when selecting data from "consumptions". */
export type Consumptions_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consumptions */
export type Consumptions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "consumptions" */
export enum Consumptions_Select_Column {
  /** column name */
  AveragePowerKW = 'average_power_kW',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Start = 'start'
}

/** input type for updating data in table "consumptions" */
export type Consumptions_Set_Input = {
  average_power_kW?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Consumptions_Stddev_Fields = {
  __typename?: 'consumptions_stddev_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "consumptions" */
export type Consumptions_Stddev_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consumptions_Stddev_Pop_Fields = {
  __typename?: 'consumptions_stddev_pop_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "consumptions" */
export type Consumptions_Stddev_Pop_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consumptions_Stddev_Samp_Fields = {
  __typename?: 'consumptions_stddev_samp_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "consumptions" */
export type Consumptions_Stddev_Samp_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consumptions" */
export type Consumptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumptions_Stream_Cursor_Value_Input = {
  average_power_kW?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Consumptions_Sum_Fields = {
  __typename?: 'consumptions_sum_fields';
  average_power_kW?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "consumptions" */
export type Consumptions_Sum_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** update columns of table "consumptions" */
export enum Consumptions_Update_Column {
  /** column name */
  AveragePowerKW = 'average_power_kW',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Start = 'start'
}

export type Consumptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consumptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consumptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consumptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consumptions_Var_Pop_Fields = {
  __typename?: 'consumptions_var_pop_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "consumptions" */
export type Consumptions_Var_Pop_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consumptions_Var_Samp_Fields = {
  __typename?: 'consumptions_var_samp_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "consumptions" */
export type Consumptions_Var_Samp_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consumptions_Variance_Fields = {
  __typename?: 'consumptions_variance_fields';
  average_power_kW?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "consumptions" */
export type Consumptions_Variance_Order_By = {
  average_power_kW?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "contracts" */
export type Contracts = {
  __typename?: 'contracts';
  contract_power: Scalars['numeric']['output'];
  created_at: Scalars['timestamptz']['output'];
  emission_factor: Scalars['numeric']['output'];
  end: Scalars['timestamp']['output'];
  energy_type: Energy_Types_Enum;
  id: Scalars['Int']['output'];
  /** An object relationship */
  site: Sites;
  site_id: Scalars['Int']['output'];
  start: Scalars['timestamp']['output'];
  /** An array relationship */
  tariffs: Array<Tariffs>;
  /** An aggregate relationship */
  tariffs_aggregate: Tariffs_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "contracts" */
export type ContractsTariffsArgs = {
  distinct_on?: InputMaybe<Array<Tariffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariffs_Order_By>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};


/** columns and relationships of "contracts" */
export type ContractsTariffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tariffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariffs_Order_By>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};

/** aggregated selection of "contracts" */
export type Contracts_Aggregate = {
  __typename?: 'contracts_aggregate';
  aggregate?: Maybe<Contracts_Aggregate_Fields>;
  nodes: Array<Contracts>;
};

export type Contracts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contracts_Aggregate_Bool_Exp_Count>;
};

export type Contracts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Contracts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contracts" */
export type Contracts_Aggregate_Fields = {
  __typename?: 'contracts_aggregate_fields';
  avg?: Maybe<Contracts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Contracts_Max_Fields>;
  min?: Maybe<Contracts_Min_Fields>;
  stddev?: Maybe<Contracts_Stddev_Fields>;
  stddev_pop?: Maybe<Contracts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contracts_Stddev_Samp_Fields>;
  sum?: Maybe<Contracts_Sum_Fields>;
  var_pop?: Maybe<Contracts_Var_Pop_Fields>;
  var_samp?: Maybe<Contracts_Var_Samp_Fields>;
  variance?: Maybe<Contracts_Variance_Fields>;
};


/** aggregate fields of "contracts" */
export type Contracts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "contracts" */
export type Contracts_Aggregate_Order_By = {
  avg?: InputMaybe<Contracts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contracts_Max_Order_By>;
  min?: InputMaybe<Contracts_Min_Order_By>;
  stddev?: InputMaybe<Contracts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Contracts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Contracts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Contracts_Sum_Order_By>;
  var_pop?: InputMaybe<Contracts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Contracts_Var_Samp_Order_By>;
  variance?: InputMaybe<Contracts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contracts" */
export type Contracts_Arr_Rel_Insert_Input = {
  data: Array<Contracts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};

/** aggregate avg on columns */
export type Contracts_Avg_Fields = {
  __typename?: 'contracts_avg_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "contracts" */
export type Contracts_Avg_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contracts". All fields are combined with a logical 'AND'. */
export type Contracts_Bool_Exp = {
  _and?: InputMaybe<Array<Contracts_Bool_Exp>>;
  _not?: InputMaybe<Contracts_Bool_Exp>;
  _or?: InputMaybe<Array<Contracts_Bool_Exp>>;
  contract_power?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  emission_factor?: InputMaybe<Numeric_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  energy_type?: InputMaybe<Energy_Types_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
  tariffs?: InputMaybe<Tariffs_Bool_Exp>;
  tariffs_aggregate?: InputMaybe<Tariffs_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "contracts" */
export enum Contracts_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractsPkey = 'contracts_pkey'
}

/** input type for incrementing numeric columns in table "contracts" */
export type Contracts_Inc_Input = {
  contract_power?: InputMaybe<Scalars['numeric']['input']>;
  emission_factor?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "contracts" */
export type Contracts_Insert_Input = {
  contract_power?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emission_factor?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  tariffs?: InputMaybe<Tariffs_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Contracts_Max_Fields = {
  __typename?: 'contracts_max_fields';
  contract_power?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  emission_factor?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "contracts" */
export type Contracts_Max_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contracts_Min_Fields = {
  __typename?: 'contracts_min_fields';
  contract_power?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  emission_factor?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "contracts" */
export type Contracts_Min_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "contracts" */
export type Contracts_Mutation_Response = {
  __typename?: 'contracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contracts>;
};

/** input type for inserting object relation for remote table "contracts" */
export type Contracts_Obj_Rel_Insert_Input = {
  data: Contracts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};

/** on_conflict condition type for table "contracts" */
export type Contracts_On_Conflict = {
  constraint: Contracts_Constraint;
  update_columns?: Array<Contracts_Update_Column>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};

/** Ordering options when selecting data from "contracts". */
export type Contracts_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  energy_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  site_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  tariffs_aggregate?: InputMaybe<Tariffs_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contracts */
export type Contracts_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "contracts" */
export enum Contracts_Select_Column {
  /** column name */
  ContractPower = 'contract_power',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmissionFactor = 'emission_factor',
  /** column name */
  End = 'end',
  /** column name */
  EnergyType = 'energy_type',
  /** column name */
  Id = 'id',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "contracts" */
export type Contracts_Set_Input = {
  contract_power?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emission_factor?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Contracts_Stddev_Fields = {
  __typename?: 'contracts_stddev_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "contracts" */
export type Contracts_Stddev_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contracts_Stddev_Pop_Fields = {
  __typename?: 'contracts_stddev_pop_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "contracts" */
export type Contracts_Stddev_Pop_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contracts_Stddev_Samp_Fields = {
  __typename?: 'contracts_stddev_samp_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "contracts" */
export type Contracts_Stddev_Samp_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "contracts" */
export type Contracts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contracts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contracts_Stream_Cursor_Value_Input = {
  contract_power?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emission_factor?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Contracts_Sum_Fields = {
  __typename?: 'contracts_sum_fields';
  contract_power?: Maybe<Scalars['numeric']['output']>;
  emission_factor?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "contracts" */
export type Contracts_Sum_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** update columns of table "contracts" */
export enum Contracts_Update_Column {
  /** column name */
  ContractPower = 'contract_power',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmissionFactor = 'emission_factor',
  /** column name */
  End = 'end',
  /** column name */
  EnergyType = 'energy_type',
  /** column name */
  Id = 'id',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contracts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contracts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contracts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contracts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contracts_Var_Pop_Fields = {
  __typename?: 'contracts_var_pop_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "contracts" */
export type Contracts_Var_Pop_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contracts_Var_Samp_Fields = {
  __typename?: 'contracts_var_samp_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "contracts" */
export type Contracts_Var_Samp_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Contracts_Variance_Fields = {
  __typename?: 'contracts_variance_fields';
  contract_power?: Maybe<Scalars['Float']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "contracts" */
export type Contracts_Variance_Order_By = {
  contract_power?: InputMaybe<Order_By>;
  emission_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "cron.job" */
export type Cron_Job = {
  __typename?: 'cron_job';
  active: Scalars['Boolean']['output'];
  command: Scalars['String']['output'];
  database: Scalars['String']['output'];
  jobid: Scalars['bigint']['output'];
  jobname?: Maybe<Scalars['String']['output']>;
  nodename: Scalars['String']['output'];
  nodeport: Scalars['Int']['output'];
  schedule: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** aggregated selection of "cron.job" */
export type Cron_Job_Aggregate = {
  __typename?: 'cron_job_aggregate';
  aggregate?: Maybe<Cron_Job_Aggregate_Fields>;
  nodes: Array<Cron_Job>;
};

/** aggregate fields of "cron.job" */
export type Cron_Job_Aggregate_Fields = {
  __typename?: 'cron_job_aggregate_fields';
  avg?: Maybe<Cron_Job_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cron_Job_Max_Fields>;
  min?: Maybe<Cron_Job_Min_Fields>;
  stddev?: Maybe<Cron_Job_Stddev_Fields>;
  stddev_pop?: Maybe<Cron_Job_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cron_Job_Stddev_Samp_Fields>;
  sum?: Maybe<Cron_Job_Sum_Fields>;
  var_pop?: Maybe<Cron_Job_Var_Pop_Fields>;
  var_samp?: Maybe<Cron_Job_Var_Samp_Fields>;
  variance?: Maybe<Cron_Job_Variance_Fields>;
};


/** aggregate fields of "cron.job" */
export type Cron_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cron_Job_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Cron_Job_Avg_Fields = {
  __typename?: 'cron_job_avg_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cron.job". All fields are combined with a logical 'AND'. */
export type Cron_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Cron_Job_Bool_Exp>>;
  _not?: InputMaybe<Cron_Job_Bool_Exp>;
  _or?: InputMaybe<Array<Cron_Job_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  command?: InputMaybe<String_Comparison_Exp>;
  database?: InputMaybe<String_Comparison_Exp>;
  jobid?: InputMaybe<Bigint_Comparison_Exp>;
  jobname?: InputMaybe<String_Comparison_Exp>;
  nodename?: InputMaybe<String_Comparison_Exp>;
  nodeport?: InputMaybe<Int_Comparison_Exp>;
  schedule?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cron.job" */
export enum Cron_Job_Constraint {
  /** unique or primary key constraint on columns "jobid" */
  JobPkey = 'job_pkey',
  /** unique or primary key constraint on columns "jobname", "username" */
  JobnameUsernameUniq = 'jobname_username_uniq'
}

/** input type for incrementing numeric columns in table "cron.job" */
export type Cron_Job_Inc_Input = {
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  nodeport?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cron.job" */
export type Cron_Job_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  command?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  jobname?: InputMaybe<Scalars['String']['input']>;
  nodename?: InputMaybe<Scalars['String']['input']>;
  nodeport?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Cron_Job_Max_Fields = {
  __typename?: 'cron_job_max_fields';
  command?: Maybe<Scalars['String']['output']>;
  database?: Maybe<Scalars['String']['output']>;
  jobid?: Maybe<Scalars['bigint']['output']>;
  jobname?: Maybe<Scalars['String']['output']>;
  nodename?: Maybe<Scalars['String']['output']>;
  nodeport?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Cron_Job_Min_Fields = {
  __typename?: 'cron_job_min_fields';
  command?: Maybe<Scalars['String']['output']>;
  database?: Maybe<Scalars['String']['output']>;
  jobid?: Maybe<Scalars['bigint']['output']>;
  jobname?: Maybe<Scalars['String']['output']>;
  nodename?: Maybe<Scalars['String']['output']>;
  nodeport?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "cron.job" */
export type Cron_Job_Mutation_Response = {
  __typename?: 'cron_job_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cron_Job>;
};

/** on_conflict condition type for table "cron.job" */
export type Cron_Job_On_Conflict = {
  constraint: Cron_Job_Constraint;
  update_columns?: Array<Cron_Job_Update_Column>;
  where?: InputMaybe<Cron_Job_Bool_Exp>;
};

/** Ordering options when selecting data from "cron.job". */
export type Cron_Job_Order_By = {
  active?: InputMaybe<Order_By>;
  command?: InputMaybe<Order_By>;
  database?: InputMaybe<Order_By>;
  jobid?: InputMaybe<Order_By>;
  jobname?: InputMaybe<Order_By>;
  nodename?: InputMaybe<Order_By>;
  nodeport?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cron.job */
export type Cron_Job_Pk_Columns_Input = {
  jobid: Scalars['bigint']['input'];
};

/** columns and relationships of "cron.job_run_details" */
export type Cron_Job_Run_Details = {
  __typename?: 'cron_job_run_details';
  command?: Maybe<Scalars['String']['output']>;
  database?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  job_pid?: Maybe<Scalars['Int']['output']>;
  jobid?: Maybe<Scalars['bigint']['output']>;
  return_message?: Maybe<Scalars['String']['output']>;
  runid: Scalars['bigint']['output'];
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "cron.job_run_details" */
export type Cron_Job_Run_Details_Aggregate = {
  __typename?: 'cron_job_run_details_aggregate';
  aggregate?: Maybe<Cron_Job_Run_Details_Aggregate_Fields>;
  nodes: Array<Cron_Job_Run_Details>;
};

/** aggregate fields of "cron.job_run_details" */
export type Cron_Job_Run_Details_Aggregate_Fields = {
  __typename?: 'cron_job_run_details_aggregate_fields';
  avg?: Maybe<Cron_Job_Run_Details_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cron_Job_Run_Details_Max_Fields>;
  min?: Maybe<Cron_Job_Run_Details_Min_Fields>;
  stddev?: Maybe<Cron_Job_Run_Details_Stddev_Fields>;
  stddev_pop?: Maybe<Cron_Job_Run_Details_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cron_Job_Run_Details_Stddev_Samp_Fields>;
  sum?: Maybe<Cron_Job_Run_Details_Sum_Fields>;
  var_pop?: Maybe<Cron_Job_Run_Details_Var_Pop_Fields>;
  var_samp?: Maybe<Cron_Job_Run_Details_Var_Samp_Fields>;
  variance?: Maybe<Cron_Job_Run_Details_Variance_Fields>;
};


/** aggregate fields of "cron.job_run_details" */
export type Cron_Job_Run_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cron_Job_Run_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Cron_Job_Run_Details_Avg_Fields = {
  __typename?: 'cron_job_run_details_avg_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cron.job_run_details". All fields are combined with a logical 'AND'. */
export type Cron_Job_Run_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Cron_Job_Run_Details_Bool_Exp>>;
  _not?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Cron_Job_Run_Details_Bool_Exp>>;
  command?: InputMaybe<String_Comparison_Exp>;
  database?: InputMaybe<String_Comparison_Exp>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  job_pid?: InputMaybe<Int_Comparison_Exp>;
  jobid?: InputMaybe<Bigint_Comparison_Exp>;
  return_message?: InputMaybe<String_Comparison_Exp>;
  runid?: InputMaybe<Bigint_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cron.job_run_details" */
export enum Cron_Job_Run_Details_Constraint {
  /** unique or primary key constraint on columns "runid" */
  JobRunDetailsPkey = 'job_run_details_pkey'
}

/** input type for incrementing numeric columns in table "cron.job_run_details" */
export type Cron_Job_Run_Details_Inc_Input = {
  job_pid?: InputMaybe<Scalars['Int']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  runid?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "cron.job_run_details" */
export type Cron_Job_Run_Details_Insert_Input = {
  command?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  job_pid?: InputMaybe<Scalars['Int']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  return_message?: InputMaybe<Scalars['String']['input']>;
  runid?: InputMaybe<Scalars['bigint']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Cron_Job_Run_Details_Max_Fields = {
  __typename?: 'cron_job_run_details_max_fields';
  command?: Maybe<Scalars['String']['output']>;
  database?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  job_pid?: Maybe<Scalars['Int']['output']>;
  jobid?: Maybe<Scalars['bigint']['output']>;
  return_message?: Maybe<Scalars['String']['output']>;
  runid?: Maybe<Scalars['bigint']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Cron_Job_Run_Details_Min_Fields = {
  __typename?: 'cron_job_run_details_min_fields';
  command?: Maybe<Scalars['String']['output']>;
  database?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['timestamptz']['output']>;
  job_pid?: Maybe<Scalars['Int']['output']>;
  jobid?: Maybe<Scalars['bigint']['output']>;
  return_message?: Maybe<Scalars['String']['output']>;
  runid?: Maybe<Scalars['bigint']['output']>;
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "cron.job_run_details" */
export type Cron_Job_Run_Details_Mutation_Response = {
  __typename?: 'cron_job_run_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cron_Job_Run_Details>;
};

/** on_conflict condition type for table "cron.job_run_details" */
export type Cron_Job_Run_Details_On_Conflict = {
  constraint: Cron_Job_Run_Details_Constraint;
  update_columns?: Array<Cron_Job_Run_Details_Update_Column>;
  where?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
};

/** Ordering options when selecting data from "cron.job_run_details". */
export type Cron_Job_Run_Details_Order_By = {
  command?: InputMaybe<Order_By>;
  database?: InputMaybe<Order_By>;
  end_time?: InputMaybe<Order_By>;
  job_pid?: InputMaybe<Order_By>;
  jobid?: InputMaybe<Order_By>;
  return_message?: InputMaybe<Order_By>;
  runid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cron.job_run_details */
export type Cron_Job_Run_Details_Pk_Columns_Input = {
  runid: Scalars['bigint']['input'];
};

/** select columns of table "cron.job_run_details" */
export enum Cron_Job_Run_Details_Select_Column {
  /** column name */
  Command = 'command',
  /** column name */
  Database = 'database',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  JobPid = 'job_pid',
  /** column name */
  Jobid = 'jobid',
  /** column name */
  ReturnMessage = 'return_message',
  /** column name */
  Runid = 'runid',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "cron.job_run_details" */
export type Cron_Job_Run_Details_Set_Input = {
  command?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  job_pid?: InputMaybe<Scalars['Int']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  return_message?: InputMaybe<Scalars['String']['input']>;
  runid?: InputMaybe<Scalars['bigint']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Cron_Job_Run_Details_Stddev_Fields = {
  __typename?: 'cron_job_run_details_stddev_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Cron_Job_Run_Details_Stddev_Pop_Fields = {
  __typename?: 'cron_job_run_details_stddev_pop_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Cron_Job_Run_Details_Stddev_Samp_Fields = {
  __typename?: 'cron_job_run_details_stddev_samp_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cron_job_run_details" */
export type Cron_Job_Run_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cron_Job_Run_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cron_Job_Run_Details_Stream_Cursor_Value_Input = {
  command?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['timestamptz']['input']>;
  job_pid?: InputMaybe<Scalars['Int']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  return_message?: InputMaybe<Scalars['String']['input']>;
  runid?: InputMaybe<Scalars['bigint']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Cron_Job_Run_Details_Sum_Fields = {
  __typename?: 'cron_job_run_details_sum_fields';
  job_pid?: Maybe<Scalars['Int']['output']>;
  jobid?: Maybe<Scalars['bigint']['output']>;
  runid?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "cron.job_run_details" */
export enum Cron_Job_Run_Details_Update_Column {
  /** column name */
  Command = 'command',
  /** column name */
  Database = 'database',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  JobPid = 'job_pid',
  /** column name */
  Jobid = 'jobid',
  /** column name */
  ReturnMessage = 'return_message',
  /** column name */
  Runid = 'runid',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  Username = 'username'
}

export type Cron_Job_Run_Details_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cron_Job_Run_Details_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cron_Job_Run_Details_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cron_Job_Run_Details_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cron_Job_Run_Details_Var_Pop_Fields = {
  __typename?: 'cron_job_run_details_var_pop_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Cron_Job_Run_Details_Var_Samp_Fields = {
  __typename?: 'cron_job_run_details_var_samp_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Cron_Job_Run_Details_Variance_Fields = {
  __typename?: 'cron_job_run_details_variance_fields';
  job_pid?: Maybe<Scalars['Float']['output']>;
  jobid?: Maybe<Scalars['Float']['output']>;
  runid?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "cron.job" */
export enum Cron_Job_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Command = 'command',
  /** column name */
  Database = 'database',
  /** column name */
  Jobid = 'jobid',
  /** column name */
  Jobname = 'jobname',
  /** column name */
  Nodename = 'nodename',
  /** column name */
  Nodeport = 'nodeport',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "cron.job" */
export type Cron_Job_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  command?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  jobname?: InputMaybe<Scalars['String']['input']>;
  nodename?: InputMaybe<Scalars['String']['input']>;
  nodeport?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Cron_Job_Stddev_Fields = {
  __typename?: 'cron_job_stddev_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Cron_Job_Stddev_Pop_Fields = {
  __typename?: 'cron_job_stddev_pop_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Cron_Job_Stddev_Samp_Fields = {
  __typename?: 'cron_job_stddev_samp_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cron_job" */
export type Cron_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cron_Job_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cron_Job_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  command?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  jobid?: InputMaybe<Scalars['bigint']['input']>;
  jobname?: InputMaybe<Scalars['String']['input']>;
  nodename?: InputMaybe<Scalars['String']['input']>;
  nodeport?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Cron_Job_Sum_Fields = {
  __typename?: 'cron_job_sum_fields';
  jobid?: Maybe<Scalars['bigint']['output']>;
  nodeport?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "cron.job" */
export enum Cron_Job_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Command = 'command',
  /** column name */
  Database = 'database',
  /** column name */
  Jobid = 'jobid',
  /** column name */
  Jobname = 'jobname',
  /** column name */
  Nodename = 'nodename',
  /** column name */
  Nodeport = 'nodeport',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  Username = 'username'
}

export type Cron_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cron_Job_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cron_Job_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cron_Job_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cron_Job_Var_Pop_Fields = {
  __typename?: 'cron_job_var_pop_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Cron_Job_Var_Samp_Fields = {
  __typename?: 'cron_job_var_samp_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Cron_Job_Variance_Fields = {
  __typename?: 'cron_job_variance_fields';
  jobid?: Maybe<Scalars['Float']['output']>;
  nodeport?: Maybe<Scalars['Float']['output']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "enedis.consumption" */
export type Enedis_Consumption = {
  __typename?: 'enedis_consumption';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "enedis.consumption" */
export type Enedis_Consumption_Aggregate = {
  __typename?: 'enedis_consumption_aggregate';
  aggregate?: Maybe<Enedis_Consumption_Aggregate_Fields>;
  nodes: Array<Enedis_Consumption>;
};

/** aggregate fields of "enedis.consumption" */
export type Enedis_Consumption_Aggregate_Fields = {
  __typename?: 'enedis_consumption_aggregate_fields';
  avg?: Maybe<Enedis_Consumption_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Enedis_Consumption_Max_Fields>;
  min?: Maybe<Enedis_Consumption_Min_Fields>;
  stddev?: Maybe<Enedis_Consumption_Stddev_Fields>;
  stddev_pop?: Maybe<Enedis_Consumption_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enedis_Consumption_Stddev_Samp_Fields>;
  sum?: Maybe<Enedis_Consumption_Sum_Fields>;
  var_pop?: Maybe<Enedis_Consumption_Var_Pop_Fields>;
  var_samp?: Maybe<Enedis_Consumption_Var_Samp_Fields>;
  variance?: Maybe<Enedis_Consumption_Variance_Fields>;
};


/** aggregate fields of "enedis.consumption" */
export type Enedis_Consumption_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enedis_Consumption_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Enedis_Consumption_Avg_Fields = {
  __typename?: 'enedis_consumption_avg_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "enedis.consumption". All fields are combined with a logical 'AND'. */
export type Enedis_Consumption_Bool_Exp = {
  _and?: InputMaybe<Array<Enedis_Consumption_Bool_Exp>>;
  _not?: InputMaybe<Enedis_Consumption_Bool_Exp>;
  _or?: InputMaybe<Array<Enedis_Consumption_Bool_Exp>>;
  consumption_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  data_source_id?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** aggregate max on columns */
export type Enedis_Consumption_Max_Fields = {
  __typename?: 'enedis_consumption_max_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Enedis_Consumption_Min_Fields = {
  __typename?: 'enedis_consumption_min_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** Ordering options when selecting data from "enedis.consumption". */
export type Enedis_Consumption_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** select columns of table "enedis.consumption" */
export enum Enedis_Consumption_Select_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  End = 'end',
  /** column name */
  Start = 'start'
}

/** aggregate stddev on columns */
export type Enedis_Consumption_Stddev_Fields = {
  __typename?: 'enedis_consumption_stddev_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Enedis_Consumption_Stddev_Pop_Fields = {
  __typename?: 'enedis_consumption_stddev_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Enedis_Consumption_Stddev_Samp_Fields = {
  __typename?: 'enedis_consumption_stddev_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "enedis_consumption" */
export type Enedis_Consumption_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enedis_Consumption_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enedis_Consumption_Stream_Cursor_Value_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Enedis_Consumption_Sum_Fields = {
  __typename?: 'enedis_consumption_sum_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Enedis_Consumption_Var_Pop_Fields = {
  __typename?: 'enedis_consumption_var_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Enedis_Consumption_Var_Samp_Fields = {
  __typename?: 'enedis_consumption_var_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Enedis_Consumption_Variance_Fields = {
  __typename?: 'enedis_consumption_variance_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "enedis.history_raw" */
export type Enedis_History_Raw = {
  __typename?: 'enedis_history_raw';
  id: Scalars['Int']['output'];
  prm: Scalars['String']['output'];
  timestamp: Scalars['timestamp']['output'];
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "enedis.history_raw" */
export type Enedis_History_Raw_Aggregate = {
  __typename?: 'enedis_history_raw_aggregate';
  aggregate?: Maybe<Enedis_History_Raw_Aggregate_Fields>;
  nodes: Array<Enedis_History_Raw>;
};

/** aggregate fields of "enedis.history_raw" */
export type Enedis_History_Raw_Aggregate_Fields = {
  __typename?: 'enedis_history_raw_aggregate_fields';
  avg?: Maybe<Enedis_History_Raw_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Enedis_History_Raw_Max_Fields>;
  min?: Maybe<Enedis_History_Raw_Min_Fields>;
  stddev?: Maybe<Enedis_History_Raw_Stddev_Fields>;
  stddev_pop?: Maybe<Enedis_History_Raw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enedis_History_Raw_Stddev_Samp_Fields>;
  sum?: Maybe<Enedis_History_Raw_Sum_Fields>;
  var_pop?: Maybe<Enedis_History_Raw_Var_Pop_Fields>;
  var_samp?: Maybe<Enedis_History_Raw_Var_Samp_Fields>;
  variance?: Maybe<Enedis_History_Raw_Variance_Fields>;
};


/** aggregate fields of "enedis.history_raw" */
export type Enedis_History_Raw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enedis_History_Raw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Enedis_History_Raw_Avg_Fields = {
  __typename?: 'enedis_history_raw_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "enedis.history_raw". All fields are combined with a logical 'AND'. */
export type Enedis_History_Raw_Bool_Exp = {
  _and?: InputMaybe<Array<Enedis_History_Raw_Bool_Exp>>;
  _not?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
  _or?: InputMaybe<Array<Enedis_History_Raw_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  prm?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "enedis.history_raw" */
export enum Enedis_History_Raw_Constraint {
  /** unique or primary key constraint on columns "id" */
  HistoryRawPkey = 'history_raw_pkey'
}

/** input type for incrementing numeric columns in table "enedis.history_raw" */
export type Enedis_History_Raw_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "enedis.history_raw" */
export type Enedis_History_Raw_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  prm?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Enedis_History_Raw_Max_Fields = {
  __typename?: 'enedis_history_raw_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  prm?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Enedis_History_Raw_Min_Fields = {
  __typename?: 'enedis_history_raw_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  prm?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "enedis.history_raw" */
export type Enedis_History_Raw_Mutation_Response = {
  __typename?: 'enedis_history_raw_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enedis_History_Raw>;
};

/** on_conflict condition type for table "enedis.history_raw" */
export type Enedis_History_Raw_On_Conflict = {
  constraint: Enedis_History_Raw_Constraint;
  update_columns?: Array<Enedis_History_Raw_Update_Column>;
  where?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
};

/** Ordering options when selecting data from "enedis.history_raw". */
export type Enedis_History_Raw_Order_By = {
  id?: InputMaybe<Order_By>;
  prm?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enedis.history_raw */
export type Enedis_History_Raw_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "enedis.history_raw" */
export enum Enedis_History_Raw_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Prm = 'prm',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enedis.history_raw" */
export type Enedis_History_Raw_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  prm?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Enedis_History_Raw_Stddev_Fields = {
  __typename?: 'enedis_history_raw_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Enedis_History_Raw_Stddev_Pop_Fields = {
  __typename?: 'enedis_history_raw_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Enedis_History_Raw_Stddev_Samp_Fields = {
  __typename?: 'enedis_history_raw_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "enedis_history_raw" */
export type Enedis_History_Raw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enedis_History_Raw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enedis_History_Raw_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  prm?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Enedis_History_Raw_Sum_Fields = {
  __typename?: 'enedis_history_raw_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "enedis.history_raw" */
export enum Enedis_History_Raw_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Prm = 'prm',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Value = 'value'
}

export type Enedis_History_Raw_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Enedis_History_Raw_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enedis_History_Raw_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enedis_History_Raw_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Enedis_History_Raw_Var_Pop_Fields = {
  __typename?: 'enedis_history_raw_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Enedis_History_Raw_Var_Samp_Fields = {
  __typename?: 'enedis_history_raw_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Enedis_History_Raw_Variance_Fields = {
  __typename?: 'enedis_history_raw_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "enedis.minutes_raw" */
export type Enedis_Minutes_Raw = {
  __typename?: 'enedis_minutes_raw';
  business_qtty: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  import_id: Scalars['String']['output'];
  physical_qtty: Scalars['String']['output'];
  prm: Scalars['String']['output'];
  timestamp: Scalars['timestamptz']['output'];
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Aggregate = {
  __typename?: 'enedis_minutes_raw_aggregate';
  aggregate?: Maybe<Enedis_Minutes_Raw_Aggregate_Fields>;
  nodes: Array<Enedis_Minutes_Raw>;
};

/** aggregate fields of "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Aggregate_Fields = {
  __typename?: 'enedis_minutes_raw_aggregate_fields';
  avg?: Maybe<Enedis_Minutes_Raw_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Enedis_Minutes_Raw_Max_Fields>;
  min?: Maybe<Enedis_Minutes_Raw_Min_Fields>;
  stddev?: Maybe<Enedis_Minutes_Raw_Stddev_Fields>;
  stddev_pop?: Maybe<Enedis_Minutes_Raw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enedis_Minutes_Raw_Stddev_Samp_Fields>;
  sum?: Maybe<Enedis_Minutes_Raw_Sum_Fields>;
  var_pop?: Maybe<Enedis_Minutes_Raw_Var_Pop_Fields>;
  var_samp?: Maybe<Enedis_Minutes_Raw_Var_Samp_Fields>;
  variance?: Maybe<Enedis_Minutes_Raw_Variance_Fields>;
};


/** aggregate fields of "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enedis_Minutes_Raw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Enedis_Minutes_Raw_Avg_Fields = {
  __typename?: 'enedis_minutes_raw_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "enedis.minutes_raw". All fields are combined with a logical 'AND'. */
export type Enedis_Minutes_Raw_Bool_Exp = {
  _and?: InputMaybe<Array<Enedis_Minutes_Raw_Bool_Exp>>;
  _not?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
  _or?: InputMaybe<Array<Enedis_Minutes_Raw_Bool_Exp>>;
  business_qtty?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  import_id?: InputMaybe<String_Comparison_Exp>;
  physical_qtty?: InputMaybe<String_Comparison_Exp>;
  prm?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "enedis.minutes_raw" */
export enum Enedis_Minutes_Raw_Constraint {
  /** unique or primary key constraint on columns "id" */
  MinutesRawPkey = 'minutes_raw_pkey'
}

/** input type for incrementing numeric columns in table "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Insert_Input = {
  business_qtty?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  import_id?: InputMaybe<Scalars['String']['input']>;
  physical_qtty?: InputMaybe<Scalars['String']['input']>;
  prm?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Enedis_Minutes_Raw_Max_Fields = {
  __typename?: 'enedis_minutes_raw_max_fields';
  business_qtty?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  import_id?: Maybe<Scalars['String']['output']>;
  physical_qtty?: Maybe<Scalars['String']['output']>;
  prm?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Enedis_Minutes_Raw_Min_Fields = {
  __typename?: 'enedis_minutes_raw_min_fields';
  business_qtty?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  import_id?: Maybe<Scalars['String']['output']>;
  physical_qtty?: Maybe<Scalars['String']['output']>;
  prm?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Mutation_Response = {
  __typename?: 'enedis_minutes_raw_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enedis_Minutes_Raw>;
};

/** on_conflict condition type for table "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_On_Conflict = {
  constraint: Enedis_Minutes_Raw_Constraint;
  update_columns?: Array<Enedis_Minutes_Raw_Update_Column>;
  where?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
};

/** Ordering options when selecting data from "enedis.minutes_raw". */
export type Enedis_Minutes_Raw_Order_By = {
  business_qtty?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  import_id?: InputMaybe<Order_By>;
  physical_qtty?: InputMaybe<Order_By>;
  prm?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enedis.minutes_raw */
export type Enedis_Minutes_Raw_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "enedis.minutes_raw" */
export enum Enedis_Minutes_Raw_Select_Column {
  /** column name */
  BusinessQtty = 'business_qtty',
  /** column name */
  Id = 'id',
  /** column name */
  ImportId = 'import_id',
  /** column name */
  PhysicalQtty = 'physical_qtty',
  /** column name */
  Prm = 'prm',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enedis.minutes_raw" */
export type Enedis_Minutes_Raw_Set_Input = {
  business_qtty?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  import_id?: InputMaybe<Scalars['String']['input']>;
  physical_qtty?: InputMaybe<Scalars['String']['input']>;
  prm?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Enedis_Minutes_Raw_Stddev_Fields = {
  __typename?: 'enedis_minutes_raw_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Enedis_Minutes_Raw_Stddev_Pop_Fields = {
  __typename?: 'enedis_minutes_raw_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Enedis_Minutes_Raw_Stddev_Samp_Fields = {
  __typename?: 'enedis_minutes_raw_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "enedis_minutes_raw" */
export type Enedis_Minutes_Raw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enedis_Minutes_Raw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enedis_Minutes_Raw_Stream_Cursor_Value_Input = {
  business_qtty?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  import_id?: InputMaybe<Scalars['String']['input']>;
  physical_qtty?: InputMaybe<Scalars['String']['input']>;
  prm?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Enedis_Minutes_Raw_Sum_Fields = {
  __typename?: 'enedis_minutes_raw_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "enedis.minutes_raw" */
export enum Enedis_Minutes_Raw_Update_Column {
  /** column name */
  BusinessQtty = 'business_qtty',
  /** column name */
  Id = 'id',
  /** column name */
  ImportId = 'import_id',
  /** column name */
  PhysicalQtty = 'physical_qtty',
  /** column name */
  Prm = 'prm',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

export type Enedis_Minutes_Raw_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Enedis_Minutes_Raw_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enedis_Minutes_Raw_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enedis_Minutes_Raw_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Enedis_Minutes_Raw_Var_Pop_Fields = {
  __typename?: 'enedis_minutes_raw_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Enedis_Minutes_Raw_Var_Samp_Fields = {
  __typename?: 'enedis_minutes_raw_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Enedis_Minutes_Raw_Variance_Fields = {
  __typename?: 'enedis_minutes_raw_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "energy_types" */
export type Energy_Types = {
  __typename?: 'energy_types';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  contracts: Array<Contracts>;
  /** An aggregate relationship */
  contracts_aggregate: Contracts_Aggregate;
  /** An array relationship */
  meter_types: Array<Meter_Types>;
  /** An aggregate relationship */
  meter_types_aggregate: Meter_Types_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "energy_types" */
export type Energy_TypesContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


/** columns and relationships of "energy_types" */
export type Energy_TypesContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


/** columns and relationships of "energy_types" */
export type Energy_TypesMeter_TypesArgs = {
  distinct_on?: InputMaybe<Array<Meter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Types_Order_By>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};


/** columns and relationships of "energy_types" */
export type Energy_TypesMeter_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Types_Order_By>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};

/** aggregated selection of "energy_types" */
export type Energy_Types_Aggregate = {
  __typename?: 'energy_types_aggregate';
  aggregate?: Maybe<Energy_Types_Aggregate_Fields>;
  nodes: Array<Energy_Types>;
};

/** aggregate fields of "energy_types" */
export type Energy_Types_Aggregate_Fields = {
  __typename?: 'energy_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Types_Max_Fields>;
  min?: Maybe<Energy_Types_Min_Fields>;
};


/** aggregate fields of "energy_types" */
export type Energy_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_types". All fields are combined with a logical 'AND'. */
export type Energy_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Types_Bool_Exp>>;
  _not?: InputMaybe<Energy_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  contracts?: InputMaybe<Contracts_Bool_Exp>;
  contracts_aggregate?: InputMaybe<Contracts_Aggregate_Bool_Exp>;
  meter_types?: InputMaybe<Meter_Types_Bool_Exp>;
  meter_types_aggregate?: InputMaybe<Meter_Types_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_types" */
export enum Energy_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnergyTypesPkey = 'energy_types_pkey'
}

export enum Energy_Types_Enum {
  Electricity = 'Electricity',
  Gas = 'Gas',
  Water = 'Water'
}

/** Boolean expression to compare columns of type "energy_types_enum". All fields are combined with logical 'AND'. */
export type Energy_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Types_Enum>;
  _in?: InputMaybe<Array<Energy_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Types_Enum>;
  _nin?: InputMaybe<Array<Energy_Types_Enum>>;
};

/** input type for inserting data into table "energy_types" */
export type Energy_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contracts?: InputMaybe<Contracts_Arr_Rel_Insert_Input>;
  meter_types?: InputMaybe<Meter_Types_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Types_Max_Fields = {
  __typename?: 'energy_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Types_Min_Fields = {
  __typename?: 'energy_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_types" */
export type Energy_Types_Mutation_Response = {
  __typename?: 'energy_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Types>;
};

/** on_conflict condition type for table "energy_types" */
export type Energy_Types_On_Conflict = {
  constraint: Energy_Types_Constraint;
  update_columns?: Array<Energy_Types_Update_Column>;
  where?: InputMaybe<Energy_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_types". */
export type Energy_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  contracts_aggregate?: InputMaybe<Contracts_Aggregate_Order_By>;
  meter_types_aggregate?: InputMaybe<Meter_Types_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_types */
export type Energy_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "energy_types" */
export enum Energy_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "energy_types" */
export type Energy_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_types" */
export type Energy_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_types" */
export enum Energy_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Energy_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Types_Bool_Exp;
};

/** columns and relationships of "energy_use_types" */
export type Energy_Use_Types = {
  __typename?: 'energy_use_types';
  logo_key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "energy_use_types" */
export type Energy_Use_Types_Aggregate = {
  __typename?: 'energy_use_types_aggregate';
  aggregate?: Maybe<Energy_Use_Types_Aggregate_Fields>;
  nodes: Array<Energy_Use_Types>;
};

/** aggregate fields of "energy_use_types" */
export type Energy_Use_Types_Aggregate_Fields = {
  __typename?: 'energy_use_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Energy_Use_Types_Max_Fields>;
  min?: Maybe<Energy_Use_Types_Min_Fields>;
};


/** aggregate fields of "energy_use_types" */
export type Energy_Use_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Use_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "energy_use_types". All fields are combined with a logical 'AND'. */
export type Energy_Use_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Use_Types_Bool_Exp>>;
  _not?: InputMaybe<Energy_Use_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Energy_Use_Types_Bool_Exp>>;
  logo_key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "energy_use_types" */
export enum Energy_Use_Types_Constraint {
  /** unique or primary key constraint on columns "logo_key" */
  EnergyUseTypesLogoKeyKey = 'energy_use_types_logo_key_key',
  /** unique or primary key constraint on columns "name" */
  EnergyUseTypesPkey = 'energy_use_types_pkey'
}

export enum Energy_Use_Types_Enum {
  /** wind */
  CompressedAirProduction = 'compressed_air_production',
  /** air-vent */
  Drying = 'drying',
  /** factory */
  FactoryHvac = 'factory_hvac',
  /** bubbles */
  Fermentation = 'fermentation',
  /** heater */
  HotWaterProduction = 'hot_water_production',
  /** truck */
  InternalTransport = 'internal_transport',
  /** lightbulb */
  Lighting = 'lighting',
  /** thermometer */
  OfficeHvac = 'office_hvac',
  /** flame */
  Roasting = 'roasting',
  /** cog */
  WinnowingGrindingMoulding = 'winnowing_grinding_moulding'
}

/** Boolean expression to compare columns of type "energy_use_types_enum". All fields are combined with logical 'AND'. */
export type Energy_Use_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Use_Types_Enum>;
  _in?: InputMaybe<Array<Energy_Use_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Use_Types_Enum>;
  _nin?: InputMaybe<Array<Energy_Use_Types_Enum>>;
};

/** input type for inserting data into table "energy_use_types" */
export type Energy_Use_Types_Insert_Input = {
  logo_key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Energy_Use_Types_Max_Fields = {
  __typename?: 'energy_use_types_max_fields';
  logo_key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Energy_Use_Types_Min_Fields = {
  __typename?: 'energy_use_types_min_fields';
  logo_key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "energy_use_types" */
export type Energy_Use_Types_Mutation_Response = {
  __typename?: 'energy_use_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Use_Types>;
};

/** on_conflict condition type for table "energy_use_types" */
export type Energy_Use_Types_On_Conflict = {
  constraint: Energy_Use_Types_Constraint;
  update_columns?: Array<Energy_Use_Types_Update_Column>;
  where?: InputMaybe<Energy_Use_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "energy_use_types". */
export type Energy_Use_Types_Order_By = {
  logo_key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: energy_use_types */
export type Energy_Use_Types_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "energy_use_types" */
export enum Energy_Use_Types_Select_Column {
  /** column name */
  LogoKey = 'logo_key',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "energy_use_types" */
export type Energy_Use_Types_Set_Input = {
  logo_key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "energy_use_types" */
export type Energy_Use_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Use_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Energy_Use_Types_Stream_Cursor_Value_Input = {
  logo_key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "energy_use_types" */
export enum Energy_Use_Types_Update_Column {
  /** column name */
  LogoKey = 'logo_key',
  /** column name */
  Name = 'name'
}

export type Energy_Use_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Use_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Energy_Use_Types_Bool_Exp;
};

/** columns and relationships of "fabrication_order_epi" */
export type Fabrication_Order_Epi = {
  __typename?: 'fabrication_order_epi';
  consumption_kwh: Scalars['numeric']['output'];
  cost: Scalars['numeric']['output'];
  cost_by_quantity: Scalars['numeric']['output'];
  epi: Scalars['numeric']['output'];
  /** An object relationship */
  fabrication_order?: Maybe<Fabrication_Orders>;
  fabrication_order_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter?: Maybe<Meters>;
  meter_id: Scalars['Int']['output'];
};

/** aggregated selection of "fabrication_order_epi" */
export type Fabrication_Order_Epi_Aggregate = {
  __typename?: 'fabrication_order_epi_aggregate';
  aggregate?: Maybe<Fabrication_Order_Epi_Aggregate_Fields>;
  nodes: Array<Fabrication_Order_Epi>;
};

export type Fabrication_Order_Epi_Aggregate_Bool_Exp = {
  count?: InputMaybe<Fabrication_Order_Epi_Aggregate_Bool_Exp_Count>;
};

export type Fabrication_Order_Epi_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fabrication_order_epi" */
export type Fabrication_Order_Epi_Aggregate_Fields = {
  __typename?: 'fabrication_order_epi_aggregate_fields';
  avg?: Maybe<Fabrication_Order_Epi_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fabrication_Order_Epi_Max_Fields>;
  min?: Maybe<Fabrication_Order_Epi_Min_Fields>;
  stddev?: Maybe<Fabrication_Order_Epi_Stddev_Fields>;
  stddev_pop?: Maybe<Fabrication_Order_Epi_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fabrication_Order_Epi_Stddev_Samp_Fields>;
  sum?: Maybe<Fabrication_Order_Epi_Sum_Fields>;
  var_pop?: Maybe<Fabrication_Order_Epi_Var_Pop_Fields>;
  var_samp?: Maybe<Fabrication_Order_Epi_Var_Samp_Fields>;
  variance?: Maybe<Fabrication_Order_Epi_Variance_Fields>;
};


/** aggregate fields of "fabrication_order_epi" */
export type Fabrication_Order_Epi_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Aggregate_Order_By = {
  avg?: InputMaybe<Fabrication_Order_Epi_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fabrication_Order_Epi_Max_Order_By>;
  min?: InputMaybe<Fabrication_Order_Epi_Min_Order_By>;
  stddev?: InputMaybe<Fabrication_Order_Epi_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fabrication_Order_Epi_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fabrication_Order_Epi_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fabrication_Order_Epi_Sum_Order_By>;
  var_pop?: InputMaybe<Fabrication_Order_Epi_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fabrication_Order_Epi_Var_Samp_Order_By>;
  variance?: InputMaybe<Fabrication_Order_Epi_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Arr_Rel_Insert_Input = {
  data: Array<Fabrication_Order_Epi_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fabrication_Order_Epi_On_Conflict>;
};

/** aggregate avg on columns */
export type Fabrication_Order_Epi_Avg_Fields = {
  __typename?: 'fabrication_order_epi_avg_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Avg_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fabrication_order_epi". All fields are combined with a logical 'AND'. */
export type Fabrication_Order_Epi_Bool_Exp = {
  _and?: InputMaybe<Array<Fabrication_Order_Epi_Bool_Exp>>;
  _not?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
  _or?: InputMaybe<Array<Fabrication_Order_Epi_Bool_Exp>>;
  consumption_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  cost_by_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  epi?: InputMaybe<Numeric_Comparison_Exp>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  fabrication_order_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "fabrication_order_epi" */
export enum Fabrication_Order_Epi_Constraint {
  /** unique or primary key constraint on columns "fabrication_order_id", "meter_id" */
  FabricationOrderEpiFabricationOrderIdMeterIdKey = 'fabrication_order_epi_fabrication_order_id_meter_id_key',
  /** unique or primary key constraint on columns "id" */
  FabricationOrderEpiIdKey = 'fabrication_order_epi_id_key',
  /** unique or primary key constraint on columns "id" */
  FabricationOrderEpiPkey = 'fabrication_order_epi_pkey'
}

/** input type for incrementing numeric columns in table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Inc_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  cost_by_quantity?: InputMaybe<Scalars['numeric']['input']>;
  epi?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Insert_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  cost_by_quantity?: InputMaybe<Scalars['numeric']['input']>;
  epi?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Obj_Rel_Insert_Input>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Fabrication_Order_Epi_Max_Fields = {
  __typename?: 'fabrication_order_epi_max_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  cost_by_quantity?: Maybe<Scalars['numeric']['output']>;
  epi?: Maybe<Scalars['numeric']['output']>;
  fabrication_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Max_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fabrication_Order_Epi_Min_Fields = {
  __typename?: 'fabrication_order_epi_min_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  cost_by_quantity?: Maybe<Scalars['numeric']['output']>;
  epi?: Maybe<Scalars['numeric']['output']>;
  fabrication_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Min_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Mutation_Response = {
  __typename?: 'fabrication_order_epi_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fabrication_Order_Epi>;
};

/** on_conflict condition type for table "fabrication_order_epi" */
export type Fabrication_Order_Epi_On_Conflict = {
  constraint: Fabrication_Order_Epi_Constraint;
  update_columns?: Array<Fabrication_Order_Epi_Update_Column>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};

/** Ordering options when selecting data from "fabrication_order_epi". */
export type Fabrication_Order_Epi_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fabrication_order_epi */
export type Fabrication_Order_Epi_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "fabrication_order_epi" */
export enum Fabrication_Order_Epi_Select_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostByQuantity = 'cost_by_quantity',
  /** column name */
  Epi = 'epi',
  /** column name */
  FabricationOrderId = 'fabrication_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id'
}

/** input type for updating data in table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Set_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  cost_by_quantity?: InputMaybe<Scalars['numeric']['input']>;
  epi?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Fabrication_Order_Epi_Stddev_Fields = {
  __typename?: 'fabrication_order_epi_stddev_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Stddev_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fabrication_Order_Epi_Stddev_Pop_Fields = {
  __typename?: 'fabrication_order_epi_stddev_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Stddev_Pop_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fabrication_Order_Epi_Stddev_Samp_Fields = {
  __typename?: 'fabrication_order_epi_stddev_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Stddev_Samp_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fabrication_Order_Epi_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fabrication_Order_Epi_Stream_Cursor_Value_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  cost_by_quantity?: InputMaybe<Scalars['numeric']['input']>;
  epi?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Fabrication_Order_Epi_Sum_Fields = {
  __typename?: 'fabrication_order_epi_sum_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  cost_by_quantity?: Maybe<Scalars['numeric']['output']>;
  epi?: Maybe<Scalars['numeric']['output']>;
  fabrication_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Sum_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** update columns of table "fabrication_order_epi" */
export enum Fabrication_Order_Epi_Update_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostByQuantity = 'cost_by_quantity',
  /** column name */
  Epi = 'epi',
  /** column name */
  FabricationOrderId = 'fabrication_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id'
}

export type Fabrication_Order_Epi_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fabrication_Order_Epi_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fabrication_Order_Epi_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fabrication_Order_Epi_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fabrication_Order_Epi_Var_Pop_Fields = {
  __typename?: 'fabrication_order_epi_var_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Var_Pop_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fabrication_Order_Epi_Var_Samp_Fields = {
  __typename?: 'fabrication_order_epi_var_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Var_Samp_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fabrication_Order_Epi_Variance_Fields = {
  __typename?: 'fabrication_order_epi_variance_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  cost_by_quantity?: Maybe<Scalars['Float']['output']>;
  epi?: Maybe<Scalars['Float']['output']>;
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "fabrication_order_epi" */
export type Fabrication_Order_Epi_Variance_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  cost_by_quantity?: InputMaybe<Order_By>;
  epi?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "fabrication_order_product" */
export type Fabrication_Order_Product = {
  __typename?: 'fabrication_order_product';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  fabrication_order?: Maybe<Fabrication_Orders>;
  fabrication_order_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  product?: Maybe<Products>;
  product_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "fabrication_order_product" */
export type Fabrication_Order_Product_Aggregate = {
  __typename?: 'fabrication_order_product_aggregate';
  aggregate?: Maybe<Fabrication_Order_Product_Aggregate_Fields>;
  nodes: Array<Fabrication_Order_Product>;
};

export type Fabrication_Order_Product_Aggregate_Bool_Exp = {
  count?: InputMaybe<Fabrication_Order_Product_Aggregate_Bool_Exp_Count>;
};

export type Fabrication_Order_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fabrication_order_product" */
export type Fabrication_Order_Product_Aggregate_Fields = {
  __typename?: 'fabrication_order_product_aggregate_fields';
  avg?: Maybe<Fabrication_Order_Product_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fabrication_Order_Product_Max_Fields>;
  min?: Maybe<Fabrication_Order_Product_Min_Fields>;
  stddev?: Maybe<Fabrication_Order_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Fabrication_Order_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fabrication_Order_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Fabrication_Order_Product_Sum_Fields>;
  var_pop?: Maybe<Fabrication_Order_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Fabrication_Order_Product_Var_Samp_Fields>;
  variance?: Maybe<Fabrication_Order_Product_Variance_Fields>;
};


/** aggregate fields of "fabrication_order_product" */
export type Fabrication_Order_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "fabrication_order_product" */
export type Fabrication_Order_Product_Aggregate_Order_By = {
  avg?: InputMaybe<Fabrication_Order_Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fabrication_Order_Product_Max_Order_By>;
  min?: InputMaybe<Fabrication_Order_Product_Min_Order_By>;
  stddev?: InputMaybe<Fabrication_Order_Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fabrication_Order_Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fabrication_Order_Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fabrication_Order_Product_Sum_Order_By>;
  var_pop?: InputMaybe<Fabrication_Order_Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fabrication_Order_Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Fabrication_Order_Product_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fabrication_order_product" */
export type Fabrication_Order_Product_Arr_Rel_Insert_Input = {
  data: Array<Fabrication_Order_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fabrication_Order_Product_On_Conflict>;
};

/** aggregate avg on columns */
export type Fabrication_Order_Product_Avg_Fields = {
  __typename?: 'fabrication_order_product_avg_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Avg_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fabrication_order_product". All fields are combined with a logical 'AND'. */
export type Fabrication_Order_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Fabrication_Order_Product_Bool_Exp>>;
  _not?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Fabrication_Order_Product_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  fabrication_order_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fabrication_order_product" */
export enum Fabrication_Order_Product_Constraint {
  /** unique or primary key constraint on columns "product_id", "fabrication_order_id" */
  FabricationOrderProductFabricationOrderIdProductIdKey = 'fabrication_order_product_fabrication_order_id_product_id_key',
  /** unique or primary key constraint on columns "id" */
  FabricationOrderProductPkey = 'fabrication_order_product_pkey'
}

/** input type for incrementing numeric columns in table "fabrication_order_product" */
export type Fabrication_Order_Product_Inc_Input = {
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "fabrication_order_product" */
export type Fabrication_Order_Product_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Obj_Rel_Insert_Input>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Fabrication_Order_Product_Max_Fields = {
  __typename?: 'fabrication_order_product_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  fabrication_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fabrication_Order_Product_Min_Fields = {
  __typename?: 'fabrication_order_product_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  fabrication_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fabrication_order_product" */
export type Fabrication_Order_Product_Mutation_Response = {
  __typename?: 'fabrication_order_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fabrication_Order_Product>;
};

/** on_conflict condition type for table "fabrication_order_product" */
export type Fabrication_Order_Product_On_Conflict = {
  constraint: Fabrication_Order_Product_Constraint;
  update_columns?: Array<Fabrication_Order_Product_Update_Column>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "fabrication_order_product". */
export type Fabrication_Order_Product_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Order_By>;
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fabrication_order_product */
export type Fabrication_Order_Product_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "fabrication_order_product" */
export enum Fabrication_Order_Product_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FabricationOrderId = 'fabrication_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "fabrication_order_product" */
export type Fabrication_Order_Product_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Fabrication_Order_Product_Stddev_Fields = {
  __typename?: 'fabrication_order_product_stddev_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Stddev_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fabrication_Order_Product_Stddev_Pop_Fields = {
  __typename?: 'fabrication_order_product_stddev_pop_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Stddev_Pop_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fabrication_Order_Product_Stddev_Samp_Fields = {
  __typename?: 'fabrication_order_product_stddev_samp_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Stddev_Samp_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fabrication_order_product" */
export type Fabrication_Order_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fabrication_Order_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fabrication_Order_Product_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Fabrication_Order_Product_Sum_Fields = {
  __typename?: 'fabrication_order_product_sum_fields';
  fabrication_order_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Sum_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** update columns of table "fabrication_order_product" */
export enum Fabrication_Order_Product_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FabricationOrderId = 'fabrication_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Fabrication_Order_Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fabrication_Order_Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fabrication_Order_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fabrication_Order_Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fabrication_Order_Product_Var_Pop_Fields = {
  __typename?: 'fabrication_order_product_var_pop_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Var_Pop_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fabrication_Order_Product_Var_Samp_Fields = {
  __typename?: 'fabrication_order_product_var_samp_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Var_Samp_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fabrication_Order_Product_Variance_Fields = {
  __typename?: 'fabrication_order_product_variance_fields';
  fabrication_order_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "fabrication_order_product" */
export type Fabrication_Order_Product_Variance_Order_By = {
  fabrication_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "fabrication_orders" */
export type Fabrication_Orders = {
  __typename?: 'fabrication_orders';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by: Scalars['String']['output'];
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id: Scalars['Int']['output'];
  client_fabrication_order_id?: Maybe<Scalars['String']['output']>;
  end: Scalars['timestamp']['output'];
  /** An array relationship */
  fabrication_order_epis: Array<Fabrication_Order_Epi>;
  /** An aggregate relationship */
  fabrication_order_epis_aggregate: Fabrication_Order_Epi_Aggregate;
  /** An array relationship */
  fabrication_order_products: Array<Fabrication_Order_Product>;
  /** An aggregate relationship */
  fabrication_order_products_aggregate: Fabrication_Order_Product_Aggregate;
  firebase_id?: Maybe<Scalars['String']['output']>;
  has_up_to_date_epi: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  ofs_by_days: Array<Ofs_By_Day>;
  /** An aggregate relationship */
  ofs_by_days_aggregate: Ofs_By_Day_Aggregate;
  quantity: Scalars['numeric']['output'];
  start: Scalars['timestamp']['output'];
};


/** columns and relationships of "fabrication_orders" */
export type Fabrication_OrdersFabrication_Order_EpisArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


/** columns and relationships of "fabrication_orders" */
export type Fabrication_OrdersFabrication_Order_Epis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


/** columns and relationships of "fabrication_orders" */
export type Fabrication_OrdersFabrication_Order_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


/** columns and relationships of "fabrication_orders" */
export type Fabrication_OrdersFabrication_Order_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


/** columns and relationships of "fabrication_orders" */
export type Fabrication_OrdersOfs_By_DaysArgs = {
  distinct_on?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ofs_By_Day_Order_By>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};


/** columns and relationships of "fabrication_orders" */
export type Fabrication_OrdersOfs_By_Days_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ofs_By_Day_Order_By>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};

/** aggregated selection of "fabrication_orders" */
export type Fabrication_Orders_Aggregate = {
  __typename?: 'fabrication_orders_aggregate';
  aggregate?: Maybe<Fabrication_Orders_Aggregate_Fields>;
  nodes: Array<Fabrication_Orders>;
};

export type Fabrication_Orders_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Fabrication_Orders_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Fabrication_Orders_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Fabrication_Orders_Aggregate_Bool_Exp_Count>;
};

export type Fabrication_Orders_Aggregate_Bool_Exp_Bool_And = {
  arguments: Fabrication_Orders_Select_Column_Fabrication_Orders_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fabrication_Orders_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Fabrication_Orders_Select_Column_Fabrication_Orders_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fabrication_Orders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fabrication_orders" */
export type Fabrication_Orders_Aggregate_Fields = {
  __typename?: 'fabrication_orders_aggregate_fields';
  avg?: Maybe<Fabrication_Orders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fabrication_Orders_Max_Fields>;
  min?: Maybe<Fabrication_Orders_Min_Fields>;
  stddev?: Maybe<Fabrication_Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Fabrication_Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fabrication_Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Fabrication_Orders_Sum_Fields>;
  var_pop?: Maybe<Fabrication_Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Fabrication_Orders_Var_Samp_Fields>;
  variance?: Maybe<Fabrication_Orders_Variance_Fields>;
};


/** aggregate fields of "fabrication_orders" */
export type Fabrication_Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "fabrication_orders" */
export type Fabrication_Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Fabrication_Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fabrication_Orders_Max_Order_By>;
  min?: InputMaybe<Fabrication_Orders_Min_Order_By>;
  stddev?: InputMaybe<Fabrication_Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fabrication_Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fabrication_Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fabrication_Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Fabrication_Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fabrication_Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Fabrication_Orders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fabrication_orders" */
export type Fabrication_Orders_Arr_Rel_Insert_Input = {
  data: Array<Fabrication_Orders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fabrication_Orders_On_Conflict>;
};

/** aggregate avg on columns */
export type Fabrication_Orders_Avg_Fields = {
  __typename?: 'fabrication_orders_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Avg_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fabrication_orders". All fields are combined with a logical 'AND'. */
export type Fabrication_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Fabrication_Orders_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Fabrication_Orders_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  client_fabrication_order_id?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  fabrication_order_epis?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
  fabrication_order_epis_aggregate?: InputMaybe<Fabrication_Order_Epi_Aggregate_Bool_Exp>;
  fabrication_order_products?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
  fabrication_order_products_aggregate?: InputMaybe<Fabrication_Order_Product_Aggregate_Bool_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  has_up_to_date_epi?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ofs_by_days?: InputMaybe<Ofs_By_Day_Bool_Exp>;
  ofs_by_days_aggregate?: InputMaybe<Ofs_By_Day_Aggregate_Bool_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "fabrication_orders" */
export enum Fabrication_Orders_Constraint {
  /** unique or primary key constraint on columns "client_fabrication_order_id" */
  FabricationOrdersClientFabricationOrderIdKey = 'fabrication_orders_client_fabrication_order_id_key',
  /** unique or primary key constraint on columns "id" */
  FabricationOrdersPkey = 'fabrication_orders_pkey'
}

/** input type for incrementing numeric columns in table "fabrication_orders" */
export type Fabrication_Orders_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "fabrication_orders" */
export type Fabrication_Orders_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  client_fabrication_order_id?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  fabrication_order_epis?: InputMaybe<Fabrication_Order_Epi_Arr_Rel_Insert_Input>;
  fabrication_order_products?: InputMaybe<Fabrication_Order_Product_Arr_Rel_Insert_Input>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  has_up_to_date_epi?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ofs_by_days?: InputMaybe<Ofs_By_Day_Arr_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Fabrication_Orders_Max_Fields = {
  __typename?: 'fabrication_orders_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  client_fabrication_order_id?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  client_fabrication_order_id?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fabrication_Orders_Min_Fields = {
  __typename?: 'fabrication_orders_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  client_fabrication_order_id?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  client_fabrication_order_id?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fabrication_orders" */
export type Fabrication_Orders_Mutation_Response = {
  __typename?: 'fabrication_orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Fabrication_Orders>;
};

/** input type for inserting object relation for remote table "fabrication_orders" */
export type Fabrication_Orders_Obj_Rel_Insert_Input = {
  data: Fabrication_Orders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fabrication_Orders_On_Conflict>;
};

/** on_conflict condition type for table "fabrication_orders" */
export type Fabrication_Orders_On_Conflict = {
  constraint: Fabrication_Orders_Constraint;
  update_columns?: Array<Fabrication_Orders_Update_Column>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "fabrication_orders". */
export type Fabrication_Orders_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  client_fabrication_order_id?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  fabrication_order_epis_aggregate?: InputMaybe<Fabrication_Order_Epi_Aggregate_Order_By>;
  fabrication_order_products_aggregate?: InputMaybe<Fabrication_Order_Product_Aggregate_Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  has_up_to_date_epi?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ofs_by_days_aggregate?: InputMaybe<Ofs_By_Day_Aggregate_Order_By>;
  quantity?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fabrication_orders */
export type Fabrication_Orders_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "fabrication_orders" */
export enum Fabrication_Orders_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  ClientFabricationOrderId = 'client_fabrication_order_id',
  /** column name */
  End = 'end',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  HasUpToDateEpi = 'has_up_to_date_epi',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Start = 'start'
}

/** select "fabrication_orders_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fabrication_orders" */
export enum Fabrication_Orders_Select_Column_Fabrication_Orders_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasUpToDateEpi = 'has_up_to_date_epi'
}

/** select "fabrication_orders_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fabrication_orders" */
export enum Fabrication_Orders_Select_Column_Fabrication_Orders_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasUpToDateEpi = 'has_up_to_date_epi'
}

/** input type for updating data in table "fabrication_orders" */
export type Fabrication_Orders_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  client_fabrication_order_id?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  has_up_to_date_epi?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Fabrication_Orders_Stddev_Fields = {
  __typename?: 'fabrication_orders_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Stddev_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fabrication_Orders_Stddev_Pop_Fields = {
  __typename?: 'fabrication_orders_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Stddev_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fabrication_Orders_Stddev_Samp_Fields = {
  __typename?: 'fabrication_orders_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Stddev_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fabrication_orders" */
export type Fabrication_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fabrication_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fabrication_Orders_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  client_fabrication_order_id?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  has_up_to_date_epi?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Fabrication_Orders_Sum_Fields = {
  __typename?: 'fabrication_orders_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Sum_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "fabrication_orders" */
export enum Fabrication_Orders_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  ClientFabricationOrderId = 'client_fabrication_order_id',
  /** column name */
  End = 'end',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  HasUpToDateEpi = 'has_up_to_date_epi',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Start = 'start'
}

export type Fabrication_Orders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fabrication_Orders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fabrication_Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fabrication_Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fabrication_Orders_Var_Pop_Fields = {
  __typename?: 'fabrication_orders_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Var_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fabrication_Orders_Var_Samp_Fields = {
  __typename?: 'fabrication_orders_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Var_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fabrication_Orders_Variance_Fields = {
  __typename?: 'fabrication_orders_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "fabrication_orders" */
export type Fabrication_Orders_Variance_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

export type Get_Aggregated_Consumption_Args = {
  end?: InputMaybe<Scalars['timestamp']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  minutes_interval?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

export type Get_Aggregated_Consumption_From_Array_Args = {
  end?: InputMaybe<Scalars['timestamp']['input']>;
  meter_ids?: InputMaybe<Scalars['_int4']['input']>;
  minutes_interval?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "incident_closing_reasons" */
export type Incident_Closing_Reasons = {
  __typename?: 'incident_closing_reasons';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "incident_closing_reasons" */
export type Incident_Closing_Reasons_Aggregate = {
  __typename?: 'incident_closing_reasons_aggregate';
  aggregate?: Maybe<Incident_Closing_Reasons_Aggregate_Fields>;
  nodes: Array<Incident_Closing_Reasons>;
};

/** aggregate fields of "incident_closing_reasons" */
export type Incident_Closing_Reasons_Aggregate_Fields = {
  __typename?: 'incident_closing_reasons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incident_Closing_Reasons_Max_Fields>;
  min?: Maybe<Incident_Closing_Reasons_Min_Fields>;
};


/** aggregate fields of "incident_closing_reasons" */
export type Incident_Closing_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incident_Closing_Reasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "incident_closing_reasons". All fields are combined with a logical 'AND'. */
export type Incident_Closing_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Incident_Closing_Reasons_Bool_Exp>>;
  _not?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
  _or?: InputMaybe<Array<Incident_Closing_Reasons_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "incident_closing_reasons" */
export enum Incident_Closing_Reasons_Constraint {
  /** unique or primary key constraint on columns "value" */
  IncidentClosingReasonsPkey = 'incident_closing_reasons_pkey'
}

export enum Incident_Closing_Reasons_Enum {
  Duplicate = 'duplicate',
  NotRealIncident = 'not_real_incident',
  Other = 'other'
}

/** Boolean expression to compare columns of type "incident_closing_reasons_enum". All fields are combined with logical 'AND'. */
export type Incident_Closing_Reasons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Incident_Closing_Reasons_Enum>;
  _in?: InputMaybe<Array<Incident_Closing_Reasons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Incident_Closing_Reasons_Enum>;
  _nin?: InputMaybe<Array<Incident_Closing_Reasons_Enum>>;
};

/** input type for inserting data into table "incident_closing_reasons" */
export type Incident_Closing_Reasons_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Incident_Closing_Reasons_Max_Fields = {
  __typename?: 'incident_closing_reasons_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Incident_Closing_Reasons_Min_Fields = {
  __typename?: 'incident_closing_reasons_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "incident_closing_reasons" */
export type Incident_Closing_Reasons_Mutation_Response = {
  __typename?: 'incident_closing_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incident_Closing_Reasons>;
};

/** on_conflict condition type for table "incident_closing_reasons" */
export type Incident_Closing_Reasons_On_Conflict = {
  constraint: Incident_Closing_Reasons_Constraint;
  update_columns?: Array<Incident_Closing_Reasons_Update_Column>;
  where?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
};

/** Ordering options when selecting data from "incident_closing_reasons". */
export type Incident_Closing_Reasons_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incident_closing_reasons */
export type Incident_Closing_Reasons_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "incident_closing_reasons" */
export enum Incident_Closing_Reasons_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "incident_closing_reasons" */
export type Incident_Closing_Reasons_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "incident_closing_reasons" */
export type Incident_Closing_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incident_Closing_Reasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incident_Closing_Reasons_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "incident_closing_reasons" */
export enum Incident_Closing_Reasons_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Incident_Closing_Reasons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incident_Closing_Reasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incident_Closing_Reasons_Bool_Exp;
};

/** columns and relationships of "incident_project" */
export type Incident_Project = {
  __typename?: 'incident_project';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  incident: Incidents;
  incident_id: Scalars['Int']['output'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['Int']['output'];
};

/** aggregated selection of "incident_project" */
export type Incident_Project_Aggregate = {
  __typename?: 'incident_project_aggregate';
  aggregate?: Maybe<Incident_Project_Aggregate_Fields>;
  nodes: Array<Incident_Project>;
};

export type Incident_Project_Aggregate_Bool_Exp = {
  count?: InputMaybe<Incident_Project_Aggregate_Bool_Exp_Count>;
};

export type Incident_Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Incident_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Incident_Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "incident_project" */
export type Incident_Project_Aggregate_Fields = {
  __typename?: 'incident_project_aggregate_fields';
  avg?: Maybe<Incident_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Incident_Project_Max_Fields>;
  min?: Maybe<Incident_Project_Min_Fields>;
  stddev?: Maybe<Incident_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Incident_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Incident_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Incident_Project_Sum_Fields>;
  var_pop?: Maybe<Incident_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Incident_Project_Var_Samp_Fields>;
  variance?: Maybe<Incident_Project_Variance_Fields>;
};


/** aggregate fields of "incident_project" */
export type Incident_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incident_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "incident_project" */
export type Incident_Project_Aggregate_Order_By = {
  avg?: InputMaybe<Incident_Project_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Incident_Project_Max_Order_By>;
  min?: InputMaybe<Incident_Project_Min_Order_By>;
  stddev?: InputMaybe<Incident_Project_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Incident_Project_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Incident_Project_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Incident_Project_Sum_Order_By>;
  var_pop?: InputMaybe<Incident_Project_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Incident_Project_Var_Samp_Order_By>;
  variance?: InputMaybe<Incident_Project_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "incident_project" */
export type Incident_Project_Arr_Rel_Insert_Input = {
  data: Array<Incident_Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Incident_Project_On_Conflict>;
};

/** aggregate avg on columns */
export type Incident_Project_Avg_Fields = {
  __typename?: 'incident_project_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "incident_project" */
export type Incident_Project_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "incident_project". All fields are combined with a logical 'AND'. */
export type Incident_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Incident_Project_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Incident_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Incident_Project_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incident?: InputMaybe<Incidents_Bool_Exp>;
  incident_id?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "incident_project" */
export enum Incident_Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  IncidentProjectPkey = 'incident_project_pkey'
}

/** input type for incrementing numeric columns in table "incident_project" */
export type Incident_Project_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "incident_project" */
export type Incident_Project_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<Incidents_Obj_Rel_Insert_Input>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Incident_Project_Max_Fields = {
  __typename?: 'incident_project_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "incident_project" */
export type Incident_Project_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Incident_Project_Min_Fields = {
  __typename?: 'incident_project_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "incident_project" */
export type Incident_Project_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "incident_project" */
export type Incident_Project_Mutation_Response = {
  __typename?: 'incident_project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incident_Project>;
};

/** on_conflict condition type for table "incident_project" */
export type Incident_Project_On_Conflict = {
  constraint: Incident_Project_Constraint;
  update_columns?: Array<Incident_Project_Update_Column>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};

/** Ordering options when selecting data from "incident_project". */
export type Incident_Project_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident?: InputMaybe<Incidents_Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incident_project */
export type Incident_Project_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "incident_project" */
export enum Incident_Project_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "incident_project" */
export type Incident_Project_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Incident_Project_Stddev_Fields = {
  __typename?: 'incident_project_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "incident_project" */
export type Incident_Project_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Incident_Project_Stddev_Pop_Fields = {
  __typename?: 'incident_project_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "incident_project" */
export type Incident_Project_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Incident_Project_Stddev_Samp_Fields = {
  __typename?: 'incident_project_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "incident_project" */
export type Incident_Project_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "incident_project" */
export type Incident_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incident_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incident_Project_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Incident_Project_Sum_Fields = {
  __typename?: 'incident_project_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "incident_project" */
export type Incident_Project_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** update columns of table "incident_project" */
export enum Incident_Project_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id',
  /** column name */
  ProjectId = 'project_id'
}

export type Incident_Project_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Incident_Project_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incident_Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incident_Project_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Incident_Project_Var_Pop_Fields = {
  __typename?: 'incident_project_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "incident_project" */
export type Incident_Project_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Incident_Project_Var_Samp_Fields = {
  __typename?: 'incident_project_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "incident_project" */
export type Incident_Project_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Incident_Project_Variance_Fields = {
  __typename?: 'incident_project_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
  project_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "incident_project" */
export type Incident_Project_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "incident_statuses" */
export type Incident_Statuses = {
  __typename?: 'incident_statuses';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  incidents: Array<Incidents>;
  /** An aggregate relationship */
  incidents_aggregate: Incidents_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "incident_statuses" */
export type Incident_StatusesIncidentsArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


/** columns and relationships of "incident_statuses" */
export type Incident_StatusesIncidents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};

/** aggregated selection of "incident_statuses" */
export type Incident_Statuses_Aggregate = {
  __typename?: 'incident_statuses_aggregate';
  aggregate?: Maybe<Incident_Statuses_Aggregate_Fields>;
  nodes: Array<Incident_Statuses>;
};

/** aggregate fields of "incident_statuses" */
export type Incident_Statuses_Aggregate_Fields = {
  __typename?: 'incident_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incident_Statuses_Max_Fields>;
  min?: Maybe<Incident_Statuses_Min_Fields>;
};


/** aggregate fields of "incident_statuses" */
export type Incident_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incident_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "incident_statuses". All fields are combined with a logical 'AND'. */
export type Incident_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Incident_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Incident_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Incident_Statuses_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  incidents?: InputMaybe<Incidents_Bool_Exp>;
  incidents_aggregate?: InputMaybe<Incidents_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "incident_statuses" */
export enum Incident_Statuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  IncidentStatusesPkey = 'incident_statuses_pkey'
}

export enum Incident_Statuses_Enum {
  Alert = 'alert',
  Closed = 'closed',
  /** soft delete */
  Deleted = 'deleted',
  InProgress = 'in_progress',
  Solved = 'solved'
}

/** Boolean expression to compare columns of type "incident_statuses_enum". All fields are combined with logical 'AND'. */
export type Incident_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Incident_Statuses_Enum>;
  _in?: InputMaybe<Array<Incident_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Incident_Statuses_Enum>;
  _nin?: InputMaybe<Array<Incident_Statuses_Enum>>;
};

/** input type for inserting data into table "incident_statuses" */
export type Incident_Statuses_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  incidents?: InputMaybe<Incidents_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Incident_Statuses_Max_Fields = {
  __typename?: 'incident_statuses_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Incident_Statuses_Min_Fields = {
  __typename?: 'incident_statuses_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "incident_statuses" */
export type Incident_Statuses_Mutation_Response = {
  __typename?: 'incident_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incident_Statuses>;
};

/** on_conflict condition type for table "incident_statuses" */
export type Incident_Statuses_On_Conflict = {
  constraint: Incident_Statuses_Constraint;
  update_columns?: Array<Incident_Statuses_Update_Column>;
  where?: InputMaybe<Incident_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "incident_statuses". */
export type Incident_Statuses_Order_By = {
  comment?: InputMaybe<Order_By>;
  incidents_aggregate?: InputMaybe<Incidents_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incident_statuses */
export type Incident_Statuses_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "incident_statuses" */
export enum Incident_Statuses_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "incident_statuses" */
export type Incident_Statuses_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "incident_statuses" */
export type Incident_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incident_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incident_Statuses_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "incident_statuses" */
export enum Incident_Statuses_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Incident_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incident_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incident_Statuses_Bool_Exp;
};

/** columns and relationships of "incident_types" */
export type Incident_Types = {
  __typename?: 'incident_types';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "incident_types" */
export type Incident_Types_Aggregate = {
  __typename?: 'incident_types_aggregate';
  aggregate?: Maybe<Incident_Types_Aggregate_Fields>;
  nodes: Array<Incident_Types>;
};

/** aggregate fields of "incident_types" */
export type Incident_Types_Aggregate_Fields = {
  __typename?: 'incident_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Incident_Types_Max_Fields>;
  min?: Maybe<Incident_Types_Min_Fields>;
};


/** aggregate fields of "incident_types" */
export type Incident_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incident_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "incident_types". All fields are combined with a logical 'AND'. */
export type Incident_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Incident_Types_Bool_Exp>>;
  _not?: InputMaybe<Incident_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Incident_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "incident_types" */
export enum Incident_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  IncidentTypesPkey = 'incident_types_pkey'
}

export enum Incident_Types_Enum {
  MachineFailure = 'machine_failure',
  MachineMaintenance = 'machine_maintenance',
  Other = 'other',
  SopNotFollowed = 'sop_not_followed',
  UnclearSop = 'unclear_sop',
  UndefinedSop = 'undefined_sop',
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "incident_types_enum". All fields are combined with logical 'AND'. */
export type Incident_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Incident_Types_Enum>;
  _in?: InputMaybe<Array<Incident_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Incident_Types_Enum>;
  _nin?: InputMaybe<Array<Incident_Types_Enum>>;
};

/** input type for inserting data into table "incident_types" */
export type Incident_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Incident_Types_Max_Fields = {
  __typename?: 'incident_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Incident_Types_Min_Fields = {
  __typename?: 'incident_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "incident_types" */
export type Incident_Types_Mutation_Response = {
  __typename?: 'incident_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incident_Types>;
};

/** on_conflict condition type for table "incident_types" */
export type Incident_Types_On_Conflict = {
  constraint: Incident_Types_Constraint;
  update_columns?: Array<Incident_Types_Update_Column>;
  where?: InputMaybe<Incident_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "incident_types". */
export type Incident_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incident_types */
export type Incident_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "incident_types" */
export enum Incident_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "incident_types" */
export type Incident_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "incident_types" */
export type Incident_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incident_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incident_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "incident_types" */
export enum Incident_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Incident_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incident_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incident_Types_Bool_Exp;
};

/** columns and relationships of "incidents" */
export type Incidents = {
  __typename?: 'incidents';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by: Scalars['String']['output'];
  /** An object relationship */
  alert?: Maybe<Alerts>;
  alert_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int']['output'];
  closing_reason?: Maybe<Incident_Closing_Reasons_Enum>;
  closing_reason_other_text?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  cost?: Maybe<Scalars['Int']['output']>;
  delete_reason?: Maybe<Scalars['String']['output']>;
  end: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  incident_projects: Array<Incident_Project>;
  /** An aggregate relationship */
  incident_projects_aggregate: Incident_Project_Aggregate;
  name: Scalars['String']['output'];
  owner_id: Scalars['String']['output'];
  /** An object relationship */
  owner_user: Users;
  source_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  source_user?: Maybe<Users>;
  start: Scalars['timestamptz']['output'];
  status: Incident_Statuses_Enum;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  type: Incident_Types_Enum;
};


/** columns and relationships of "incidents" */
export type IncidentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "incidents" */
export type IncidentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "incidents" */
export type IncidentsIncident_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


/** columns and relationships of "incidents" */
export type IncidentsIncident_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


/** columns and relationships of "incidents" */
export type IncidentsTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


/** columns and relationships of "incidents" */
export type IncidentsTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** aggregated selection of "incidents" */
export type Incidents_Aggregate = {
  __typename?: 'incidents_aggregate';
  aggregate?: Maybe<Incidents_Aggregate_Fields>;
  nodes: Array<Incidents>;
};

export type Incidents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Incidents_Aggregate_Bool_Exp_Count>;
};

export type Incidents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Incidents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Incidents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "incidents" */
export type Incidents_Aggregate_Fields = {
  __typename?: 'incidents_aggregate_fields';
  avg?: Maybe<Incidents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Incidents_Max_Fields>;
  min?: Maybe<Incidents_Min_Fields>;
  stddev?: Maybe<Incidents_Stddev_Fields>;
  stddev_pop?: Maybe<Incidents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Incidents_Stddev_Samp_Fields>;
  sum?: Maybe<Incidents_Sum_Fields>;
  var_pop?: Maybe<Incidents_Var_Pop_Fields>;
  var_samp?: Maybe<Incidents_Var_Samp_Fields>;
  variance?: Maybe<Incidents_Variance_Fields>;
};


/** aggregate fields of "incidents" */
export type Incidents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incidents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "incidents" */
export type Incidents_Aggregate_Order_By = {
  avg?: InputMaybe<Incidents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Incidents_Max_Order_By>;
  min?: InputMaybe<Incidents_Min_Order_By>;
  stddev?: InputMaybe<Incidents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Incidents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Incidents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Incidents_Sum_Order_By>;
  var_pop?: InputMaybe<Incidents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Incidents_Var_Samp_Order_By>;
  variance?: InputMaybe<Incidents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "incidents" */
export type Incidents_Arr_Rel_Insert_Input = {
  data: Array<Incidents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Incidents_On_Conflict>;
};

/** aggregate avg on columns */
export type Incidents_Avg_Fields = {
  __typename?: 'incidents_avg_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "incidents" */
export type Incidents_Avg_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "incidents". All fields are combined with a logical 'AND'. */
export type Incidents_Bool_Exp = {
  _and?: InputMaybe<Array<Incidents_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Incidents_Bool_Exp>;
  _or?: InputMaybe<Array<Incidents_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  alert?: InputMaybe<Alerts_Bool_Exp>;
  alert_id?: InputMaybe<Int_Comparison_Exp>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  closing_reason?: InputMaybe<Incident_Closing_Reasons_Enum_Comparison_Exp>;
  closing_reason_other_text?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Bool_Exp>;
  cost?: InputMaybe<Int_Comparison_Exp>;
  delete_reason?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incident_projects?: InputMaybe<Incident_Project_Bool_Exp>;
  incident_projects_aggregate?: InputMaybe<Incident_Project_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<String_Comparison_Exp>;
  owner_user?: InputMaybe<Users_Bool_Exp>;
  source_id?: InputMaybe<String_Comparison_Exp>;
  source_user?: InputMaybe<Users_Bool_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Incident_Statuses_Enum_Comparison_Exp>;
  tasks?: InputMaybe<Tasks_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Bool_Exp>;
  type?: InputMaybe<Incident_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "incidents" */
export enum Incidents_Constraint {
  /** unique or primary key constraint on columns "id" */
  IncidentsPkey = 'incidents_pkey'
}

/** input type for incrementing numeric columns in table "incidents" */
export type Incidents_Inc_Input = {
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "incidents" */
export type Incidents_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  alert?: InputMaybe<Alerts_Obj_Rel_Insert_Input>;
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  closing_reason?: InputMaybe<Incident_Closing_Reasons_Enum>;
  closing_reason_other_text?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  delete_reason?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_projects?: InputMaybe<Incident_Project_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  owner_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  source_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Incident_Statuses_Enum>;
  tasks?: InputMaybe<Tasks_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Incident_Types_Enum>;
};

/** aggregate max on columns */
export type Incidents_Max_Fields = {
  __typename?: 'incidents_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  alert_id?: Maybe<Scalars['Int']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  closing_reason_other_text?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  delete_reason?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "incidents" */
export type Incidents_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  closing_reason_other_text?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  delete_reason?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Incidents_Min_Fields = {
  __typename?: 'incidents_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  alert_id?: Maybe<Scalars['Int']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  closing_reason_other_text?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  delete_reason?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_id?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "incidents" */
export type Incidents_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  closing_reason_other_text?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  delete_reason?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "incidents" */
export type Incidents_Mutation_Response = {
  __typename?: 'incidents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Incidents>;
};

/** input type for inserting object relation for remote table "incidents" */
export type Incidents_Obj_Rel_Insert_Input = {
  data: Incidents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Incidents_On_Conflict>;
};

/** on_conflict condition type for table "incidents" */
export type Incidents_On_Conflict = {
  constraint: Incidents_Constraint;
  update_columns?: Array<Incidents_Update_Column>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};

/** Ordering options when selecting data from "incidents". */
export type Incidents_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  alert?: InputMaybe<Alerts_Order_By>;
  alert_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  closing_reason?: InputMaybe<Order_By>;
  closing_reason_other_text?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  cost?: InputMaybe<Order_By>;
  delete_reason?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_projects_aggregate?: InputMaybe<Incident_Project_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  owner_user?: InputMaybe<Users_Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_user?: InputMaybe<Users_Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Tasks_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: incidents */
export type Incidents_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "incidents" */
export enum Incidents_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  ClosingReason = 'closing_reason',
  /** column name */
  ClosingReasonOtherText = 'closing_reason_other_text',
  /** column name */
  Cost = 'cost',
  /** column name */
  DeleteReason = 'delete_reason',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "incidents" */
export type Incidents_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  closing_reason?: InputMaybe<Incident_Closing_Reasons_Enum>;
  closing_reason_other_text?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  delete_reason?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Incident_Statuses_Enum>;
  type?: InputMaybe<Incident_Types_Enum>;
};

/** aggregate stddev on columns */
export type Incidents_Stddev_Fields = {
  __typename?: 'incidents_stddev_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "incidents" */
export type Incidents_Stddev_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Incidents_Stddev_Pop_Fields = {
  __typename?: 'incidents_stddev_pop_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "incidents" */
export type Incidents_Stddev_Pop_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Incidents_Stddev_Samp_Fields = {
  __typename?: 'incidents_stddev_samp_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "incidents" */
export type Incidents_Stddev_Samp_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "incidents" */
export type Incidents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incidents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incidents_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  alert_id?: InputMaybe<Scalars['Int']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  closing_reason?: InputMaybe<Incident_Closing_Reasons_Enum>;
  closing_reason_other_text?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  delete_reason?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_id?: InputMaybe<Scalars['String']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Incident_Statuses_Enum>;
  type?: InputMaybe<Incident_Types_Enum>;
};

/** aggregate sum on columns */
export type Incidents_Sum_Fields = {
  __typename?: 'incidents_sum_fields';
  alert_id?: Maybe<Scalars['Int']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "incidents" */
export type Incidents_Sum_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "incidents" */
export enum Incidents_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  ClosingReason = 'closing_reason',
  /** column name */
  ClosingReasonOtherText = 'closing_reason_other_text',
  /** column name */
  Cost = 'cost',
  /** column name */
  DeleteReason = 'delete_reason',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

export type Incidents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Incidents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Incidents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Incidents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Incidents_Var_Pop_Fields = {
  __typename?: 'incidents_var_pop_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "incidents" */
export type Incidents_Var_Pop_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Incidents_Var_Samp_Fields = {
  __typename?: 'incidents_var_samp_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "incidents" */
export type Incidents_Var_Samp_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Incidents_Variance_Fields = {
  __typename?: 'incidents_variance_fields';
  alert_id?: Maybe<Scalars['Float']['output']>;
  area_id?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "incidents" */
export type Incidents_Variance_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions = {
  __typename?: 'meter_daily_consumptions';
  consumption_kwh: Scalars['numeric']['output'];
  cost?: Maybe<Scalars['numeric']['output']>;
  date: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter?: Maybe<Meters>;
  meter_id: Scalars['Int']['output'];
};

/** aggregated selection of "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Aggregate = {
  __typename?: 'meter_daily_consumptions_aggregate';
  aggregate?: Maybe<Meter_Daily_Consumptions_Aggregate_Fields>;
  nodes: Array<Meter_Daily_Consumptions>;
};

/** aggregate fields of "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Aggregate_Fields = {
  __typename?: 'meter_daily_consumptions_aggregate_fields';
  avg?: Maybe<Meter_Daily_Consumptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Meter_Daily_Consumptions_Max_Fields>;
  min?: Maybe<Meter_Daily_Consumptions_Min_Fields>;
  stddev?: Maybe<Meter_Daily_Consumptions_Stddev_Fields>;
  stddev_pop?: Maybe<Meter_Daily_Consumptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Meter_Daily_Consumptions_Stddev_Samp_Fields>;
  sum?: Maybe<Meter_Daily_Consumptions_Sum_Fields>;
  var_pop?: Maybe<Meter_Daily_Consumptions_Var_Pop_Fields>;
  var_samp?: Maybe<Meter_Daily_Consumptions_Var_Samp_Fields>;
  variance?: Maybe<Meter_Daily_Consumptions_Variance_Fields>;
};


/** aggregate fields of "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Daily_Consumptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Meter_Daily_Consumptions_Avg_Fields = {
  __typename?: 'meter_daily_consumptions_avg_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "consumption.daily_consumptions". All fields are combined with a logical 'AND'. */
export type Meter_Daily_Consumptions_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Daily_Consumptions_Bool_Exp>>;
  _not?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
  _or?: InputMaybe<Array<Meter_Daily_Consumptions_Bool_Exp>>;
  consumption_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumption.daily_consumptions" */
export enum Meter_Daily_Consumptions_Constraint {
  /** unique or primary key constraint on columns "date", "meter_id" */
  DailyConsumptionsMeterIdDateKey = 'daily_consumptions_meter_id_date_key',
  /** unique or primary key constraint on columns "id" */
  DailyConsumptionsPkey = 'daily_consumptions_pkey'
}

/** input type for incrementing numeric columns in table "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Inc_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Insert_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Meter_Daily_Consumptions_Max_Fields = {
  __typename?: 'meter_daily_consumptions_max_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Meter_Daily_Consumptions_Min_Fields = {
  __typename?: 'meter_daily_consumptions_min_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Mutation_Response = {
  __typename?: 'meter_daily_consumptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Daily_Consumptions>;
};

/** on_conflict condition type for table "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_On_Conflict = {
  constraint: Meter_Daily_Consumptions_Constraint;
  update_columns?: Array<Meter_Daily_Consumptions_Update_Column>;
  where?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
};

/** Ordering options when selecting data from "consumption.daily_consumptions". */
export type Meter_Daily_Consumptions_Order_By = {
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consumption.daily_consumptions */
export type Meter_Daily_Consumptions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "consumption.daily_consumptions" */
export enum Meter_Daily_Consumptions_Select_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id'
}

/** input type for updating data in table "consumption.daily_consumptions" */
export type Meter_Daily_Consumptions_Set_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Meter_Daily_Consumptions_Stddev_Fields = {
  __typename?: 'meter_daily_consumptions_stddev_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Meter_Daily_Consumptions_Stddev_Pop_Fields = {
  __typename?: 'meter_daily_consumptions_stddev_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Meter_Daily_Consumptions_Stddev_Samp_Fields = {
  __typename?: 'meter_daily_consumptions_stddev_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "meter_daily_consumptions" */
export type Meter_Daily_Consumptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Daily_Consumptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Meter_Daily_Consumptions_Stream_Cursor_Value_Input = {
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Meter_Daily_Consumptions_Sum_Fields = {
  __typename?: 'meter_daily_consumptions_sum_fields';
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "consumption.daily_consumptions" */
export enum Meter_Daily_Consumptions_Update_Column {
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id'
}

export type Meter_Daily_Consumptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Daily_Consumptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Daily_Consumptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Meter_Daily_Consumptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Meter_Daily_Consumptions_Var_Pop_Fields = {
  __typename?: 'meter_daily_consumptions_var_pop_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Meter_Daily_Consumptions_Var_Samp_Fields = {
  __typename?: 'meter_daily_consumptions_var_samp_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Meter_Daily_Consumptions_Variance_Fields = {
  __typename?: 'meter_daily_consumptions_variance_fields';
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "meter_types" */
export type Meter_Types = {
  __typename?: 'meter_types';
  energy_type: Energy_Types_Enum;
  id: Scalars['Int']['output'];
  measure_to_consumption_factor: Scalars['numeric']['output'];
  /** An array relationship */
  meters: Array<Meters>;
  /** An aggregate relationship */
  meters_aggregate: Meters_Aggregate;
  name: Scalars['String']['output'];
  source: Sources_Enum;
  step_seconds: Scalars['Int']['output'];
};


/** columns and relationships of "meter_types" */
export type Meter_TypesMetersArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


/** columns and relationships of "meter_types" */
export type Meter_TypesMeters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};

/** aggregated selection of "meter_types" */
export type Meter_Types_Aggregate = {
  __typename?: 'meter_types_aggregate';
  aggregate?: Maybe<Meter_Types_Aggregate_Fields>;
  nodes: Array<Meter_Types>;
};

export type Meter_Types_Aggregate_Bool_Exp = {
  count?: InputMaybe<Meter_Types_Aggregate_Bool_Exp_Count>;
};

export type Meter_Types_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meter_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Meter_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "meter_types" */
export type Meter_Types_Aggregate_Fields = {
  __typename?: 'meter_types_aggregate_fields';
  avg?: Maybe<Meter_Types_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Meter_Types_Max_Fields>;
  min?: Maybe<Meter_Types_Min_Fields>;
  stddev?: Maybe<Meter_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Meter_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Meter_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Meter_Types_Sum_Fields>;
  var_pop?: Maybe<Meter_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Meter_Types_Var_Samp_Fields>;
  variance?: Maybe<Meter_Types_Variance_Fields>;
};


/** aggregate fields of "meter_types" */
export type Meter_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "meter_types" */
export type Meter_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Meter_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Meter_Types_Max_Order_By>;
  min?: InputMaybe<Meter_Types_Min_Order_By>;
  stddev?: InputMaybe<Meter_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Meter_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Meter_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Meter_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Meter_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Meter_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Meter_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "meter_types" */
export type Meter_Types_Arr_Rel_Insert_Input = {
  data: Array<Meter_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Meter_Types_Avg_Fields = {
  __typename?: 'meter_types_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "meter_types" */
export type Meter_Types_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "meter_types". All fields are combined with a logical 'AND'. */
export type Meter_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Types_Bool_Exp>>;
  _not?: InputMaybe<Meter_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Meter_Types_Bool_Exp>>;
  energy_type?: InputMaybe<Energy_Types_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  measure_to_consumption_factor?: InputMaybe<Numeric_Comparison_Exp>;
  meters?: InputMaybe<Meters_Bool_Exp>;
  meters_aggregate?: InputMaybe<Meters_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Sources_Enum_Comparison_Exp>;
  step_seconds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "meter_types" */
export enum Meter_Types_Constraint {
  /** unique or primary key constraint on columns "name" */
  MeterTypesNameKey = 'meter_types_name_key',
  /** unique or primary key constraint on columns "id" */
  MeterTypesPkey = 'meter_types_pkey'
}

/** input type for incrementing numeric columns in table "meter_types" */
export type Meter_Types_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  measure_to_consumption_factor?: InputMaybe<Scalars['numeric']['input']>;
  step_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "meter_types" */
export type Meter_Types_Insert_Input = {
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measure_to_consumption_factor?: InputMaybe<Scalars['numeric']['input']>;
  meters?: InputMaybe<Meters_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Sources_Enum>;
  step_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Meter_Types_Max_Fields = {
  __typename?: 'meter_types_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  step_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "meter_types" */
export type Meter_Types_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Meter_Types_Min_Fields = {
  __typename?: 'meter_types_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  step_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "meter_types" */
export type Meter_Types_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "meter_types" */
export type Meter_Types_Mutation_Response = {
  __typename?: 'meter_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Types>;
};

/** input type for inserting object relation for remote table "meter_types" */
export type Meter_Types_Obj_Rel_Insert_Input = {
  data: Meter_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Types_On_Conflict>;
};

/** on_conflict condition type for table "meter_types" */
export type Meter_Types_On_Conflict = {
  constraint: Meter_Types_Constraint;
  update_columns?: Array<Meter_Types_Update_Column>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "meter_types". */
export type Meter_Types_Order_By = {
  energy_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  meters_aggregate?: InputMaybe<Meters_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: meter_types */
export type Meter_Types_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "meter_types" */
export enum Meter_Types_Select_Column {
  /** column name */
  EnergyType = 'energy_type',
  /** column name */
  Id = 'id',
  /** column name */
  MeasureToConsumptionFactor = 'measure_to_consumption_factor',
  /** column name */
  Name = 'name',
  /** column name */
  Source = 'source',
  /** column name */
  StepSeconds = 'step_seconds'
}

/** input type for updating data in table "meter_types" */
export type Meter_Types_Set_Input = {
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measure_to_consumption_factor?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Sources_Enum>;
  step_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Meter_Types_Stddev_Fields = {
  __typename?: 'meter_types_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "meter_types" */
export type Meter_Types_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Meter_Types_Stddev_Pop_Fields = {
  __typename?: 'meter_types_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "meter_types" */
export type Meter_Types_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Meter_Types_Stddev_Samp_Fields = {
  __typename?: 'meter_types_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "meter_types" */
export type Meter_Types_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "meter_types" */
export type Meter_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Meter_Types_Stream_Cursor_Value_Input = {
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measure_to_consumption_factor?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Sources_Enum>;
  step_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Meter_Types_Sum_Fields = {
  __typename?: 'meter_types_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['numeric']['output']>;
  step_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "meter_types" */
export type Meter_Types_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** update columns of table "meter_types" */
export enum Meter_Types_Update_Column {
  /** column name */
  EnergyType = 'energy_type',
  /** column name */
  Id = 'id',
  /** column name */
  MeasureToConsumptionFactor = 'measure_to_consumption_factor',
  /** column name */
  Name = 'name',
  /** column name */
  Source = 'source',
  /** column name */
  StepSeconds = 'step_seconds'
}

export type Meter_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Meter_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Meter_Types_Var_Pop_Fields = {
  __typename?: 'meter_types_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "meter_types" */
export type Meter_Types_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Meter_Types_Var_Samp_Fields = {
  __typename?: 'meter_types_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "meter_types" */
export type Meter_Types_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Meter_Types_Variance_Fields = {
  __typename?: 'meter_types_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  measure_to_consumption_factor?: Maybe<Scalars['Float']['output']>;
  step_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "meter_types" */
export type Meter_Types_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  measure_to_consumption_factor?: InputMaybe<Order_By>;
  step_seconds?: InputMaybe<Order_By>;
};

/** columns and relationships of "meters" */
export type Meters = {
  __typename?: 'meters';
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int']['output'];
  /** An array relationship */
  consumptions: Array<Consumptions>;
  /** An aggregate relationship */
  consumptions_aggregate: Consumptions_Aggregate;
  data_source_id: Scalars['String']['output'];
  firebase_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter_type: Meter_Types;
  meter_type_id: Scalars['Int']['output'];
  /** An array relationship */
  objectives: Array<Objectives>;
  /** An aggregate relationship */
  objectives_aggregate: Objectives_Aggregate;
};


/** columns and relationships of "meters" */
export type MetersConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumptions_Order_By>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


/** columns and relationships of "meters" */
export type MetersConsumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumptions_Order_By>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


/** columns and relationships of "meters" */
export type MetersObjectivesArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


/** columns and relationships of "meters" */
export type MetersObjectives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};

/** aggregated selection of "meters" */
export type Meters_Aggregate = {
  __typename?: 'meters_aggregate';
  aggregate?: Maybe<Meters_Aggregate_Fields>;
  nodes: Array<Meters>;
};

export type Meters_Aggregate_Bool_Exp = {
  count?: InputMaybe<Meters_Aggregate_Bool_Exp_Count>;
};

export type Meters_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Meters_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "meters" */
export type Meters_Aggregate_Fields = {
  __typename?: 'meters_aggregate_fields';
  avg?: Maybe<Meters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Meters_Max_Fields>;
  min?: Maybe<Meters_Min_Fields>;
  stddev?: Maybe<Meters_Stddev_Fields>;
  stddev_pop?: Maybe<Meters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Meters_Stddev_Samp_Fields>;
  sum?: Maybe<Meters_Sum_Fields>;
  var_pop?: Maybe<Meters_Var_Pop_Fields>;
  var_samp?: Maybe<Meters_Var_Samp_Fields>;
  variance?: Maybe<Meters_Variance_Fields>;
};


/** aggregate fields of "meters" */
export type Meters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "meters" */
export type Meters_Aggregate_Order_By = {
  avg?: InputMaybe<Meters_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Meters_Max_Order_By>;
  min?: InputMaybe<Meters_Min_Order_By>;
  stddev?: InputMaybe<Meters_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Meters_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Meters_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Meters_Sum_Order_By>;
  var_pop?: InputMaybe<Meters_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Meters_Var_Samp_Order_By>;
  variance?: InputMaybe<Meters_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "meters" */
export type Meters_Arr_Rel_Insert_Input = {
  data: Array<Meters_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Meters_On_Conflict>;
};

/** aggregate avg on columns */
export type Meters_Avg_Fields = {
  __typename?: 'meters_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "meters" */
export type Meters_Avg_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "meters". All fields are combined with a logical 'AND'. */
export type Meters_Bool_Exp = {
  _and?: InputMaybe<Array<Meters_Bool_Exp>>;
  _not?: InputMaybe<Meters_Bool_Exp>;
  _or?: InputMaybe<Array<Meters_Bool_Exp>>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  consumptions?: InputMaybe<Consumptions_Bool_Exp>;
  consumptions_aggregate?: InputMaybe<Consumptions_Aggregate_Bool_Exp>;
  data_source_id?: InputMaybe<String_Comparison_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter_type?: InputMaybe<Meter_Types_Bool_Exp>;
  meter_type_id?: InputMaybe<Int_Comparison_Exp>;
  objectives?: InputMaybe<Objectives_Bool_Exp>;
  objectives_aggregate?: InputMaybe<Objectives_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "meters" */
export enum Meters_Constraint {
  /** unique or primary key constraint on columns "id" */
  MetersPkey = 'meters_pkey'
}

/** input type for incrementing numeric columns in table "meters" */
export type Meters_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "meters" */
export type Meters_Insert_Input = {
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  consumptions?: InputMaybe<Consumptions_Arr_Rel_Insert_Input>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type?: InputMaybe<Meter_Types_Obj_Rel_Insert_Input>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
  objectives?: InputMaybe<Objectives_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Meters_Max_Fields = {
  __typename?: 'meters_max_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "meters" */
export type Meters_Max_Order_By = {
  area_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Meters_Min_Fields = {
  __typename?: 'meters_min_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "meters" */
export type Meters_Min_Order_By = {
  area_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "meters" */
export type Meters_Mutation_Response = {
  __typename?: 'meters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Meters>;
};

/** input type for inserting object relation for remote table "meters" */
export type Meters_Obj_Rel_Insert_Input = {
  data: Meters_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Meters_On_Conflict>;
};

/** on_conflict condition type for table "meters" */
export type Meters_On_Conflict = {
  constraint: Meters_Constraint;
  update_columns?: Array<Meters_Update_Column>;
  where?: InputMaybe<Meters_Bool_Exp>;
};

/** Ordering options when selecting data from "meters". */
export type Meters_Order_By = {
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  consumptions_aggregate?: InputMaybe<Consumptions_Aggregate_Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type?: InputMaybe<Meter_Types_Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
  objectives_aggregate?: InputMaybe<Objectives_Aggregate_Order_By>;
};

/** primary key columns input for table: meters */
export type Meters_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "meters" */
export enum Meters_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeterTypeId = 'meter_type_id'
}

/** input type for updating data in table "meters" */
export type Meters_Set_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Meters_Stddev_Fields = {
  __typename?: 'meters_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "meters" */
export type Meters_Stddev_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Meters_Stddev_Pop_Fields = {
  __typename?: 'meters_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "meters" */
export type Meters_Stddev_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Meters_Stddev_Samp_Fields = {
  __typename?: 'meters_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "meters" */
export type Meters_Stddev_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "meters" */
export type Meters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Meters_Stream_Cursor_Value_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Meters_Sum_Fields = {
  __typename?: 'meters_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "meters" */
export type Meters_Sum_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "meters" */
export enum Meters_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeterTypeId = 'meter_type_id'
}

export type Meters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meters_Set_Input>;
  /** filter the rows which have to be updated */
  where: Meters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Meters_Var_Pop_Fields = {
  __typename?: 'meters_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "meters" */
export type Meters_Var_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Meters_Var_Samp_Fields = {
  __typename?: 'meters_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "meters" */
export type Meters_Var_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Meters_Variance_Fields = {
  __typename?: 'meters_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "meters" */
export type Meters_Variance_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

export type Mqtt_Get_Missing_Data_Grouped_By_Topic_Args = {
  end_ts?: InputMaybe<Scalars['timestamp']['input']>;
  start_ts?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "mqtt.missing_data" */
export type Mqtt_Missing_Data = {
  __typename?: 'mqtt_missing_data';
  following_payload: Scalars['jsonb']['output'];
  following_ts: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter?: Maybe<Mqtt_Pressac_Meters>;
  previous_payload: Scalars['jsonb']['output'];
  previous_ts: Scalars['timestamp']['output'];
  start: Scalars['timestamp']['output'];
  topic: Scalars['String']['output'];
};


/** columns and relationships of "mqtt.missing_data" */
export type Mqtt_Missing_DataFollowing_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "mqtt.missing_data" */
export type Mqtt_Missing_DataPrevious_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mqtt.missing_data" */
export type Mqtt_Missing_Data_Aggregate = {
  __typename?: 'mqtt_missing_data_aggregate';
  aggregate?: Maybe<Mqtt_Missing_Data_Aggregate_Fields>;
  nodes: Array<Mqtt_Missing_Data>;
};

/** aggregate fields of "mqtt.missing_data" */
export type Mqtt_Missing_Data_Aggregate_Fields = {
  __typename?: 'mqtt_missing_data_aggregate_fields';
  avg?: Maybe<Mqtt_Missing_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mqtt_Missing_Data_Max_Fields>;
  min?: Maybe<Mqtt_Missing_Data_Min_Fields>;
  stddev?: Maybe<Mqtt_Missing_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Mqtt_Missing_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mqtt_Missing_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Mqtt_Missing_Data_Sum_Fields>;
  var_pop?: Maybe<Mqtt_Missing_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Mqtt_Missing_Data_Var_Samp_Fields>;
  variance?: Maybe<Mqtt_Missing_Data_Variance_Fields>;
};


/** aggregate fields of "mqtt.missing_data" */
export type Mqtt_Missing_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mqtt_Missing_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mqtt_Missing_Data_Append_Input = {
  following_payload?: InputMaybe<Scalars['jsonb']['input']>;
  previous_payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Mqtt_Missing_Data_Avg_Fields = {
  __typename?: 'mqtt_missing_data_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mqtt.missing_data". All fields are combined with a logical 'AND'. */
export type Mqtt_Missing_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Mqtt_Missing_Data_Bool_Exp>>;
  _not?: InputMaybe<Mqtt_Missing_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Mqtt_Missing_Data_Bool_Exp>>;
  following_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  following_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
  previous_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  previous_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
  topic?: InputMaybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mqtt_Missing_Data_Delete_At_Path_Input = {
  following_payload?: InputMaybe<Array<Scalars['String']['input']>>;
  previous_payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mqtt_Missing_Data_Delete_Elem_Input = {
  following_payload?: InputMaybe<Scalars['Int']['input']>;
  previous_payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mqtt_Missing_Data_Delete_Key_Input = {
  following_payload?: InputMaybe<Scalars['String']['input']>;
  previous_payload?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic = {
  __typename?: 'mqtt_missing_data_grouped_by_topic';
  duration_minutes: Scalars['numeric']['output'];
  /** An object relationship */
  meter?: Maybe<Mqtt_Pressac_Meters>;
  nb_missing_periods: Scalars['bigint']['output'];
  topic: Scalars['String']['output'];
};

export type Mqtt_Missing_Data_Grouped_By_Topic_Aggregate = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_aggregate';
  aggregate?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Aggregate_Fields>;
  nodes: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
};

/** aggregate fields of "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Aggregate_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_aggregate_fields';
  avg?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Max_Fields>;
  min?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Min_Fields>;
  stddev?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Stddev_Fields>;
  stddev_pop?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Stddev_Samp_Fields>;
  sum?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Sum_Fields>;
  var_pop?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Var_Pop_Fields>;
  var_samp?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Var_Samp_Fields>;
  variance?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Variance_Fields>;
};


/** aggregate fields of "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Avg_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_avg_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mqtt.missing_data_grouped_by_topic". All fields are combined with a logical 'AND'. */
export type Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp = {
  _and?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>>;
  _not?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
  _or?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>>;
  duration_minutes?: InputMaybe<Numeric_Comparison_Exp>;
  meter?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
  nb_missing_periods?: InputMaybe<Bigint_Comparison_Exp>;
  topic?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mqtt.missing_data_grouped_by_topic" */
export enum Mqtt_Missing_Data_Grouped_By_Topic_Constraint {
  /** unique or primary key constraint on columns "topic" */
  MissingDataGroupedByTopicPkey = 'missing_data_grouped_by_topic_pkey'
}

/** input type for incrementing numeric columns in table "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Inc_Input = {
  duration_minutes?: InputMaybe<Scalars['numeric']['input']>;
  nb_missing_periods?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Insert_Input = {
  duration_minutes?: InputMaybe<Scalars['numeric']['input']>;
  meter?: InputMaybe<Mqtt_Pressac_Meters_Obj_Rel_Insert_Input>;
  nb_missing_periods?: InputMaybe<Scalars['bigint']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Max_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_max_fields';
  duration_minutes?: Maybe<Scalars['numeric']['output']>;
  nb_missing_periods?: Maybe<Scalars['bigint']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Min_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_min_fields';
  duration_minutes?: Maybe<Scalars['numeric']['output']>;
  nb_missing_periods?: Maybe<Scalars['bigint']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Mutation_Response = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
};

/** on_conflict condition type for table "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_On_Conflict = {
  constraint: Mqtt_Missing_Data_Grouped_By_Topic_Constraint;
  update_columns?: Array<Mqtt_Missing_Data_Grouped_By_Topic_Update_Column>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};

/** Ordering options when selecting data from "mqtt.missing_data_grouped_by_topic". */
export type Mqtt_Missing_Data_Grouped_By_Topic_Order_By = {
  duration_minutes?: InputMaybe<Order_By>;
  meter?: InputMaybe<Mqtt_Pressac_Meters_Order_By>;
  nb_missing_periods?: InputMaybe<Order_By>;
  topic?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mqtt.missing_data_grouped_by_topic */
export type Mqtt_Missing_Data_Grouped_By_Topic_Pk_Columns_Input = {
  topic: Scalars['String']['input'];
};

/** select columns of table "mqtt.missing_data_grouped_by_topic" */
export enum Mqtt_Missing_Data_Grouped_By_Topic_Select_Column {
  /** column name */
  DurationMinutes = 'duration_minutes',
  /** column name */
  NbMissingPeriods = 'nb_missing_periods',
  /** column name */
  Topic = 'topic'
}

/** input type for updating data in table "mqtt.missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Set_Input = {
  duration_minutes?: InputMaybe<Scalars['numeric']['input']>;
  nb_missing_periods?: InputMaybe<Scalars['bigint']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Stddev_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_stddev_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Stddev_Pop_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_stddev_pop_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Stddev_Samp_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_stddev_samp_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mqtt_missing_data_grouped_by_topic" */
export type Mqtt_Missing_Data_Grouped_By_Topic_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mqtt_Missing_Data_Grouped_By_Topic_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mqtt_Missing_Data_Grouped_By_Topic_Stream_Cursor_Value_Input = {
  duration_minutes?: InputMaybe<Scalars['numeric']['input']>;
  nb_missing_periods?: InputMaybe<Scalars['bigint']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Sum_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_sum_fields';
  duration_minutes?: Maybe<Scalars['numeric']['output']>;
  nb_missing_periods?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "mqtt.missing_data_grouped_by_topic" */
export enum Mqtt_Missing_Data_Grouped_By_Topic_Update_Column {
  /** column name */
  DurationMinutes = 'duration_minutes',
  /** column name */
  NbMissingPeriods = 'nb_missing_periods',
  /** column name */
  Topic = 'topic'
}

export type Mqtt_Missing_Data_Grouped_By_Topic_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Var_Pop_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_var_pop_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Var_Samp_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_var_samp_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mqtt_Missing_Data_Grouped_By_Topic_Variance_Fields = {
  __typename?: 'mqtt_missing_data_grouped_by_topic_variance_fields';
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  nb_missing_periods?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "mqtt.missing_data" */
export type Mqtt_Missing_Data_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mqtt.missing_data" */
export type Mqtt_Missing_Data_Insert_Input = {
  following_payload?: InputMaybe<Scalars['jsonb']['input']>;
  following_ts?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter?: InputMaybe<Mqtt_Pressac_Meters_Obj_Rel_Insert_Input>;
  previous_payload?: InputMaybe<Scalars['jsonb']['input']>;
  previous_ts?: InputMaybe<Scalars['timestamp']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mqtt_Missing_Data_Max_Fields = {
  __typename?: 'mqtt_missing_data_max_fields';
  following_ts?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  previous_ts?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mqtt_Missing_Data_Min_Fields = {
  __typename?: 'mqtt_missing_data_min_fields';
  following_ts?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  previous_ts?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mqtt.missing_data" */
export type Mqtt_Missing_Data_Mutation_Response = {
  __typename?: 'mqtt_missing_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mqtt_Missing_Data>;
};

/** Ordering options when selecting data from "mqtt.missing_data". */
export type Mqtt_Missing_Data_Order_By = {
  following_payload?: InputMaybe<Order_By>;
  following_ts?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter?: InputMaybe<Mqtt_Pressac_Meters_Order_By>;
  previous_payload?: InputMaybe<Order_By>;
  previous_ts?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  topic?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mqtt_Missing_Data_Prepend_Input = {
  following_payload?: InputMaybe<Scalars['jsonb']['input']>;
  previous_payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mqtt.missing_data" */
export enum Mqtt_Missing_Data_Select_Column {
  /** column name */
  FollowingPayload = 'following_payload',
  /** column name */
  FollowingTs = 'following_ts',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousPayload = 'previous_payload',
  /** column name */
  PreviousTs = 'previous_ts',
  /** column name */
  Start = 'start',
  /** column name */
  Topic = 'topic'
}

/** input type for updating data in table "mqtt.missing_data" */
export type Mqtt_Missing_Data_Set_Input = {
  following_payload?: InputMaybe<Scalars['jsonb']['input']>;
  following_ts?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  previous_payload?: InputMaybe<Scalars['jsonb']['input']>;
  previous_ts?: InputMaybe<Scalars['timestamp']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Mqtt_Missing_Data_Stddev_Fields = {
  __typename?: 'mqtt_missing_data_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mqtt_Missing_Data_Stddev_Pop_Fields = {
  __typename?: 'mqtt_missing_data_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mqtt_Missing_Data_Stddev_Samp_Fields = {
  __typename?: 'mqtt_missing_data_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mqtt_missing_data" */
export type Mqtt_Missing_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mqtt_Missing_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mqtt_Missing_Data_Stream_Cursor_Value_Input = {
  following_payload?: InputMaybe<Scalars['jsonb']['input']>;
  following_ts?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  previous_payload?: InputMaybe<Scalars['jsonb']['input']>;
  previous_ts?: InputMaybe<Scalars['timestamp']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mqtt_Missing_Data_Sum_Fields = {
  __typename?: 'mqtt_missing_data_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

export type Mqtt_Missing_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Mqtt_Missing_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Mqtt_Missing_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Mqtt_Missing_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Mqtt_Missing_Data_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mqtt_Missing_Data_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Mqtt_Missing_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mqtt_Missing_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mqtt_Missing_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mqtt_Missing_Data_Var_Pop_Fields = {
  __typename?: 'mqtt_missing_data_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mqtt_Missing_Data_Var_Samp_Fields = {
  __typename?: 'mqtt_missing_data_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mqtt_Missing_Data_Variance_Fields = {
  __typename?: 'mqtt_missing_data_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mqtt.parsed" */
export type Mqtt_Parsed = {
  __typename?: 'mqtt_parsed';
  channel1_unit?: Maybe<Scalars['String']['output']>;
  channel1_value?: Maybe<Scalars['numeric']['output']>;
  channel2_unit?: Maybe<Scalars['String']['output']>;
  channel2_value?: Maybe<Scalars['numeric']['output']>;
  channel3_unit?: Maybe<Scalars['String']['output']>;
  channel3_value?: Maybe<Scalars['numeric']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  dbm?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  payload?: Maybe<Scalars['jsonb']['output']>;
  powerfailuredetected?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  total_power_kw?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "mqtt.parsed" */
export type Mqtt_ParsedPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mqtt.parsed" */
export type Mqtt_Parsed_Aggregate = {
  __typename?: 'mqtt_parsed_aggregate';
  aggregate?: Maybe<Mqtt_Parsed_Aggregate_Fields>;
  nodes: Array<Mqtt_Parsed>;
};

/** aggregate fields of "mqtt.parsed" */
export type Mqtt_Parsed_Aggregate_Fields = {
  __typename?: 'mqtt_parsed_aggregate_fields';
  avg?: Maybe<Mqtt_Parsed_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mqtt_Parsed_Max_Fields>;
  min?: Maybe<Mqtt_Parsed_Min_Fields>;
  stddev?: Maybe<Mqtt_Parsed_Stddev_Fields>;
  stddev_pop?: Maybe<Mqtt_Parsed_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mqtt_Parsed_Stddev_Samp_Fields>;
  sum?: Maybe<Mqtt_Parsed_Sum_Fields>;
  var_pop?: Maybe<Mqtt_Parsed_Var_Pop_Fields>;
  var_samp?: Maybe<Mqtt_Parsed_Var_Samp_Fields>;
  variance?: Maybe<Mqtt_Parsed_Variance_Fields>;
};


/** aggregate fields of "mqtt.parsed" */
export type Mqtt_Parsed_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mqtt_Parsed_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mqtt_Parsed_Avg_Fields = {
  __typename?: 'mqtt_parsed_avg_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mqtt.parsed". All fields are combined with a logical 'AND'. */
export type Mqtt_Parsed_Bool_Exp = {
  _and?: InputMaybe<Array<Mqtt_Parsed_Bool_Exp>>;
  _not?: InputMaybe<Mqtt_Parsed_Bool_Exp>;
  _or?: InputMaybe<Array<Mqtt_Parsed_Bool_Exp>>;
  channel1_unit?: InputMaybe<String_Comparison_Exp>;
  channel1_value?: InputMaybe<Numeric_Comparison_Exp>;
  channel2_unit?: InputMaybe<String_Comparison_Exp>;
  channel2_value?: InputMaybe<Numeric_Comparison_Exp>;
  channel3_unit?: InputMaybe<String_Comparison_Exp>;
  channel3_value?: InputMaybe<Numeric_Comparison_Exp>;
  data_source_id?: InputMaybe<String_Comparison_Exp>;
  dbm?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  powerfailuredetected?: InputMaybe<Boolean_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  total_power_kw?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mqtt_Parsed_Max_Fields = {
  __typename?: 'mqtt_parsed_max_fields';
  channel1_unit?: Maybe<Scalars['String']['output']>;
  channel1_value?: Maybe<Scalars['numeric']['output']>;
  channel2_unit?: Maybe<Scalars['String']['output']>;
  channel2_value?: Maybe<Scalars['numeric']['output']>;
  channel3_unit?: Maybe<Scalars['String']['output']>;
  channel3_value?: Maybe<Scalars['numeric']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  dbm?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  total_power_kw?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Mqtt_Parsed_Min_Fields = {
  __typename?: 'mqtt_parsed_min_fields';
  channel1_unit?: Maybe<Scalars['String']['output']>;
  channel1_value?: Maybe<Scalars['numeric']['output']>;
  channel2_unit?: Maybe<Scalars['String']['output']>;
  channel2_value?: Maybe<Scalars['numeric']['output']>;
  channel3_unit?: Maybe<Scalars['String']['output']>;
  channel3_value?: Maybe<Scalars['numeric']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  dbm?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  total_power_kw?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "mqtt.parsed". */
export type Mqtt_Parsed_Order_By = {
  channel1_unit?: InputMaybe<Order_By>;
  channel1_value?: InputMaybe<Order_By>;
  channel2_unit?: InputMaybe<Order_By>;
  channel2_value?: InputMaybe<Order_By>;
  channel3_unit?: InputMaybe<Order_By>;
  channel3_value?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  dbm?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  powerfailuredetected?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  total_power_kw?: InputMaybe<Order_By>;
};

/** select columns of table "mqtt.parsed" */
export enum Mqtt_Parsed_Select_Column {
  /** column name */
  Channel1Unit = 'channel1_unit',
  /** column name */
  Channel1Value = 'channel1_value',
  /** column name */
  Channel2Unit = 'channel2_unit',
  /** column name */
  Channel2Value = 'channel2_value',
  /** column name */
  Channel3Unit = 'channel3_unit',
  /** column name */
  Channel3Value = 'channel3_value',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  Dbm = 'dbm',
  /** column name */
  End = 'end',
  /** column name */
  Payload = 'payload',
  /** column name */
  Powerfailuredetected = 'powerfailuredetected',
  /** column name */
  Start = 'start',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  TotalPowerKw = 'total_power_kw'
}

/** aggregate stddev on columns */
export type Mqtt_Parsed_Stddev_Fields = {
  __typename?: 'mqtt_parsed_stddev_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mqtt_Parsed_Stddev_Pop_Fields = {
  __typename?: 'mqtt_parsed_stddev_pop_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mqtt_Parsed_Stddev_Samp_Fields = {
  __typename?: 'mqtt_parsed_stddev_samp_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mqtt_parsed" */
export type Mqtt_Parsed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mqtt_Parsed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mqtt_Parsed_Stream_Cursor_Value_Input = {
  channel1_unit?: InputMaybe<Scalars['String']['input']>;
  channel1_value?: InputMaybe<Scalars['numeric']['input']>;
  channel2_unit?: InputMaybe<Scalars['String']['input']>;
  channel2_value?: InputMaybe<Scalars['numeric']['input']>;
  channel3_unit?: InputMaybe<Scalars['String']['input']>;
  channel3_value?: InputMaybe<Scalars['numeric']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  dbm?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  powerfailuredetected?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  total_power_kw?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Mqtt_Parsed_Sum_Fields = {
  __typename?: 'mqtt_parsed_sum_fields';
  channel1_value?: Maybe<Scalars['numeric']['output']>;
  channel2_value?: Maybe<Scalars['numeric']['output']>;
  channel3_value?: Maybe<Scalars['numeric']['output']>;
  total_power_kw?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Mqtt_Parsed_Var_Pop_Fields = {
  __typename?: 'mqtt_parsed_var_pop_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mqtt_Parsed_Var_Samp_Fields = {
  __typename?: 'mqtt_parsed_var_samp_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mqtt_Parsed_Variance_Fields = {
  __typename?: 'mqtt_parsed_variance_fields';
  channel1_value?: Maybe<Scalars['Float']['output']>;
  channel2_value?: Maybe<Scalars['Float']['output']>;
  channel3_value?: Maybe<Scalars['Float']['output']>;
  total_power_kw?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters = {
  __typename?: 'mqtt_pressac_meters';
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  meter_type?: Maybe<Meter_Types>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Aggregate = {
  __typename?: 'mqtt_pressac_meters_aggregate';
  aggregate?: Maybe<Mqtt_Pressac_Meters_Aggregate_Fields>;
  nodes: Array<Mqtt_Pressac_Meters>;
};

/** aggregate fields of "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Aggregate_Fields = {
  __typename?: 'mqtt_pressac_meters_aggregate_fields';
  avg?: Maybe<Mqtt_Pressac_Meters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mqtt_Pressac_Meters_Max_Fields>;
  min?: Maybe<Mqtt_Pressac_Meters_Min_Fields>;
  stddev?: Maybe<Mqtt_Pressac_Meters_Stddev_Fields>;
  stddev_pop?: Maybe<Mqtt_Pressac_Meters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mqtt_Pressac_Meters_Stddev_Samp_Fields>;
  sum?: Maybe<Mqtt_Pressac_Meters_Sum_Fields>;
  var_pop?: Maybe<Mqtt_Pressac_Meters_Var_Pop_Fields>;
  var_samp?: Maybe<Mqtt_Pressac_Meters_Var_Samp_Fields>;
  variance?: Maybe<Mqtt_Pressac_Meters_Variance_Fields>;
};


/** aggregate fields of "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mqtt_Pressac_Meters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mqtt_Pressac_Meters_Avg_Fields = {
  __typename?: 'mqtt_pressac_meters_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mqtt.pressac_meters". All fields are combined with a logical 'AND'. */
export type Mqtt_Pressac_Meters_Bool_Exp = {
  _and?: InputMaybe<Array<Mqtt_Pressac_Meters_Bool_Exp>>;
  _not?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
  _or?: InputMaybe<Array<Mqtt_Pressac_Meters_Bool_Exp>>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  data_source_id?: InputMaybe<String_Comparison_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter_type?: InputMaybe<Meter_Types_Bool_Exp>;
  meter_type_id?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Insert_Input = {
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type?: InputMaybe<Meter_Types_Obj_Rel_Insert_Input>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Mqtt_Pressac_Meters_Max_Fields = {
  __typename?: 'mqtt_pressac_meters_max_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Mqtt_Pressac_Meters_Min_Fields = {
  __typename?: 'mqtt_pressac_meters_min_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Mutation_Response = {
  __typename?: 'mqtt_pressac_meters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mqtt_Pressac_Meters>;
};

/** input type for inserting object relation for remote table "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Obj_Rel_Insert_Input = {
  data: Mqtt_Pressac_Meters_Insert_Input;
};

/** Ordering options when selecting data from "mqtt.pressac_meters". */
export type Mqtt_Pressac_Meters_Order_By = {
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type?: InputMaybe<Meter_Types_Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** select columns of table "mqtt.pressac_meters" */
export enum Mqtt_Pressac_Meters_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeterTypeId = 'meter_type_id'
}

/** input type for updating data in table "mqtt.pressac_meters" */
export type Mqtt_Pressac_Meters_Set_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Mqtt_Pressac_Meters_Stddev_Fields = {
  __typename?: 'mqtt_pressac_meters_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mqtt_Pressac_Meters_Stddev_Pop_Fields = {
  __typename?: 'mqtt_pressac_meters_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mqtt_Pressac_Meters_Stddev_Samp_Fields = {
  __typename?: 'mqtt_pressac_meters_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mqtt_pressac_meters" */
export type Mqtt_Pressac_Meters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mqtt_Pressac_Meters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mqtt_Pressac_Meters_Stream_Cursor_Value_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Mqtt_Pressac_Meters_Sum_Fields = {
  __typename?: 'mqtt_pressac_meters_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

export type Mqtt_Pressac_Meters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mqtt_Pressac_Meters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mqtt_Pressac_Meters_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mqtt_Pressac_Meters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mqtt_Pressac_Meters_Var_Pop_Fields = {
  __typename?: 'mqtt_pressac_meters_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mqtt_Pressac_Meters_Var_Samp_Fields = {
  __typename?: 'mqtt_pressac_meters_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mqtt_Pressac_Meters_Variance_Fields = {
  __typename?: 'mqtt_pressac_meters_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mqtt.raw" */
export type Mqtt_Raw = {
  __typename?: 'mqtt_raw';
  id: Scalars['Int']['output'];
  payload: Scalars['jsonb']['output'];
  topic: Scalars['String']['output'];
};


/** columns and relationships of "mqtt.raw" */
export type Mqtt_RawPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mqtt.raw" */
export type Mqtt_Raw_Aggregate = {
  __typename?: 'mqtt_raw_aggregate';
  aggregate?: Maybe<Mqtt_Raw_Aggregate_Fields>;
  nodes: Array<Mqtt_Raw>;
};

/** aggregate fields of "mqtt.raw" */
export type Mqtt_Raw_Aggregate_Fields = {
  __typename?: 'mqtt_raw_aggregate_fields';
  avg?: Maybe<Mqtt_Raw_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mqtt_Raw_Max_Fields>;
  min?: Maybe<Mqtt_Raw_Min_Fields>;
  stddev?: Maybe<Mqtt_Raw_Stddev_Fields>;
  stddev_pop?: Maybe<Mqtt_Raw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mqtt_Raw_Stddev_Samp_Fields>;
  sum?: Maybe<Mqtt_Raw_Sum_Fields>;
  var_pop?: Maybe<Mqtt_Raw_Var_Pop_Fields>;
  var_samp?: Maybe<Mqtt_Raw_Var_Samp_Fields>;
  variance?: Maybe<Mqtt_Raw_Variance_Fields>;
};


/** aggregate fields of "mqtt.raw" */
export type Mqtt_Raw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mqtt_Raw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mqtt_Raw_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Mqtt_Raw_Avg_Fields = {
  __typename?: 'mqtt_raw_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mqtt.raw". All fields are combined with a logical 'AND'. */
export type Mqtt_Raw_Bool_Exp = {
  _and?: InputMaybe<Array<Mqtt_Raw_Bool_Exp>>;
  _not?: InputMaybe<Mqtt_Raw_Bool_Exp>;
  _or?: InputMaybe<Array<Mqtt_Raw_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  topic?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mqtt.raw" */
export enum Mqtt_Raw_Constraint {
  /** unique or primary key constraint on columns "id" */
  RawPkey = 'raw_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mqtt_Raw_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mqtt_Raw_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mqtt_Raw_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "mqtt.raw" */
export type Mqtt_Raw_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mqtt.raw" */
export type Mqtt_Raw_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mqtt_Raw_Max_Fields = {
  __typename?: 'mqtt_raw_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mqtt_Raw_Min_Fields = {
  __typename?: 'mqtt_raw_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mqtt.raw" */
export type Mqtt_Raw_Mutation_Response = {
  __typename?: 'mqtt_raw_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mqtt_Raw>;
};

/** on_conflict condition type for table "mqtt.raw" */
export type Mqtt_Raw_On_Conflict = {
  constraint: Mqtt_Raw_Constraint;
  update_columns?: Array<Mqtt_Raw_Update_Column>;
  where?: InputMaybe<Mqtt_Raw_Bool_Exp>;
};

/** Ordering options when selecting data from "mqtt.raw". */
export type Mqtt_Raw_Order_By = {
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  topic?: InputMaybe<Order_By>;
};

/** columns and relationships of "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned = {
  __typename?: 'mqtt_raw_partitioned';
  id: Scalars['Int']['output'];
  payload: Scalars['jsonb']['output'];
  timestamp: Scalars['timestamp']['output'];
  topic: Scalars['String']['output'];
};


/** columns and relationships of "mqtt.raw_partitioned" */
export type Mqtt_Raw_PartitionedPayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Aggregate = {
  __typename?: 'mqtt_raw_partitioned_aggregate';
  aggregate?: Maybe<Mqtt_Raw_Partitioned_Aggregate_Fields>;
  nodes: Array<Mqtt_Raw_Partitioned>;
};

/** aggregate fields of "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Aggregate_Fields = {
  __typename?: 'mqtt_raw_partitioned_aggregate_fields';
  avg?: Maybe<Mqtt_Raw_Partitioned_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mqtt_Raw_Partitioned_Max_Fields>;
  min?: Maybe<Mqtt_Raw_Partitioned_Min_Fields>;
  stddev?: Maybe<Mqtt_Raw_Partitioned_Stddev_Fields>;
  stddev_pop?: Maybe<Mqtt_Raw_Partitioned_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mqtt_Raw_Partitioned_Stddev_Samp_Fields>;
  sum?: Maybe<Mqtt_Raw_Partitioned_Sum_Fields>;
  var_pop?: Maybe<Mqtt_Raw_Partitioned_Var_Pop_Fields>;
  var_samp?: Maybe<Mqtt_Raw_Partitioned_Var_Samp_Fields>;
  variance?: Maybe<Mqtt_Raw_Partitioned_Variance_Fields>;
};


/** aggregate fields of "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mqtt_Raw_Partitioned_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mqtt_Raw_Partitioned_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Mqtt_Raw_Partitioned_Avg_Fields = {
  __typename?: 'mqtt_raw_partitioned_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mqtt.raw_partitioned". All fields are combined with a logical 'AND'. */
export type Mqtt_Raw_Partitioned_Bool_Exp = {
  _and?: InputMaybe<Array<Mqtt_Raw_Partitioned_Bool_Exp>>;
  _not?: InputMaybe<Mqtt_Raw_Partitioned_Bool_Exp>;
  _or?: InputMaybe<Array<Mqtt_Raw_Partitioned_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  topic?: InputMaybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mqtt_Raw_Partitioned_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mqtt_Raw_Partitioned_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mqtt_Raw_Partitioned_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mqtt_Raw_Partitioned_Max_Fields = {
  __typename?: 'mqtt_raw_partitioned_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mqtt_Raw_Partitioned_Min_Fields = {
  __typename?: 'mqtt_raw_partitioned_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Mutation_Response = {
  __typename?: 'mqtt_raw_partitioned_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mqtt_Raw_Partitioned>;
};

/** Ordering options when selecting data from "mqtt.raw_partitioned". */
export type Mqtt_Raw_Partitioned_Order_By = {
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  topic?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mqtt_Raw_Partitioned_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mqtt.raw_partitioned" */
export enum Mqtt_Raw_Partitioned_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Topic = 'topic'
}

/** input type for updating data in table "mqtt.raw_partitioned" */
export type Mqtt_Raw_Partitioned_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Mqtt_Raw_Partitioned_Stddev_Fields = {
  __typename?: 'mqtt_raw_partitioned_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mqtt_Raw_Partitioned_Stddev_Pop_Fields = {
  __typename?: 'mqtt_raw_partitioned_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mqtt_Raw_Partitioned_Stddev_Samp_Fields = {
  __typename?: 'mqtt_raw_partitioned_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mqtt_raw_partitioned" */
export type Mqtt_Raw_Partitioned_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mqtt_Raw_Partitioned_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mqtt_Raw_Partitioned_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mqtt_Raw_Partitioned_Sum_Fields = {
  __typename?: 'mqtt_raw_partitioned_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

export type Mqtt_Raw_Partitioned_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Mqtt_Raw_Partitioned_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Mqtt_Raw_Partitioned_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Mqtt_Raw_Partitioned_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Mqtt_Raw_Partitioned_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mqtt_Raw_Partitioned_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Mqtt_Raw_Partitioned_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mqtt_Raw_Partitioned_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mqtt_Raw_Partitioned_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mqtt_Raw_Partitioned_Var_Pop_Fields = {
  __typename?: 'mqtt_raw_partitioned_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mqtt_Raw_Partitioned_Var_Samp_Fields = {
  __typename?: 'mqtt_raw_partitioned_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mqtt_Raw_Partitioned_Variance_Fields = {
  __typename?: 'mqtt_raw_partitioned_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** primary key columns input for table: mqtt.raw */
export type Mqtt_Raw_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mqtt_Raw_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mqtt.raw" */
export enum Mqtt_Raw_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Topic = 'topic'
}

/** input type for updating data in table "mqtt.raw" */
export type Mqtt_Raw_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Mqtt_Raw_Stddev_Fields = {
  __typename?: 'mqtt_raw_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mqtt_Raw_Stddev_Pop_Fields = {
  __typename?: 'mqtt_raw_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mqtt_Raw_Stddev_Samp_Fields = {
  __typename?: 'mqtt_raw_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mqtt_raw" */
export type Mqtt_Raw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mqtt_Raw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mqtt_Raw_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mqtt_Raw_Sum_Fields = {
  __typename?: 'mqtt_raw_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "mqtt.raw" */
export enum Mqtt_Raw_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Topic = 'topic'
}

export type Mqtt_Raw_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Mqtt_Raw_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Mqtt_Raw_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Mqtt_Raw_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Mqtt_Raw_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mqtt_Raw_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Mqtt_Raw_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mqtt_Raw_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mqtt_Raw_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mqtt_Raw_Var_Pop_Fields = {
  __typename?: 'mqtt_raw_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mqtt_Raw_Var_Samp_Fields = {
  __typename?: 'mqtt_raw_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mqtt_Raw_Variance_Fields = {
  __typename?: 'mqtt_raw_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "actions" */
  delete_actions?: Maybe<Actions_Mutation_Response>;
  /** delete single row from the table: "actions" */
  delete_actions_by_pk?: Maybe<Actions>;
  /** delete data from the table: "alert_types" */
  delete_alert_types?: Maybe<Alert_Types_Mutation_Response>;
  /** delete single row from the table: "alert_types" */
  delete_alert_types_by_pk?: Maybe<Alert_Types>;
  /** delete data from the table: "alert_user" */
  delete_alert_user?: Maybe<Alert_User_Mutation_Response>;
  /** delete single row from the table: "alert_user" */
  delete_alert_user_by_pk?: Maybe<Alert_User>;
  /** delete data from the table: "alerts" */
  delete_alerts?: Maybe<Alerts_Mutation_Response>;
  /** delete single row from the table: "alerts" */
  delete_alerts_by_pk?: Maybe<Alerts>;
  /** delete data from the table: "area_types" */
  delete_area_types?: Maybe<Area_Types_Mutation_Response>;
  /** delete single row from the table: "area_types" */
  delete_area_types_by_pk?: Maybe<Area_Types>;
  /** delete data from the table: "areas" */
  delete_areas?: Maybe<Areas_Mutation_Response>;
  /** delete single row from the table: "areas" */
  delete_areas_by_pk?: Maybe<Areas>;
  /** delete data from the table: "baselines" */
  delete_baselines?: Maybe<Baselines_Mutation_Response>;
  /** delete single row from the table: "baselines" */
  delete_baselines_by_pk?: Maybe<Baselines>;
  /** delete data from the table: "clients" */
  delete_clients?: Maybe<Clients_Mutation_Response>;
  /** delete single row from the table: "clients" */
  delete_clients_by_pk?: Maybe<Clients>;
  /** delete data from the table: "comments" */
  delete_comments?: Maybe<Comments_Mutation_Response>;
  /** delete single row from the table: "comments" */
  delete_comments_by_pk?: Maybe<Comments>;
  /** delete data from the table: "consumption_by_timestamp" */
  delete_consumption_by_timestamp?: Maybe<Consumption_By_Timestamp_Mutation_Response>;
  /** delete single row from the table: "consumption_by_timestamp" */
  delete_consumption_by_timestamp_by_pk?: Maybe<Consumption_By_Timestamp>;
  /** delete data from the table: "consumption_reference" */
  delete_consumption_reference?: Maybe<Consumption_Reference_Mutation_Response>;
  /** delete single row from the table: "consumption_reference" */
  delete_consumption_reference_by_pk?: Maybe<Consumption_Reference>;
  /** delete data from the table: "consumptions" */
  delete_consumptions?: Maybe<Consumptions_Mutation_Response>;
  /** delete single row from the table: "consumptions" */
  delete_consumptions_by_pk?: Maybe<Consumptions>;
  /** delete data from the table: "contracts" */
  delete_contracts?: Maybe<Contracts_Mutation_Response>;
  /** delete single row from the table: "contracts" */
  delete_contracts_by_pk?: Maybe<Contracts>;
  /** delete data from the table: "cron.job" */
  delete_cron_job?: Maybe<Cron_Job_Mutation_Response>;
  /** delete single row from the table: "cron.job" */
  delete_cron_job_by_pk?: Maybe<Cron_Job>;
  /** delete data from the table: "cron.job_run_details" */
  delete_cron_job_run_details?: Maybe<Cron_Job_Run_Details_Mutation_Response>;
  /** delete single row from the table: "cron.job_run_details" */
  delete_cron_job_run_details_by_pk?: Maybe<Cron_Job_Run_Details>;
  /** delete data from the table: "enedis.history_raw" */
  delete_enedis_history_raw?: Maybe<Enedis_History_Raw_Mutation_Response>;
  /** delete single row from the table: "enedis.history_raw" */
  delete_enedis_history_raw_by_pk?: Maybe<Enedis_History_Raw>;
  /** delete data from the table: "enedis.minutes_raw" */
  delete_enedis_minutes_raw?: Maybe<Enedis_Minutes_Raw_Mutation_Response>;
  /** delete single row from the table: "enedis.minutes_raw" */
  delete_enedis_minutes_raw_by_pk?: Maybe<Enedis_Minutes_Raw>;
  /** delete data from the table: "energy_types" */
  delete_energy_types?: Maybe<Energy_Types_Mutation_Response>;
  /** delete single row from the table: "energy_types" */
  delete_energy_types_by_pk?: Maybe<Energy_Types>;
  /** delete data from the table: "energy_use_types" */
  delete_energy_use_types?: Maybe<Energy_Use_Types_Mutation_Response>;
  /** delete single row from the table: "energy_use_types" */
  delete_energy_use_types_by_pk?: Maybe<Energy_Use_Types>;
  /** delete data from the table: "fabrication_order_epi" */
  delete_fabrication_order_epi?: Maybe<Fabrication_Order_Epi_Mutation_Response>;
  /** delete single row from the table: "fabrication_order_epi" */
  delete_fabrication_order_epi_by_pk?: Maybe<Fabrication_Order_Epi>;
  /** delete data from the table: "fabrication_order_product" */
  delete_fabrication_order_product?: Maybe<Fabrication_Order_Product_Mutation_Response>;
  /** delete single row from the table: "fabrication_order_product" */
  delete_fabrication_order_product_by_pk?: Maybe<Fabrication_Order_Product>;
  /** delete data from the table: "fabrication_orders" */
  delete_fabrication_orders?: Maybe<Fabrication_Orders_Mutation_Response>;
  /** delete single row from the table: "fabrication_orders" */
  delete_fabrication_orders_by_pk?: Maybe<Fabrication_Orders>;
  /** delete data from the table: "incident_closing_reasons" */
  delete_incident_closing_reasons?: Maybe<Incident_Closing_Reasons_Mutation_Response>;
  /** delete single row from the table: "incident_closing_reasons" */
  delete_incident_closing_reasons_by_pk?: Maybe<Incident_Closing_Reasons>;
  /** delete data from the table: "incident_project" */
  delete_incident_project?: Maybe<Incident_Project_Mutation_Response>;
  /** delete single row from the table: "incident_project" */
  delete_incident_project_by_pk?: Maybe<Incident_Project>;
  /** delete data from the table: "incident_statuses" */
  delete_incident_statuses?: Maybe<Incident_Statuses_Mutation_Response>;
  /** delete single row from the table: "incident_statuses" */
  delete_incident_statuses_by_pk?: Maybe<Incident_Statuses>;
  /** delete data from the table: "incident_types" */
  delete_incident_types?: Maybe<Incident_Types_Mutation_Response>;
  /** delete single row from the table: "incident_types" */
  delete_incident_types_by_pk?: Maybe<Incident_Types>;
  /** delete data from the table: "incidents" */
  delete_incidents?: Maybe<Incidents_Mutation_Response>;
  /** delete single row from the table: "incidents" */
  delete_incidents_by_pk?: Maybe<Incidents>;
  /** delete data from the table: "consumption.daily_consumptions" */
  delete_meter_daily_consumptions?: Maybe<Meter_Daily_Consumptions_Mutation_Response>;
  /** delete single row from the table: "consumption.daily_consumptions" */
  delete_meter_daily_consumptions_by_pk?: Maybe<Meter_Daily_Consumptions>;
  /** delete data from the table: "meter_types" */
  delete_meter_types?: Maybe<Meter_Types_Mutation_Response>;
  /** delete single row from the table: "meter_types" */
  delete_meter_types_by_pk?: Maybe<Meter_Types>;
  /** delete data from the table: "meters" */
  delete_meters?: Maybe<Meters_Mutation_Response>;
  /** delete single row from the table: "meters" */
  delete_meters_by_pk?: Maybe<Meters>;
  /** delete data from the table: "mqtt.missing_data" */
  delete_mqtt_missing_data?: Maybe<Mqtt_Missing_Data_Mutation_Response>;
  /** delete data from the table: "mqtt.missing_data_grouped_by_topic" */
  delete_mqtt_missing_data_grouped_by_topic?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Mutation_Response>;
  /** delete single row from the table: "mqtt.missing_data_grouped_by_topic" */
  delete_mqtt_missing_data_grouped_by_topic_by_pk?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** delete data from the table: "mqtt.pressac_meters" */
  delete_mqtt_pressac_meters?: Maybe<Mqtt_Pressac_Meters_Mutation_Response>;
  /** delete data from the table: "mqtt.raw" */
  delete_mqtt_raw?: Maybe<Mqtt_Raw_Mutation_Response>;
  /** delete single row from the table: "mqtt.raw" */
  delete_mqtt_raw_by_pk?: Maybe<Mqtt_Raw>;
  /** delete data from the table: "mqtt.raw_partitioned" */
  delete_mqtt_raw_partitioned?: Maybe<Mqtt_Raw_Partitioned_Mutation_Response>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "objective_milestones" */
  delete_objective_milestones?: Maybe<Objective_Milestones_Mutation_Response>;
  /** delete single row from the table: "objective_milestones" */
  delete_objective_milestones_by_pk?: Maybe<Objective_Milestones>;
  /** delete data from the table: "objective_types" */
  delete_objective_types?: Maybe<Objective_Types_Mutation_Response>;
  /** delete single row from the table: "objective_types" */
  delete_objective_types_by_pk?: Maybe<Objective_Types>;
  /** delete data from the table: "objectives" */
  delete_objectives?: Maybe<Objectives_Mutation_Response>;
  /** delete single row from the table: "objectives" */
  delete_objectives_by_pk?: Maybe<Objectives>;
  /** delete data from the table: "off_production_consumptions" */
  delete_off_production_consumptions?: Maybe<Off_Production_Consumptions_Mutation_Response>;
  /** delete single row from the table: "off_production_consumptions" */
  delete_off_production_consumptions_by_pk?: Maybe<Off_Production_Consumptions>;
  /** delete data from the table: "ofs_by_day" */
  delete_ofs_by_day?: Maybe<Ofs_By_Day_Mutation_Response>;
  /** delete single row from the table: "ofs_by_day" */
  delete_ofs_by_day_by_pk?: Maybe<Ofs_By_Day>;
  /** delete data from the table: "production_hours" */
  delete_production_hours?: Maybe<Production_Hours_Mutation_Response>;
  /** delete single row from the table: "production_hours" */
  delete_production_hours_by_pk?: Maybe<Production_Hours>;
  /** delete data from the table: "production_reporting_frequencies" */
  delete_production_reporting_frequencies?: Maybe<Production_Reporting_Frequencies_Mutation_Response>;
  /** delete single row from the table: "production_reporting_frequencies" */
  delete_production_reporting_frequencies_by_pk?: Maybe<Production_Reporting_Frequencies>;
  /** delete data from the table: "productions" */
  delete_productions?: Maybe<Productions_Mutation_Response>;
  /** delete single row from the table: "productions" */
  delete_productions_by_pk?: Maybe<Productions>;
  /** delete data from the table: "products" */
  delete_products?: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk?: Maybe<Products>;
  /** delete data from the table: "project_ROI_durations" */
  delete_project_ROI_durations?: Maybe<Project_Roi_Durations_Mutation_Response>;
  /** delete single row from the table: "project_ROI_durations" */
  delete_project_ROI_durations_by_pk?: Maybe<Project_Roi_Durations>;
  /** delete data from the table: "project_budget_ranges" */
  delete_project_budget_ranges?: Maybe<Project_Budget_Ranges_Mutation_Response>;
  /** delete single row from the table: "project_budget_ranges" */
  delete_project_budget_ranges_by_pk?: Maybe<Project_Budget_Ranges>;
  /** delete data from the table: "project_complexities" */
  delete_project_complexities?: Maybe<Project_Complexities_Mutation_Response>;
  /** delete single row from the table: "project_complexities" */
  delete_project_complexities_by_pk?: Maybe<Project_Complexities>;
  /** delete data from the table: "project_statuses" */
  delete_project_statuses?: Maybe<Project_Statuses_Mutation_Response>;
  /** delete single row from the table: "project_statuses" */
  delete_project_statuses_by_pk?: Maybe<Project_Statuses>;
  /** delete data from the table: "project_templates" */
  delete_project_templates?: Maybe<Project_Templates_Mutation_Response>;
  /** delete single row from the table: "project_templates" */
  delete_project_templates_by_pk?: Maybe<Project_Templates>;
  /** delete data from the table: "projects" */
  delete_projects?: Maybe<Projects_Mutation_Response>;
  /** delete single row from the table: "projects" */
  delete_projects_by_pk?: Maybe<Projects>;
  /** delete data from the table: "sites" */
  delete_sites?: Maybe<Sites_Mutation_Response>;
  /** delete single row from the table: "sites" */
  delete_sites_by_pk?: Maybe<Sites>;
  /** delete data from the table: "sources" */
  delete_sources?: Maybe<Sources_Mutation_Response>;
  /** delete single row from the table: "sources" */
  delete_sources_by_pk?: Maybe<Sources>;
  /** delete data from the table: "standard_types" */
  delete_standard_types?: Maybe<Standard_Types_Mutation_Response>;
  /** delete single row from the table: "standard_types" */
  delete_standard_types_by_pk?: Maybe<Standard_Types>;
  /** delete data from the table: "standards" */
  delete_standards?: Maybe<Standards_Mutation_Response>;
  /** delete single row from the table: "standards" */
  delete_standards_by_pk?: Maybe<Standards>;
  /** delete data from the table: "subventions" */
  delete_subventions?: Maybe<Subventions_Mutation_Response>;
  /** delete single row from the table: "subventions" */
  delete_subventions_by_pk?: Maybe<Subventions>;
  /** delete data from the table: "tariff_schedules" */
  delete_tariff_schedules?: Maybe<Tariff_Schedules_Mutation_Response>;
  /** delete single row from the table: "tariff_schedules" */
  delete_tariff_schedules_by_pk?: Maybe<Tariff_Schedules>;
  /** delete data from the table: "tariffs" */
  delete_tariffs?: Maybe<Tariffs_Mutation_Response>;
  /** delete single row from the table: "tariffs" */
  delete_tariffs_by_pk?: Maybe<Tariffs>;
  /** delete data from the table: "task_statuses" */
  delete_task_statuses?: Maybe<Task_Statuses_Mutation_Response>;
  /** delete single row from the table: "task_statuses" */
  delete_task_statuses_by_pk?: Maybe<Task_Statuses>;
  /** delete data from the table: "task_types" */
  delete_task_types?: Maybe<Task_Types_Mutation_Response>;
  /** delete single row from the table: "task_types" */
  delete_task_types_by_pk?: Maybe<Task_Types>;
  /** delete data from the table: "tasks" */
  delete_tasks?: Maybe<Tasks_Mutation_Response>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: Maybe<Tasks>;
  /** delete data from the table: "third_party.consumptions" */
  delete_third_party_consumptions?: Maybe<Third_Party_Consumptions_Mutation_Response>;
  /** delete data from the table: "third_party.indexes" */
  delete_third_party_indexes?: Maybe<Third_Party_Indexes_Mutation_Response>;
  /** delete single row from the table: "third_party.indexes" */
  delete_third_party_indexes_by_pk?: Maybe<Third_Party_Indexes>;
  /** delete data from the table: "third_party.sftp_files" */
  delete_third_party_sftp_files?: Maybe<Third_Party_Sftp_Files_Mutation_Response>;
  /** delete single row from the table: "third_party.sftp_files" */
  delete_third_party_sftp_files_by_pk?: Maybe<Third_Party_Sftp_Files>;
  /** delete data from the table: "unit_types" */
  delete_unit_types?: Maybe<Unit_Types_Mutation_Response>;
  /** delete single row from the table: "unit_types" */
  delete_unit_types_by_pk?: Maybe<Unit_Types>;
  /** delete data from the table: "units" */
  delete_units?: Maybe<Units_Mutation_Response>;
  /** delete single row from the table: "units" */
  delete_units_by_pk?: Maybe<Units>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "weather.daily_measures" */
  delete_weather_daily_measures?: Maybe<Weather_Daily_Measures_Mutation_Response>;
  /** delete single row from the table: "weather.daily_measures" */
  delete_weather_daily_measures_by_pk?: Maybe<Weather_Daily_Measures>;
  /** delete data from the table: "weather.measures" */
  delete_weather_measures?: Maybe<Weather_Measures_Mutation_Response>;
  /** delete single row from the table: "weather.measures" */
  delete_weather_measures_by_pk?: Maybe<Weather_Measures>;
  /** delete data from the table: "weather.providers" */
  delete_weather_providers?: Maybe<Weather_Providers_Mutation_Response>;
  /** delete single row from the table: "weather.providers" */
  delete_weather_providers_by_pk?: Maybe<Weather_Providers>;
  /** delete data from the table: "weather.stations" */
  delete_weather_stations?: Maybe<Weather_Stations_Mutation_Response>;
  /** delete single row from the table: "weather.stations" */
  delete_weather_stations_by_pk?: Maybe<Weather_Stations>;
  /** delete data from the table: "weekdays" */
  delete_weekdays?: Maybe<Weekdays_Mutation_Response>;
  /** delete single row from the table: "weekdays" */
  delete_weekdays_by_pk?: Maybe<Weekdays>;
  /** insert data into the table: "actions" */
  insert_actions?: Maybe<Actions_Mutation_Response>;
  /** insert a single row into the table: "actions" */
  insert_actions_one?: Maybe<Actions>;
  /** insert data into the table: "alert_types" */
  insert_alert_types?: Maybe<Alert_Types_Mutation_Response>;
  /** insert a single row into the table: "alert_types" */
  insert_alert_types_one?: Maybe<Alert_Types>;
  /** insert data into the table: "alert_user" */
  insert_alert_user?: Maybe<Alert_User_Mutation_Response>;
  /** insert a single row into the table: "alert_user" */
  insert_alert_user_one?: Maybe<Alert_User>;
  /** insert data into the table: "alerts" */
  insert_alerts?: Maybe<Alerts_Mutation_Response>;
  /** insert a single row into the table: "alerts" */
  insert_alerts_one?: Maybe<Alerts>;
  /** insert data into the table: "area_types" */
  insert_area_types?: Maybe<Area_Types_Mutation_Response>;
  /** insert a single row into the table: "area_types" */
  insert_area_types_one?: Maybe<Area_Types>;
  /** insert data into the table: "areas" */
  insert_areas?: Maybe<Areas_Mutation_Response>;
  /** insert a single row into the table: "areas" */
  insert_areas_one?: Maybe<Areas>;
  /** insert data into the table: "baselines" */
  insert_baselines?: Maybe<Baselines_Mutation_Response>;
  /** insert a single row into the table: "baselines" */
  insert_baselines_one?: Maybe<Baselines>;
  /** insert data into the table: "clients" */
  insert_clients?: Maybe<Clients_Mutation_Response>;
  /** insert a single row into the table: "clients" */
  insert_clients_one?: Maybe<Clients>;
  /** insert data into the table: "comments" */
  insert_comments?: Maybe<Comments_Mutation_Response>;
  /** insert a single row into the table: "comments" */
  insert_comments_one?: Maybe<Comments>;
  /** insert data into the table: "consumption_by_timestamp" */
  insert_consumption_by_timestamp?: Maybe<Consumption_By_Timestamp_Mutation_Response>;
  /** insert a single row into the table: "consumption_by_timestamp" */
  insert_consumption_by_timestamp_one?: Maybe<Consumption_By_Timestamp>;
  /** insert data into the table: "consumption_reference" */
  insert_consumption_reference?: Maybe<Consumption_Reference_Mutation_Response>;
  /** insert a single row into the table: "consumption_reference" */
  insert_consumption_reference_one?: Maybe<Consumption_Reference>;
  /** insert data into the table: "consumptions" */
  insert_consumptions?: Maybe<Consumptions_Mutation_Response>;
  /** insert a single row into the table: "consumptions" */
  insert_consumptions_one?: Maybe<Consumptions>;
  /** insert data into the table: "contracts" */
  insert_contracts?: Maybe<Contracts_Mutation_Response>;
  /** insert a single row into the table: "contracts" */
  insert_contracts_one?: Maybe<Contracts>;
  /** insert data into the table: "cron.job" */
  insert_cron_job?: Maybe<Cron_Job_Mutation_Response>;
  /** insert a single row into the table: "cron.job" */
  insert_cron_job_one?: Maybe<Cron_Job>;
  /** insert data into the table: "cron.job_run_details" */
  insert_cron_job_run_details?: Maybe<Cron_Job_Run_Details_Mutation_Response>;
  /** insert a single row into the table: "cron.job_run_details" */
  insert_cron_job_run_details_one?: Maybe<Cron_Job_Run_Details>;
  /** insert data into the table: "enedis.history_raw" */
  insert_enedis_history_raw?: Maybe<Enedis_History_Raw_Mutation_Response>;
  /** insert a single row into the table: "enedis.history_raw" */
  insert_enedis_history_raw_one?: Maybe<Enedis_History_Raw>;
  /** insert data into the table: "enedis.minutes_raw" */
  insert_enedis_minutes_raw?: Maybe<Enedis_Minutes_Raw_Mutation_Response>;
  /** insert a single row into the table: "enedis.minutes_raw" */
  insert_enedis_minutes_raw_one?: Maybe<Enedis_Minutes_Raw>;
  /** insert data into the table: "energy_types" */
  insert_energy_types?: Maybe<Energy_Types_Mutation_Response>;
  /** insert a single row into the table: "energy_types" */
  insert_energy_types_one?: Maybe<Energy_Types>;
  /** insert data into the table: "energy_use_types" */
  insert_energy_use_types?: Maybe<Energy_Use_Types_Mutation_Response>;
  /** insert a single row into the table: "energy_use_types" */
  insert_energy_use_types_one?: Maybe<Energy_Use_Types>;
  /** insert data into the table: "fabrication_order_epi" */
  insert_fabrication_order_epi?: Maybe<Fabrication_Order_Epi_Mutation_Response>;
  /** insert a single row into the table: "fabrication_order_epi" */
  insert_fabrication_order_epi_one?: Maybe<Fabrication_Order_Epi>;
  /** insert data into the table: "fabrication_order_product" */
  insert_fabrication_order_product?: Maybe<Fabrication_Order_Product_Mutation_Response>;
  /** insert a single row into the table: "fabrication_order_product" */
  insert_fabrication_order_product_one?: Maybe<Fabrication_Order_Product>;
  /** insert data into the table: "fabrication_orders" */
  insert_fabrication_orders?: Maybe<Fabrication_Orders_Mutation_Response>;
  /** insert a single row into the table: "fabrication_orders" */
  insert_fabrication_orders_one?: Maybe<Fabrication_Orders>;
  /** insert data into the table: "incident_closing_reasons" */
  insert_incident_closing_reasons?: Maybe<Incident_Closing_Reasons_Mutation_Response>;
  /** insert a single row into the table: "incident_closing_reasons" */
  insert_incident_closing_reasons_one?: Maybe<Incident_Closing_Reasons>;
  /** insert data into the table: "incident_project" */
  insert_incident_project?: Maybe<Incident_Project_Mutation_Response>;
  /** insert a single row into the table: "incident_project" */
  insert_incident_project_one?: Maybe<Incident_Project>;
  /** insert data into the table: "incident_statuses" */
  insert_incident_statuses?: Maybe<Incident_Statuses_Mutation_Response>;
  /** insert a single row into the table: "incident_statuses" */
  insert_incident_statuses_one?: Maybe<Incident_Statuses>;
  /** insert data into the table: "incident_types" */
  insert_incident_types?: Maybe<Incident_Types_Mutation_Response>;
  /** insert a single row into the table: "incident_types" */
  insert_incident_types_one?: Maybe<Incident_Types>;
  /** insert data into the table: "incidents" */
  insert_incidents?: Maybe<Incidents_Mutation_Response>;
  /** insert a single row into the table: "incidents" */
  insert_incidents_one?: Maybe<Incidents>;
  /** insert data into the table: "consumption.daily_consumptions" */
  insert_meter_daily_consumptions?: Maybe<Meter_Daily_Consumptions_Mutation_Response>;
  /** insert a single row into the table: "consumption.daily_consumptions" */
  insert_meter_daily_consumptions_one?: Maybe<Meter_Daily_Consumptions>;
  /** insert data into the table: "meter_types" */
  insert_meter_types?: Maybe<Meter_Types_Mutation_Response>;
  /** insert a single row into the table: "meter_types" */
  insert_meter_types_one?: Maybe<Meter_Types>;
  /** insert data into the table: "meters" */
  insert_meters?: Maybe<Meters_Mutation_Response>;
  /** insert a single row into the table: "meters" */
  insert_meters_one?: Maybe<Meters>;
  /** insert data into the table: "mqtt.missing_data" */
  insert_mqtt_missing_data?: Maybe<Mqtt_Missing_Data_Mutation_Response>;
  /** insert data into the table: "mqtt.missing_data_grouped_by_topic" */
  insert_mqtt_missing_data_grouped_by_topic?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Mutation_Response>;
  /** insert a single row into the table: "mqtt.missing_data_grouped_by_topic" */
  insert_mqtt_missing_data_grouped_by_topic_one?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** insert a single row into the table: "mqtt.missing_data" */
  insert_mqtt_missing_data_one?: Maybe<Mqtt_Missing_Data>;
  /** insert data into the table: "mqtt.pressac_meters" */
  insert_mqtt_pressac_meters?: Maybe<Mqtt_Pressac_Meters_Mutation_Response>;
  /** insert a single row into the table: "mqtt.pressac_meters" */
  insert_mqtt_pressac_meters_one?: Maybe<Mqtt_Pressac_Meters>;
  /** insert data into the table: "mqtt.raw" */
  insert_mqtt_raw?: Maybe<Mqtt_Raw_Mutation_Response>;
  /** insert a single row into the table: "mqtt.raw" */
  insert_mqtt_raw_one?: Maybe<Mqtt_Raw>;
  /** insert data into the table: "mqtt.raw_partitioned" */
  insert_mqtt_raw_partitioned?: Maybe<Mqtt_Raw_Partitioned_Mutation_Response>;
  /** insert a single row into the table: "mqtt.raw_partitioned" */
  insert_mqtt_raw_partitioned_one?: Maybe<Mqtt_Raw_Partitioned>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "objective_milestones" */
  insert_objective_milestones?: Maybe<Objective_Milestones_Mutation_Response>;
  /** insert a single row into the table: "objective_milestones" */
  insert_objective_milestones_one?: Maybe<Objective_Milestones>;
  /** insert data into the table: "objective_types" */
  insert_objective_types?: Maybe<Objective_Types_Mutation_Response>;
  /** insert a single row into the table: "objective_types" */
  insert_objective_types_one?: Maybe<Objective_Types>;
  /** insert data into the table: "objectives" */
  insert_objectives?: Maybe<Objectives_Mutation_Response>;
  /** insert a single row into the table: "objectives" */
  insert_objectives_one?: Maybe<Objectives>;
  /** insert data into the table: "off_production_consumptions" */
  insert_off_production_consumptions?: Maybe<Off_Production_Consumptions_Mutation_Response>;
  /** insert a single row into the table: "off_production_consumptions" */
  insert_off_production_consumptions_one?: Maybe<Off_Production_Consumptions>;
  /** insert data into the table: "ofs_by_day" */
  insert_ofs_by_day?: Maybe<Ofs_By_Day_Mutation_Response>;
  /** insert a single row into the table: "ofs_by_day" */
  insert_ofs_by_day_one?: Maybe<Ofs_By_Day>;
  /** insert data into the table: "production_hours" */
  insert_production_hours?: Maybe<Production_Hours_Mutation_Response>;
  /** insert a single row into the table: "production_hours" */
  insert_production_hours_one?: Maybe<Production_Hours>;
  /** insert data into the table: "production_reporting_frequencies" */
  insert_production_reporting_frequencies?: Maybe<Production_Reporting_Frequencies_Mutation_Response>;
  /** insert a single row into the table: "production_reporting_frequencies" */
  insert_production_reporting_frequencies_one?: Maybe<Production_Reporting_Frequencies>;
  /** insert data into the table: "productions" */
  insert_productions?: Maybe<Productions_Mutation_Response>;
  /** insert a single row into the table: "productions" */
  insert_productions_one?: Maybe<Productions>;
  /** insert data into the table: "products" */
  insert_products?: Maybe<Products_Mutation_Response>;
  /** insert a single row into the table: "products" */
  insert_products_one?: Maybe<Products>;
  /** insert data into the table: "project_ROI_durations" */
  insert_project_ROI_durations?: Maybe<Project_Roi_Durations_Mutation_Response>;
  /** insert a single row into the table: "project_ROI_durations" */
  insert_project_ROI_durations_one?: Maybe<Project_Roi_Durations>;
  /** insert data into the table: "project_budget_ranges" */
  insert_project_budget_ranges?: Maybe<Project_Budget_Ranges_Mutation_Response>;
  /** insert a single row into the table: "project_budget_ranges" */
  insert_project_budget_ranges_one?: Maybe<Project_Budget_Ranges>;
  /** insert data into the table: "project_complexities" */
  insert_project_complexities?: Maybe<Project_Complexities_Mutation_Response>;
  /** insert a single row into the table: "project_complexities" */
  insert_project_complexities_one?: Maybe<Project_Complexities>;
  /** insert data into the table: "project_statuses" */
  insert_project_statuses?: Maybe<Project_Statuses_Mutation_Response>;
  /** insert a single row into the table: "project_statuses" */
  insert_project_statuses_one?: Maybe<Project_Statuses>;
  /** insert data into the table: "project_templates" */
  insert_project_templates?: Maybe<Project_Templates_Mutation_Response>;
  /** insert a single row into the table: "project_templates" */
  insert_project_templates_one?: Maybe<Project_Templates>;
  /** insert data into the table: "projects" */
  insert_projects?: Maybe<Projects_Mutation_Response>;
  /** insert a single row into the table: "projects" */
  insert_projects_one?: Maybe<Projects>;
  /** insert data into the table: "sites" */
  insert_sites?: Maybe<Sites_Mutation_Response>;
  /** insert a single row into the table: "sites" */
  insert_sites_one?: Maybe<Sites>;
  /** insert data into the table: "sources" */
  insert_sources?: Maybe<Sources_Mutation_Response>;
  /** insert a single row into the table: "sources" */
  insert_sources_one?: Maybe<Sources>;
  /** insert data into the table: "standard_types" */
  insert_standard_types?: Maybe<Standard_Types_Mutation_Response>;
  /** insert a single row into the table: "standard_types" */
  insert_standard_types_one?: Maybe<Standard_Types>;
  /** insert data into the table: "standards" */
  insert_standards?: Maybe<Standards_Mutation_Response>;
  /** insert a single row into the table: "standards" */
  insert_standards_one?: Maybe<Standards>;
  /** insert data into the table: "subventions" */
  insert_subventions?: Maybe<Subventions_Mutation_Response>;
  /** insert a single row into the table: "subventions" */
  insert_subventions_one?: Maybe<Subventions>;
  /** insert data into the table: "tariff_schedules" */
  insert_tariff_schedules?: Maybe<Tariff_Schedules_Mutation_Response>;
  /** insert a single row into the table: "tariff_schedules" */
  insert_tariff_schedules_one?: Maybe<Tariff_Schedules>;
  /** insert data into the table: "tariffs" */
  insert_tariffs?: Maybe<Tariffs_Mutation_Response>;
  /** insert a single row into the table: "tariffs" */
  insert_tariffs_one?: Maybe<Tariffs>;
  /** insert data into the table: "task_statuses" */
  insert_task_statuses?: Maybe<Task_Statuses_Mutation_Response>;
  /** insert a single row into the table: "task_statuses" */
  insert_task_statuses_one?: Maybe<Task_Statuses>;
  /** insert data into the table: "task_types" */
  insert_task_types?: Maybe<Task_Types_Mutation_Response>;
  /** insert a single row into the table: "task_types" */
  insert_task_types_one?: Maybe<Task_Types>;
  /** insert data into the table: "tasks" */
  insert_tasks?: Maybe<Tasks_Mutation_Response>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: Maybe<Tasks>;
  /** insert data into the table: "third_party.consumptions" */
  insert_third_party_consumptions?: Maybe<Third_Party_Consumptions_Mutation_Response>;
  /** insert a single row into the table: "third_party.consumptions" */
  insert_third_party_consumptions_one?: Maybe<Third_Party_Consumptions>;
  /** insert data into the table: "third_party.indexes" */
  insert_third_party_indexes?: Maybe<Third_Party_Indexes_Mutation_Response>;
  /** insert a single row into the table: "third_party.indexes" */
  insert_third_party_indexes_one?: Maybe<Third_Party_Indexes>;
  /** insert data into the table: "third_party.sftp_files" */
  insert_third_party_sftp_files?: Maybe<Third_Party_Sftp_Files_Mutation_Response>;
  /** insert a single row into the table: "third_party.sftp_files" */
  insert_third_party_sftp_files_one?: Maybe<Third_Party_Sftp_Files>;
  /** insert data into the table: "unit_types" */
  insert_unit_types?: Maybe<Unit_Types_Mutation_Response>;
  /** insert a single row into the table: "unit_types" */
  insert_unit_types_one?: Maybe<Unit_Types>;
  /** insert data into the table: "units" */
  insert_units?: Maybe<Units_Mutation_Response>;
  /** insert a single row into the table: "units" */
  insert_units_one?: Maybe<Units>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "weather.daily_measures" */
  insert_weather_daily_measures?: Maybe<Weather_Daily_Measures_Mutation_Response>;
  /** insert a single row into the table: "weather.daily_measures" */
  insert_weather_daily_measures_one?: Maybe<Weather_Daily_Measures>;
  /** insert data into the table: "weather.measures" */
  insert_weather_measures?: Maybe<Weather_Measures_Mutation_Response>;
  /** insert a single row into the table: "weather.measures" */
  insert_weather_measures_one?: Maybe<Weather_Measures>;
  /** insert data into the table: "weather.providers" */
  insert_weather_providers?: Maybe<Weather_Providers_Mutation_Response>;
  /** insert a single row into the table: "weather.providers" */
  insert_weather_providers_one?: Maybe<Weather_Providers>;
  /** insert data into the table: "weather.stations" */
  insert_weather_stations?: Maybe<Weather_Stations_Mutation_Response>;
  /** insert a single row into the table: "weather.stations" */
  insert_weather_stations_one?: Maybe<Weather_Stations>;
  /** insert data into the table: "weekdays" */
  insert_weekdays?: Maybe<Weekdays_Mutation_Response>;
  /** insert a single row into the table: "weekdays" */
  insert_weekdays_one?: Maybe<Weekdays>;
  /** update data of the table: "actions" */
  update_actions?: Maybe<Actions_Mutation_Response>;
  /** update single row of the table: "actions" */
  update_actions_by_pk?: Maybe<Actions>;
  /** update multiples rows of table: "actions" */
  update_actions_many?: Maybe<Array<Maybe<Actions_Mutation_Response>>>;
  /** update data of the table: "alert_types" */
  update_alert_types?: Maybe<Alert_Types_Mutation_Response>;
  /** update single row of the table: "alert_types" */
  update_alert_types_by_pk?: Maybe<Alert_Types>;
  /** update multiples rows of table: "alert_types" */
  update_alert_types_many?: Maybe<Array<Maybe<Alert_Types_Mutation_Response>>>;
  /** update data of the table: "alert_user" */
  update_alert_user?: Maybe<Alert_User_Mutation_Response>;
  /** update single row of the table: "alert_user" */
  update_alert_user_by_pk?: Maybe<Alert_User>;
  /** update multiples rows of table: "alert_user" */
  update_alert_user_many?: Maybe<Array<Maybe<Alert_User_Mutation_Response>>>;
  /** update data of the table: "alerts" */
  update_alerts?: Maybe<Alerts_Mutation_Response>;
  /** update single row of the table: "alerts" */
  update_alerts_by_pk?: Maybe<Alerts>;
  /** update multiples rows of table: "alerts" */
  update_alerts_many?: Maybe<Array<Maybe<Alerts_Mutation_Response>>>;
  /** update data of the table: "area_types" */
  update_area_types?: Maybe<Area_Types_Mutation_Response>;
  /** update single row of the table: "area_types" */
  update_area_types_by_pk?: Maybe<Area_Types>;
  /** update multiples rows of table: "area_types" */
  update_area_types_many?: Maybe<Array<Maybe<Area_Types_Mutation_Response>>>;
  /** update data of the table: "areas" */
  update_areas?: Maybe<Areas_Mutation_Response>;
  /** update single row of the table: "areas" */
  update_areas_by_pk?: Maybe<Areas>;
  /** update multiples rows of table: "areas" */
  update_areas_many?: Maybe<Array<Maybe<Areas_Mutation_Response>>>;
  /** update data of the table: "baselines" */
  update_baselines?: Maybe<Baselines_Mutation_Response>;
  /** update single row of the table: "baselines" */
  update_baselines_by_pk?: Maybe<Baselines>;
  /** update multiples rows of table: "baselines" */
  update_baselines_many?: Maybe<Array<Maybe<Baselines_Mutation_Response>>>;
  /** update data of the table: "clients" */
  update_clients?: Maybe<Clients_Mutation_Response>;
  /** update single row of the table: "clients" */
  update_clients_by_pk?: Maybe<Clients>;
  /** update multiples rows of table: "clients" */
  update_clients_many?: Maybe<Array<Maybe<Clients_Mutation_Response>>>;
  /** update data of the table: "comments" */
  update_comments?: Maybe<Comments_Mutation_Response>;
  /** update single row of the table: "comments" */
  update_comments_by_pk?: Maybe<Comments>;
  /** update multiples rows of table: "comments" */
  update_comments_many?: Maybe<Array<Maybe<Comments_Mutation_Response>>>;
  /** update data of the table: "consumption_by_timestamp" */
  update_consumption_by_timestamp?: Maybe<Consumption_By_Timestamp_Mutation_Response>;
  /** update single row of the table: "consumption_by_timestamp" */
  update_consumption_by_timestamp_by_pk?: Maybe<Consumption_By_Timestamp>;
  /** update multiples rows of table: "consumption_by_timestamp" */
  update_consumption_by_timestamp_many?: Maybe<Array<Maybe<Consumption_By_Timestamp_Mutation_Response>>>;
  /** update data of the table: "consumption_reference" */
  update_consumption_reference?: Maybe<Consumption_Reference_Mutation_Response>;
  /** update single row of the table: "consumption_reference" */
  update_consumption_reference_by_pk?: Maybe<Consumption_Reference>;
  /** update multiples rows of table: "consumption_reference" */
  update_consumption_reference_many?: Maybe<Array<Maybe<Consumption_Reference_Mutation_Response>>>;
  /** update data of the table: "consumptions" */
  update_consumptions?: Maybe<Consumptions_Mutation_Response>;
  /** update single row of the table: "consumptions" */
  update_consumptions_by_pk?: Maybe<Consumptions>;
  /** update multiples rows of table: "consumptions" */
  update_consumptions_many?: Maybe<Array<Maybe<Consumptions_Mutation_Response>>>;
  /** update data of the table: "contracts" */
  update_contracts?: Maybe<Contracts_Mutation_Response>;
  /** update single row of the table: "contracts" */
  update_contracts_by_pk?: Maybe<Contracts>;
  /** update multiples rows of table: "contracts" */
  update_contracts_many?: Maybe<Array<Maybe<Contracts_Mutation_Response>>>;
  /** update data of the table: "cron.job" */
  update_cron_job?: Maybe<Cron_Job_Mutation_Response>;
  /** update single row of the table: "cron.job" */
  update_cron_job_by_pk?: Maybe<Cron_Job>;
  /** update multiples rows of table: "cron.job" */
  update_cron_job_many?: Maybe<Array<Maybe<Cron_Job_Mutation_Response>>>;
  /** update data of the table: "cron.job_run_details" */
  update_cron_job_run_details?: Maybe<Cron_Job_Run_Details_Mutation_Response>;
  /** update single row of the table: "cron.job_run_details" */
  update_cron_job_run_details_by_pk?: Maybe<Cron_Job_Run_Details>;
  /** update multiples rows of table: "cron.job_run_details" */
  update_cron_job_run_details_many?: Maybe<Array<Maybe<Cron_Job_Run_Details_Mutation_Response>>>;
  /** update data of the table: "enedis.history_raw" */
  update_enedis_history_raw?: Maybe<Enedis_History_Raw_Mutation_Response>;
  /** update single row of the table: "enedis.history_raw" */
  update_enedis_history_raw_by_pk?: Maybe<Enedis_History_Raw>;
  /** update multiples rows of table: "enedis.history_raw" */
  update_enedis_history_raw_many?: Maybe<Array<Maybe<Enedis_History_Raw_Mutation_Response>>>;
  /** update data of the table: "enedis.minutes_raw" */
  update_enedis_minutes_raw?: Maybe<Enedis_Minutes_Raw_Mutation_Response>;
  /** update single row of the table: "enedis.minutes_raw" */
  update_enedis_minutes_raw_by_pk?: Maybe<Enedis_Minutes_Raw>;
  /** update multiples rows of table: "enedis.minutes_raw" */
  update_enedis_minutes_raw_many?: Maybe<Array<Maybe<Enedis_Minutes_Raw_Mutation_Response>>>;
  /** update data of the table: "energy_types" */
  update_energy_types?: Maybe<Energy_Types_Mutation_Response>;
  /** update single row of the table: "energy_types" */
  update_energy_types_by_pk?: Maybe<Energy_Types>;
  /** update multiples rows of table: "energy_types" */
  update_energy_types_many?: Maybe<Array<Maybe<Energy_Types_Mutation_Response>>>;
  /** update data of the table: "energy_use_types" */
  update_energy_use_types?: Maybe<Energy_Use_Types_Mutation_Response>;
  /** update single row of the table: "energy_use_types" */
  update_energy_use_types_by_pk?: Maybe<Energy_Use_Types>;
  /** update multiples rows of table: "energy_use_types" */
  update_energy_use_types_many?: Maybe<Array<Maybe<Energy_Use_Types_Mutation_Response>>>;
  /** update data of the table: "fabrication_order_epi" */
  update_fabrication_order_epi?: Maybe<Fabrication_Order_Epi_Mutation_Response>;
  /** update single row of the table: "fabrication_order_epi" */
  update_fabrication_order_epi_by_pk?: Maybe<Fabrication_Order_Epi>;
  /** update multiples rows of table: "fabrication_order_epi" */
  update_fabrication_order_epi_many?: Maybe<Array<Maybe<Fabrication_Order_Epi_Mutation_Response>>>;
  /** update data of the table: "fabrication_order_product" */
  update_fabrication_order_product?: Maybe<Fabrication_Order_Product_Mutation_Response>;
  /** update single row of the table: "fabrication_order_product" */
  update_fabrication_order_product_by_pk?: Maybe<Fabrication_Order_Product>;
  /** update multiples rows of table: "fabrication_order_product" */
  update_fabrication_order_product_many?: Maybe<Array<Maybe<Fabrication_Order_Product_Mutation_Response>>>;
  /** update data of the table: "fabrication_orders" */
  update_fabrication_orders?: Maybe<Fabrication_Orders_Mutation_Response>;
  /** update single row of the table: "fabrication_orders" */
  update_fabrication_orders_by_pk?: Maybe<Fabrication_Orders>;
  /** update multiples rows of table: "fabrication_orders" */
  update_fabrication_orders_many?: Maybe<Array<Maybe<Fabrication_Orders_Mutation_Response>>>;
  /** update data of the table: "incident_closing_reasons" */
  update_incident_closing_reasons?: Maybe<Incident_Closing_Reasons_Mutation_Response>;
  /** update single row of the table: "incident_closing_reasons" */
  update_incident_closing_reasons_by_pk?: Maybe<Incident_Closing_Reasons>;
  /** update multiples rows of table: "incident_closing_reasons" */
  update_incident_closing_reasons_many?: Maybe<Array<Maybe<Incident_Closing_Reasons_Mutation_Response>>>;
  /** update data of the table: "incident_project" */
  update_incident_project?: Maybe<Incident_Project_Mutation_Response>;
  /** update single row of the table: "incident_project" */
  update_incident_project_by_pk?: Maybe<Incident_Project>;
  /** update multiples rows of table: "incident_project" */
  update_incident_project_many?: Maybe<Array<Maybe<Incident_Project_Mutation_Response>>>;
  /** update data of the table: "incident_statuses" */
  update_incident_statuses?: Maybe<Incident_Statuses_Mutation_Response>;
  /** update single row of the table: "incident_statuses" */
  update_incident_statuses_by_pk?: Maybe<Incident_Statuses>;
  /** update multiples rows of table: "incident_statuses" */
  update_incident_statuses_many?: Maybe<Array<Maybe<Incident_Statuses_Mutation_Response>>>;
  /** update data of the table: "incident_types" */
  update_incident_types?: Maybe<Incident_Types_Mutation_Response>;
  /** update single row of the table: "incident_types" */
  update_incident_types_by_pk?: Maybe<Incident_Types>;
  /** update multiples rows of table: "incident_types" */
  update_incident_types_many?: Maybe<Array<Maybe<Incident_Types_Mutation_Response>>>;
  /** update data of the table: "incidents" */
  update_incidents?: Maybe<Incidents_Mutation_Response>;
  /** update single row of the table: "incidents" */
  update_incidents_by_pk?: Maybe<Incidents>;
  /** update multiples rows of table: "incidents" */
  update_incidents_many?: Maybe<Array<Maybe<Incidents_Mutation_Response>>>;
  /** update data of the table: "consumption.daily_consumptions" */
  update_meter_daily_consumptions?: Maybe<Meter_Daily_Consumptions_Mutation_Response>;
  /** update single row of the table: "consumption.daily_consumptions" */
  update_meter_daily_consumptions_by_pk?: Maybe<Meter_Daily_Consumptions>;
  /** update multiples rows of table: "consumption.daily_consumptions" */
  update_meter_daily_consumptions_many?: Maybe<Array<Maybe<Meter_Daily_Consumptions_Mutation_Response>>>;
  /** update data of the table: "meter_types" */
  update_meter_types?: Maybe<Meter_Types_Mutation_Response>;
  /** update single row of the table: "meter_types" */
  update_meter_types_by_pk?: Maybe<Meter_Types>;
  /** update multiples rows of table: "meter_types" */
  update_meter_types_many?: Maybe<Array<Maybe<Meter_Types_Mutation_Response>>>;
  /** update data of the table: "meters" */
  update_meters?: Maybe<Meters_Mutation_Response>;
  /** update single row of the table: "meters" */
  update_meters_by_pk?: Maybe<Meters>;
  /** update multiples rows of table: "meters" */
  update_meters_many?: Maybe<Array<Maybe<Meters_Mutation_Response>>>;
  /** update data of the table: "mqtt.missing_data" */
  update_mqtt_missing_data?: Maybe<Mqtt_Missing_Data_Mutation_Response>;
  /** update data of the table: "mqtt.missing_data_grouped_by_topic" */
  update_mqtt_missing_data_grouped_by_topic?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Mutation_Response>;
  /** update single row of the table: "mqtt.missing_data_grouped_by_topic" */
  update_mqtt_missing_data_grouped_by_topic_by_pk?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** update multiples rows of table: "mqtt.missing_data_grouped_by_topic" */
  update_mqtt_missing_data_grouped_by_topic_many?: Maybe<Array<Maybe<Mqtt_Missing_Data_Grouped_By_Topic_Mutation_Response>>>;
  /** update multiples rows of table: "mqtt.missing_data" */
  update_mqtt_missing_data_many?: Maybe<Array<Maybe<Mqtt_Missing_Data_Mutation_Response>>>;
  /** update data of the table: "mqtt.pressac_meters" */
  update_mqtt_pressac_meters?: Maybe<Mqtt_Pressac_Meters_Mutation_Response>;
  /** update multiples rows of table: "mqtt.pressac_meters" */
  update_mqtt_pressac_meters_many?: Maybe<Array<Maybe<Mqtt_Pressac_Meters_Mutation_Response>>>;
  /** update data of the table: "mqtt.raw" */
  update_mqtt_raw?: Maybe<Mqtt_Raw_Mutation_Response>;
  /** update single row of the table: "mqtt.raw" */
  update_mqtt_raw_by_pk?: Maybe<Mqtt_Raw>;
  /** update multiples rows of table: "mqtt.raw" */
  update_mqtt_raw_many?: Maybe<Array<Maybe<Mqtt_Raw_Mutation_Response>>>;
  /** update data of the table: "mqtt.raw_partitioned" */
  update_mqtt_raw_partitioned?: Maybe<Mqtt_Raw_Partitioned_Mutation_Response>;
  /** update multiples rows of table: "mqtt.raw_partitioned" */
  update_mqtt_raw_partitioned_many?: Maybe<Array<Maybe<Mqtt_Raw_Partitioned_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "objective_milestones" */
  update_objective_milestones?: Maybe<Objective_Milestones_Mutation_Response>;
  /** update single row of the table: "objective_milestones" */
  update_objective_milestones_by_pk?: Maybe<Objective_Milestones>;
  /** update multiples rows of table: "objective_milestones" */
  update_objective_milestones_many?: Maybe<Array<Maybe<Objective_Milestones_Mutation_Response>>>;
  /** update data of the table: "objective_types" */
  update_objective_types?: Maybe<Objective_Types_Mutation_Response>;
  /** update single row of the table: "objective_types" */
  update_objective_types_by_pk?: Maybe<Objective_Types>;
  /** update multiples rows of table: "objective_types" */
  update_objective_types_many?: Maybe<Array<Maybe<Objective_Types_Mutation_Response>>>;
  /** update data of the table: "objectives" */
  update_objectives?: Maybe<Objectives_Mutation_Response>;
  /** update single row of the table: "objectives" */
  update_objectives_by_pk?: Maybe<Objectives>;
  /** update multiples rows of table: "objectives" */
  update_objectives_many?: Maybe<Array<Maybe<Objectives_Mutation_Response>>>;
  /** update data of the table: "off_production_consumptions" */
  update_off_production_consumptions?: Maybe<Off_Production_Consumptions_Mutation_Response>;
  /** update single row of the table: "off_production_consumptions" */
  update_off_production_consumptions_by_pk?: Maybe<Off_Production_Consumptions>;
  /** update multiples rows of table: "off_production_consumptions" */
  update_off_production_consumptions_many?: Maybe<Array<Maybe<Off_Production_Consumptions_Mutation_Response>>>;
  /** update data of the table: "ofs_by_day" */
  update_ofs_by_day?: Maybe<Ofs_By_Day_Mutation_Response>;
  /** update single row of the table: "ofs_by_day" */
  update_ofs_by_day_by_pk?: Maybe<Ofs_By_Day>;
  /** update multiples rows of table: "ofs_by_day" */
  update_ofs_by_day_many?: Maybe<Array<Maybe<Ofs_By_Day_Mutation_Response>>>;
  /** update data of the table: "production_hours" */
  update_production_hours?: Maybe<Production_Hours_Mutation_Response>;
  /** update single row of the table: "production_hours" */
  update_production_hours_by_pk?: Maybe<Production_Hours>;
  /** update multiples rows of table: "production_hours" */
  update_production_hours_many?: Maybe<Array<Maybe<Production_Hours_Mutation_Response>>>;
  /** update data of the table: "production_reporting_frequencies" */
  update_production_reporting_frequencies?: Maybe<Production_Reporting_Frequencies_Mutation_Response>;
  /** update single row of the table: "production_reporting_frequencies" */
  update_production_reporting_frequencies_by_pk?: Maybe<Production_Reporting_Frequencies>;
  /** update multiples rows of table: "production_reporting_frequencies" */
  update_production_reporting_frequencies_many?: Maybe<Array<Maybe<Production_Reporting_Frequencies_Mutation_Response>>>;
  /** update data of the table: "productions" */
  update_productions?: Maybe<Productions_Mutation_Response>;
  /** update single row of the table: "productions" */
  update_productions_by_pk?: Maybe<Productions>;
  /** update multiples rows of table: "productions" */
  update_productions_many?: Maybe<Array<Maybe<Productions_Mutation_Response>>>;
  /** update data of the table: "products" */
  update_products?: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk?: Maybe<Products>;
  /** update multiples rows of table: "products" */
  update_products_many?: Maybe<Array<Maybe<Products_Mutation_Response>>>;
  /** update data of the table: "project_ROI_durations" */
  update_project_ROI_durations?: Maybe<Project_Roi_Durations_Mutation_Response>;
  /** update single row of the table: "project_ROI_durations" */
  update_project_ROI_durations_by_pk?: Maybe<Project_Roi_Durations>;
  /** update multiples rows of table: "project_ROI_durations" */
  update_project_ROI_durations_many?: Maybe<Array<Maybe<Project_Roi_Durations_Mutation_Response>>>;
  /** update data of the table: "project_budget_ranges" */
  update_project_budget_ranges?: Maybe<Project_Budget_Ranges_Mutation_Response>;
  /** update single row of the table: "project_budget_ranges" */
  update_project_budget_ranges_by_pk?: Maybe<Project_Budget_Ranges>;
  /** update multiples rows of table: "project_budget_ranges" */
  update_project_budget_ranges_many?: Maybe<Array<Maybe<Project_Budget_Ranges_Mutation_Response>>>;
  /** update data of the table: "project_complexities" */
  update_project_complexities?: Maybe<Project_Complexities_Mutation_Response>;
  /** update single row of the table: "project_complexities" */
  update_project_complexities_by_pk?: Maybe<Project_Complexities>;
  /** update multiples rows of table: "project_complexities" */
  update_project_complexities_many?: Maybe<Array<Maybe<Project_Complexities_Mutation_Response>>>;
  /** update data of the table: "project_statuses" */
  update_project_statuses?: Maybe<Project_Statuses_Mutation_Response>;
  /** update single row of the table: "project_statuses" */
  update_project_statuses_by_pk?: Maybe<Project_Statuses>;
  /** update multiples rows of table: "project_statuses" */
  update_project_statuses_many?: Maybe<Array<Maybe<Project_Statuses_Mutation_Response>>>;
  /** update data of the table: "project_templates" */
  update_project_templates?: Maybe<Project_Templates_Mutation_Response>;
  /** update single row of the table: "project_templates" */
  update_project_templates_by_pk?: Maybe<Project_Templates>;
  /** update multiples rows of table: "project_templates" */
  update_project_templates_many?: Maybe<Array<Maybe<Project_Templates_Mutation_Response>>>;
  /** update data of the table: "projects" */
  update_projects?: Maybe<Projects_Mutation_Response>;
  /** update single row of the table: "projects" */
  update_projects_by_pk?: Maybe<Projects>;
  /** update multiples rows of table: "projects" */
  update_projects_many?: Maybe<Array<Maybe<Projects_Mutation_Response>>>;
  /** update data of the table: "sites" */
  update_sites?: Maybe<Sites_Mutation_Response>;
  /** update single row of the table: "sites" */
  update_sites_by_pk?: Maybe<Sites>;
  /** update multiples rows of table: "sites" */
  update_sites_many?: Maybe<Array<Maybe<Sites_Mutation_Response>>>;
  /** update data of the table: "sources" */
  update_sources?: Maybe<Sources_Mutation_Response>;
  /** update single row of the table: "sources" */
  update_sources_by_pk?: Maybe<Sources>;
  /** update multiples rows of table: "sources" */
  update_sources_many?: Maybe<Array<Maybe<Sources_Mutation_Response>>>;
  /** update data of the table: "standard_types" */
  update_standard_types?: Maybe<Standard_Types_Mutation_Response>;
  /** update single row of the table: "standard_types" */
  update_standard_types_by_pk?: Maybe<Standard_Types>;
  /** update multiples rows of table: "standard_types" */
  update_standard_types_many?: Maybe<Array<Maybe<Standard_Types_Mutation_Response>>>;
  /** update data of the table: "standards" */
  update_standards?: Maybe<Standards_Mutation_Response>;
  /** update single row of the table: "standards" */
  update_standards_by_pk?: Maybe<Standards>;
  /** update multiples rows of table: "standards" */
  update_standards_many?: Maybe<Array<Maybe<Standards_Mutation_Response>>>;
  /** update data of the table: "subventions" */
  update_subventions?: Maybe<Subventions_Mutation_Response>;
  /** update single row of the table: "subventions" */
  update_subventions_by_pk?: Maybe<Subventions>;
  /** update multiples rows of table: "subventions" */
  update_subventions_many?: Maybe<Array<Maybe<Subventions_Mutation_Response>>>;
  /** update data of the table: "tariff_schedules" */
  update_tariff_schedules?: Maybe<Tariff_Schedules_Mutation_Response>;
  /** update single row of the table: "tariff_schedules" */
  update_tariff_schedules_by_pk?: Maybe<Tariff_Schedules>;
  /** update multiples rows of table: "tariff_schedules" */
  update_tariff_schedules_many?: Maybe<Array<Maybe<Tariff_Schedules_Mutation_Response>>>;
  /** update data of the table: "tariffs" */
  update_tariffs?: Maybe<Tariffs_Mutation_Response>;
  /** update single row of the table: "tariffs" */
  update_tariffs_by_pk?: Maybe<Tariffs>;
  /** update multiples rows of table: "tariffs" */
  update_tariffs_many?: Maybe<Array<Maybe<Tariffs_Mutation_Response>>>;
  /** update data of the table: "task_statuses" */
  update_task_statuses?: Maybe<Task_Statuses_Mutation_Response>;
  /** update single row of the table: "task_statuses" */
  update_task_statuses_by_pk?: Maybe<Task_Statuses>;
  /** update multiples rows of table: "task_statuses" */
  update_task_statuses_many?: Maybe<Array<Maybe<Task_Statuses_Mutation_Response>>>;
  /** update data of the table: "task_types" */
  update_task_types?: Maybe<Task_Types_Mutation_Response>;
  /** update single row of the table: "task_types" */
  update_task_types_by_pk?: Maybe<Task_Types>;
  /** update multiples rows of table: "task_types" */
  update_task_types_many?: Maybe<Array<Maybe<Task_Types_Mutation_Response>>>;
  /** update data of the table: "tasks" */
  update_tasks?: Maybe<Tasks_Mutation_Response>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: Maybe<Tasks>;
  /** update multiples rows of table: "tasks" */
  update_tasks_many?: Maybe<Array<Maybe<Tasks_Mutation_Response>>>;
  /** update data of the table: "third_party.consumptions" */
  update_third_party_consumptions?: Maybe<Third_Party_Consumptions_Mutation_Response>;
  /** update multiples rows of table: "third_party.consumptions" */
  update_third_party_consumptions_many?: Maybe<Array<Maybe<Third_Party_Consumptions_Mutation_Response>>>;
  /** update data of the table: "third_party.indexes" */
  update_third_party_indexes?: Maybe<Third_Party_Indexes_Mutation_Response>;
  /** update single row of the table: "third_party.indexes" */
  update_third_party_indexes_by_pk?: Maybe<Third_Party_Indexes>;
  /** update multiples rows of table: "third_party.indexes" */
  update_third_party_indexes_many?: Maybe<Array<Maybe<Third_Party_Indexes_Mutation_Response>>>;
  /** update data of the table: "third_party.sftp_files" */
  update_third_party_sftp_files?: Maybe<Third_Party_Sftp_Files_Mutation_Response>;
  /** update single row of the table: "third_party.sftp_files" */
  update_third_party_sftp_files_by_pk?: Maybe<Third_Party_Sftp_Files>;
  /** update multiples rows of table: "third_party.sftp_files" */
  update_third_party_sftp_files_many?: Maybe<Array<Maybe<Third_Party_Sftp_Files_Mutation_Response>>>;
  /** update data of the table: "unit_types" */
  update_unit_types?: Maybe<Unit_Types_Mutation_Response>;
  /** update single row of the table: "unit_types" */
  update_unit_types_by_pk?: Maybe<Unit_Types>;
  /** update multiples rows of table: "unit_types" */
  update_unit_types_many?: Maybe<Array<Maybe<Unit_Types_Mutation_Response>>>;
  /** update data of the table: "units" */
  update_units?: Maybe<Units_Mutation_Response>;
  /** update single row of the table: "units" */
  update_units_by_pk?: Maybe<Units>;
  /** update multiples rows of table: "units" */
  update_units_many?: Maybe<Array<Maybe<Units_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "weather.daily_measures" */
  update_weather_daily_measures?: Maybe<Weather_Daily_Measures_Mutation_Response>;
  /** update single row of the table: "weather.daily_measures" */
  update_weather_daily_measures_by_pk?: Maybe<Weather_Daily_Measures>;
  /** update multiples rows of table: "weather.daily_measures" */
  update_weather_daily_measures_many?: Maybe<Array<Maybe<Weather_Daily_Measures_Mutation_Response>>>;
  /** update data of the table: "weather.measures" */
  update_weather_measures?: Maybe<Weather_Measures_Mutation_Response>;
  /** update single row of the table: "weather.measures" */
  update_weather_measures_by_pk?: Maybe<Weather_Measures>;
  /** update multiples rows of table: "weather.measures" */
  update_weather_measures_many?: Maybe<Array<Maybe<Weather_Measures_Mutation_Response>>>;
  /** update data of the table: "weather.providers" */
  update_weather_providers?: Maybe<Weather_Providers_Mutation_Response>;
  /** update single row of the table: "weather.providers" */
  update_weather_providers_by_pk?: Maybe<Weather_Providers>;
  /** update multiples rows of table: "weather.providers" */
  update_weather_providers_many?: Maybe<Array<Maybe<Weather_Providers_Mutation_Response>>>;
  /** update data of the table: "weather.stations" */
  update_weather_stations?: Maybe<Weather_Stations_Mutation_Response>;
  /** update single row of the table: "weather.stations" */
  update_weather_stations_by_pk?: Maybe<Weather_Stations>;
  /** update multiples rows of table: "weather.stations" */
  update_weather_stations_many?: Maybe<Array<Maybe<Weather_Stations_Mutation_Response>>>;
  /** update data of the table: "weekdays" */
  update_weekdays?: Maybe<Weekdays_Mutation_Response>;
  /** update single row of the table: "weekdays" */
  update_weekdays_by_pk?: Maybe<Weekdays>;
  /** update multiples rows of table: "weekdays" */
  update_weekdays_many?: Maybe<Array<Maybe<Weekdays_Mutation_Response>>>;
  /** execute VOLATILE function "upsert_epi_in_table" which returns "fabrication_order_epi" */
  upsert_epi_in_table: Array<Fabrication_Order_Epi>;
};


/** mutation root */
export type Mutation_RootDelete_ActionsArgs = {
  where: Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Actions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Alert_TypesArgs = {
  where: Alert_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alert_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Alert_UserArgs = {
  where: Alert_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alert_User_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AlertsArgs = {
  where: Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alerts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Area_TypesArgs = {
  where: Area_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Area_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AreasArgs = {
  where: Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Areas_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BaselinesArgs = {
  where: Baselines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Baselines_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClientsArgs = {
  where: Clients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clients_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CommentsArgs = {
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Comments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Consumption_By_TimestampArgs = {
  where: Consumption_By_Timestamp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumption_By_Timestamp_By_PkArgs = {
  timestamp: Scalars['timestamp']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Consumption_ReferenceArgs = {
  where: Consumption_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumption_Reference_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConsumptionsArgs = {
  where: Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ContractsArgs = {
  where: Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contracts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cron_JobArgs = {
  where: Cron_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cron_Job_By_PkArgs = {
  jobid: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cron_Job_Run_DetailsArgs = {
  where: Cron_Job_Run_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cron_Job_Run_Details_By_PkArgs = {
  runid: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enedis_History_RawArgs = {
  where: Enedis_History_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enedis_History_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enedis_Minutes_RawArgs = {
  where: Enedis_Minutes_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enedis_Minutes_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_TypesArgs = {
  where: Energy_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Energy_Use_TypesArgs = {
  where: Energy_Use_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Energy_Use_Types_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fabrication_Order_EpiArgs = {
  where: Fabrication_Order_Epi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fabrication_Order_Epi_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fabrication_Order_ProductArgs = {
  where: Fabrication_Order_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fabrication_Order_Product_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Fabrication_OrdersArgs = {
  where: Fabrication_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fabrication_Orders_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incident_Closing_ReasonsArgs = {
  where: Incident_Closing_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incident_Closing_Reasons_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incident_ProjectArgs = {
  where: Incident_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incident_Project_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incident_StatusesArgs = {
  where: Incident_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incident_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Incident_TypesArgs = {
  where: Incident_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incident_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IncidentsArgs = {
  where: Incidents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Incidents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Meter_Daily_ConsumptionsArgs = {
  where: Meter_Daily_Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Meter_Daily_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Meter_TypesArgs = {
  where: Meter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Meter_Types_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MetersArgs = {
  where: Meters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Meters_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_Missing_DataArgs = {
  where: Mqtt_Missing_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_Missing_Data_Grouped_By_TopicArgs = {
  where: Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_Missing_Data_Grouped_By_Topic_By_PkArgs = {
  topic: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_Pressac_MetersArgs = {
  where: Mqtt_Pressac_Meters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_RawArgs = {
  where: Mqtt_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mqtt_Raw_PartitionedArgs = {
  where: Mqtt_Raw_Partitioned_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Objective_MilestonesArgs = {
  where: Objective_Milestones_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Objective_Milestones_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Objective_TypesArgs = {
  where: Objective_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Objective_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ObjectivesArgs = {
  where: Objectives_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Objectives_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Off_Production_ConsumptionsArgs = {
  where: Off_Production_Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Off_Production_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ofs_By_DayArgs = {
  where: Ofs_By_Day_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ofs_By_Day_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Production_HoursArgs = {
  where: Production_Hours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Production_Hours_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Production_Reporting_FrequenciesArgs = {
  where: Production_Reporting_Frequencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Production_Reporting_Frequencies_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProductionsArgs = {
  where: Productions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Productions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Roi_DurationsArgs = {
  where: Project_Roi_Durations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Roi_Durations_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Budget_RangesArgs = {
  where: Project_Budget_Ranges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Budget_Ranges_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ComplexitiesArgs = {
  where: Project_Complexities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Complexities_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_StatusesArgs = {
  where: Project_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_TemplatesArgs = {
  where: Project_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Templates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectsArgs = {
  where: Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Projects_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SitesArgs = {
  where: Sites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SourcesArgs = {
  where: Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sources_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Standard_TypesArgs = {
  where: Standard_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Standard_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StandardsArgs = {
  where: Standards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Standards_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubventionsArgs = {
  where: Subventions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subventions_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tariff_SchedulesArgs = {
  where: Tariff_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tariff_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TariffsArgs = {
  where: Tariffs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tariffs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_StatusesArgs = {
  where: Task_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_TypesArgs = {
  where: Task_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TasksArgs = {
  where: Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tasks_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_ConsumptionsArgs = {
  where: Third_Party_Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_IndexesArgs = {
  where: Third_Party_Indexes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_Indexes_By_PkArgs = {
  source_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_Sftp_FilesArgs = {
  where: Third_Party_Sftp_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Third_Party_Sftp_Files_By_PkArgs = {
  path: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unit_TypesArgs = {
  where: Unit_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UnitsArgs = {
  where: Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Units_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_Daily_MeasuresArgs = {
  where: Weather_Daily_Measures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Daily_Measures_By_PkArgs = {
  date: Scalars['date']['input'];
  id: Scalars['Int']['input'];
  key: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_MeasuresArgs = {
  where: Weather_Measures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Measures_By_PkArgs = {
  id: Scalars['Int']['input'];
  timestamp: Scalars['timestamp']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_ProvidersArgs = {
  where: Weather_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Providers_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_StationsArgs = {
  where: Weather_Stations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Stations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WeekdaysArgs = {
  where: Weekdays_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weekdays_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_ActionsArgs = {
  objects: Array<Actions_Insert_Input>;
  on_conflict?: InputMaybe<Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Actions_OneArgs = {
  object: Actions_Insert_Input;
  on_conflict?: InputMaybe<Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_TypesArgs = {
  objects: Array<Alert_Types_Insert_Input>;
  on_conflict?: InputMaybe<Alert_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_Types_OneArgs = {
  object: Alert_Types_Insert_Input;
  on_conflict?: InputMaybe<Alert_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_UserArgs = {
  objects: Array<Alert_User_Insert_Input>;
  on_conflict?: InputMaybe<Alert_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_User_OneArgs = {
  object: Alert_User_Insert_Input;
  on_conflict?: InputMaybe<Alert_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AlertsArgs = {
  objects: Array<Alerts_Insert_Input>;
  on_conflict?: InputMaybe<Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alerts_OneArgs = {
  object: Alerts_Insert_Input;
  on_conflict?: InputMaybe<Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Area_TypesArgs = {
  objects: Array<Area_Types_Insert_Input>;
  on_conflict?: InputMaybe<Area_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Area_Types_OneArgs = {
  object: Area_Types_Insert_Input;
  on_conflict?: InputMaybe<Area_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AreasArgs = {
  objects: Array<Areas_Insert_Input>;
  on_conflict?: InputMaybe<Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Areas_OneArgs = {
  object: Areas_Insert_Input;
  on_conflict?: InputMaybe<Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BaselinesArgs = {
  objects: Array<Baselines_Insert_Input>;
  on_conflict?: InputMaybe<Baselines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Baselines_OneArgs = {
  object: Baselines_Insert_Input;
  on_conflict?: InputMaybe<Baselines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClientsArgs = {
  objects: Array<Clients_Insert_Input>;
  on_conflict?: InputMaybe<Clients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clients_OneArgs = {
  object: Clients_Insert_Input;
  on_conflict?: InputMaybe<Clients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentsArgs = {
  objects: Array<Comments_Insert_Input>;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Comments_OneArgs = {
  object: Comments_Insert_Input;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_By_TimestampArgs = {
  objects: Array<Consumption_By_Timestamp_Insert_Input>;
  on_conflict?: InputMaybe<Consumption_By_Timestamp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_By_Timestamp_OneArgs = {
  object: Consumption_By_Timestamp_Insert_Input;
  on_conflict?: InputMaybe<Consumption_By_Timestamp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_ReferenceArgs = {
  objects: Array<Consumption_Reference_Insert_Input>;
  on_conflict?: InputMaybe<Consumption_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumption_Reference_OneArgs = {
  object: Consumption_Reference_Insert_Input;
  on_conflict?: InputMaybe<Consumption_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConsumptionsArgs = {
  objects: Array<Consumptions_Insert_Input>;
  on_conflict?: InputMaybe<Consumptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumptions_OneArgs = {
  object: Consumptions_Insert_Input;
  on_conflict?: InputMaybe<Consumptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContractsArgs = {
  objects: Array<Contracts_Insert_Input>;
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contracts_OneArgs = {
  object: Contracts_Insert_Input;
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cron_JobArgs = {
  objects: Array<Cron_Job_Insert_Input>;
  on_conflict?: InputMaybe<Cron_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cron_Job_OneArgs = {
  object: Cron_Job_Insert_Input;
  on_conflict?: InputMaybe<Cron_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cron_Job_Run_DetailsArgs = {
  objects: Array<Cron_Job_Run_Details_Insert_Input>;
  on_conflict?: InputMaybe<Cron_Job_Run_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cron_Job_Run_Details_OneArgs = {
  object: Cron_Job_Run_Details_Insert_Input;
  on_conflict?: InputMaybe<Cron_Job_Run_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enedis_History_RawArgs = {
  objects: Array<Enedis_History_Raw_Insert_Input>;
  on_conflict?: InputMaybe<Enedis_History_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enedis_History_Raw_OneArgs = {
  object: Enedis_History_Raw_Insert_Input;
  on_conflict?: InputMaybe<Enedis_History_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enedis_Minutes_RawArgs = {
  objects: Array<Enedis_Minutes_Raw_Insert_Input>;
  on_conflict?: InputMaybe<Enedis_Minutes_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enedis_Minutes_Raw_OneArgs = {
  object: Enedis_Minutes_Raw_Insert_Input;
  on_conflict?: InputMaybe<Enedis_Minutes_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_TypesArgs = {
  objects: Array<Energy_Types_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Types_OneArgs = {
  object: Energy_Types_Insert_Input;
  on_conflict?: InputMaybe<Energy_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Use_TypesArgs = {
  objects: Array<Energy_Use_Types_Insert_Input>;
  on_conflict?: InputMaybe<Energy_Use_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Energy_Use_Types_OneArgs = {
  object: Energy_Use_Types_Insert_Input;
  on_conflict?: InputMaybe<Energy_Use_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fabrication_Order_EpiArgs = {
  objects: Array<Fabrication_Order_Epi_Insert_Input>;
  on_conflict?: InputMaybe<Fabrication_Order_Epi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fabrication_Order_Epi_OneArgs = {
  object: Fabrication_Order_Epi_Insert_Input;
  on_conflict?: InputMaybe<Fabrication_Order_Epi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fabrication_Order_ProductArgs = {
  objects: Array<Fabrication_Order_Product_Insert_Input>;
  on_conflict?: InputMaybe<Fabrication_Order_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fabrication_Order_Product_OneArgs = {
  object: Fabrication_Order_Product_Insert_Input;
  on_conflict?: InputMaybe<Fabrication_Order_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fabrication_OrdersArgs = {
  objects: Array<Fabrication_Orders_Insert_Input>;
  on_conflict?: InputMaybe<Fabrication_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fabrication_Orders_OneArgs = {
  object: Fabrication_Orders_Insert_Input;
  on_conflict?: InputMaybe<Fabrication_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_Closing_ReasonsArgs = {
  objects: Array<Incident_Closing_Reasons_Insert_Input>;
  on_conflict?: InputMaybe<Incident_Closing_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_Closing_Reasons_OneArgs = {
  object: Incident_Closing_Reasons_Insert_Input;
  on_conflict?: InputMaybe<Incident_Closing_Reasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_ProjectArgs = {
  objects: Array<Incident_Project_Insert_Input>;
  on_conflict?: InputMaybe<Incident_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_Project_OneArgs = {
  object: Incident_Project_Insert_Input;
  on_conflict?: InputMaybe<Incident_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_StatusesArgs = {
  objects: Array<Incident_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Incident_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_Statuses_OneArgs = {
  object: Incident_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Incident_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_TypesArgs = {
  objects: Array<Incident_Types_Insert_Input>;
  on_conflict?: InputMaybe<Incident_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incident_Types_OneArgs = {
  object: Incident_Types_Insert_Input;
  on_conflict?: InputMaybe<Incident_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IncidentsArgs = {
  objects: Array<Incidents_Insert_Input>;
  on_conflict?: InputMaybe<Incidents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Incidents_OneArgs = {
  object: Incidents_Insert_Input;
  on_conflict?: InputMaybe<Incidents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Meter_Daily_ConsumptionsArgs = {
  objects: Array<Meter_Daily_Consumptions_Insert_Input>;
  on_conflict?: InputMaybe<Meter_Daily_Consumptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Meter_Daily_Consumptions_OneArgs = {
  object: Meter_Daily_Consumptions_Insert_Input;
  on_conflict?: InputMaybe<Meter_Daily_Consumptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Meter_TypesArgs = {
  objects: Array<Meter_Types_Insert_Input>;
  on_conflict?: InputMaybe<Meter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Meter_Types_OneArgs = {
  object: Meter_Types_Insert_Input;
  on_conflict?: InputMaybe<Meter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MetersArgs = {
  objects: Array<Meters_Insert_Input>;
  on_conflict?: InputMaybe<Meters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Meters_OneArgs = {
  object: Meters_Insert_Input;
  on_conflict?: InputMaybe<Meters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Missing_DataArgs = {
  objects: Array<Mqtt_Missing_Data_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Missing_Data_Grouped_By_TopicArgs = {
  objects: Array<Mqtt_Missing_Data_Grouped_By_Topic_Insert_Input>;
  on_conflict?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Missing_Data_Grouped_By_Topic_OneArgs = {
  object: Mqtt_Missing_Data_Grouped_By_Topic_Insert_Input;
  on_conflict?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Missing_Data_OneArgs = {
  object: Mqtt_Missing_Data_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Pressac_MetersArgs = {
  objects: Array<Mqtt_Pressac_Meters_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Pressac_Meters_OneArgs = {
  object: Mqtt_Pressac_Meters_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_RawArgs = {
  objects: Array<Mqtt_Raw_Insert_Input>;
  on_conflict?: InputMaybe<Mqtt_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Raw_OneArgs = {
  object: Mqtt_Raw_Insert_Input;
  on_conflict?: InputMaybe<Mqtt_Raw_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Raw_PartitionedArgs = {
  objects: Array<Mqtt_Raw_Partitioned_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Mqtt_Raw_Partitioned_OneArgs = {
  object: Mqtt_Raw_Partitioned_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Objective_MilestonesArgs = {
  objects: Array<Objective_Milestones_Insert_Input>;
  on_conflict?: InputMaybe<Objective_Milestones_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Objective_Milestones_OneArgs = {
  object: Objective_Milestones_Insert_Input;
  on_conflict?: InputMaybe<Objective_Milestones_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Objective_TypesArgs = {
  objects: Array<Objective_Types_Insert_Input>;
  on_conflict?: InputMaybe<Objective_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Objective_Types_OneArgs = {
  object: Objective_Types_Insert_Input;
  on_conflict?: InputMaybe<Objective_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ObjectivesArgs = {
  objects: Array<Objectives_Insert_Input>;
  on_conflict?: InputMaybe<Objectives_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Objectives_OneArgs = {
  object: Objectives_Insert_Input;
  on_conflict?: InputMaybe<Objectives_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Off_Production_ConsumptionsArgs = {
  objects: Array<Off_Production_Consumptions_Insert_Input>;
  on_conflict?: InputMaybe<Off_Production_Consumptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Off_Production_Consumptions_OneArgs = {
  object: Off_Production_Consumptions_Insert_Input;
  on_conflict?: InputMaybe<Off_Production_Consumptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ofs_By_DayArgs = {
  objects: Array<Ofs_By_Day_Insert_Input>;
  on_conflict?: InputMaybe<Ofs_By_Day_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ofs_By_Day_OneArgs = {
  object: Ofs_By_Day_Insert_Input;
  on_conflict?: InputMaybe<Ofs_By_Day_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Production_HoursArgs = {
  objects: Array<Production_Hours_Insert_Input>;
  on_conflict?: InputMaybe<Production_Hours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Production_Hours_OneArgs = {
  object: Production_Hours_Insert_Input;
  on_conflict?: InputMaybe<Production_Hours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Production_Reporting_FrequenciesArgs = {
  objects: Array<Production_Reporting_Frequencies_Insert_Input>;
  on_conflict?: InputMaybe<Production_Reporting_Frequencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Production_Reporting_Frequencies_OneArgs = {
  object: Production_Reporting_Frequencies_Insert_Input;
  on_conflict?: InputMaybe<Production_Reporting_Frequencies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductionsArgs = {
  objects: Array<Productions_Insert_Input>;
  on_conflict?: InputMaybe<Productions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Productions_OneArgs = {
  object: Productions_Insert_Input;
  on_conflict?: InputMaybe<Productions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Roi_DurationsArgs = {
  objects: Array<Project_Roi_Durations_Insert_Input>;
  on_conflict?: InputMaybe<Project_Roi_Durations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Roi_Durations_OneArgs = {
  object: Project_Roi_Durations_Insert_Input;
  on_conflict?: InputMaybe<Project_Roi_Durations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Budget_RangesArgs = {
  objects: Array<Project_Budget_Ranges_Insert_Input>;
  on_conflict?: InputMaybe<Project_Budget_Ranges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Budget_Ranges_OneArgs = {
  object: Project_Budget_Ranges_Insert_Input;
  on_conflict?: InputMaybe<Project_Budget_Ranges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ComplexitiesArgs = {
  objects: Array<Project_Complexities_Insert_Input>;
  on_conflict?: InputMaybe<Project_Complexities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Complexities_OneArgs = {
  object: Project_Complexities_Insert_Input;
  on_conflict?: InputMaybe<Project_Complexities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_StatusesArgs = {
  objects: Array<Project_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Project_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Statuses_OneArgs = {
  object: Project_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Project_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_TemplatesArgs = {
  objects: Array<Project_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Project_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Templates_OneArgs = {
  object: Project_Templates_Insert_Input;
  on_conflict?: InputMaybe<Project_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectsArgs = {
  objects: Array<Projects_Insert_Input>;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Projects_OneArgs = {
  object: Projects_Insert_Input;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SitesArgs = {
  objects: Array<Sites_Insert_Input>;
  on_conflict?: InputMaybe<Sites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sites_OneArgs = {
  object: Sites_Insert_Input;
  on_conflict?: InputMaybe<Sites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SourcesArgs = {
  objects: Array<Sources_Insert_Input>;
  on_conflict?: InputMaybe<Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sources_OneArgs = {
  object: Sources_Insert_Input;
  on_conflict?: InputMaybe<Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Standard_TypesArgs = {
  objects: Array<Standard_Types_Insert_Input>;
  on_conflict?: InputMaybe<Standard_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Standard_Types_OneArgs = {
  object: Standard_Types_Insert_Input;
  on_conflict?: InputMaybe<Standard_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StandardsArgs = {
  objects: Array<Standards_Insert_Input>;
  on_conflict?: InputMaybe<Standards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Standards_OneArgs = {
  object: Standards_Insert_Input;
  on_conflict?: InputMaybe<Standards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubventionsArgs = {
  objects: Array<Subventions_Insert_Input>;
  on_conflict?: InputMaybe<Subventions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subventions_OneArgs = {
  object: Subventions_Insert_Input;
  on_conflict?: InputMaybe<Subventions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tariff_SchedulesArgs = {
  objects: Array<Tariff_Schedules_Insert_Input>;
  on_conflict?: InputMaybe<Tariff_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tariff_Schedules_OneArgs = {
  object: Tariff_Schedules_Insert_Input;
  on_conflict?: InputMaybe<Tariff_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TariffsArgs = {
  objects: Array<Tariffs_Insert_Input>;
  on_conflict?: InputMaybe<Tariffs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tariffs_OneArgs = {
  object: Tariffs_Insert_Input;
  on_conflict?: InputMaybe<Tariffs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_StatusesArgs = {
  objects: Array<Task_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Task_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Statuses_OneArgs = {
  object: Task_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Task_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_TypesArgs = {
  objects: Array<Task_Types_Insert_Input>;
  on_conflict?: InputMaybe<Task_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_Types_OneArgs = {
  object: Task_Types_Insert_Input;
  on_conflict?: InputMaybe<Task_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TasksArgs = {
  objects: Array<Tasks_Insert_Input>;
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tasks_OneArgs = {
  object: Tasks_Insert_Input;
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_ConsumptionsArgs = {
  objects: Array<Third_Party_Consumptions_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_Consumptions_OneArgs = {
  object: Third_Party_Consumptions_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_IndexesArgs = {
  objects: Array<Third_Party_Indexes_Insert_Input>;
  on_conflict?: InputMaybe<Third_Party_Indexes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_Indexes_OneArgs = {
  object: Third_Party_Indexes_Insert_Input;
  on_conflict?: InputMaybe<Third_Party_Indexes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_Sftp_FilesArgs = {
  objects: Array<Third_Party_Sftp_Files_Insert_Input>;
  on_conflict?: InputMaybe<Third_Party_Sftp_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Third_Party_Sftp_Files_OneArgs = {
  object: Third_Party_Sftp_Files_Insert_Input;
  on_conflict?: InputMaybe<Third_Party_Sftp_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_TypesArgs = {
  objects: Array<Unit_Types_Insert_Input>;
  on_conflict?: InputMaybe<Unit_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Types_OneArgs = {
  object: Unit_Types_Insert_Input;
  on_conflict?: InputMaybe<Unit_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnitsArgs = {
  objects: Array<Units_Insert_Input>;
  on_conflict?: InputMaybe<Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Units_OneArgs = {
  object: Units_Insert_Input;
  on_conflict?: InputMaybe<Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Daily_MeasuresArgs = {
  objects: Array<Weather_Daily_Measures_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Daily_Measures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Daily_Measures_OneArgs = {
  object: Weather_Daily_Measures_Insert_Input;
  on_conflict?: InputMaybe<Weather_Daily_Measures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_MeasuresArgs = {
  objects: Array<Weather_Measures_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Measures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Measures_OneArgs = {
  object: Weather_Measures_Insert_Input;
  on_conflict?: InputMaybe<Weather_Measures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_ProvidersArgs = {
  objects: Array<Weather_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Providers_OneArgs = {
  object: Weather_Providers_Insert_Input;
  on_conflict?: InputMaybe<Weather_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_StationsArgs = {
  objects: Array<Weather_Stations_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Stations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Stations_OneArgs = {
  object: Weather_Stations_Insert_Input;
  on_conflict?: InputMaybe<Weather_Stations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WeekdaysArgs = {
  objects: Array<Weekdays_Insert_Input>;
  on_conflict?: InputMaybe<Weekdays_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weekdays_OneArgs = {
  object: Weekdays_Insert_Input;
  on_conflict?: InputMaybe<Weekdays_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_ActionsArgs = {
  _inc?: InputMaybe<Actions_Inc_Input>;
  _set?: InputMaybe<Actions_Set_Input>;
  where: Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Actions_By_PkArgs = {
  _inc?: InputMaybe<Actions_Inc_Input>;
  _set?: InputMaybe<Actions_Set_Input>;
  pk_columns: Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Actions_ManyArgs = {
  updates: Array<Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_TypesArgs = {
  _set?: InputMaybe<Alert_Types_Set_Input>;
  where: Alert_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Types_By_PkArgs = {
  _set?: InputMaybe<Alert_Types_Set_Input>;
  pk_columns: Alert_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Types_ManyArgs = {
  updates: Array<Alert_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_UserArgs = {
  _inc?: InputMaybe<Alert_User_Inc_Input>;
  _set?: InputMaybe<Alert_User_Set_Input>;
  where: Alert_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_User_By_PkArgs = {
  _inc?: InputMaybe<Alert_User_Inc_Input>;
  _set?: InputMaybe<Alert_User_Set_Input>;
  pk_columns: Alert_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_User_ManyArgs = {
  updates: Array<Alert_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AlertsArgs = {
  _append?: InputMaybe<Alerts_Append_Input>;
  _delete_at_path?: InputMaybe<Alerts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Alerts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Alerts_Delete_Key_Input>;
  _inc?: InputMaybe<Alerts_Inc_Input>;
  _prepend?: InputMaybe<Alerts_Prepend_Input>;
  _set?: InputMaybe<Alerts_Set_Input>;
  where: Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alerts_By_PkArgs = {
  _append?: InputMaybe<Alerts_Append_Input>;
  _delete_at_path?: InputMaybe<Alerts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Alerts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Alerts_Delete_Key_Input>;
  _inc?: InputMaybe<Alerts_Inc_Input>;
  _prepend?: InputMaybe<Alerts_Prepend_Input>;
  _set?: InputMaybe<Alerts_Set_Input>;
  pk_columns: Alerts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alerts_ManyArgs = {
  updates: Array<Alerts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Area_TypesArgs = {
  _set?: InputMaybe<Area_Types_Set_Input>;
  where: Area_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Area_Types_By_PkArgs = {
  _set?: InputMaybe<Area_Types_Set_Input>;
  pk_columns: Area_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Area_Types_ManyArgs = {
  updates: Array<Area_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AreasArgs = {
  _inc?: InputMaybe<Areas_Inc_Input>;
  _set?: InputMaybe<Areas_Set_Input>;
  where: Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Areas_By_PkArgs = {
  _inc?: InputMaybe<Areas_Inc_Input>;
  _set?: InputMaybe<Areas_Set_Input>;
  pk_columns: Areas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Areas_ManyArgs = {
  updates: Array<Areas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BaselinesArgs = {
  _append?: InputMaybe<Baselines_Append_Input>;
  _delete_at_path?: InputMaybe<Baselines_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Baselines_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Baselines_Delete_Key_Input>;
  _inc?: InputMaybe<Baselines_Inc_Input>;
  _prepend?: InputMaybe<Baselines_Prepend_Input>;
  _set?: InputMaybe<Baselines_Set_Input>;
  where: Baselines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Baselines_By_PkArgs = {
  _append?: InputMaybe<Baselines_Append_Input>;
  _delete_at_path?: InputMaybe<Baselines_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Baselines_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Baselines_Delete_Key_Input>;
  _inc?: InputMaybe<Baselines_Inc_Input>;
  _prepend?: InputMaybe<Baselines_Prepend_Input>;
  _set?: InputMaybe<Baselines_Set_Input>;
  pk_columns: Baselines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Baselines_ManyArgs = {
  updates: Array<Baselines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClientsArgs = {
  _inc?: InputMaybe<Clients_Inc_Input>;
  _set?: InputMaybe<Clients_Set_Input>;
  where: Clients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clients_By_PkArgs = {
  _inc?: InputMaybe<Clients_Inc_Input>;
  _set?: InputMaybe<Clients_Set_Input>;
  pk_columns: Clients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clients_ManyArgs = {
  updates: Array<Clients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentsArgs = {
  _inc?: InputMaybe<Comments_Inc_Input>;
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_By_PkArgs = {
  _inc?: InputMaybe<Comments_Inc_Input>;
  _set?: InputMaybe<Comments_Set_Input>;
  pk_columns: Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_By_TimestampArgs = {
  _inc?: InputMaybe<Consumption_By_Timestamp_Inc_Input>;
  _set?: InputMaybe<Consumption_By_Timestamp_Set_Input>;
  where: Consumption_By_Timestamp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_By_Timestamp_By_PkArgs = {
  _inc?: InputMaybe<Consumption_By_Timestamp_Inc_Input>;
  _set?: InputMaybe<Consumption_By_Timestamp_Set_Input>;
  pk_columns: Consumption_By_Timestamp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_By_Timestamp_ManyArgs = {
  updates: Array<Consumption_By_Timestamp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_ReferenceArgs = {
  _inc?: InputMaybe<Consumption_Reference_Inc_Input>;
  _set?: InputMaybe<Consumption_Reference_Set_Input>;
  where: Consumption_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_Reference_By_PkArgs = {
  _inc?: InputMaybe<Consumption_Reference_Inc_Input>;
  _set?: InputMaybe<Consumption_Reference_Set_Input>;
  pk_columns: Consumption_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consumption_Reference_ManyArgs = {
  updates: Array<Consumption_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConsumptionsArgs = {
  _inc?: InputMaybe<Consumptions_Inc_Input>;
  _set?: InputMaybe<Consumptions_Set_Input>;
  where: Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consumptions_By_PkArgs = {
  _inc?: InputMaybe<Consumptions_Inc_Input>;
  _set?: InputMaybe<Consumptions_Set_Input>;
  pk_columns: Consumptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consumptions_ManyArgs = {
  updates: Array<Consumptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContractsArgs = {
  _inc?: InputMaybe<Contracts_Inc_Input>;
  _set?: InputMaybe<Contracts_Set_Input>;
  where: Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_By_PkArgs = {
  _inc?: InputMaybe<Contracts_Inc_Input>;
  _set?: InputMaybe<Contracts_Set_Input>;
  pk_columns: Contracts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_ManyArgs = {
  updates: Array<Contracts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cron_JobArgs = {
  _inc?: InputMaybe<Cron_Job_Inc_Input>;
  _set?: InputMaybe<Cron_Job_Set_Input>;
  where: Cron_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cron_Job_By_PkArgs = {
  _inc?: InputMaybe<Cron_Job_Inc_Input>;
  _set?: InputMaybe<Cron_Job_Set_Input>;
  pk_columns: Cron_Job_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cron_Job_ManyArgs = {
  updates: Array<Cron_Job_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cron_Job_Run_DetailsArgs = {
  _inc?: InputMaybe<Cron_Job_Run_Details_Inc_Input>;
  _set?: InputMaybe<Cron_Job_Run_Details_Set_Input>;
  where: Cron_Job_Run_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cron_Job_Run_Details_By_PkArgs = {
  _inc?: InputMaybe<Cron_Job_Run_Details_Inc_Input>;
  _set?: InputMaybe<Cron_Job_Run_Details_Set_Input>;
  pk_columns: Cron_Job_Run_Details_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cron_Job_Run_Details_ManyArgs = {
  updates: Array<Cron_Job_Run_Details_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enedis_History_RawArgs = {
  _inc?: InputMaybe<Enedis_History_Raw_Inc_Input>;
  _set?: InputMaybe<Enedis_History_Raw_Set_Input>;
  where: Enedis_History_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enedis_History_Raw_By_PkArgs = {
  _inc?: InputMaybe<Enedis_History_Raw_Inc_Input>;
  _set?: InputMaybe<Enedis_History_Raw_Set_Input>;
  pk_columns: Enedis_History_Raw_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enedis_History_Raw_ManyArgs = {
  updates: Array<Enedis_History_Raw_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enedis_Minutes_RawArgs = {
  _inc?: InputMaybe<Enedis_Minutes_Raw_Inc_Input>;
  _set?: InputMaybe<Enedis_Minutes_Raw_Set_Input>;
  where: Enedis_Minutes_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enedis_Minutes_Raw_By_PkArgs = {
  _inc?: InputMaybe<Enedis_Minutes_Raw_Inc_Input>;
  _set?: InputMaybe<Enedis_Minutes_Raw_Set_Input>;
  pk_columns: Enedis_Minutes_Raw_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enedis_Minutes_Raw_ManyArgs = {
  updates: Array<Enedis_Minutes_Raw_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_TypesArgs = {
  _set?: InputMaybe<Energy_Types_Set_Input>;
  where: Energy_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Types_By_PkArgs = {
  _set?: InputMaybe<Energy_Types_Set_Input>;
  pk_columns: Energy_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Types_ManyArgs = {
  updates: Array<Energy_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Use_TypesArgs = {
  _set?: InputMaybe<Energy_Use_Types_Set_Input>;
  where: Energy_Use_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Use_Types_By_PkArgs = {
  _set?: InputMaybe<Energy_Use_Types_Set_Input>;
  pk_columns: Energy_Use_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Energy_Use_Types_ManyArgs = {
  updates: Array<Energy_Use_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Order_EpiArgs = {
  _inc?: InputMaybe<Fabrication_Order_Epi_Inc_Input>;
  _set?: InputMaybe<Fabrication_Order_Epi_Set_Input>;
  where: Fabrication_Order_Epi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Order_Epi_By_PkArgs = {
  _inc?: InputMaybe<Fabrication_Order_Epi_Inc_Input>;
  _set?: InputMaybe<Fabrication_Order_Epi_Set_Input>;
  pk_columns: Fabrication_Order_Epi_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Order_Epi_ManyArgs = {
  updates: Array<Fabrication_Order_Epi_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Order_ProductArgs = {
  _inc?: InputMaybe<Fabrication_Order_Product_Inc_Input>;
  _set?: InputMaybe<Fabrication_Order_Product_Set_Input>;
  where: Fabrication_Order_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Order_Product_By_PkArgs = {
  _inc?: InputMaybe<Fabrication_Order_Product_Inc_Input>;
  _set?: InputMaybe<Fabrication_Order_Product_Set_Input>;
  pk_columns: Fabrication_Order_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Order_Product_ManyArgs = {
  updates: Array<Fabrication_Order_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_OrdersArgs = {
  _inc?: InputMaybe<Fabrication_Orders_Inc_Input>;
  _set?: InputMaybe<Fabrication_Orders_Set_Input>;
  where: Fabrication_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Orders_By_PkArgs = {
  _inc?: InputMaybe<Fabrication_Orders_Inc_Input>;
  _set?: InputMaybe<Fabrication_Orders_Set_Input>;
  pk_columns: Fabrication_Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fabrication_Orders_ManyArgs = {
  updates: Array<Fabrication_Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Closing_ReasonsArgs = {
  _set?: InputMaybe<Incident_Closing_Reasons_Set_Input>;
  where: Incident_Closing_Reasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Closing_Reasons_By_PkArgs = {
  _set?: InputMaybe<Incident_Closing_Reasons_Set_Input>;
  pk_columns: Incident_Closing_Reasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Closing_Reasons_ManyArgs = {
  updates: Array<Incident_Closing_Reasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_ProjectArgs = {
  _inc?: InputMaybe<Incident_Project_Inc_Input>;
  _set?: InputMaybe<Incident_Project_Set_Input>;
  where: Incident_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Project_By_PkArgs = {
  _inc?: InputMaybe<Incident_Project_Inc_Input>;
  _set?: InputMaybe<Incident_Project_Set_Input>;
  pk_columns: Incident_Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Project_ManyArgs = {
  updates: Array<Incident_Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_StatusesArgs = {
  _set?: InputMaybe<Incident_Statuses_Set_Input>;
  where: Incident_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Statuses_By_PkArgs = {
  _set?: InputMaybe<Incident_Statuses_Set_Input>;
  pk_columns: Incident_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Statuses_ManyArgs = {
  updates: Array<Incident_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_TypesArgs = {
  _set?: InputMaybe<Incident_Types_Set_Input>;
  where: Incident_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Types_By_PkArgs = {
  _set?: InputMaybe<Incident_Types_Set_Input>;
  pk_columns: Incident_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incident_Types_ManyArgs = {
  updates: Array<Incident_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IncidentsArgs = {
  _inc?: InputMaybe<Incidents_Inc_Input>;
  _set?: InputMaybe<Incidents_Set_Input>;
  where: Incidents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Incidents_By_PkArgs = {
  _inc?: InputMaybe<Incidents_Inc_Input>;
  _set?: InputMaybe<Incidents_Set_Input>;
  pk_columns: Incidents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Incidents_ManyArgs = {
  updates: Array<Incidents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Meter_Daily_ConsumptionsArgs = {
  _inc?: InputMaybe<Meter_Daily_Consumptions_Inc_Input>;
  _set?: InputMaybe<Meter_Daily_Consumptions_Set_Input>;
  where: Meter_Daily_Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Meter_Daily_Consumptions_By_PkArgs = {
  _inc?: InputMaybe<Meter_Daily_Consumptions_Inc_Input>;
  _set?: InputMaybe<Meter_Daily_Consumptions_Set_Input>;
  pk_columns: Meter_Daily_Consumptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Meter_Daily_Consumptions_ManyArgs = {
  updates: Array<Meter_Daily_Consumptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Meter_TypesArgs = {
  _inc?: InputMaybe<Meter_Types_Inc_Input>;
  _set?: InputMaybe<Meter_Types_Set_Input>;
  where: Meter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Meter_Types_By_PkArgs = {
  _inc?: InputMaybe<Meter_Types_Inc_Input>;
  _set?: InputMaybe<Meter_Types_Set_Input>;
  pk_columns: Meter_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Meter_Types_ManyArgs = {
  updates: Array<Meter_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MetersArgs = {
  _inc?: InputMaybe<Meters_Inc_Input>;
  _set?: InputMaybe<Meters_Set_Input>;
  where: Meters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Meters_By_PkArgs = {
  _inc?: InputMaybe<Meters_Inc_Input>;
  _set?: InputMaybe<Meters_Set_Input>;
  pk_columns: Meters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Meters_ManyArgs = {
  updates: Array<Meters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Missing_DataArgs = {
  _append?: InputMaybe<Mqtt_Missing_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Mqtt_Missing_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mqtt_Missing_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mqtt_Missing_Data_Delete_Key_Input>;
  _inc?: InputMaybe<Mqtt_Missing_Data_Inc_Input>;
  _prepend?: InputMaybe<Mqtt_Missing_Data_Prepend_Input>;
  _set?: InputMaybe<Mqtt_Missing_Data_Set_Input>;
  where: Mqtt_Missing_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Missing_Data_Grouped_By_TopicArgs = {
  _inc?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Inc_Input>;
  _set?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Set_Input>;
  where: Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Missing_Data_Grouped_By_Topic_By_PkArgs = {
  _inc?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Inc_Input>;
  _set?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Set_Input>;
  pk_columns: Mqtt_Missing_Data_Grouped_By_Topic_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Missing_Data_Grouped_By_Topic_ManyArgs = {
  updates: Array<Mqtt_Missing_Data_Grouped_By_Topic_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Missing_Data_ManyArgs = {
  updates: Array<Mqtt_Missing_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Pressac_MetersArgs = {
  _inc?: InputMaybe<Mqtt_Pressac_Meters_Inc_Input>;
  _set?: InputMaybe<Mqtt_Pressac_Meters_Set_Input>;
  where: Mqtt_Pressac_Meters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Pressac_Meters_ManyArgs = {
  updates: Array<Mqtt_Pressac_Meters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_RawArgs = {
  _append?: InputMaybe<Mqtt_Raw_Append_Input>;
  _delete_at_path?: InputMaybe<Mqtt_Raw_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mqtt_Raw_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mqtt_Raw_Delete_Key_Input>;
  _inc?: InputMaybe<Mqtt_Raw_Inc_Input>;
  _prepend?: InputMaybe<Mqtt_Raw_Prepend_Input>;
  _set?: InputMaybe<Mqtt_Raw_Set_Input>;
  where: Mqtt_Raw_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Raw_By_PkArgs = {
  _append?: InputMaybe<Mqtt_Raw_Append_Input>;
  _delete_at_path?: InputMaybe<Mqtt_Raw_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mqtt_Raw_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mqtt_Raw_Delete_Key_Input>;
  _inc?: InputMaybe<Mqtt_Raw_Inc_Input>;
  _prepend?: InputMaybe<Mqtt_Raw_Prepend_Input>;
  _set?: InputMaybe<Mqtt_Raw_Set_Input>;
  pk_columns: Mqtt_Raw_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Raw_ManyArgs = {
  updates: Array<Mqtt_Raw_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Raw_PartitionedArgs = {
  _append?: InputMaybe<Mqtt_Raw_Partitioned_Append_Input>;
  _delete_at_path?: InputMaybe<Mqtt_Raw_Partitioned_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mqtt_Raw_Partitioned_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mqtt_Raw_Partitioned_Delete_Key_Input>;
  _inc?: InputMaybe<Mqtt_Raw_Partitioned_Inc_Input>;
  _prepend?: InputMaybe<Mqtt_Raw_Partitioned_Prepend_Input>;
  _set?: InputMaybe<Mqtt_Raw_Partitioned_Set_Input>;
  where: Mqtt_Raw_Partitioned_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mqtt_Raw_Partitioned_ManyArgs = {
  updates: Array<Mqtt_Raw_Partitioned_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_MilestonesArgs = {
  _inc?: InputMaybe<Objective_Milestones_Inc_Input>;
  _set?: InputMaybe<Objective_Milestones_Set_Input>;
  where: Objective_Milestones_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_Milestones_By_PkArgs = {
  _inc?: InputMaybe<Objective_Milestones_Inc_Input>;
  _set?: InputMaybe<Objective_Milestones_Set_Input>;
  pk_columns: Objective_Milestones_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_Milestones_ManyArgs = {
  updates: Array<Objective_Milestones_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_TypesArgs = {
  _set?: InputMaybe<Objective_Types_Set_Input>;
  where: Objective_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_Types_By_PkArgs = {
  _set?: InputMaybe<Objective_Types_Set_Input>;
  pk_columns: Objective_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_Types_ManyArgs = {
  updates: Array<Objective_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ObjectivesArgs = {
  _inc?: InputMaybe<Objectives_Inc_Input>;
  _set?: InputMaybe<Objectives_Set_Input>;
  where: Objectives_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Objectives_By_PkArgs = {
  _inc?: InputMaybe<Objectives_Inc_Input>;
  _set?: InputMaybe<Objectives_Set_Input>;
  pk_columns: Objectives_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Objectives_ManyArgs = {
  updates: Array<Objectives_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Off_Production_ConsumptionsArgs = {
  _inc?: InputMaybe<Off_Production_Consumptions_Inc_Input>;
  _set?: InputMaybe<Off_Production_Consumptions_Set_Input>;
  where: Off_Production_Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Off_Production_Consumptions_By_PkArgs = {
  _inc?: InputMaybe<Off_Production_Consumptions_Inc_Input>;
  _set?: InputMaybe<Off_Production_Consumptions_Set_Input>;
  pk_columns: Off_Production_Consumptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Off_Production_Consumptions_ManyArgs = {
  updates: Array<Off_Production_Consumptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ofs_By_DayArgs = {
  _inc?: InputMaybe<Ofs_By_Day_Inc_Input>;
  _set?: InputMaybe<Ofs_By_Day_Set_Input>;
  where: Ofs_By_Day_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ofs_By_Day_By_PkArgs = {
  _inc?: InputMaybe<Ofs_By_Day_Inc_Input>;
  _set?: InputMaybe<Ofs_By_Day_Set_Input>;
  pk_columns: Ofs_By_Day_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ofs_By_Day_ManyArgs = {
  updates: Array<Ofs_By_Day_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Production_HoursArgs = {
  _inc?: InputMaybe<Production_Hours_Inc_Input>;
  _set?: InputMaybe<Production_Hours_Set_Input>;
  where: Production_Hours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Production_Hours_By_PkArgs = {
  _inc?: InputMaybe<Production_Hours_Inc_Input>;
  _set?: InputMaybe<Production_Hours_Set_Input>;
  pk_columns: Production_Hours_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Production_Hours_ManyArgs = {
  updates: Array<Production_Hours_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Production_Reporting_FrequenciesArgs = {
  _set?: InputMaybe<Production_Reporting_Frequencies_Set_Input>;
  where: Production_Reporting_Frequencies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Production_Reporting_Frequencies_By_PkArgs = {
  _set?: InputMaybe<Production_Reporting_Frequencies_Set_Input>;
  pk_columns: Production_Reporting_Frequencies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Production_Reporting_Frequencies_ManyArgs = {
  updates: Array<Production_Reporting_Frequencies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductionsArgs = {
  _inc?: InputMaybe<Productions_Inc_Input>;
  _set?: InputMaybe<Productions_Set_Input>;
  where: Productions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Productions_By_PkArgs = {
  _inc?: InputMaybe<Productions_Inc_Input>;
  _set?: InputMaybe<Productions_Set_Input>;
  pk_columns: Productions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Productions_ManyArgs = {
  updates: Array<Productions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_ManyArgs = {
  updates: Array<Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Roi_DurationsArgs = {
  _set?: InputMaybe<Project_Roi_Durations_Set_Input>;
  where: Project_Roi_Durations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Roi_Durations_By_PkArgs = {
  _set?: InputMaybe<Project_Roi_Durations_Set_Input>;
  pk_columns: Project_Roi_Durations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Roi_Durations_ManyArgs = {
  updates: Array<Project_Roi_Durations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Budget_RangesArgs = {
  _set?: InputMaybe<Project_Budget_Ranges_Set_Input>;
  where: Project_Budget_Ranges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Budget_Ranges_By_PkArgs = {
  _set?: InputMaybe<Project_Budget_Ranges_Set_Input>;
  pk_columns: Project_Budget_Ranges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Budget_Ranges_ManyArgs = {
  updates: Array<Project_Budget_Ranges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ComplexitiesArgs = {
  _set?: InputMaybe<Project_Complexities_Set_Input>;
  where: Project_Complexities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Complexities_By_PkArgs = {
  _set?: InputMaybe<Project_Complexities_Set_Input>;
  pk_columns: Project_Complexities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Complexities_ManyArgs = {
  updates: Array<Project_Complexities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_StatusesArgs = {
  _set?: InputMaybe<Project_Statuses_Set_Input>;
  where: Project_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Statuses_By_PkArgs = {
  _set?: InputMaybe<Project_Statuses_Set_Input>;
  pk_columns: Project_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Statuses_ManyArgs = {
  updates: Array<Project_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_TemplatesArgs = {
  _append?: InputMaybe<Project_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Templates_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Templates_Inc_Input>;
  _prepend?: InputMaybe<Project_Templates_Prepend_Input>;
  _set?: InputMaybe<Project_Templates_Set_Input>;
  where: Project_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Templates_By_PkArgs = {
  _append?: InputMaybe<Project_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Templates_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Templates_Inc_Input>;
  _prepend?: InputMaybe<Project_Templates_Prepend_Input>;
  _set?: InputMaybe<Project_Templates_Set_Input>;
  pk_columns: Project_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Templates_ManyArgs = {
  updates: Array<Project_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectsArgs = {
  _append?: InputMaybe<Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Inc_Input>;
  _prepend?: InputMaybe<Projects_Prepend_Input>;
  _set?: InputMaybe<Projects_Set_Input>;
  where: Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_By_PkArgs = {
  _append?: InputMaybe<Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Projects_Inc_Input>;
  _prepend?: InputMaybe<Projects_Prepend_Input>;
  _set?: InputMaybe<Projects_Set_Input>;
  pk_columns: Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Projects_ManyArgs = {
  updates: Array<Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SitesArgs = {
  _inc?: InputMaybe<Sites_Inc_Input>;
  _set?: InputMaybe<Sites_Set_Input>;
  where: Sites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sites_By_PkArgs = {
  _inc?: InputMaybe<Sites_Inc_Input>;
  _set?: InputMaybe<Sites_Set_Input>;
  pk_columns: Sites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sites_ManyArgs = {
  updates: Array<Sites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SourcesArgs = {
  _set?: InputMaybe<Sources_Set_Input>;
  where: Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sources_By_PkArgs = {
  _set?: InputMaybe<Sources_Set_Input>;
  pk_columns: Sources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sources_ManyArgs = {
  updates: Array<Sources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Standard_TypesArgs = {
  _set?: InputMaybe<Standard_Types_Set_Input>;
  where: Standard_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Standard_Types_By_PkArgs = {
  _set?: InputMaybe<Standard_Types_Set_Input>;
  pk_columns: Standard_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Standard_Types_ManyArgs = {
  updates: Array<Standard_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StandardsArgs = {
  _inc?: InputMaybe<Standards_Inc_Input>;
  _set?: InputMaybe<Standards_Set_Input>;
  where: Standards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Standards_By_PkArgs = {
  _inc?: InputMaybe<Standards_Inc_Input>;
  _set?: InputMaybe<Standards_Set_Input>;
  pk_columns: Standards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Standards_ManyArgs = {
  updates: Array<Standards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubventionsArgs = {
  _set?: InputMaybe<Subventions_Set_Input>;
  where: Subventions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subventions_By_PkArgs = {
  _set?: InputMaybe<Subventions_Set_Input>;
  pk_columns: Subventions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subventions_ManyArgs = {
  updates: Array<Subventions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tariff_SchedulesArgs = {
  _inc?: InputMaybe<Tariff_Schedules_Inc_Input>;
  _set?: InputMaybe<Tariff_Schedules_Set_Input>;
  where: Tariff_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tariff_Schedules_By_PkArgs = {
  _inc?: InputMaybe<Tariff_Schedules_Inc_Input>;
  _set?: InputMaybe<Tariff_Schedules_Set_Input>;
  pk_columns: Tariff_Schedules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tariff_Schedules_ManyArgs = {
  updates: Array<Tariff_Schedules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TariffsArgs = {
  _inc?: InputMaybe<Tariffs_Inc_Input>;
  _set?: InputMaybe<Tariffs_Set_Input>;
  where: Tariffs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tariffs_By_PkArgs = {
  _inc?: InputMaybe<Tariffs_Inc_Input>;
  _set?: InputMaybe<Tariffs_Set_Input>;
  pk_columns: Tariffs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tariffs_ManyArgs = {
  updates: Array<Tariffs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_StatusesArgs = {
  _set?: InputMaybe<Task_Statuses_Set_Input>;
  where: Task_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Statuses_By_PkArgs = {
  _set?: InputMaybe<Task_Statuses_Set_Input>;
  pk_columns: Task_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Statuses_ManyArgs = {
  updates: Array<Task_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_TypesArgs = {
  _set?: InputMaybe<Task_Types_Set_Input>;
  where: Task_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Types_By_PkArgs = {
  _set?: InputMaybe<Task_Types_Set_Input>;
  pk_columns: Task_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_Types_ManyArgs = {
  updates: Array<Task_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TasksArgs = {
  _inc?: InputMaybe<Tasks_Inc_Input>;
  _set?: InputMaybe<Tasks_Set_Input>;
  where: Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tasks_By_PkArgs = {
  _inc?: InputMaybe<Tasks_Inc_Input>;
  _set?: InputMaybe<Tasks_Set_Input>;
  pk_columns: Tasks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tasks_ManyArgs = {
  updates: Array<Tasks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_ConsumptionsArgs = {
  _inc?: InputMaybe<Third_Party_Consumptions_Inc_Input>;
  _set?: InputMaybe<Third_Party_Consumptions_Set_Input>;
  where: Third_Party_Consumptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Consumptions_ManyArgs = {
  updates: Array<Third_Party_Consumptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_IndexesArgs = {
  _inc?: InputMaybe<Third_Party_Indexes_Inc_Input>;
  _set?: InputMaybe<Third_Party_Indexes_Set_Input>;
  where: Third_Party_Indexes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Indexes_By_PkArgs = {
  _inc?: InputMaybe<Third_Party_Indexes_Inc_Input>;
  _set?: InputMaybe<Third_Party_Indexes_Set_Input>;
  pk_columns: Third_Party_Indexes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Indexes_ManyArgs = {
  updates: Array<Third_Party_Indexes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Sftp_FilesArgs = {
  _set?: InputMaybe<Third_Party_Sftp_Files_Set_Input>;
  where: Third_Party_Sftp_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Sftp_Files_By_PkArgs = {
  _set?: InputMaybe<Third_Party_Sftp_Files_Set_Input>;
  pk_columns: Third_Party_Sftp_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Third_Party_Sftp_Files_ManyArgs = {
  updates: Array<Third_Party_Sftp_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_TypesArgs = {
  _set?: InputMaybe<Unit_Types_Set_Input>;
  where: Unit_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Types_By_PkArgs = {
  _set?: InputMaybe<Unit_Types_Set_Input>;
  pk_columns: Unit_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Types_ManyArgs = {
  updates: Array<Unit_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnitsArgs = {
  _inc?: InputMaybe<Units_Inc_Input>;
  _set?: InputMaybe<Units_Set_Input>;
  where: Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Units_By_PkArgs = {
  _inc?: InputMaybe<Units_Inc_Input>;
  _set?: InputMaybe<Units_Set_Input>;
  pk_columns: Units_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Units_ManyArgs = {
  updates: Array<Units_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Daily_MeasuresArgs = {
  _inc?: InputMaybe<Weather_Daily_Measures_Inc_Input>;
  _set?: InputMaybe<Weather_Daily_Measures_Set_Input>;
  where: Weather_Daily_Measures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Daily_Measures_By_PkArgs = {
  _inc?: InputMaybe<Weather_Daily_Measures_Inc_Input>;
  _set?: InputMaybe<Weather_Daily_Measures_Set_Input>;
  pk_columns: Weather_Daily_Measures_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Daily_Measures_ManyArgs = {
  updates: Array<Weather_Daily_Measures_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_MeasuresArgs = {
  _inc?: InputMaybe<Weather_Measures_Inc_Input>;
  _set?: InputMaybe<Weather_Measures_Set_Input>;
  where: Weather_Measures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Measures_By_PkArgs = {
  _inc?: InputMaybe<Weather_Measures_Inc_Input>;
  _set?: InputMaybe<Weather_Measures_Set_Input>;
  pk_columns: Weather_Measures_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Measures_ManyArgs = {
  updates: Array<Weather_Measures_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_ProvidersArgs = {
  _set?: InputMaybe<Weather_Providers_Set_Input>;
  where: Weather_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Providers_By_PkArgs = {
  _set?: InputMaybe<Weather_Providers_Set_Input>;
  pk_columns: Weather_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Providers_ManyArgs = {
  updates: Array<Weather_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_StationsArgs = {
  _inc?: InputMaybe<Weather_Stations_Inc_Input>;
  _set?: InputMaybe<Weather_Stations_Set_Input>;
  where: Weather_Stations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Stations_By_PkArgs = {
  _inc?: InputMaybe<Weather_Stations_Inc_Input>;
  _set?: InputMaybe<Weather_Stations_Set_Input>;
  pk_columns: Weather_Stations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Stations_ManyArgs = {
  updates: Array<Weather_Stations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WeekdaysArgs = {
  _set?: InputMaybe<Weekdays_Set_Input>;
  where: Weekdays_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weekdays_By_PkArgs = {
  _set?: InputMaybe<Weekdays_Set_Input>;
  pk_columns: Weekdays_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weekdays_ManyArgs = {
  updates: Array<Weekdays_Updates>;
};


/** mutation root */
export type Mutation_RootUpsert_Epi_In_TableArgs = {
  args: Upsert_Epi_In_Table_Args;
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  created_for: Scalars['String']['output'];
  data: Scalars['json']['output'];
  id: Scalars['Int']['output'];
  read: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


/** columns and relationships of "notifications" */
export type NotificationsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_for?: InputMaybe<String_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  read?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for incrementing numeric columns in table "notifications" */
export type Notifications_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_for?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_for?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_for?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_for?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedFor = 'created_for',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Read = 'read',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_for?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_for?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedFor = 'created_for',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Read = 'read',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

export type Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "objective_milestones" */
export type Objective_Milestones = {
  __typename?: 'objective_milestones';
  co2_target?: Maybe<Scalars['numeric']['output']>;
  consumption_target: Scalars['numeric']['output'];
  cost_target?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  objective: Objectives;
  objective_id: Scalars['Int']['output'];
  timestamp: Scalars['timestamptz']['output'];
};

/** aggregated selection of "objective_milestones" */
export type Objective_Milestones_Aggregate = {
  __typename?: 'objective_milestones_aggregate';
  aggregate?: Maybe<Objective_Milestones_Aggregate_Fields>;
  nodes: Array<Objective_Milestones>;
};

export type Objective_Milestones_Aggregate_Bool_Exp = {
  count?: InputMaybe<Objective_Milestones_Aggregate_Bool_Exp_Count>;
};

export type Objective_Milestones_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Objective_Milestones_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "objective_milestones" */
export type Objective_Milestones_Aggregate_Fields = {
  __typename?: 'objective_milestones_aggregate_fields';
  avg?: Maybe<Objective_Milestones_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Objective_Milestones_Max_Fields>;
  min?: Maybe<Objective_Milestones_Min_Fields>;
  stddev?: Maybe<Objective_Milestones_Stddev_Fields>;
  stddev_pop?: Maybe<Objective_Milestones_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Objective_Milestones_Stddev_Samp_Fields>;
  sum?: Maybe<Objective_Milestones_Sum_Fields>;
  var_pop?: Maybe<Objective_Milestones_Var_Pop_Fields>;
  var_samp?: Maybe<Objective_Milestones_Var_Samp_Fields>;
  variance?: Maybe<Objective_Milestones_Variance_Fields>;
};


/** aggregate fields of "objective_milestones" */
export type Objective_Milestones_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "objective_milestones" */
export type Objective_Milestones_Aggregate_Order_By = {
  avg?: InputMaybe<Objective_Milestones_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Objective_Milestones_Max_Order_By>;
  min?: InputMaybe<Objective_Milestones_Min_Order_By>;
  stddev?: InputMaybe<Objective_Milestones_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Objective_Milestones_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Objective_Milestones_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Objective_Milestones_Sum_Order_By>;
  var_pop?: InputMaybe<Objective_Milestones_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Objective_Milestones_Var_Samp_Order_By>;
  variance?: InputMaybe<Objective_Milestones_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "objective_milestones" */
export type Objective_Milestones_Arr_Rel_Insert_Input = {
  data: Array<Objective_Milestones_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Objective_Milestones_On_Conflict>;
};

/** aggregate avg on columns */
export type Objective_Milestones_Avg_Fields = {
  __typename?: 'objective_milestones_avg_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "objective_milestones" */
export type Objective_Milestones_Avg_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "objective_milestones". All fields are combined with a logical 'AND'. */
export type Objective_Milestones_Bool_Exp = {
  _and?: InputMaybe<Array<Objective_Milestones_Bool_Exp>>;
  _not?: InputMaybe<Objective_Milestones_Bool_Exp>;
  _or?: InputMaybe<Array<Objective_Milestones_Bool_Exp>>;
  co2_target?: InputMaybe<Numeric_Comparison_Exp>;
  consumption_target?: InputMaybe<Numeric_Comparison_Exp>;
  cost_target?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  objective?: InputMaybe<Objectives_Bool_Exp>;
  objective_id?: InputMaybe<Int_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "objective_milestones" */
export enum Objective_Milestones_Constraint {
  /** unique or primary key constraint on columns "id" */
  ObjectiveMilestonesPkey = 'objective_milestones_pkey'
}

/** input type for incrementing numeric columns in table "objective_milestones" */
export type Objective_Milestones_Inc_Input = {
  co2_target?: InputMaybe<Scalars['numeric']['input']>;
  consumption_target?: InputMaybe<Scalars['numeric']['input']>;
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  objective_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "objective_milestones" */
export type Objective_Milestones_Insert_Input = {
  co2_target?: InputMaybe<Scalars['numeric']['input']>;
  consumption_target?: InputMaybe<Scalars['numeric']['input']>;
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  objective?: InputMaybe<Objectives_Obj_Rel_Insert_Input>;
  objective_id?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Objective_Milestones_Max_Fields = {
  __typename?: 'objective_milestones_max_fields';
  co2_target?: Maybe<Scalars['numeric']['output']>;
  consumption_target?: Maybe<Scalars['numeric']['output']>;
  cost_target?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  objective_id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "objective_milestones" */
export type Objective_Milestones_Max_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Objective_Milestones_Min_Fields = {
  __typename?: 'objective_milestones_min_fields';
  co2_target?: Maybe<Scalars['numeric']['output']>;
  consumption_target?: Maybe<Scalars['numeric']['output']>;
  cost_target?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  objective_id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "objective_milestones" */
export type Objective_Milestones_Min_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "objective_milestones" */
export type Objective_Milestones_Mutation_Response = {
  __typename?: 'objective_milestones_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Objective_Milestones>;
};

/** on_conflict condition type for table "objective_milestones" */
export type Objective_Milestones_On_Conflict = {
  constraint: Objective_Milestones_Constraint;
  update_columns?: Array<Objective_Milestones_Update_Column>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};

/** Ordering options when selecting data from "objective_milestones". */
export type Objective_Milestones_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective?: InputMaybe<Objectives_Order_By>;
  objective_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: objective_milestones */
export type Objective_Milestones_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "objective_milestones" */
export enum Objective_Milestones_Select_Column {
  /** column name */
  Co2Target = 'co2_target',
  /** column name */
  ConsumptionTarget = 'consumption_target',
  /** column name */
  CostTarget = 'cost_target',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectiveId = 'objective_id',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "objective_milestones" */
export type Objective_Milestones_Set_Input = {
  co2_target?: InputMaybe<Scalars['numeric']['input']>;
  consumption_target?: InputMaybe<Scalars['numeric']['input']>;
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  objective_id?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Objective_Milestones_Stddev_Fields = {
  __typename?: 'objective_milestones_stddev_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "objective_milestones" */
export type Objective_Milestones_Stddev_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Objective_Milestones_Stddev_Pop_Fields = {
  __typename?: 'objective_milestones_stddev_pop_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "objective_milestones" */
export type Objective_Milestones_Stddev_Pop_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Objective_Milestones_Stddev_Samp_Fields = {
  __typename?: 'objective_milestones_stddev_samp_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "objective_milestones" */
export type Objective_Milestones_Stddev_Samp_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "objective_milestones" */
export type Objective_Milestones_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Objective_Milestones_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Objective_Milestones_Stream_Cursor_Value_Input = {
  co2_target?: InputMaybe<Scalars['numeric']['input']>;
  consumption_target?: InputMaybe<Scalars['numeric']['input']>;
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  objective_id?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Objective_Milestones_Sum_Fields = {
  __typename?: 'objective_milestones_sum_fields';
  co2_target?: Maybe<Scalars['numeric']['output']>;
  consumption_target?: Maybe<Scalars['numeric']['output']>;
  cost_target?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  objective_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "objective_milestones" */
export type Objective_Milestones_Sum_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** update columns of table "objective_milestones" */
export enum Objective_Milestones_Update_Column {
  /** column name */
  Co2Target = 'co2_target',
  /** column name */
  ConsumptionTarget = 'consumption_target',
  /** column name */
  CostTarget = 'cost_target',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectiveId = 'objective_id',
  /** column name */
  Timestamp = 'timestamp'
}

export type Objective_Milestones_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Objective_Milestones_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Objective_Milestones_Set_Input>;
  /** filter the rows which have to be updated */
  where: Objective_Milestones_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Objective_Milestones_Var_Pop_Fields = {
  __typename?: 'objective_milestones_var_pop_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "objective_milestones" */
export type Objective_Milestones_Var_Pop_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Objective_Milestones_Var_Samp_Fields = {
  __typename?: 'objective_milestones_var_samp_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "objective_milestones" */
export type Objective_Milestones_Var_Samp_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Objective_Milestones_Variance_Fields = {
  __typename?: 'objective_milestones_variance_fields';
  co2_target?: Maybe<Scalars['Float']['output']>;
  consumption_target?: Maybe<Scalars['Float']['output']>;
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  objective_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "objective_milestones" */
export type Objective_Milestones_Variance_Order_By = {
  co2_target?: InputMaybe<Order_By>;
  consumption_target?: InputMaybe<Order_By>;
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objective_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "objective_types" */
export type Objective_Types = {
  __typename?: 'objective_types';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  objectives: Array<Objectives>;
  /** An aggregate relationship */
  objectives_aggregate: Objectives_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "objective_types" */
export type Objective_TypesObjectivesArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


/** columns and relationships of "objective_types" */
export type Objective_TypesObjectives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};

/** aggregated selection of "objective_types" */
export type Objective_Types_Aggregate = {
  __typename?: 'objective_types_aggregate';
  aggregate?: Maybe<Objective_Types_Aggregate_Fields>;
  nodes: Array<Objective_Types>;
};

/** aggregate fields of "objective_types" */
export type Objective_Types_Aggregate_Fields = {
  __typename?: 'objective_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Objective_Types_Max_Fields>;
  min?: Maybe<Objective_Types_Min_Fields>;
};


/** aggregate fields of "objective_types" */
export type Objective_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Objective_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "objective_types". All fields are combined with a logical 'AND'. */
export type Objective_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Objective_Types_Bool_Exp>>;
  _not?: InputMaybe<Objective_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Objective_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  objectives?: InputMaybe<Objectives_Bool_Exp>;
  objectives_aggregate?: InputMaybe<Objectives_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "objective_types" */
export enum Objective_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  ObjectiveTypesPkey = 'objective_types_pkey'
}

export enum Objective_Types_Enum {
  Consumption = 'Consumption',
  CumulatedConsumption = 'Cumulated_consumption'
}

/** Boolean expression to compare columns of type "objective_types_enum". All fields are combined with logical 'AND'. */
export type Objective_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Objective_Types_Enum>;
  _in?: InputMaybe<Array<Objective_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Objective_Types_Enum>;
  _nin?: InputMaybe<Array<Objective_Types_Enum>>;
};

/** input type for inserting data into table "objective_types" */
export type Objective_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Objectives_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Objective_Types_Max_Fields = {
  __typename?: 'objective_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Objective_Types_Min_Fields = {
  __typename?: 'objective_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "objective_types" */
export type Objective_Types_Mutation_Response = {
  __typename?: 'objective_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Objective_Types>;
};

/** on_conflict condition type for table "objective_types" */
export type Objective_Types_On_Conflict = {
  constraint: Objective_Types_Constraint;
  update_columns?: Array<Objective_Types_Update_Column>;
  where?: InputMaybe<Objective_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "objective_types". */
export type Objective_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  objectives_aggregate?: InputMaybe<Objectives_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: objective_types */
export type Objective_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "objective_types" */
export enum Objective_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "objective_types" */
export type Objective_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "objective_types" */
export type Objective_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Objective_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Objective_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "objective_types" */
export enum Objective_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Objective_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Objective_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Objective_Types_Bool_Exp;
};

/** columns and relationships of "objectives" */
export type Objectives = {
  __typename?: 'objectives';
  cost_target?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['timestamptz']['output'];
  firebase_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_archived: Scalars['Boolean']['output'];
  /** An object relationship */
  meter: Meters;
  meter_id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  objective_milestones: Array<Objective_Milestones>;
  /** An aggregate relationship */
  objective_milestones_aggregate: Objective_Milestones_Aggregate;
  reduction_objective_in_pourcent?: Maybe<Scalars['numeric']['output']>;
  reference_year?: Maybe<Scalars['numeric']['output']>;
  start: Scalars['timestamptz']['output'];
  target: Scalars['numeric']['output'];
  type: Objective_Types_Enum;
};


/** columns and relationships of "objectives" */
export type ObjectivesObjective_MilestonesArgs = {
  distinct_on?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Milestones_Order_By>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};


/** columns and relationships of "objectives" */
export type ObjectivesObjective_Milestones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Milestones_Order_By>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};

/** aggregated selection of "objectives" */
export type Objectives_Aggregate = {
  __typename?: 'objectives_aggregate';
  aggregate?: Maybe<Objectives_Aggregate_Fields>;
  nodes: Array<Objectives>;
};

export type Objectives_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Objectives_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Objectives_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Objectives_Aggregate_Bool_Exp_Count>;
};

export type Objectives_Aggregate_Bool_Exp_Bool_And = {
  arguments: Objectives_Select_Column_Objectives_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Objectives_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Objectives_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Objectives_Select_Column_Objectives_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Objectives_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Objectives_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Objectives_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Objectives_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "objectives" */
export type Objectives_Aggregate_Fields = {
  __typename?: 'objectives_aggregate_fields';
  avg?: Maybe<Objectives_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Objectives_Max_Fields>;
  min?: Maybe<Objectives_Min_Fields>;
  stddev?: Maybe<Objectives_Stddev_Fields>;
  stddev_pop?: Maybe<Objectives_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Objectives_Stddev_Samp_Fields>;
  sum?: Maybe<Objectives_Sum_Fields>;
  var_pop?: Maybe<Objectives_Var_Pop_Fields>;
  var_samp?: Maybe<Objectives_Var_Samp_Fields>;
  variance?: Maybe<Objectives_Variance_Fields>;
};


/** aggregate fields of "objectives" */
export type Objectives_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Objectives_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "objectives" */
export type Objectives_Aggregate_Order_By = {
  avg?: InputMaybe<Objectives_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Objectives_Max_Order_By>;
  min?: InputMaybe<Objectives_Min_Order_By>;
  stddev?: InputMaybe<Objectives_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Objectives_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Objectives_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Objectives_Sum_Order_By>;
  var_pop?: InputMaybe<Objectives_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Objectives_Var_Samp_Order_By>;
  variance?: InputMaybe<Objectives_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "objectives" */
export type Objectives_Arr_Rel_Insert_Input = {
  data: Array<Objectives_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Objectives_On_Conflict>;
};

/** aggregate avg on columns */
export type Objectives_Avg_Fields = {
  __typename?: 'objectives_avg_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "objectives" */
export type Objectives_Avg_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "objectives". All fields are combined with a logical 'AND'. */
export type Objectives_Bool_Exp = {
  _and?: InputMaybe<Array<Objectives_Bool_Exp>>;
  _not?: InputMaybe<Objectives_Bool_Exp>;
  _or?: InputMaybe<Array<Objectives_Bool_Exp>>;
  cost_target?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  objective_milestones?: InputMaybe<Objective_Milestones_Bool_Exp>;
  objective_milestones_aggregate?: InputMaybe<Objective_Milestones_Aggregate_Bool_Exp>;
  reduction_objective_in_pourcent?: InputMaybe<Numeric_Comparison_Exp>;
  reference_year?: InputMaybe<Numeric_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  target?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Objective_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "objectives" */
export enum Objectives_Constraint {
  /** unique or primary key constraint on columns "id" */
  ObjectivesPkey = 'objectives_pkey'
}

/** input type for incrementing numeric columns in table "objectives" */
export type Objectives_Inc_Input = {
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  reduction_objective_in_pourcent?: InputMaybe<Scalars['numeric']['input']>;
  reference_year?: InputMaybe<Scalars['numeric']['input']>;
  target?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "objectives" */
export type Objectives_Insert_Input = {
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective_milestones?: InputMaybe<Objective_Milestones_Arr_Rel_Insert_Input>;
  reduction_objective_in_pourcent?: InputMaybe<Scalars['numeric']['input']>;
  reference_year?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  target?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Objective_Types_Enum>;
};

/** aggregate max on columns */
export type Objectives_Max_Fields = {
  __typename?: 'objectives_max_fields';
  cost_target?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['numeric']['output']>;
  reference_year?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  target?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "objectives" */
export type Objectives_Max_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Objectives_Min_Fields = {
  __typename?: 'objectives_min_fields';
  cost_target?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['numeric']['output']>;
  reference_year?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  target?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "objectives" */
export type Objectives_Min_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "objectives" */
export type Objectives_Mutation_Response = {
  __typename?: 'objectives_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Objectives>;
};

/** input type for inserting object relation for remote table "objectives" */
export type Objectives_Obj_Rel_Insert_Input = {
  data: Objectives_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Objectives_On_Conflict>;
};

/** on_conflict condition type for table "objectives" */
export type Objectives_On_Conflict = {
  constraint: Objectives_Constraint;
  update_columns?: Array<Objectives_Update_Column>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};

/** Ordering options when selecting data from "objectives". */
export type Objectives_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  objective_milestones_aggregate?: InputMaybe<Objective_Milestones_Aggregate_Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: objectives */
export type Objectives_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "objectives" */
export enum Objectives_Select_Column {
  /** column name */
  CostTarget = 'cost_target',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Name = 'name',
  /** column name */
  ReductionObjectiveInPourcent = 'reduction_objective_in_pourcent',
  /** column name */
  ReferenceYear = 'reference_year',
  /** column name */
  Start = 'start',
  /** column name */
  Target = 'target',
  /** column name */
  Type = 'type'
}

/** select "objectives_aggregate_bool_exp_bool_and_arguments_columns" columns of table "objectives" */
export enum Objectives_Select_Column_Objectives_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsArchived = 'is_archived'
}

/** select "objectives_aggregate_bool_exp_bool_or_arguments_columns" columns of table "objectives" */
export enum Objectives_Select_Column_Objectives_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsArchived = 'is_archived'
}

/** input type for updating data in table "objectives" */
export type Objectives_Set_Input = {
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reduction_objective_in_pourcent?: InputMaybe<Scalars['numeric']['input']>;
  reference_year?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  target?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Objective_Types_Enum>;
};

/** aggregate stddev on columns */
export type Objectives_Stddev_Fields = {
  __typename?: 'objectives_stddev_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "objectives" */
export type Objectives_Stddev_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Objectives_Stddev_Pop_Fields = {
  __typename?: 'objectives_stddev_pop_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "objectives" */
export type Objectives_Stddev_Pop_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Objectives_Stddev_Samp_Fields = {
  __typename?: 'objectives_stddev_samp_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "objectives" */
export type Objectives_Stddev_Samp_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "objectives" */
export type Objectives_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Objectives_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Objectives_Stream_Cursor_Value_Input = {
  cost_target?: InputMaybe<Scalars['numeric']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reduction_objective_in_pourcent?: InputMaybe<Scalars['numeric']['input']>;
  reference_year?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  target?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Objective_Types_Enum>;
};

/** aggregate sum on columns */
export type Objectives_Sum_Fields = {
  __typename?: 'objectives_sum_fields';
  cost_target?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['numeric']['output']>;
  reference_year?: Maybe<Scalars['numeric']['output']>;
  target?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "objectives" */
export type Objectives_Sum_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** update columns of table "objectives" */
export enum Objectives_Update_Column {
  /** column name */
  CostTarget = 'cost_target',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Name = 'name',
  /** column name */
  ReductionObjectiveInPourcent = 'reduction_objective_in_pourcent',
  /** column name */
  ReferenceYear = 'reference_year',
  /** column name */
  Start = 'start',
  /** column name */
  Target = 'target',
  /** column name */
  Type = 'type'
}

export type Objectives_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Objectives_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Objectives_Set_Input>;
  /** filter the rows which have to be updated */
  where: Objectives_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Objectives_Var_Pop_Fields = {
  __typename?: 'objectives_var_pop_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "objectives" */
export type Objectives_Var_Pop_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Objectives_Var_Samp_Fields = {
  __typename?: 'objectives_var_samp_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "objectives" */
export type Objectives_Var_Samp_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Objectives_Variance_Fields = {
  __typename?: 'objectives_variance_fields';
  cost_target?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
  reduction_objective_in_pourcent?: Maybe<Scalars['Float']['output']>;
  reference_year?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "objectives" */
export type Objectives_Variance_Order_By = {
  cost_target?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_id?: InputMaybe<Order_By>;
  reduction_objective_in_pourcent?: InputMaybe<Order_By>;
  reference_year?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
};

/** columns and relationships of "off_production_consumptions" */
export type Off_Production_Consumptions = {
  __typename?: 'off_production_consumptions';
  avg_power_kw: Scalars['numeric']['output'];
  consumption_kwh: Scalars['numeric']['output'];
  cost?: Maybe<Scalars['numeric']['output']>;
  end: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter?: Maybe<Meters>;
  meter_id: Scalars['Int']['output'];
  start: Scalars['timestamp']['output'];
};

/** aggregated selection of "off_production_consumptions" */
export type Off_Production_Consumptions_Aggregate = {
  __typename?: 'off_production_consumptions_aggregate';
  aggregate?: Maybe<Off_Production_Consumptions_Aggregate_Fields>;
  nodes: Array<Off_Production_Consumptions>;
};

/** aggregate fields of "off_production_consumptions" */
export type Off_Production_Consumptions_Aggregate_Fields = {
  __typename?: 'off_production_consumptions_aggregate_fields';
  avg?: Maybe<Off_Production_Consumptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Off_Production_Consumptions_Max_Fields>;
  min?: Maybe<Off_Production_Consumptions_Min_Fields>;
  stddev?: Maybe<Off_Production_Consumptions_Stddev_Fields>;
  stddev_pop?: Maybe<Off_Production_Consumptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Off_Production_Consumptions_Stddev_Samp_Fields>;
  sum?: Maybe<Off_Production_Consumptions_Sum_Fields>;
  var_pop?: Maybe<Off_Production_Consumptions_Var_Pop_Fields>;
  var_samp?: Maybe<Off_Production_Consumptions_Var_Samp_Fields>;
  variance?: Maybe<Off_Production_Consumptions_Variance_Fields>;
};


/** aggregate fields of "off_production_consumptions" */
export type Off_Production_Consumptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Off_Production_Consumptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Off_Production_Consumptions_Avg_Fields = {
  __typename?: 'off_production_consumptions_avg_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "off_production_consumptions". All fields are combined with a logical 'AND'. */
export type Off_Production_Consumptions_Bool_Exp = {
  _and?: InputMaybe<Array<Off_Production_Consumptions_Bool_Exp>>;
  _not?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
  _or?: InputMaybe<Array<Off_Production_Consumptions_Bool_Exp>>;
  avg_power_kw?: InputMaybe<Numeric_Comparison_Exp>;
  consumption_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter?: InputMaybe<Meters_Bool_Exp>;
  meter_id?: InputMaybe<Int_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "off_production_consumptions" */
export enum Off_Production_Consumptions_Constraint {
  /** unique or primary key constraint on columns "start", "meter_id" */
  OffProductionConsumptionsMeterIdStartKey = 'off_production_consumptions_meter_id_start_key',
  /** unique or primary key constraint on columns "id" */
  OffProductionConsumptionsPkey = 'off_production_consumptions_pkey'
}

/** input type for incrementing numeric columns in table "off_production_consumptions" */
export type Off_Production_Consumptions_Inc_Input = {
  avg_power_kw?: InputMaybe<Scalars['numeric']['input']>;
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "off_production_consumptions" */
export type Off_Production_Consumptions_Insert_Input = {
  avg_power_kw?: InputMaybe<Scalars['numeric']['input']>;
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter?: InputMaybe<Meters_Obj_Rel_Insert_Input>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Off_Production_Consumptions_Max_Fields = {
  __typename?: 'off_production_consumptions_max_fields';
  avg_power_kw?: Maybe<Scalars['numeric']['output']>;
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Off_Production_Consumptions_Min_Fields = {
  __typename?: 'off_production_consumptions_min_fields';
  avg_power_kw?: Maybe<Scalars['numeric']['output']>;
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "off_production_consumptions" */
export type Off_Production_Consumptions_Mutation_Response = {
  __typename?: 'off_production_consumptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Off_Production_Consumptions>;
};

/** on_conflict condition type for table "off_production_consumptions" */
export type Off_Production_Consumptions_On_Conflict = {
  constraint: Off_Production_Consumptions_Constraint;
  update_columns?: Array<Off_Production_Consumptions_Update_Column>;
  where?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
};

/** Ordering options when selecting data from "off_production_consumptions". */
export type Off_Production_Consumptions_Order_By = {
  avg_power_kw?: InputMaybe<Order_By>;
  consumption_kwh?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter?: InputMaybe<Meters_Order_By>;
  meter_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** primary key columns input for table: off_production_consumptions */
export type Off_Production_Consumptions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "off_production_consumptions" */
export enum Off_Production_Consumptions_Select_Column {
  /** column name */
  AvgPowerKw = 'avg_power_kw',
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Start = 'start'
}

/** input type for updating data in table "off_production_consumptions" */
export type Off_Production_Consumptions_Set_Input = {
  avg_power_kw?: InputMaybe<Scalars['numeric']['input']>;
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Off_Production_Consumptions_Stddev_Fields = {
  __typename?: 'off_production_consumptions_stddev_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Off_Production_Consumptions_Stddev_Pop_Fields = {
  __typename?: 'off_production_consumptions_stddev_pop_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Off_Production_Consumptions_Stddev_Samp_Fields = {
  __typename?: 'off_production_consumptions_stddev_samp_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "off_production_consumptions" */
export type Off_Production_Consumptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Off_Production_Consumptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Off_Production_Consumptions_Stream_Cursor_Value_Input = {
  avg_power_kw?: InputMaybe<Scalars['numeric']['input']>;
  consumption_kwh?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Off_Production_Consumptions_Sum_Fields = {
  __typename?: 'off_production_consumptions_sum_fields';
  avg_power_kw?: Maybe<Scalars['numeric']['output']>;
  consumption_kwh?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "off_production_consumptions" */
export enum Off_Production_Consumptions_Update_Column {
  /** column name */
  AvgPowerKw = 'avg_power_kw',
  /** column name */
  ConsumptionKwh = 'consumption_kwh',
  /** column name */
  Cost = 'cost',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  MeterId = 'meter_id',
  /** column name */
  Start = 'start'
}

export type Off_Production_Consumptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Off_Production_Consumptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Off_Production_Consumptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Off_Production_Consumptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Off_Production_Consumptions_Var_Pop_Fields = {
  __typename?: 'off_production_consumptions_var_pop_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Off_Production_Consumptions_Var_Samp_Fields = {
  __typename?: 'off_production_consumptions_var_samp_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Off_Production_Consumptions_Variance_Fields = {
  __typename?: 'off_production_consumptions_variance_fields';
  avg_power_kw?: Maybe<Scalars['Float']['output']>;
  consumption_kwh?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "ofs_by_day" */
export type Ofs_By_Day = {
  __typename?: 'ofs_by_day';
  created_at: Scalars['timestamptz']['output'];
  day: Scalars['date']['output'];
  /** An object relationship */
  fabrication_order: Fabrication_Orders;
  id: Scalars['Int']['output'];
  of_id: Scalars['Int']['output'];
  quantity: Scalars['numeric']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "ofs_by_day" */
export type Ofs_By_Day_Aggregate = {
  __typename?: 'ofs_by_day_aggregate';
  aggregate?: Maybe<Ofs_By_Day_Aggregate_Fields>;
  nodes: Array<Ofs_By_Day>;
};

export type Ofs_By_Day_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ofs_By_Day_Aggregate_Bool_Exp_Count>;
};

export type Ofs_By_Day_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ofs_By_Day_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ofs_by_day" */
export type Ofs_By_Day_Aggregate_Fields = {
  __typename?: 'ofs_by_day_aggregate_fields';
  avg?: Maybe<Ofs_By_Day_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ofs_By_Day_Max_Fields>;
  min?: Maybe<Ofs_By_Day_Min_Fields>;
  stddev?: Maybe<Ofs_By_Day_Stddev_Fields>;
  stddev_pop?: Maybe<Ofs_By_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ofs_By_Day_Stddev_Samp_Fields>;
  sum?: Maybe<Ofs_By_Day_Sum_Fields>;
  var_pop?: Maybe<Ofs_By_Day_Var_Pop_Fields>;
  var_samp?: Maybe<Ofs_By_Day_Var_Samp_Fields>;
  variance?: Maybe<Ofs_By_Day_Variance_Fields>;
};


/** aggregate fields of "ofs_by_day" */
export type Ofs_By_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ofs_by_day" */
export type Ofs_By_Day_Aggregate_Order_By = {
  avg?: InputMaybe<Ofs_By_Day_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ofs_By_Day_Max_Order_By>;
  min?: InputMaybe<Ofs_By_Day_Min_Order_By>;
  stddev?: InputMaybe<Ofs_By_Day_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ofs_By_Day_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ofs_By_Day_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ofs_By_Day_Sum_Order_By>;
  var_pop?: InputMaybe<Ofs_By_Day_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ofs_By_Day_Var_Samp_Order_By>;
  variance?: InputMaybe<Ofs_By_Day_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ofs_by_day" */
export type Ofs_By_Day_Arr_Rel_Insert_Input = {
  data: Array<Ofs_By_Day_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ofs_By_Day_On_Conflict>;
};

/** aggregate avg on columns */
export type Ofs_By_Day_Avg_Fields = {
  __typename?: 'ofs_by_day_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ofs_by_day". All fields are combined with a logical 'AND'. */
export type Ofs_By_Day_Bool_Exp = {
  _and?: InputMaybe<Array<Ofs_By_Day_Bool_Exp>>;
  _not?: InputMaybe<Ofs_By_Day_Bool_Exp>;
  _or?: InputMaybe<Array<Ofs_By_Day_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  day?: InputMaybe<Date_Comparison_Exp>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  of_id?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ofs_by_day" */
export enum Ofs_By_Day_Constraint {
  /** unique or primary key constraint on columns "id" */
  OfsByDayPkey = 'ofs_by_day_pkey'
}

/** input type for incrementing numeric columns in table "ofs_by_day" */
export type Ofs_By_Day_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  of_id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "ofs_by_day" */
export type Ofs_By_Day_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day?: InputMaybe<Scalars['date']['input']>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  of_id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Ofs_By_Day_Max_Fields = {
  __typename?: 'ofs_by_day_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  of_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ofs_By_Day_Min_Fields = {
  __typename?: 'ofs_by_day_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  day?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  of_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ofs_by_day" */
export type Ofs_By_Day_Mutation_Response = {
  __typename?: 'ofs_by_day_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ofs_By_Day>;
};

/** on_conflict condition type for table "ofs_by_day" */
export type Ofs_By_Day_On_Conflict = {
  constraint: Ofs_By_Day_Constraint;
  update_columns?: Array<Ofs_By_Day_Update_Column>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};

/** Ordering options when selecting data from "ofs_by_day". */
export type Ofs_By_Day_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  fabrication_order?: InputMaybe<Fabrication_Orders_Order_By>;
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ofs_by_day */
export type Ofs_By_Day_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "ofs_by_day" */
export enum Ofs_By_Day_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  OfId = 'of_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ofs_by_day" */
export type Ofs_By_Day_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  of_id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Ofs_By_Day_Stddev_Fields = {
  __typename?: 'ofs_by_day_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ofs_By_Day_Stddev_Pop_Fields = {
  __typename?: 'ofs_by_day_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ofs_By_Day_Stddev_Samp_Fields = {
  __typename?: 'ofs_by_day_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ofs_by_day" */
export type Ofs_By_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ofs_By_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ofs_By_Day_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  of_id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Ofs_By_Day_Sum_Fields = {
  __typename?: 'ofs_by_day_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  of_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "ofs_by_day" */
export enum Ofs_By_Day_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  OfId = 'of_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ofs_By_Day_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ofs_By_Day_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ofs_By_Day_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ofs_By_Day_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ofs_By_Day_Var_Pop_Fields = {
  __typename?: 'ofs_by_day_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ofs_By_Day_Var_Samp_Fields = {
  __typename?: 'ofs_by_day_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ofs_By_Day_Variance_Fields = {
  __typename?: 'ofs_by_day_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  of_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ofs_by_day" */
export type Ofs_By_Day_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  of_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "production_hours" */
export type Production_Hours = {
  __typename?: 'production_hours';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  day_id: Scalars['Int']['output'];
  end: Scalars['time']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  site: Sites;
  site_id: Scalars['Int']['output'];
  start: Scalars['time']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "production_hours" */
export type Production_Hours_Aggregate = {
  __typename?: 'production_hours_aggregate';
  aggregate?: Maybe<Production_Hours_Aggregate_Fields>;
  nodes: Array<Production_Hours>;
};

export type Production_Hours_Aggregate_Bool_Exp = {
  count?: InputMaybe<Production_Hours_Aggregate_Bool_Exp_Count>;
};

export type Production_Hours_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Production_Hours_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Production_Hours_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "production_hours" */
export type Production_Hours_Aggregate_Fields = {
  __typename?: 'production_hours_aggregate_fields';
  avg?: Maybe<Production_Hours_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Production_Hours_Max_Fields>;
  min?: Maybe<Production_Hours_Min_Fields>;
  stddev?: Maybe<Production_Hours_Stddev_Fields>;
  stddev_pop?: Maybe<Production_Hours_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Production_Hours_Stddev_Samp_Fields>;
  sum?: Maybe<Production_Hours_Sum_Fields>;
  var_pop?: Maybe<Production_Hours_Var_Pop_Fields>;
  var_samp?: Maybe<Production_Hours_Var_Samp_Fields>;
  variance?: Maybe<Production_Hours_Variance_Fields>;
};


/** aggregate fields of "production_hours" */
export type Production_Hours_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Hours_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "production_hours" */
export type Production_Hours_Aggregate_Order_By = {
  avg?: InputMaybe<Production_Hours_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Production_Hours_Max_Order_By>;
  min?: InputMaybe<Production_Hours_Min_Order_By>;
  stddev?: InputMaybe<Production_Hours_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Production_Hours_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Production_Hours_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Production_Hours_Sum_Order_By>;
  var_pop?: InputMaybe<Production_Hours_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Production_Hours_Var_Samp_Order_By>;
  variance?: InputMaybe<Production_Hours_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "production_hours" */
export type Production_Hours_Arr_Rel_Insert_Input = {
  data: Array<Production_Hours_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Production_Hours_On_Conflict>;
};

/** aggregate avg on columns */
export type Production_Hours_Avg_Fields = {
  __typename?: 'production_hours_avg_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "production_hours" */
export type Production_Hours_Avg_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "production_hours". All fields are combined with a logical 'AND'. */
export type Production_Hours_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Hours_Bool_Exp>>;
  _not?: InputMaybe<Production_Hours_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Hours_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  day_id?: InputMaybe<Int_Comparison_Exp>;
  end?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
  start?: InputMaybe<Time_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "production_hours" */
export enum Production_Hours_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductionHoursPkey = 'production_hours_pkey'
}

/** input type for incrementing numeric columns in table "production_hours" */
export type Production_Hours_Inc_Input = {
  day_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "production_hours" */
export type Production_Hours_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day_id?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Production_Hours_Max_Fields = {
  __typename?: 'production_hours_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  day_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "production_hours" */
export type Production_Hours_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Production_Hours_Min_Fields = {
  __typename?: 'production_hours_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  day_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "production_hours" */
export type Production_Hours_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "production_hours" */
export type Production_Hours_Mutation_Response = {
  __typename?: 'production_hours_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Production_Hours>;
};

/** on_conflict condition type for table "production_hours" */
export type Production_Hours_On_Conflict = {
  constraint: Production_Hours_Constraint;
  update_columns?: Array<Production_Hours_Update_Column>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};

/** Ordering options when selecting data from "production_hours". */
export type Production_Hours_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_id?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  site_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: production_hours */
export type Production_Hours_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "production_hours" */
export enum Production_Hours_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayId = 'day_id',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "production_hours" */
export type Production_Hours_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day_id?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Production_Hours_Stddev_Fields = {
  __typename?: 'production_hours_stddev_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "production_hours" */
export type Production_Hours_Stddev_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Production_Hours_Stddev_Pop_Fields = {
  __typename?: 'production_hours_stddev_pop_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "production_hours" */
export type Production_Hours_Stddev_Pop_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Production_Hours_Stddev_Samp_Fields = {
  __typename?: 'production_hours_stddev_samp_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "production_hours" */
export type Production_Hours_Stddev_Samp_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "production_hours" */
export type Production_Hours_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Hours_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Hours_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day_id?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['time']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Production_Hours_Sum_Fields = {
  __typename?: 'production_hours_sum_fields';
  day_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "production_hours" */
export type Production_Hours_Sum_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** update columns of table "production_hours" */
export enum Production_Hours_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayId = 'day_id',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SiteId = 'site_id',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Production_Hours_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Production_Hours_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Production_Hours_Set_Input>;
  /** filter the rows which have to be updated */
  where: Production_Hours_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Production_Hours_Var_Pop_Fields = {
  __typename?: 'production_hours_var_pop_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "production_hours" */
export type Production_Hours_Var_Pop_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Production_Hours_Var_Samp_Fields = {
  __typename?: 'production_hours_var_samp_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "production_hours" */
export type Production_Hours_Var_Samp_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Production_Hours_Variance_Fields = {
  __typename?: 'production_hours_variance_fields';
  day_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "production_hours" */
export type Production_Hours_Variance_Order_By = {
  day_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "production_reporting_frequencies" */
export type Production_Reporting_Frequencies = {
  __typename?: 'production_reporting_frequencies';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Aggregate = {
  __typename?: 'production_reporting_frequencies_aggregate';
  aggregate?: Maybe<Production_Reporting_Frequencies_Aggregate_Fields>;
  nodes: Array<Production_Reporting_Frequencies>;
};

/** aggregate fields of "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Aggregate_Fields = {
  __typename?: 'production_reporting_frequencies_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Production_Reporting_Frequencies_Max_Fields>;
  min?: Maybe<Production_Reporting_Frequencies_Min_Fields>;
};


/** aggregate fields of "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Reporting_Frequencies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "production_reporting_frequencies". All fields are combined with a logical 'AND'. */
export type Production_Reporting_Frequencies_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Reporting_Frequencies_Bool_Exp>>;
  _not?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Reporting_Frequencies_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "production_reporting_frequencies" */
export enum Production_Reporting_Frequencies_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProductionReportingFrequenciesPkey = 'production_reporting_frequencies_pkey'
}

export enum Production_Reporting_Frequencies_Enum {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

/** Boolean expression to compare columns of type "production_reporting_frequencies_enum". All fields are combined with logical 'AND'. */
export type Production_Reporting_Frequencies_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Production_Reporting_Frequencies_Enum>;
  _in?: InputMaybe<Array<Production_Reporting_Frequencies_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Production_Reporting_Frequencies_Enum>;
  _nin?: InputMaybe<Array<Production_Reporting_Frequencies_Enum>>;
};

/** input type for inserting data into table "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Production_Reporting_Frequencies_Max_Fields = {
  __typename?: 'production_reporting_frequencies_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Production_Reporting_Frequencies_Min_Fields = {
  __typename?: 'production_reporting_frequencies_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Mutation_Response = {
  __typename?: 'production_reporting_frequencies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Production_Reporting_Frequencies>;
};

/** on_conflict condition type for table "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_On_Conflict = {
  constraint: Production_Reporting_Frequencies_Constraint;
  update_columns?: Array<Production_Reporting_Frequencies_Update_Column>;
  where?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
};

/** Ordering options when selecting data from "production_reporting_frequencies". */
export type Production_Reporting_Frequencies_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: production_reporting_frequencies */
export type Production_Reporting_Frequencies_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "production_reporting_frequencies" */
export enum Production_Reporting_Frequencies_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "production_reporting_frequencies" */
export type Production_Reporting_Frequencies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Reporting_Frequencies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Reporting_Frequencies_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "production_reporting_frequencies" */
export enum Production_Reporting_Frequencies_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Production_Reporting_Frequencies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Production_Reporting_Frequencies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Production_Reporting_Frequencies_Bool_Exp;
};

/** columns and relationships of "productions" */
export type Productions = {
  __typename?: 'productions';
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  end: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['numeric']['output'];
  start: Scalars['date']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "productions" */
export type Productions_Aggregate = {
  __typename?: 'productions_aggregate';
  aggregate?: Maybe<Productions_Aggregate_Fields>;
  nodes: Array<Productions>;
};

export type Productions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Productions_Aggregate_Bool_Exp_Count>;
};

export type Productions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Productions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Productions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "productions" */
export type Productions_Aggregate_Fields = {
  __typename?: 'productions_aggregate_fields';
  avg?: Maybe<Productions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Productions_Max_Fields>;
  min?: Maybe<Productions_Min_Fields>;
  stddev?: Maybe<Productions_Stddev_Fields>;
  stddev_pop?: Maybe<Productions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Productions_Stddev_Samp_Fields>;
  sum?: Maybe<Productions_Sum_Fields>;
  var_pop?: Maybe<Productions_Var_Pop_Fields>;
  var_samp?: Maybe<Productions_Var_Samp_Fields>;
  variance?: Maybe<Productions_Variance_Fields>;
};


/** aggregate fields of "productions" */
export type Productions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Productions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "productions" */
export type Productions_Aggregate_Order_By = {
  avg?: InputMaybe<Productions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Productions_Max_Order_By>;
  min?: InputMaybe<Productions_Min_Order_By>;
  stddev?: InputMaybe<Productions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Productions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Productions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Productions_Sum_Order_By>;
  var_pop?: InputMaybe<Productions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Productions_Var_Samp_Order_By>;
  variance?: InputMaybe<Productions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "productions" */
export type Productions_Arr_Rel_Insert_Input = {
  data: Array<Productions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Productions_On_Conflict>;
};

/** aggregate avg on columns */
export type Productions_Avg_Fields = {
  __typename?: 'productions_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "productions" */
export type Productions_Avg_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "productions". All fields are combined with a logical 'AND'. */
export type Productions_Bool_Exp = {
  _and?: InputMaybe<Array<Productions_Bool_Exp>>;
  _not?: InputMaybe<Productions_Bool_Exp>;
  _or?: InputMaybe<Array<Productions_Bool_Exp>>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "productions" */
export enum Productions_Constraint {
  /** unique or primary key constraint on columns "start", "area_id", "end" */
  ProductionsAreaIdStartEndKey = 'productions_area_id_start_end_key',
  /** unique or primary key constraint on columns "id" */
  ProductionsPkey = 'productions_pkey'
}

/** input type for incrementing numeric columns in table "productions" */
export type Productions_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "productions" */
export type Productions_Insert_Input = {
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Productions_Max_Fields = {
  __typename?: 'productions_max_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "productions" */
export type Productions_Max_Order_By = {
  area_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Productions_Min_Fields = {
  __typename?: 'productions_min_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "productions" */
export type Productions_Min_Order_By = {
  area_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "productions" */
export type Productions_Mutation_Response = {
  __typename?: 'productions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Productions>;
};

/** on_conflict condition type for table "productions" */
export type Productions_On_Conflict = {
  constraint: Productions_Constraint;
  update_columns?: Array<Productions_Update_Column>;
  where?: InputMaybe<Productions_Bool_Exp>;
};

/** Ordering options when selecting data from "productions". */
export type Productions_Order_By = {
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: productions */
export type Productions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "productions" */
export enum Productions_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "productions" */
export type Productions_Set_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Productions_Stddev_Fields = {
  __typename?: 'productions_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "productions" */
export type Productions_Stddev_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Productions_Stddev_Pop_Fields = {
  __typename?: 'productions_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "productions" */
export type Productions_Stddev_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Productions_Stddev_Samp_Fields = {
  __typename?: 'productions_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "productions" */
export type Productions_Stddev_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "productions" */
export type Productions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Productions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Productions_Stream_Cursor_Value_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Productions_Sum_Fields = {
  __typename?: 'productions_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "productions" */
export type Productions_Sum_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "productions" */
export enum Productions_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Productions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Productions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Productions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Productions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Productions_Var_Pop_Fields = {
  __typename?: 'productions_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "productions" */
export type Productions_Var_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Productions_Var_Samp_Fields = {
  __typename?: 'productions_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "productions" */
export type Productions_Var_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Productions_Variance_Fields = {
  __typename?: 'productions_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "productions" */
export type Productions_Variance_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  client_product_id: Scalars['String']['output'];
  epi_standard?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  fabrication_order_products: Array<Fabrication_Order_Product>;
  /** An aggregate relationship */
  fabrication_order_products_aggregate: Fabrication_Order_Product_Aggregate;
  fabrication_order_to_production_ratio?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  site: Sites;
  site_id: Scalars['Int']['output'];
};


/** columns and relationships of "products" */
export type ProductsFabrication_Order_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsFabrication_Order_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

export type Products_Aggregate_Bool_Exp = {
  count?: InputMaybe<Products_Aggregate_Bool_Exp_Count>;
};

export type Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "products" */
export type Products_Aggregate_Order_By = {
  avg?: InputMaybe<Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Products_Max_Order_By>;
  min?: InputMaybe<Products_Min_Order_By>;
  stddev?: InputMaybe<Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Products_Sum_Order_By>;
  var_pop?: InputMaybe<Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "products" */
export type Products_Arr_Rel_Insert_Input = {
  data: Array<Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "products" */
export type Products_Avg_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  client_product_id?: InputMaybe<String_Comparison_Exp>;
  epi_standard?: InputMaybe<Numeric_Comparison_Exp>;
  fabrication_order_products?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
  fabrication_order_products_aggregate?: InputMaybe<Fabrication_Order_Product_Aggregate_Bool_Exp>;
  fabrication_order_to_production_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  site_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsPkey = 'products_pkey',
  /** unique or primary key constraint on columns "client_product_id", "site_id" */
  ProductsSiteIdClientProductIdKey = 'products_site_id_client_product_id_key'
}

/** input type for incrementing numeric columns in table "products" */
export type Products_Inc_Input = {
  epi_standard?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_to_production_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  client_product_id?: InputMaybe<Scalars['String']['input']>;
  epi_standard?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_products?: InputMaybe<Fabrication_Order_Product_Arr_Rel_Insert_Input>;
  fabrication_order_to_production_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  client_product_id?: Maybe<Scalars['String']['output']>;
  epi_standard?: Maybe<Scalars['numeric']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "products" */
export type Products_Max_Order_By = {
  client_product_id?: InputMaybe<Order_By>;
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  client_product_id?: Maybe<Scalars['String']['output']>;
  epi_standard?: Maybe<Scalars['numeric']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "products" */
export type Products_Min_Order_By = {
  client_product_id?: InputMaybe<Order_By>;
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on_conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns?: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  client_product_id?: InputMaybe<Order_By>;
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_products_aggregate?: InputMaybe<Fabrication_Order_Product_Aggregate_Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  ClientProductId = 'client_product_id',
  /** column name */
  EpiStandard = 'epi_standard',
  /** column name */
  FabricationOrderToProductionRatio = 'fabrication_order_to_production_ratio',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  SiteId = 'site_id'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  client_product_id?: InputMaybe<Scalars['String']['input']>;
  epi_standard?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_to_production_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "products" */
export type Products_Stddev_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "products" */
export type Products_Stddev_Pop_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "products" */
export type Products_Stddev_Samp_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "products" */
export type Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Stream_Cursor_Value_Input = {
  client_product_id?: InputMaybe<Scalars['String']['input']>;
  epi_standard?: InputMaybe<Scalars['numeric']['input']>;
  fabrication_order_to_production_ratio?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  site_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  epi_standard?: Maybe<Scalars['numeric']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  site_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "products" */
export type Products_Sum_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  ClientProductId = 'client_product_id',
  /** column name */
  EpiStandard = 'epi_standard',
  /** column name */
  FabricationOrderToProductionRatio = 'fabrication_order_to_production_ratio',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  SiteId = 'site_id'
}

export type Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "products" */
export type Products_Var_Pop_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "products" */
export type Products_Var_Samp_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  epi_standard?: Maybe<Scalars['Float']['output']>;
  fabrication_order_to_production_ratio?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  site_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "products" */
export type Products_Variance_Order_By = {
  epi_standard?: InputMaybe<Order_By>;
  fabrication_order_to_production_ratio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_ROI_durations" */
export type Project_Roi_Durations = {
  __typename?: 'project_ROI_durations';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "project_ROI_durations" */
export type Project_Roi_Durations_Aggregate = {
  __typename?: 'project_ROI_durations_aggregate';
  aggregate?: Maybe<Project_Roi_Durations_Aggregate_Fields>;
  nodes: Array<Project_Roi_Durations>;
};

/** aggregate fields of "project_ROI_durations" */
export type Project_Roi_Durations_Aggregate_Fields = {
  __typename?: 'project_ROI_durations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Roi_Durations_Max_Fields>;
  min?: Maybe<Project_Roi_Durations_Min_Fields>;
};


/** aggregate fields of "project_ROI_durations" */
export type Project_Roi_Durations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Roi_Durations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_ROI_durations". All fields are combined with a logical 'AND'. */
export type Project_Roi_Durations_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Roi_Durations_Bool_Exp>>;
  _not?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Roi_Durations_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_ROI_durations" */
export enum Project_Roi_Durations_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectRoiDurationsPkey = 'project_ROI_durations_pkey'
}

export enum Project_Roi_Durations_Enum {
  Between_6And_12Months = 'BETWEEN_6_AND_12_MONTHS',
  Between_12And_24Months = 'BETWEEN_12_AND_24_MONTHS',
  Between_24And_36Months = 'BETWEEN_24_AND_36_MONTHS',
  LessThan_6Months = 'LESS_THAN_6_MONTHS',
  MoreThan_36Months = 'MORE_THAN_36_MONTHS'
}

/** Boolean expression to compare columns of type "project_ROI_durations_enum". All fields are combined with logical 'AND'. */
export type Project_Roi_Durations_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Roi_Durations_Enum>;
  _in?: InputMaybe<Array<Project_Roi_Durations_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Roi_Durations_Enum>;
  _nin?: InputMaybe<Array<Project_Roi_Durations_Enum>>;
};

/** input type for inserting data into table "project_ROI_durations" */
export type Project_Roi_Durations_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Roi_Durations_Max_Fields = {
  __typename?: 'project_ROI_durations_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Roi_Durations_Min_Fields = {
  __typename?: 'project_ROI_durations_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_ROI_durations" */
export type Project_Roi_Durations_Mutation_Response = {
  __typename?: 'project_ROI_durations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Roi_Durations>;
};

/** on_conflict condition type for table "project_ROI_durations" */
export type Project_Roi_Durations_On_Conflict = {
  constraint: Project_Roi_Durations_Constraint;
  update_columns?: Array<Project_Roi_Durations_Update_Column>;
  where?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
};

/** Ordering options when selecting data from "project_ROI_durations". */
export type Project_Roi_Durations_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_ROI_durations */
export type Project_Roi_Durations_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "project_ROI_durations" */
export enum Project_Roi_Durations_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_ROI_durations" */
export type Project_Roi_Durations_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_ROI_durations" */
export type Project_Roi_Durations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Roi_Durations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Roi_Durations_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_ROI_durations" */
export enum Project_Roi_Durations_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Project_Roi_Durations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Roi_Durations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Roi_Durations_Bool_Exp;
};

/** columns and relationships of "project_budget_ranges" */
export type Project_Budget_Ranges = {
  __typename?: 'project_budget_ranges';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "project_budget_ranges" */
export type Project_Budget_Ranges_Aggregate = {
  __typename?: 'project_budget_ranges_aggregate';
  aggregate?: Maybe<Project_Budget_Ranges_Aggregate_Fields>;
  nodes: Array<Project_Budget_Ranges>;
};

/** aggregate fields of "project_budget_ranges" */
export type Project_Budget_Ranges_Aggregate_Fields = {
  __typename?: 'project_budget_ranges_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Budget_Ranges_Max_Fields>;
  min?: Maybe<Project_Budget_Ranges_Min_Fields>;
};


/** aggregate fields of "project_budget_ranges" */
export type Project_Budget_Ranges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Budget_Ranges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_budget_ranges". All fields are combined with a logical 'AND'. */
export type Project_Budget_Ranges_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Budget_Ranges_Bool_Exp>>;
  _not?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Budget_Ranges_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_budget_ranges" */
export enum Project_Budget_Ranges_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectBudgetRangesPkey = 'project_budget_ranges_pkey'
}

export enum Project_Budget_Ranges_Enum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

/** Boolean expression to compare columns of type "project_budget_ranges_enum". All fields are combined with logical 'AND'. */
export type Project_Budget_Ranges_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Budget_Ranges_Enum>;
  _in?: InputMaybe<Array<Project_Budget_Ranges_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Budget_Ranges_Enum>;
  _nin?: InputMaybe<Array<Project_Budget_Ranges_Enum>>;
};

/** input type for inserting data into table "project_budget_ranges" */
export type Project_Budget_Ranges_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Budget_Ranges_Max_Fields = {
  __typename?: 'project_budget_ranges_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Budget_Ranges_Min_Fields = {
  __typename?: 'project_budget_ranges_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_budget_ranges" */
export type Project_Budget_Ranges_Mutation_Response = {
  __typename?: 'project_budget_ranges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Budget_Ranges>;
};

/** on_conflict condition type for table "project_budget_ranges" */
export type Project_Budget_Ranges_On_Conflict = {
  constraint: Project_Budget_Ranges_Constraint;
  update_columns?: Array<Project_Budget_Ranges_Update_Column>;
  where?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
};

/** Ordering options when selecting data from "project_budget_ranges". */
export type Project_Budget_Ranges_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_budget_ranges */
export type Project_Budget_Ranges_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "project_budget_ranges" */
export enum Project_Budget_Ranges_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_budget_ranges" */
export type Project_Budget_Ranges_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_budget_ranges" */
export type Project_Budget_Ranges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Budget_Ranges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Budget_Ranges_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_budget_ranges" */
export enum Project_Budget_Ranges_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Project_Budget_Ranges_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Budget_Ranges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Budget_Ranges_Bool_Exp;
};

/** columns and relationships of "project_complexities" */
export type Project_Complexities = {
  __typename?: 'project_complexities';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "project_complexities" */
export type Project_Complexities_Aggregate = {
  __typename?: 'project_complexities_aggregate';
  aggregate?: Maybe<Project_Complexities_Aggregate_Fields>;
  nodes: Array<Project_Complexities>;
};

/** aggregate fields of "project_complexities" */
export type Project_Complexities_Aggregate_Fields = {
  __typename?: 'project_complexities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Complexities_Max_Fields>;
  min?: Maybe<Project_Complexities_Min_Fields>;
};


/** aggregate fields of "project_complexities" */
export type Project_Complexities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Complexities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_complexities". All fields are combined with a logical 'AND'. */
export type Project_Complexities_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Complexities_Bool_Exp>>;
  _not?: InputMaybe<Project_Complexities_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Complexities_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_complexities" */
export enum Project_Complexities_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectComplexitiesPkey = 'project_complexities_pkey'
}

export enum Project_Complexities_Enum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Boolean expression to compare columns of type "project_complexities_enum". All fields are combined with logical 'AND'. */
export type Project_Complexities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Complexities_Enum>;
  _in?: InputMaybe<Array<Project_Complexities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Complexities_Enum>;
  _nin?: InputMaybe<Array<Project_Complexities_Enum>>;
};

/** input type for inserting data into table "project_complexities" */
export type Project_Complexities_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Complexities_Max_Fields = {
  __typename?: 'project_complexities_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Complexities_Min_Fields = {
  __typename?: 'project_complexities_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_complexities" */
export type Project_Complexities_Mutation_Response = {
  __typename?: 'project_complexities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Complexities>;
};

/** on_conflict condition type for table "project_complexities" */
export type Project_Complexities_On_Conflict = {
  constraint: Project_Complexities_Constraint;
  update_columns?: Array<Project_Complexities_Update_Column>;
  where?: InputMaybe<Project_Complexities_Bool_Exp>;
};

/** Ordering options when selecting data from "project_complexities". */
export type Project_Complexities_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_complexities */
export type Project_Complexities_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "project_complexities" */
export enum Project_Complexities_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_complexities" */
export type Project_Complexities_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_complexities" */
export type Project_Complexities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Complexities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Complexities_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_complexities" */
export enum Project_Complexities_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Project_Complexities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Complexities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Complexities_Bool_Exp;
};

/** columns and relationships of "project_statuses" */
export type Project_Statuses = {
  __typename?: 'project_statuses';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "project_statuses" */
export type Project_Statuses_Aggregate = {
  __typename?: 'project_statuses_aggregate';
  aggregate?: Maybe<Project_Statuses_Aggregate_Fields>;
  nodes: Array<Project_Statuses>;
};

/** aggregate fields of "project_statuses" */
export type Project_Statuses_Aggregate_Fields = {
  __typename?: 'project_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Statuses_Max_Fields>;
  min?: Maybe<Project_Statuses_Min_Fields>;
};


/** aggregate fields of "project_statuses" */
export type Project_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_statuses". All fields are combined with a logical 'AND'. */
export type Project_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Project_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Statuses_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_statuses" */
export enum Project_Statuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProjectStatusesPkey = 'project_statuses_pkey'
}

export enum Project_Statuses_Enum {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

/** Boolean expression to compare columns of type "project_statuses_enum". All fields are combined with logical 'AND'. */
export type Project_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Statuses_Enum>;
  _in?: InputMaybe<Array<Project_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Statuses_Enum>;
  _nin?: InputMaybe<Array<Project_Statuses_Enum>>;
};

/** input type for inserting data into table "project_statuses" */
export type Project_Statuses_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Statuses_Max_Fields = {
  __typename?: 'project_statuses_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Statuses_Min_Fields = {
  __typename?: 'project_statuses_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_statuses" */
export type Project_Statuses_Mutation_Response = {
  __typename?: 'project_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Statuses>;
};

/** on_conflict condition type for table "project_statuses" */
export type Project_Statuses_On_Conflict = {
  constraint: Project_Statuses_Constraint;
  update_columns?: Array<Project_Statuses_Update_Column>;
  where?: InputMaybe<Project_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "project_statuses". */
export type Project_Statuses_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_statuses */
export type Project_Statuses_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "project_statuses" */
export enum Project_Statuses_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "project_statuses" */
export type Project_Statuses_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_statuses" */
export type Project_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Statuses_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_statuses" */
export enum Project_Statuses_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Project_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Statuses_Bool_Exp;
};

/** columns and relationships of "project_templates" */
export type Project_Templates = {
  __typename?: 'project_templates';
  average_time_to_ROI: Project_Roi_Durations_Enum;
  budget_range: Project_Budget_Ranges_Enum;
  can_be_funded: Scalars['Boolean']['output'];
  complexity: Project_Complexities_Enum;
  content: Scalars['jsonb']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** An object relationship */
  subvention?: Maybe<Subventions>;
  subvention_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "project_templates" */
export type Project_TemplatesContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "project_templates" */
export type Project_TemplatesProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "project_templates" */
export type Project_TemplatesProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** aggregated selection of "project_templates" */
export type Project_Templates_Aggregate = {
  __typename?: 'project_templates_aggregate';
  aggregate?: Maybe<Project_Templates_Aggregate_Fields>;
  nodes: Array<Project_Templates>;
};

/** aggregate fields of "project_templates" */
export type Project_Templates_Aggregate_Fields = {
  __typename?: 'project_templates_aggregate_fields';
  avg?: Maybe<Project_Templates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Templates_Max_Fields>;
  min?: Maybe<Project_Templates_Min_Fields>;
  stddev?: Maybe<Project_Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Templates_Sum_Fields>;
  var_pop?: Maybe<Project_Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Templates_Var_Samp_Fields>;
  variance?: Maybe<Project_Templates_Variance_Fields>;
};


/** aggregate fields of "project_templates" */
export type Project_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Templates_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Project_Templates_Avg_Fields = {
  __typename?: 'project_templates_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_templates". All fields are combined with a logical 'AND'. */
export type Project_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Templates_Bool_Exp>>;
  _not?: InputMaybe<Project_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Templates_Bool_Exp>>;
  average_time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum_Comparison_Exp>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum_Comparison_Exp>;
  can_be_funded?: InputMaybe<Boolean_Comparison_Exp>;
  complexity?: InputMaybe<Project_Complexities_Enum_Comparison_Exp>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Projects_Bool_Exp>;
  projects_aggregate?: InputMaybe<Projects_Aggregate_Bool_Exp>;
  subvention?: InputMaybe<Subventions_Bool_Exp>;
  subvention_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_templates" */
export enum Project_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectTemplatesPkey = 'project_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Templates_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Templates_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Templates_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "project_templates" */
export type Project_Templates_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_templates" */
export type Project_Templates_Insert_Input = {
  average_time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum>;
  can_be_funded?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<Project_Complexities_Enum>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Projects_Arr_Rel_Insert_Input>;
  subvention?: InputMaybe<Subventions_Obj_Rel_Insert_Input>;
  subvention_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Templates_Max_Fields = {
  __typename?: 'project_templates_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subvention_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Templates_Min_Fields = {
  __typename?: 'project_templates_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subvention_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_templates" */
export type Project_Templates_Mutation_Response = {
  __typename?: 'project_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Templates>;
};

/** input type for inserting object relation for remote table "project_templates" */
export type Project_Templates_Obj_Rel_Insert_Input = {
  data: Project_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Templates_On_Conflict>;
};

/** on_conflict condition type for table "project_templates" */
export type Project_Templates_On_Conflict = {
  constraint: Project_Templates_Constraint;
  update_columns?: Array<Project_Templates_Update_Column>;
  where?: InputMaybe<Project_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "project_templates". */
export type Project_Templates_Order_By = {
  average_time_to_ROI?: InputMaybe<Order_By>;
  budget_range?: InputMaybe<Order_By>;
  can_be_funded?: InputMaybe<Order_By>;
  complexity?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Aggregate_Order_By>;
  subvention?: InputMaybe<Subventions_Order_By>;
  subvention_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_templates */
export type Project_Templates_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Templates_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "project_templates" */
export enum Project_Templates_Select_Column {
  /** column name */
  AverageTimeToRoi = 'average_time_to_ROI',
  /** column name */
  BudgetRange = 'budget_range',
  /** column name */
  CanBeFunded = 'can_be_funded',
  /** column name */
  Complexity = 'complexity',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SubventionId = 'subvention_id'
}

/** input type for updating data in table "project_templates" */
export type Project_Templates_Set_Input = {
  average_time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum>;
  can_be_funded?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<Project_Complexities_Enum>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subvention_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Project_Templates_Stddev_Fields = {
  __typename?: 'project_templates_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Templates_Stddev_Pop_Fields = {
  __typename?: 'project_templates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Templates_Stddev_Samp_Fields = {
  __typename?: 'project_templates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project_templates" */
export type Project_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Templates_Stream_Cursor_Value_Input = {
  average_time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum>;
  can_be_funded?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<Project_Complexities_Enum>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subvention_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Project_Templates_Sum_Fields = {
  __typename?: 'project_templates_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "project_templates" */
export enum Project_Templates_Update_Column {
  /** column name */
  AverageTimeToRoi = 'average_time_to_ROI',
  /** column name */
  BudgetRange = 'budget_range',
  /** column name */
  CanBeFunded = 'can_be_funded',
  /** column name */
  Complexity = 'complexity',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SubventionId = 'subvention_id'
}

export type Project_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Templates_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Templates_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Templates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Templates_Var_Pop_Fields = {
  __typename?: 'project_templates_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Templates_Var_Samp_Fields = {
  __typename?: 'project_templates_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Templates_Variance_Fields = {
  __typename?: 'project_templates_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'projects';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by: Scalars['String']['output'];
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int']['output'];
  budget_range: Project_Budget_Ranges_Enum;
  can_be_funded?: Maybe<Scalars['Boolean']['output']>;
  complexity?: Maybe<Scalars['String']['output']>;
  content: Scalars['jsonb']['output'];
  end: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  incident_projects: Array<Incident_Project>;
  /** An aggregate relationship */
  incident_projects_aggregate: Incident_Project_Aggregate;
  name: Scalars['String']['output'];
  start: Scalars['timestamptz']['output'];
  status: Project_Statuses_Enum;
  /** An object relationship */
  subvention?: Maybe<Subventions>;
  subvention_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  template: Project_Templates;
  template_id: Scalars['Int']['output'];
  time_to_ROI: Project_Roi_Durations_Enum;
};


/** columns and relationships of "projects" */
export type ProjectsContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "projects" */
export type ProjectsIncident_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsIncident_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};

/** aggregated selection of "projects" */
export type Projects_Aggregate = {
  __typename?: 'projects_aggregate';
  aggregate?: Maybe<Projects_Aggregate_Fields>;
  nodes: Array<Projects>;
};

export type Projects_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Projects_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Projects_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Projects_Aggregate_Bool_Exp_Count>;
};

export type Projects_Aggregate_Bool_Exp_Bool_And = {
  arguments: Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Projects_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Projects_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Projects_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "projects" */
export type Projects_Aggregate_Fields = {
  __typename?: 'projects_aggregate_fields';
  avg?: Maybe<Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_Max_Fields>;
  min?: Maybe<Projects_Min_Fields>;
  stddev?: Maybe<Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Sum_Fields>;
  var_pop?: Maybe<Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Var_Samp_Fields>;
  variance?: Maybe<Projects_Variance_Fields>;
};


/** aggregate fields of "projects" */
export type Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "projects" */
export type Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_Max_Order_By>;
  min?: InputMaybe<Projects_Min_Order_By>;
  stddev?: InputMaybe<Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Projects_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Projects_Append_Input = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "projects" */
export type Projects_Arr_Rel_Insert_Input = {
  data: Array<Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type Projects_Avg_Fields = {
  __typename?: 'projects_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "projects" */
export type Projects_Avg_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum_Comparison_Exp>;
  can_be_funded?: InputMaybe<Boolean_Comparison_Exp>;
  complexity?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incident_projects?: InputMaybe<Incident_Project_Bool_Exp>;
  incident_projects_aggregate?: InputMaybe<Incident_Project_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Project_Statuses_Enum_Comparison_Exp>;
  subvention?: InputMaybe<Subventions_Bool_Exp>;
  subvention_id?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<Project_Templates_Bool_Exp>;
  template_id?: InputMaybe<Int_Comparison_Exp>;
  time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "projects" */
export enum Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsPkey = 'projects_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Projects_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Projects_Delete_Elem_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Projects_Delete_Key_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "projects" */
export type Projects_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  template_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "projects" */
export type Projects_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum>;
  can_be_funded?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_projects?: InputMaybe<Incident_Project_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Project_Statuses_Enum>;
  subvention?: InputMaybe<Subventions_Obj_Rel_Insert_Input>;
  subvention_id?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Project_Templates_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['Int']['input']>;
  time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum>;
};

/** aggregate max on columns */
export type Projects_Max_Fields = {
  __typename?: 'projects_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  complexity?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  subvention_id?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "projects" */
export type Projects_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  complexity?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  subvention_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projects_Min_Fields = {
  __typename?: 'projects_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  area_id?: Maybe<Scalars['Int']['output']>;
  complexity?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  subvention_id?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "projects" */
export type Projects_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  area_id?: InputMaybe<Order_By>;
  complexity?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  subvention_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "projects" */
export type Projects_Mutation_Response = {
  __typename?: 'projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects>;
};

/** input type for inserting object relation for remote table "projects" */
export type Projects_Obj_Rel_Insert_Input = {
  data: Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** on_conflict condition type for table "projects" */
export type Projects_On_Conflict = {
  constraint: Projects_Constraint;
  update_columns?: Array<Projects_Update_Column>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "projects". */
export type Projects_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  budget_range?: InputMaybe<Order_By>;
  can_be_funded?: InputMaybe<Order_By>;
  complexity?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_projects_aggregate?: InputMaybe<Incident_Project_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subvention?: InputMaybe<Subventions_Order_By>;
  subvention_id?: InputMaybe<Order_By>;
  template?: InputMaybe<Project_Templates_Order_By>;
  template_id?: InputMaybe<Order_By>;
  time_to_ROI?: InputMaybe<Order_By>;
};

/** primary key columns input for table: projects */
export type Projects_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Projects_Prepend_Input = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "projects" */
export enum Projects_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  BudgetRange = 'budget_range',
  /** column name */
  CanBeFunded = 'can_be_funded',
  /** column name */
  Complexity = 'complexity',
  /** column name */
  Content = 'content',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  SubventionId = 'subvention_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TimeToRoi = 'time_to_ROI'
}

/** select "projects_aggregate_bool_exp_bool_and_arguments_columns" columns of table "projects" */
export enum Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanBeFunded = 'can_be_funded'
}

/** select "projects_aggregate_bool_exp_bool_or_arguments_columns" columns of table "projects" */
export enum Projects_Select_Column_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanBeFunded = 'can_be_funded'
}

/** input type for updating data in table "projects" */
export type Projects_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum>;
  can_be_funded?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Project_Statuses_Enum>;
  subvention_id?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['Int']['input']>;
  time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum>;
};

/** aggregate stddev on columns */
export type Projects_Stddev_Fields = {
  __typename?: 'projects_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "projects" */
export type Projects_Stddev_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Projects_Stddev_Pop_Fields = {
  __typename?: 'projects_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "projects" */
export type Projects_Stddev_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Projects_Stddev_Samp_Fields = {
  __typename?: 'projects_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "projects" */
export type Projects_Stddev_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projects" */
export type Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  budget_range?: InputMaybe<Project_Budget_Ranges_Enum>;
  can_be_funded?: InputMaybe<Scalars['Boolean']['input']>;
  complexity?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Project_Statuses_Enum>;
  subvention_id?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['Int']['input']>;
  time_to_ROI?: InputMaybe<Project_Roi_Durations_Enum>;
};

/** aggregate sum on columns */
export type Projects_Sum_Fields = {
  __typename?: 'projects_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  template_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "projects" */
export type Projects_Sum_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "projects" */
export enum Projects_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  BudgetRange = 'budget_range',
  /** column name */
  CanBeFunded = 'can_be_funded',
  /** column name */
  Complexity = 'complexity',
  /** column name */
  Content = 'content',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  SubventionId = 'subvention_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TimeToRoi = 'time_to_ROI'
}

export type Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Projects_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Projects_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Projects_Var_Pop_Fields = {
  __typename?: 'projects_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "projects" */
export type Projects_Var_Pop_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Projects_Var_Samp_Fields = {
  __typename?: 'projects_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "projects" */
export type Projects_Var_Samp_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Projects_Variance_Fields = {
  __typename?: 'projects_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  template_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "projects" */
export type Projects_Variance_Order_By = {
  area_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "actions" */
  actions: Array<Actions>;
  /** fetch aggregated fields from the table: "actions" */
  actions_aggregate: Actions_Aggregate;
  /** fetch data from the table: "actions" using primary key columns */
  actions_by_pk?: Maybe<Actions>;
  /** fetch data from the table: "alert_types" */
  alert_types: Array<Alert_Types>;
  /** fetch aggregated fields from the table: "alert_types" */
  alert_types_aggregate: Alert_Types_Aggregate;
  /** fetch data from the table: "alert_types" using primary key columns */
  alert_types_by_pk?: Maybe<Alert_Types>;
  /** fetch data from the table: "alert_user" */
  alert_user: Array<Alert_User>;
  /** fetch aggregated fields from the table: "alert_user" */
  alert_user_aggregate: Alert_User_Aggregate;
  /** fetch data from the table: "alert_user" using primary key columns */
  alert_user_by_pk?: Maybe<Alert_User>;
  /** fetch data from the table: "alerts" */
  alerts: Array<Alerts>;
  /** fetch aggregated fields from the table: "alerts" */
  alerts_aggregate: Alerts_Aggregate;
  /** fetch data from the table: "alerts" using primary key columns */
  alerts_by_pk?: Maybe<Alerts>;
  /** fetch data from the table: "area_types" */
  area_types: Array<Area_Types>;
  /** fetch aggregated fields from the table: "area_types" */
  area_types_aggregate: Area_Types_Aggregate;
  /** fetch data from the table: "area_types" using primary key columns */
  area_types_by_pk?: Maybe<Area_Types>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table: "baselines" */
  baselines: Array<Baselines>;
  /** fetch aggregated fields from the table: "baselines" */
  baselines_aggregate: Baselines_Aggregate;
  /** fetch data from the table: "baselines" using primary key columns */
  baselines_by_pk?: Maybe<Baselines>;
  /** fetch data from the table: "clients" */
  clients: Array<Clients>;
  /** fetch aggregated fields from the table: "clients" */
  clients_aggregate: Clients_Aggregate;
  /** fetch data from the table: "clients" using primary key columns */
  clients_by_pk?: Maybe<Clients>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table: "consumption_by_timestamp" */
  consumption_by_timestamp: Array<Consumption_By_Timestamp>;
  /** fetch aggregated fields from the table: "consumption_by_timestamp" */
  consumption_by_timestamp_aggregate: Consumption_By_Timestamp_Aggregate;
  /** fetch data from the table: "consumption_by_timestamp" using primary key columns */
  consumption_by_timestamp_by_pk?: Maybe<Consumption_By_Timestamp>;
  /** fetch data from the table: "consumption.meter_consumption" */
  consumption_meter_consumption: Array<Consumption_Meter_Consumption>;
  /** fetch aggregated fields from the table: "consumption.meter_consumption" */
  consumption_meter_consumption_aggregate: Consumption_Meter_Consumption_Aggregate;
  /** fetch data from the table: "consumption_reference" */
  consumption_reference: Array<Consumption_Reference>;
  /** fetch aggregated fields from the table: "consumption_reference" */
  consumption_reference_aggregate: Consumption_Reference_Aggregate;
  /** fetch data from the table: "consumption_reference" using primary key columns */
  consumption_reference_by_pk?: Maybe<Consumption_Reference>;
  /** An array relationship */
  consumptions: Array<Consumptions>;
  /** An aggregate relationship */
  consumptions_aggregate: Consumptions_Aggregate;
  /** fetch data from the table: "consumptions" using primary key columns */
  consumptions_by_pk?: Maybe<Consumptions>;
  /** An array relationship */
  contracts: Array<Contracts>;
  /** An aggregate relationship */
  contracts_aggregate: Contracts_Aggregate;
  /** fetch data from the table: "contracts" using primary key columns */
  contracts_by_pk?: Maybe<Contracts>;
  /** fetch data from the table: "cron.job" */
  cron_job: Array<Cron_Job>;
  /** fetch aggregated fields from the table: "cron.job" */
  cron_job_aggregate: Cron_Job_Aggregate;
  /** fetch data from the table: "cron.job" using primary key columns */
  cron_job_by_pk?: Maybe<Cron_Job>;
  /** fetch data from the table: "cron.job_run_details" */
  cron_job_run_details: Array<Cron_Job_Run_Details>;
  /** fetch aggregated fields from the table: "cron.job_run_details" */
  cron_job_run_details_aggregate: Cron_Job_Run_Details_Aggregate;
  /** fetch data from the table: "cron.job_run_details" using primary key columns */
  cron_job_run_details_by_pk?: Maybe<Cron_Job_Run_Details>;
  /** fetch data from the table: "enedis.consumption" */
  enedis_consumption: Array<Enedis_Consumption>;
  /** fetch aggregated fields from the table: "enedis.consumption" */
  enedis_consumption_aggregate: Enedis_Consumption_Aggregate;
  /** fetch data from the table: "enedis.history_raw" */
  enedis_history_raw: Array<Enedis_History_Raw>;
  /** fetch aggregated fields from the table: "enedis.history_raw" */
  enedis_history_raw_aggregate: Enedis_History_Raw_Aggregate;
  /** fetch data from the table: "enedis.history_raw" using primary key columns */
  enedis_history_raw_by_pk?: Maybe<Enedis_History_Raw>;
  /** fetch data from the table: "enedis.minutes_raw" */
  enedis_minutes_raw: Array<Enedis_Minutes_Raw>;
  /** fetch aggregated fields from the table: "enedis.minutes_raw" */
  enedis_minutes_raw_aggregate: Enedis_Minutes_Raw_Aggregate;
  /** fetch data from the table: "enedis.minutes_raw" using primary key columns */
  enedis_minutes_raw_by_pk?: Maybe<Enedis_Minutes_Raw>;
  /** fetch data from the table: "energy_types" */
  energy_types: Array<Energy_Types>;
  /** fetch aggregated fields from the table: "energy_types" */
  energy_types_aggregate: Energy_Types_Aggregate;
  /** fetch data from the table: "energy_types" using primary key columns */
  energy_types_by_pk?: Maybe<Energy_Types>;
  /** fetch data from the table: "energy_use_types" */
  energy_use_types: Array<Energy_Use_Types>;
  /** fetch aggregated fields from the table: "energy_use_types" */
  energy_use_types_aggregate: Energy_Use_Types_Aggregate;
  /** fetch data from the table: "energy_use_types" using primary key columns */
  energy_use_types_by_pk?: Maybe<Energy_Use_Types>;
  /** fetch data from the table: "fabrication_order_epi" */
  fabrication_order_epi: Array<Fabrication_Order_Epi>;
  /** fetch aggregated fields from the table: "fabrication_order_epi" */
  fabrication_order_epi_aggregate: Fabrication_Order_Epi_Aggregate;
  /** fetch data from the table: "fabrication_order_epi" using primary key columns */
  fabrication_order_epi_by_pk?: Maybe<Fabrication_Order_Epi>;
  /** fetch data from the table: "fabrication_order_product" */
  fabrication_order_product: Array<Fabrication_Order_Product>;
  /** fetch aggregated fields from the table: "fabrication_order_product" */
  fabrication_order_product_aggregate: Fabrication_Order_Product_Aggregate;
  /** fetch data from the table: "fabrication_order_product" using primary key columns */
  fabrication_order_product_by_pk?: Maybe<Fabrication_Order_Product>;
  /** An array relationship */
  fabrication_orders: Array<Fabrication_Orders>;
  /** An aggregate relationship */
  fabrication_orders_aggregate: Fabrication_Orders_Aggregate;
  /** fetch data from the table: "fabrication_orders" using primary key columns */
  fabrication_orders_by_pk?: Maybe<Fabrication_Orders>;
  /** execute function "get_aggregated_consumption" which returns "consumption_by_timestamp" */
  get_aggregated_consumption: Array<Consumption_By_Timestamp>;
  /** execute function "get_aggregated_consumption" and query aggregates on result of table type "consumption_by_timestamp" */
  get_aggregated_consumption_aggregate: Consumption_By_Timestamp_Aggregate;
  /** execute function "get_aggregated_consumption_from_array" which returns "consumption_by_timestamp" */
  get_aggregated_consumption_from_array: Array<Consumption_By_Timestamp>;
  /** execute function "get_aggregated_consumption_from_array" and query aggregates on result of table type "consumption_by_timestamp" */
  get_aggregated_consumption_from_array_aggregate: Consumption_By_Timestamp_Aggregate;
  /** fetch data from the table: "incident_closing_reasons" */
  incident_closing_reasons: Array<Incident_Closing_Reasons>;
  /** fetch aggregated fields from the table: "incident_closing_reasons" */
  incident_closing_reasons_aggregate: Incident_Closing_Reasons_Aggregate;
  /** fetch data from the table: "incident_closing_reasons" using primary key columns */
  incident_closing_reasons_by_pk?: Maybe<Incident_Closing_Reasons>;
  /** fetch data from the table: "incident_project" */
  incident_project: Array<Incident_Project>;
  /** fetch aggregated fields from the table: "incident_project" */
  incident_project_aggregate: Incident_Project_Aggregate;
  /** fetch data from the table: "incident_project" using primary key columns */
  incident_project_by_pk?: Maybe<Incident_Project>;
  /** fetch data from the table: "incident_statuses" */
  incident_statuses: Array<Incident_Statuses>;
  /** fetch aggregated fields from the table: "incident_statuses" */
  incident_statuses_aggregate: Incident_Statuses_Aggregate;
  /** fetch data from the table: "incident_statuses" using primary key columns */
  incident_statuses_by_pk?: Maybe<Incident_Statuses>;
  /** fetch data from the table: "incident_types" */
  incident_types: Array<Incident_Types>;
  /** fetch aggregated fields from the table: "incident_types" */
  incident_types_aggregate: Incident_Types_Aggregate;
  /** fetch data from the table: "incident_types" using primary key columns */
  incident_types_by_pk?: Maybe<Incident_Types>;
  /** An array relationship */
  incidents: Array<Incidents>;
  /** An aggregate relationship */
  incidents_aggregate: Incidents_Aggregate;
  /** fetch data from the table: "incidents" using primary key columns */
  incidents_by_pk?: Maybe<Incidents>;
  /** fetch data from the table: "consumption.daily_consumptions" */
  meter_daily_consumptions: Array<Meter_Daily_Consumptions>;
  /** fetch aggregated fields from the table: "consumption.daily_consumptions" */
  meter_daily_consumptions_aggregate: Meter_Daily_Consumptions_Aggregate;
  /** fetch data from the table: "consumption.daily_consumptions" using primary key columns */
  meter_daily_consumptions_by_pk?: Maybe<Meter_Daily_Consumptions>;
  /** An array relationship */
  meter_types: Array<Meter_Types>;
  /** An aggregate relationship */
  meter_types_aggregate: Meter_Types_Aggregate;
  /** fetch data from the table: "meter_types" using primary key columns */
  meter_types_by_pk?: Maybe<Meter_Types>;
  /** An array relationship */
  meters: Array<Meters>;
  /** An aggregate relationship */
  meters_aggregate: Meters_Aggregate;
  /** fetch data from the table: "meters" using primary key columns */
  meters_by_pk?: Maybe<Meters>;
  /** execute function "mqtt.get_missing_data_grouped_by_topic" which returns "mqtt.missing_data_grouped_by_topic" */
  mqtt_get_missing_data_grouped_by_topic: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** execute function "mqtt.get_missing_data_grouped_by_topic" and query aggregates on result of table type "mqtt.missing_data_grouped_by_topic" */
  mqtt_get_missing_data_grouped_by_topic_aggregate: Mqtt_Missing_Data_Grouped_By_Topic_Aggregate;
  /** fetch data from the table: "mqtt.missing_data" */
  mqtt_missing_data: Array<Mqtt_Missing_Data>;
  /** fetch aggregated fields from the table: "mqtt.missing_data" */
  mqtt_missing_data_aggregate: Mqtt_Missing_Data_Aggregate;
  /** fetch data from the table: "mqtt.missing_data_grouped_by_topic" */
  mqtt_missing_data_grouped_by_topic: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** fetch aggregated fields from the table: "mqtt.missing_data_grouped_by_topic" */
  mqtt_missing_data_grouped_by_topic_aggregate: Mqtt_Missing_Data_Grouped_By_Topic_Aggregate;
  /** fetch data from the table: "mqtt.missing_data_grouped_by_topic" using primary key columns */
  mqtt_missing_data_grouped_by_topic_by_pk?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** fetch data from the table: "mqtt.parsed" */
  mqtt_parsed: Array<Mqtt_Parsed>;
  /** fetch aggregated fields from the table: "mqtt.parsed" */
  mqtt_parsed_aggregate: Mqtt_Parsed_Aggregate;
  /** fetch data from the table: "mqtt.pressac_meters" */
  mqtt_pressac_meters: Array<Mqtt_Pressac_Meters>;
  /** fetch aggregated fields from the table: "mqtt.pressac_meters" */
  mqtt_pressac_meters_aggregate: Mqtt_Pressac_Meters_Aggregate;
  /** fetch data from the table: "mqtt.raw" */
  mqtt_raw: Array<Mqtt_Raw>;
  /** fetch aggregated fields from the table: "mqtt.raw" */
  mqtt_raw_aggregate: Mqtt_Raw_Aggregate;
  /** fetch data from the table: "mqtt.raw" using primary key columns */
  mqtt_raw_by_pk?: Maybe<Mqtt_Raw>;
  /** fetch data from the table: "mqtt.raw_partitioned" */
  mqtt_raw_partitioned: Array<Mqtt_Raw_Partitioned>;
  /** fetch aggregated fields from the table: "mqtt.raw_partitioned" */
  mqtt_raw_partitioned_aggregate: Mqtt_Raw_Partitioned_Aggregate;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** An array relationship */
  objective_milestones: Array<Objective_Milestones>;
  /** An aggregate relationship */
  objective_milestones_aggregate: Objective_Milestones_Aggregate;
  /** fetch data from the table: "objective_milestones" using primary key columns */
  objective_milestones_by_pk?: Maybe<Objective_Milestones>;
  /** fetch data from the table: "objective_types" */
  objective_types: Array<Objective_Types>;
  /** fetch aggregated fields from the table: "objective_types" */
  objective_types_aggregate: Objective_Types_Aggregate;
  /** fetch data from the table: "objective_types" using primary key columns */
  objective_types_by_pk?: Maybe<Objective_Types>;
  /** An array relationship */
  objectives: Array<Objectives>;
  /** An aggregate relationship */
  objectives_aggregate: Objectives_Aggregate;
  /** fetch data from the table: "objectives" using primary key columns */
  objectives_by_pk?: Maybe<Objectives>;
  /** fetch data from the table: "off_production_consumptions" */
  off_production_consumptions: Array<Off_Production_Consumptions>;
  /** fetch aggregated fields from the table: "off_production_consumptions" */
  off_production_consumptions_aggregate: Off_Production_Consumptions_Aggregate;
  /** fetch data from the table: "off_production_consumptions" using primary key columns */
  off_production_consumptions_by_pk?: Maybe<Off_Production_Consumptions>;
  /** fetch data from the table: "ofs_by_day" */
  ofs_by_day: Array<Ofs_By_Day>;
  /** fetch aggregated fields from the table: "ofs_by_day" */
  ofs_by_day_aggregate: Ofs_By_Day_Aggregate;
  /** fetch data from the table: "ofs_by_day" using primary key columns */
  ofs_by_day_by_pk?: Maybe<Ofs_By_Day>;
  /** An array relationship */
  production_hours: Array<Production_Hours>;
  /** An aggregate relationship */
  production_hours_aggregate: Production_Hours_Aggregate;
  /** fetch data from the table: "production_hours" using primary key columns */
  production_hours_by_pk?: Maybe<Production_Hours>;
  /** fetch data from the table: "production_reporting_frequencies" */
  production_reporting_frequencies: Array<Production_Reporting_Frequencies>;
  /** fetch aggregated fields from the table: "production_reporting_frequencies" */
  production_reporting_frequencies_aggregate: Production_Reporting_Frequencies_Aggregate;
  /** fetch data from the table: "production_reporting_frequencies" using primary key columns */
  production_reporting_frequencies_by_pk?: Maybe<Production_Reporting_Frequencies>;
  /** An array relationship */
  productions: Array<Productions>;
  /** An aggregate relationship */
  productions_aggregate: Productions_Aggregate;
  /** fetch data from the table: "productions" using primary key columns */
  productions_by_pk?: Maybe<Productions>;
  /** An array relationship */
  products: Array<Products>;
  /** An aggregate relationship */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "project_ROI_durations" */
  project_ROI_durations: Array<Project_Roi_Durations>;
  /** fetch aggregated fields from the table: "project_ROI_durations" */
  project_ROI_durations_aggregate: Project_Roi_Durations_Aggregate;
  /** fetch data from the table: "project_ROI_durations" using primary key columns */
  project_ROI_durations_by_pk?: Maybe<Project_Roi_Durations>;
  /** fetch data from the table: "project_budget_ranges" */
  project_budget_ranges: Array<Project_Budget_Ranges>;
  /** fetch aggregated fields from the table: "project_budget_ranges" */
  project_budget_ranges_aggregate: Project_Budget_Ranges_Aggregate;
  /** fetch data from the table: "project_budget_ranges" using primary key columns */
  project_budget_ranges_by_pk?: Maybe<Project_Budget_Ranges>;
  /** fetch data from the table: "project_complexities" */
  project_complexities: Array<Project_Complexities>;
  /** fetch aggregated fields from the table: "project_complexities" */
  project_complexities_aggregate: Project_Complexities_Aggregate;
  /** fetch data from the table: "project_complexities" using primary key columns */
  project_complexities_by_pk?: Maybe<Project_Complexities>;
  /** fetch data from the table: "project_statuses" */
  project_statuses: Array<Project_Statuses>;
  /** fetch aggregated fields from the table: "project_statuses" */
  project_statuses_aggregate: Project_Statuses_Aggregate;
  /** fetch data from the table: "project_statuses" using primary key columns */
  project_statuses_by_pk?: Maybe<Project_Statuses>;
  /** fetch data from the table: "project_templates" */
  project_templates: Array<Project_Templates>;
  /** fetch aggregated fields from the table: "project_templates" */
  project_templates_aggregate: Project_Templates_Aggregate;
  /** fetch data from the table: "project_templates" using primary key columns */
  project_templates_by_pk?: Maybe<Project_Templates>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** An array relationship */
  sites: Array<Sites>;
  /** An aggregate relationship */
  sites_aggregate: Sites_Aggregate;
  /** fetch data from the table: "sites" using primary key columns */
  sites_by_pk?: Maybe<Sites>;
  /** fetch data from the table: "sources" */
  sources: Array<Sources>;
  /** fetch aggregated fields from the table: "sources" */
  sources_aggregate: Sources_Aggregate;
  /** fetch data from the table: "sources" using primary key columns */
  sources_by_pk?: Maybe<Sources>;
  /** fetch data from the table: "standard_types" */
  standard_types: Array<Standard_Types>;
  /** fetch aggregated fields from the table: "standard_types" */
  standard_types_aggregate: Standard_Types_Aggregate;
  /** fetch data from the table: "standard_types" using primary key columns */
  standard_types_by_pk?: Maybe<Standard_Types>;
  /** fetch data from the table: "standards" */
  standards: Array<Standards>;
  /** fetch aggregated fields from the table: "standards" */
  standards_aggregate: Standards_Aggregate;
  /** fetch data from the table: "standards" using primary key columns */
  standards_by_pk?: Maybe<Standards>;
  /** fetch data from the table: "subventions" */
  subventions: Array<Subventions>;
  /** fetch aggregated fields from the table: "subventions" */
  subventions_aggregate: Subventions_Aggregate;
  /** fetch data from the table: "subventions" using primary key columns */
  subventions_by_pk?: Maybe<Subventions>;
  /** An array relationship */
  tariff_schedules: Array<Tariff_Schedules>;
  /** An aggregate relationship */
  tariff_schedules_aggregate: Tariff_Schedules_Aggregate;
  /** fetch data from the table: "tariff_schedules" using primary key columns */
  tariff_schedules_by_pk?: Maybe<Tariff_Schedules>;
  /** An array relationship */
  tariffs: Array<Tariffs>;
  /** An aggregate relationship */
  tariffs_aggregate: Tariffs_Aggregate;
  /** fetch data from the table: "tariffs" using primary key columns */
  tariffs_by_pk?: Maybe<Tariffs>;
  /** fetch data from the table: "task_statuses" */
  task_statuses: Array<Task_Statuses>;
  /** fetch aggregated fields from the table: "task_statuses" */
  task_statuses_aggregate: Task_Statuses_Aggregate;
  /** fetch data from the table: "task_statuses" using primary key columns */
  task_statuses_by_pk?: Maybe<Task_Statuses>;
  /** fetch data from the table: "task_types" */
  task_types: Array<Task_Types>;
  /** fetch aggregated fields from the table: "task_types" */
  task_types_aggregate: Task_Types_Aggregate;
  /** fetch data from the table: "task_types" using primary key columns */
  task_types_by_pk?: Maybe<Task_Types>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table: "third_party.consumptions" */
  third_party_consumptions: Array<Third_Party_Consumptions>;
  /** fetch aggregated fields from the table: "third_party.consumptions" */
  third_party_consumptions_aggregate: Third_Party_Consumptions_Aggregate;
  /** fetch data from the table: "third_party.indexes" */
  third_party_indexes: Array<Third_Party_Indexes>;
  /** fetch aggregated fields from the table: "third_party.indexes" */
  third_party_indexes_aggregate: Third_Party_Indexes_Aggregate;
  /** fetch data from the table: "third_party.indexes" using primary key columns */
  third_party_indexes_by_pk?: Maybe<Third_Party_Indexes>;
  /** fetch data from the table: "third_party.sftp_files" */
  third_party_sftp_files: Array<Third_Party_Sftp_Files>;
  /** fetch aggregated fields from the table: "third_party.sftp_files" */
  third_party_sftp_files_aggregate: Third_Party_Sftp_Files_Aggregate;
  /** fetch data from the table: "third_party.sftp_files" using primary key columns */
  third_party_sftp_files_by_pk?: Maybe<Third_Party_Sftp_Files>;
  /** fetch data from the table: "third_party.third_party_meters" */
  third_party_third_party_meters: Array<Third_Party_Third_Party_Meters>;
  /** fetch aggregated fields from the table: "third_party.third_party_meters" */
  third_party_third_party_meters_aggregate: Third_Party_Third_Party_Meters_Aggregate;
  /** fetch data from the table: "unit_types" */
  unit_types: Array<Unit_Types>;
  /** fetch aggregated fields from the table: "unit_types" */
  unit_types_aggregate: Unit_Types_Aggregate;
  /** fetch data from the table: "unit_types" using primary key columns */
  unit_types_by_pk?: Maybe<Unit_Types>;
  /** fetch data from the table: "units" */
  units: Array<Units>;
  /** fetch aggregated fields from the table: "units" */
  units_aggregate: Units_Aggregate;
  /** fetch data from the table: "units" using primary key columns */
  units_by_pk?: Maybe<Units>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "weather.daily_measures" */
  weather_daily_measures: Array<Weather_Daily_Measures>;
  /** fetch aggregated fields from the table: "weather.daily_measures" */
  weather_daily_measures_aggregate: Weather_Daily_Measures_Aggregate;
  /** fetch data from the table: "weather.daily_measures" using primary key columns */
  weather_daily_measures_by_pk?: Maybe<Weather_Daily_Measures>;
  /** fetch data from the table: "weather.measures" */
  weather_measures: Array<Weather_Measures>;
  /** fetch aggregated fields from the table: "weather.measures" */
  weather_measures_aggregate: Weather_Measures_Aggregate;
  /** fetch data from the table: "weather.measures" using primary key columns */
  weather_measures_by_pk?: Maybe<Weather_Measures>;
  /** fetch data from the table: "weather.providers" */
  weather_providers: Array<Weather_Providers>;
  /** fetch aggregated fields from the table: "weather.providers" */
  weather_providers_aggregate: Weather_Providers_Aggregate;
  /** fetch data from the table: "weather.providers" using primary key columns */
  weather_providers_by_pk?: Maybe<Weather_Providers>;
  /** fetch data from the table: "weather.stations" */
  weather_stations: Array<Weather_Stations>;
  /** fetch aggregated fields from the table: "weather.stations" */
  weather_stations_aggregate: Weather_Stations_Aggregate;
  /** fetch data from the table: "weather.stations" using primary key columns */
  weather_stations_by_pk?: Maybe<Weather_Stations>;
  /** fetch data from the table: "weekdays" */
  weekdays: Array<Weekdays>;
  /** fetch aggregated fields from the table: "weekdays" */
  weekdays_aggregate: Weekdays_Aggregate;
  /** fetch data from the table: "weekdays" using primary key columns */
  weekdays_by_pk?: Maybe<Weekdays>;
};


export type Query_RootActionsArgs = {
  distinct_on?: InputMaybe<Array<Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Actions_Order_By>>;
  where?: InputMaybe<Actions_Bool_Exp>;
};


export type Query_RootActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Actions_Order_By>>;
  where?: InputMaybe<Actions_Bool_Exp>;
};


export type Query_RootActions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAlert_TypesArgs = {
  distinct_on?: InputMaybe<Array<Alert_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_Types_Order_By>>;
  where?: InputMaybe<Alert_Types_Bool_Exp>;
};


export type Query_RootAlert_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_Types_Order_By>>;
  where?: InputMaybe<Alert_Types_Bool_Exp>;
};


export type Query_RootAlert_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAlert_UserArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


export type Query_RootAlert_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


export type Query_RootAlert_User_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAlertsArgs = {
  distinct_on?: InputMaybe<Array<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Query_RootAlerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Query_RootAlerts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootArea_TypesArgs = {
  distinct_on?: InputMaybe<Array<Area_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Area_Types_Order_By>>;
  where?: InputMaybe<Area_Types_Bool_Exp>;
};


export type Query_RootArea_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Area_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Area_Types_Order_By>>;
  where?: InputMaybe<Area_Types_Bool_Exp>;
};


export type Query_RootArea_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAreasArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


export type Query_RootAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


export type Query_RootAreas_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootBaselinesArgs = {
  distinct_on?: InputMaybe<Array<Baselines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Baselines_Order_By>>;
  where?: InputMaybe<Baselines_Bool_Exp>;
};


export type Query_RootBaselines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Baselines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Baselines_Order_By>>;
  where?: InputMaybe<Baselines_Bool_Exp>;
};


export type Query_RootBaselines_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootClientsArgs = {
  distinct_on?: InputMaybe<Array<Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clients_Order_By>>;
  where?: InputMaybe<Clients_Bool_Exp>;
};


export type Query_RootClients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clients_Order_By>>;
  where?: InputMaybe<Clients_Bool_Exp>;
};


export type Query_RootClients_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootComments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootConsumption_By_TimestampArgs = {
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Query_RootConsumption_By_Timestamp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Query_RootConsumption_By_Timestamp_By_PkArgs = {
  timestamp: Scalars['timestamp']['input'];
};


export type Query_RootConsumption_Meter_ConsumptionArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Meter_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Meter_Consumption_Order_By>>;
  where?: InputMaybe<Consumption_Meter_Consumption_Bool_Exp>;
};


export type Query_RootConsumption_Meter_Consumption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Meter_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Meter_Consumption_Order_By>>;
  where?: InputMaybe<Consumption_Meter_Consumption_Bool_Exp>;
};


export type Query_RootConsumption_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Reference_Order_By>>;
  where?: InputMaybe<Consumption_Reference_Bool_Exp>;
};


export type Query_RootConsumption_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Reference_Order_By>>;
  where?: InputMaybe<Consumption_Reference_Bool_Exp>;
};


export type Query_RootConsumption_Reference_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumptions_Order_By>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


export type Query_RootConsumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumptions_Order_By>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


export type Query_RootConsumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Query_RootContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Query_RootContracts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCron_JobArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Order_By>>;
  where?: InputMaybe<Cron_Job_Bool_Exp>;
};


export type Query_RootCron_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Order_By>>;
  where?: InputMaybe<Cron_Job_Bool_Exp>;
};


export type Query_RootCron_Job_By_PkArgs = {
  jobid: Scalars['bigint']['input'];
};


export type Query_RootCron_Job_Run_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Run_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Run_Details_Order_By>>;
  where?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
};


export type Query_RootCron_Job_Run_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Run_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Run_Details_Order_By>>;
  where?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
};


export type Query_RootCron_Job_Run_Details_By_PkArgs = {
  runid: Scalars['bigint']['input'];
};


export type Query_RootEnedis_ConsumptionArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Consumption_Order_By>>;
  where?: InputMaybe<Enedis_Consumption_Bool_Exp>;
};


export type Query_RootEnedis_Consumption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Consumption_Order_By>>;
  where?: InputMaybe<Enedis_Consumption_Bool_Exp>;
};


export type Query_RootEnedis_History_RawArgs = {
  distinct_on?: InputMaybe<Array<Enedis_History_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_History_Raw_Order_By>>;
  where?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
};


export type Query_RootEnedis_History_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enedis_History_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_History_Raw_Order_By>>;
  where?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
};


export type Query_RootEnedis_History_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEnedis_Minutes_RawArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Minutes_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Minutes_Raw_Order_By>>;
  where?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
};


export type Query_RootEnedis_Minutes_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Minutes_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Minutes_Raw_Order_By>>;
  where?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
};


export type Query_RootEnedis_Minutes_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEnergy_TypesArgs = {
  distinct_on?: InputMaybe<Array<Energy_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Types_Order_By>>;
  where?: InputMaybe<Energy_Types_Bool_Exp>;
};


export type Query_RootEnergy_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Types_Order_By>>;
  where?: InputMaybe<Energy_Types_Bool_Exp>;
};


export type Query_RootEnergy_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnergy_Use_TypesArgs = {
  distinct_on?: InputMaybe<Array<Energy_Use_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Use_Types_Order_By>>;
  where?: InputMaybe<Energy_Use_Types_Bool_Exp>;
};


export type Query_RootEnergy_Use_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Use_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Use_Types_Order_By>>;
  where?: InputMaybe<Energy_Use_Types_Bool_Exp>;
};


export type Query_RootEnergy_Use_Types_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootFabrication_Order_EpiArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


export type Query_RootFabrication_Order_Epi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


export type Query_RootFabrication_Order_Epi_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFabrication_Order_ProductArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


export type Query_RootFabrication_Order_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


export type Query_RootFabrication_Order_Product_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFabrication_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Orders_Order_By>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


export type Query_RootFabrication_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Orders_Order_By>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


export type Query_RootFabrication_Orders_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGet_Aggregated_ConsumptionArgs = {
  args: Get_Aggregated_Consumption_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Query_RootGet_Aggregated_Consumption_AggregateArgs = {
  args: Get_Aggregated_Consumption_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Query_RootGet_Aggregated_Consumption_From_ArrayArgs = {
  args: Get_Aggregated_Consumption_From_Array_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Query_RootGet_Aggregated_Consumption_From_Array_AggregateArgs = {
  args: Get_Aggregated_Consumption_From_Array_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Query_RootIncident_Closing_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Incident_Closing_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Closing_Reasons_Order_By>>;
  where?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
};


export type Query_RootIncident_Closing_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Closing_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Closing_Reasons_Order_By>>;
  where?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
};


export type Query_RootIncident_Closing_Reasons_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootIncident_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


export type Query_RootIncident_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


export type Query_RootIncident_Project_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootIncident_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Incident_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Statuses_Order_By>>;
  where?: InputMaybe<Incident_Statuses_Bool_Exp>;
};


export type Query_RootIncident_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Statuses_Order_By>>;
  where?: InputMaybe<Incident_Statuses_Bool_Exp>;
};


export type Query_RootIncident_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootIncident_TypesArgs = {
  distinct_on?: InputMaybe<Array<Incident_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Types_Order_By>>;
  where?: InputMaybe<Incident_Types_Bool_Exp>;
};


export type Query_RootIncident_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Types_Order_By>>;
  where?: InputMaybe<Incident_Types_Bool_Exp>;
};


export type Query_RootIncident_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootIncidentsArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


export type Query_RootIncidents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


export type Query_RootIncidents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMeter_Daily_ConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Daily_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Daily_Consumptions_Order_By>>;
  where?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
};


export type Query_RootMeter_Daily_Consumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Daily_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Daily_Consumptions_Order_By>>;
  where?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
};


export type Query_RootMeter_Daily_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMeter_TypesArgs = {
  distinct_on?: InputMaybe<Array<Meter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Types_Order_By>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};


export type Query_RootMeter_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Types_Order_By>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};


export type Query_RootMeter_Types_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMetersArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


export type Query_RootMeters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


export type Query_RootMeters_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMqtt_Get_Missing_Data_Grouped_By_TopicArgs = {
  args: Mqtt_Get_Missing_Data_Grouped_By_Topic_Args;
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Query_RootMqtt_Get_Missing_Data_Grouped_By_Topic_AggregateArgs = {
  args: Mqtt_Get_Missing_Data_Grouped_By_Topic_Args;
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Query_RootMqtt_Missing_DataArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Bool_Exp>;
};


export type Query_RootMqtt_Missing_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Bool_Exp>;
};


export type Query_RootMqtt_Missing_Data_Grouped_By_TopicArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Query_RootMqtt_Missing_Data_Grouped_By_Topic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Query_RootMqtt_Missing_Data_Grouped_By_Topic_By_PkArgs = {
  topic: Scalars['String']['input'];
};


export type Query_RootMqtt_ParsedArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Parsed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Parsed_Order_By>>;
  where?: InputMaybe<Mqtt_Parsed_Bool_Exp>;
};


export type Query_RootMqtt_Parsed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Parsed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Parsed_Order_By>>;
  where?: InputMaybe<Mqtt_Parsed_Bool_Exp>;
};


export type Query_RootMqtt_Pressac_MetersArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Pressac_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Pressac_Meters_Order_By>>;
  where?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
};


export type Query_RootMqtt_Pressac_Meters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Pressac_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Pressac_Meters_Order_By>>;
  where?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
};


export type Query_RootMqtt_RawArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Bool_Exp>;
};


export type Query_RootMqtt_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Bool_Exp>;
};


export type Query_RootMqtt_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMqtt_Raw_PartitionedArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Partitioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Partitioned_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Partitioned_Bool_Exp>;
};


export type Query_RootMqtt_Raw_Partitioned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Partitioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Partitioned_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Partitioned_Bool_Exp>;
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootObjective_MilestonesArgs = {
  distinct_on?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Milestones_Order_By>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};


export type Query_RootObjective_Milestones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Milestones_Order_By>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};


export type Query_RootObjective_Milestones_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootObjective_TypesArgs = {
  distinct_on?: InputMaybe<Array<Objective_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Types_Order_By>>;
  where?: InputMaybe<Objective_Types_Bool_Exp>;
};


export type Query_RootObjective_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objective_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Types_Order_By>>;
  where?: InputMaybe<Objective_Types_Bool_Exp>;
};


export type Query_RootObjective_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootObjectivesArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


export type Query_RootObjectives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


export type Query_RootObjectives_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOff_Production_ConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Off_Production_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Off_Production_Consumptions_Order_By>>;
  where?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
};


export type Query_RootOff_Production_Consumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Off_Production_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Off_Production_Consumptions_Order_By>>;
  where?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
};


export type Query_RootOff_Production_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOfs_By_DayArgs = {
  distinct_on?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ofs_By_Day_Order_By>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};


export type Query_RootOfs_By_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ofs_By_Day_Order_By>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};


export type Query_RootOfs_By_Day_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProduction_HoursArgs = {
  distinct_on?: InputMaybe<Array<Production_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Hours_Order_By>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


export type Query_RootProduction_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Hours_Order_By>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


export type Query_RootProduction_Hours_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProduction_Reporting_FrequenciesArgs = {
  distinct_on?: InputMaybe<Array<Production_Reporting_Frequencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Reporting_Frequencies_Order_By>>;
  where?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
};


export type Query_RootProduction_Reporting_Frequencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Reporting_Frequencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Reporting_Frequencies_Order_By>>;
  where?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
};


export type Query_RootProduction_Reporting_Frequencies_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProductionsArgs = {
  distinct_on?: InputMaybe<Array<Productions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Productions_Order_By>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};


export type Query_RootProductions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Productions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Productions_Order_By>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};


export type Query_RootProductions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProject_Roi_DurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Roi_Durations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Roi_Durations_Order_By>>;
  where?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
};


export type Query_RootProject_Roi_Durations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Roi_Durations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Roi_Durations_Order_By>>;
  where?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
};


export type Query_RootProject_Roi_Durations_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProject_Budget_RangesArgs = {
  distinct_on?: InputMaybe<Array<Project_Budget_Ranges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Budget_Ranges_Order_By>>;
  where?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
};


export type Query_RootProject_Budget_Ranges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Budget_Ranges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Budget_Ranges_Order_By>>;
  where?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
};


export type Query_RootProject_Budget_Ranges_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProject_ComplexitiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Complexities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Complexities_Order_By>>;
  where?: InputMaybe<Project_Complexities_Bool_Exp>;
};


export type Query_RootProject_Complexities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Complexities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Complexities_Order_By>>;
  where?: InputMaybe<Project_Complexities_Bool_Exp>;
};


export type Query_RootProject_Complexities_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProject_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Project_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Statuses_Order_By>>;
  where?: InputMaybe<Project_Statuses_Bool_Exp>;
};


export type Query_RootProject_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Statuses_Order_By>>;
  where?: InputMaybe<Project_Statuses_Bool_Exp>;
};


export type Query_RootProject_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProject_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Project_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Templates_Order_By>>;
  where?: InputMaybe<Project_Templates_Bool_Exp>;
};


export type Query_RootProject_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Templates_Order_By>>;
  where?: InputMaybe<Project_Templates_Bool_Exp>;
};


export type Query_RootProject_Templates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSitesArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


export type Query_RootSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


export type Query_RootSites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSourcesArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Query_RootSources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Query_RootSources_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStandard_TypesArgs = {
  distinct_on?: InputMaybe<Array<Standard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standard_Types_Order_By>>;
  where?: InputMaybe<Standard_Types_Bool_Exp>;
};


export type Query_RootStandard_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Standard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standard_Types_Order_By>>;
  where?: InputMaybe<Standard_Types_Bool_Exp>;
};


export type Query_RootStandard_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStandardsArgs = {
  distinct_on?: InputMaybe<Array<Standards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standards_Order_By>>;
  where?: InputMaybe<Standards_Bool_Exp>;
};


export type Query_RootStandards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Standards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standards_Order_By>>;
  where?: InputMaybe<Standards_Bool_Exp>;
};


export type Query_RootStandards_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSubventionsArgs = {
  distinct_on?: InputMaybe<Array<Subventions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subventions_Order_By>>;
  where?: InputMaybe<Subventions_Bool_Exp>;
};


export type Query_RootSubventions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subventions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subventions_Order_By>>;
  where?: InputMaybe<Subventions_Bool_Exp>;
};


export type Query_RootSubventions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTariff_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariff_Schedules_Order_By>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};


export type Query_RootTariff_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariff_Schedules_Order_By>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};


export type Query_RootTariff_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTariffsArgs = {
  distinct_on?: InputMaybe<Array<Tariffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariffs_Order_By>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};


export type Query_RootTariffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tariffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariffs_Order_By>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};


export type Query_RootTariffs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTask_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Task_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Statuses_Order_By>>;
  where?: InputMaybe<Task_Statuses_Bool_Exp>;
};


export type Query_RootTask_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Statuses_Order_By>>;
  where?: InputMaybe<Task_Statuses_Bool_Exp>;
};


export type Query_RootTask_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTask_TypesArgs = {
  distinct_on?: InputMaybe<Array<Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Types_Order_By>>;
  where?: InputMaybe<Task_Types_Bool_Exp>;
};


export type Query_RootTask_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Types_Order_By>>;
  where?: InputMaybe<Task_Types_Bool_Exp>;
};


export type Query_RootTask_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Query_RootTasks_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootThird_Party_ConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Consumptions_Order_By>>;
  where?: InputMaybe<Third_Party_Consumptions_Bool_Exp>;
};


export type Query_RootThird_Party_Consumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Consumptions_Order_By>>;
  where?: InputMaybe<Third_Party_Consumptions_Bool_Exp>;
};


export type Query_RootThird_Party_IndexesArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Indexes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Indexes_Order_By>>;
  where?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
};


export type Query_RootThird_Party_Indexes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Indexes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Indexes_Order_By>>;
  where?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
};


export type Query_RootThird_Party_Indexes_By_PkArgs = {
  source_id: Scalars['String']['input'];
};


export type Query_RootThird_Party_Sftp_FilesArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Sftp_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Sftp_Files_Order_By>>;
  where?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
};


export type Query_RootThird_Party_Sftp_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Sftp_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Sftp_Files_Order_By>>;
  where?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
};


export type Query_RootThird_Party_Sftp_Files_By_PkArgs = {
  path: Scalars['String']['input'];
};


export type Query_RootThird_Party_Third_Party_MetersArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Third_Party_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Third_Party_Meters_Order_By>>;
  where?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
};


export type Query_RootThird_Party_Third_Party_Meters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Third_Party_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Third_Party_Meters_Order_By>>;
  where?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
};


export type Query_RootUnit_TypesArgs = {
  distinct_on?: InputMaybe<Array<Unit_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Types_Order_By>>;
  where?: InputMaybe<Unit_Types_Bool_Exp>;
};


export type Query_RootUnit_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Types_Order_By>>;
  where?: InputMaybe<Unit_Types_Bool_Exp>;
};


export type Query_RootUnit_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUnitsArgs = {
  distinct_on?: InputMaybe<Array<Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Units_Order_By>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Query_RootUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Units_Order_By>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Query_RootUnits_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootWeather_Daily_MeasuresArgs = {
  distinct_on?: InputMaybe<Array<Weather_Daily_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Daily_Measures_Order_By>>;
  where?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
};


export type Query_RootWeather_Daily_Measures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Daily_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Daily_Measures_Order_By>>;
  where?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
};


export type Query_RootWeather_Daily_Measures_By_PkArgs = {
  date: Scalars['date']['input'];
  id: Scalars['Int']['input'];
  key: Scalars['String']['input'];
};


export type Query_RootWeather_MeasuresArgs = {
  distinct_on?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Measures_Order_By>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


export type Query_RootWeather_Measures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Measures_Order_By>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


export type Query_RootWeather_Measures_By_PkArgs = {
  id: Scalars['Int']['input'];
  timestamp: Scalars['timestamp']['input'];
};


export type Query_RootWeather_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Weather_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Providers_Order_By>>;
  where?: InputMaybe<Weather_Providers_Bool_Exp>;
};


export type Query_RootWeather_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Providers_Order_By>>;
  where?: InputMaybe<Weather_Providers_Bool_Exp>;
};


export type Query_RootWeather_Providers_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWeather_StationsArgs = {
  distinct_on?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Stations_Order_By>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};


export type Query_RootWeather_Stations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Stations_Order_By>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};


export type Query_RootWeather_Stations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootWeekdaysArgs = {
  distinct_on?: InputMaybe<Array<Weekdays_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekdays_Order_By>>;
  where?: InputMaybe<Weekdays_Bool_Exp>;
};


export type Query_RootWeekdays_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekdays_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekdays_Order_By>>;
  where?: InputMaybe<Weekdays_Bool_Exp>;
};


export type Query_RootWeekdays_By_PkArgs = {
  value: Scalars['String']['input'];
};

/** columns and relationships of "sites" */
export type Sites = {
  __typename?: 'sites';
  _created_at: Scalars['timestamptz']['output'];
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  /** An object relationship */
  client: Clients;
  client_id: Scalars['Int']['output'];
  /** An object relationship */
  consumption_reference?: Maybe<Consumption_Reference>;
  /** An array relationship */
  contracts: Array<Contracts>;
  /** An aggregate relationship */
  contracts_aggregate: Contracts_Aggregate;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  production_hours: Array<Production_Hours>;
  /** An aggregate relationship */
  production_hours_aggregate: Production_Hours_Aggregate;
  production_start_weekday: Weekdays_Enum;
  /** An array relationship */
  products: Array<Products>;
  /** An aggregate relationship */
  products_aggregate: Products_Aggregate;
  timezone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  weather_station?: Maybe<Weather_Stations>;
  weather_station_id?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "sites" */
export type SitesAreasArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesProduction_HoursArgs = {
  distinct_on?: InputMaybe<Array<Production_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Hours_Order_By>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesProduction_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Hours_Order_By>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


/** columns and relationships of "sites" */
export type SitesProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** aggregated selection of "sites" */
export type Sites_Aggregate = {
  __typename?: 'sites_aggregate';
  aggregate?: Maybe<Sites_Aggregate_Fields>;
  nodes: Array<Sites>;
};

export type Sites_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sites_Aggregate_Bool_Exp_Count>;
};

export type Sites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sites" */
export type Sites_Aggregate_Fields = {
  __typename?: 'sites_aggregate_fields';
  avg?: Maybe<Sites_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sites_Max_Fields>;
  min?: Maybe<Sites_Min_Fields>;
  stddev?: Maybe<Sites_Stddev_Fields>;
  stddev_pop?: Maybe<Sites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sites_Stddev_Samp_Fields>;
  sum?: Maybe<Sites_Sum_Fields>;
  var_pop?: Maybe<Sites_Var_Pop_Fields>;
  var_samp?: Maybe<Sites_Var_Samp_Fields>;
  variance?: Maybe<Sites_Variance_Fields>;
};


/** aggregate fields of "sites" */
export type Sites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sites" */
export type Sites_Aggregate_Order_By = {
  avg?: InputMaybe<Sites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sites_Max_Order_By>;
  min?: InputMaybe<Sites_Min_Order_By>;
  stddev?: InputMaybe<Sites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sites_Sum_Order_By>;
  var_pop?: InputMaybe<Sites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sites_Var_Samp_Order_By>;
  variance?: InputMaybe<Sites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sites" */
export type Sites_Arr_Rel_Insert_Input = {
  data: Array<Sites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sites_On_Conflict>;
};

/** aggregate avg on columns */
export type Sites_Avg_Fields = {
  __typename?: 'sites_avg_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sites" */
export type Sites_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sites". All fields are combined with a logical 'AND'. */
export type Sites_Bool_Exp = {
  _and?: InputMaybe<Array<Sites_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Sites_Bool_Exp>;
  _or?: InputMaybe<Array<Sites_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  areas?: InputMaybe<Areas_Bool_Exp>;
  areas_aggregate?: InputMaybe<Areas_Aggregate_Bool_Exp>;
  client?: InputMaybe<Clients_Bool_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  consumption_reference?: InputMaybe<Consumption_Reference_Bool_Exp>;
  contracts?: InputMaybe<Contracts_Bool_Exp>;
  contracts_aggregate?: InputMaybe<Contracts_Aggregate_Bool_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  long?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  production_hours?: InputMaybe<Production_Hours_Bool_Exp>;
  production_hours_aggregate?: InputMaybe<Production_Hours_Aggregate_Bool_Exp>;
  production_start_weekday?: InputMaybe<Weekdays_Enum_Comparison_Exp>;
  products?: InputMaybe<Products_Bool_Exp>;
  products_aggregate?: InputMaybe<Products_Aggregate_Bool_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  weather_station?: InputMaybe<Weather_Stations_Bool_Exp>;
  weather_station_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "sites" */
export enum Sites_Constraint {
  /** unique or primary key constraint on columns "id" */
  SitesIdKey = 'sites_id_key',
  /** unique or primary key constraint on columns "id" */
  SitesPkey = 'sites_pkey'
}

/** input type for incrementing numeric columns in table "sites" */
export type Sites_Inc_Input = {
  client_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  weather_station_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sites" */
export type Sites_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  areas?: InputMaybe<Areas_Arr_Rel_Insert_Input>;
  client?: InputMaybe<Clients_Obj_Rel_Insert_Input>;
  client_id?: InputMaybe<Scalars['Int']['input']>;
  consumption_reference?: InputMaybe<Consumption_Reference_Obj_Rel_Insert_Input>;
  contracts?: InputMaybe<Contracts_Arr_Rel_Insert_Input>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  production_hours?: InputMaybe<Production_Hours_Arr_Rel_Insert_Input>;
  production_start_weekday?: InputMaybe<Weekdays_Enum>;
  products?: InputMaybe<Products_Arr_Rel_Insert_Input>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  weather_station?: InputMaybe<Weather_Stations_Obj_Rel_Insert_Input>;
  weather_station_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Sites_Max_Fields = {
  __typename?: 'sites_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['Int']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  weather_station_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "sites" */
export type Sites_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sites_Min_Fields = {
  __typename?: 'sites_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['Int']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  weather_station_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "sites" */
export type Sites_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sites" */
export type Sites_Mutation_Response = {
  __typename?: 'sites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sites>;
};

/** input type for inserting object relation for remote table "sites" */
export type Sites_Obj_Rel_Insert_Input = {
  data: Sites_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sites_On_Conflict>;
};

/** on_conflict condition type for table "sites" */
export type Sites_On_Conflict = {
  constraint: Sites_Constraint;
  update_columns?: Array<Sites_Update_Column>;
  where?: InputMaybe<Sites_Bool_Exp>;
};

/** Ordering options when selecting data from "sites". */
export type Sites_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  areas_aggregate?: InputMaybe<Areas_Aggregate_Order_By>;
  client?: InputMaybe<Clients_Order_By>;
  client_id?: InputMaybe<Order_By>;
  consumption_reference?: InputMaybe<Consumption_Reference_Order_By>;
  contracts_aggregate?: InputMaybe<Contracts_Aggregate_Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  production_hours_aggregate?: InputMaybe<Production_Hours_Aggregate_Order_By>;
  production_start_weekday?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Products_Aggregate_Order_By>;
  timezone?: InputMaybe<Order_By>;
  weather_station?: InputMaybe<Weather_Stations_Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sites */
export type Sites_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "sites" */
export enum Sites_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Address = 'address',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Long = 'long',
  /** column name */
  Name = 'name',
  /** column name */
  ProductionStartWeekday = 'production_start_weekday',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  WeatherStationId = 'weather_station_id'
}

/** input type for updating data in table "sites" */
export type Sites_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['Int']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  production_start_weekday?: InputMaybe<Weekdays_Enum>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  weather_station_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Sites_Stddev_Fields = {
  __typename?: 'sites_stddev_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sites" */
export type Sites_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sites_Stddev_Pop_Fields = {
  __typename?: 'sites_stddev_pop_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sites" */
export type Sites_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sites_Stddev_Samp_Fields = {
  __typename?: 'sites_stddev_samp_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sites" */
export type Sites_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sites" */
export type Sites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sites_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['Int']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  production_start_weekday?: InputMaybe<Weekdays_Enum>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  weather_station_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Sites_Sum_Fields = {
  __typename?: 'sites_sum_fields';
  client_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
  weather_station_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "sites" */
export type Sites_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** update columns of table "sites" */
export enum Sites_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  Address = 'address',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Long = 'long',
  /** column name */
  Name = 'name',
  /** column name */
  ProductionStartWeekday = 'production_start_weekday',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  WeatherStationId = 'weather_station_id'
}

export type Sites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sites_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sites_Var_Pop_Fields = {
  __typename?: 'sites_var_pop_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sites" */
export type Sites_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sites_Var_Samp_Fields = {
  __typename?: 'sites_var_samp_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sites" */
export type Sites_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sites_Variance_Fields = {
  __typename?: 'sites_variance_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  weather_station_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sites" */
export type Sites_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "sources" */
export type Sources = {
  __typename?: 'sources';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "sources" */
export type Sources_Aggregate = {
  __typename?: 'sources_aggregate';
  aggregate?: Maybe<Sources_Aggregate_Fields>;
  nodes: Array<Sources>;
};

/** aggregate fields of "sources" */
export type Sources_Aggregate_Fields = {
  __typename?: 'sources_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sources_Max_Fields>;
  min?: Maybe<Sources_Min_Fields>;
};


/** aggregate fields of "sources" */
export type Sources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sources". All fields are combined with a logical 'AND'. */
export type Sources_Bool_Exp = {
  _and?: InputMaybe<Array<Sources_Bool_Exp>>;
  _not?: InputMaybe<Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Sources_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sources" */
export enum Sources_Constraint {
  /** unique or primary key constraint on columns "value" */
  SourcesPkey = 'sources_pkey'
}

export enum Sources_Enum {
  Enedis = 'enedis',
  Grdf = 'grdf',
  PressacClamps = 'pressac_clamps',
  Pulses = 'pulses',
  ThirdParty = 'third_party'
}

/** Boolean expression to compare columns of type "sources_enum". All fields are combined with logical 'AND'. */
export type Sources_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Sources_Enum>;
  _in?: InputMaybe<Array<Sources_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Sources_Enum>;
  _nin?: InputMaybe<Array<Sources_Enum>>;
};

/** input type for inserting data into table "sources" */
export type Sources_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sources_Max_Fields = {
  __typename?: 'sources_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Sources_Min_Fields = {
  __typename?: 'sources_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sources" */
export type Sources_Mutation_Response = {
  __typename?: 'sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sources>;
};

/** on_conflict condition type for table "sources" */
export type Sources_On_Conflict = {
  constraint: Sources_Constraint;
  update_columns?: Array<Sources_Update_Column>;
  where?: InputMaybe<Sources_Bool_Exp>;
};

/** Ordering options when selecting data from "sources". */
export type Sources_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sources */
export type Sources_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "sources" */
export enum Sources_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "sources" */
export type Sources_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "sources" */
export type Sources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sources_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "sources" */
export enum Sources_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Sources_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sources_Bool_Exp;
};

/** columns and relationships of "standard_types" */
export type Standard_Types = {
  __typename?: 'standard_types';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "standard_types" */
export type Standard_Types_Aggregate = {
  __typename?: 'standard_types_aggregate';
  aggregate?: Maybe<Standard_Types_Aggregate_Fields>;
  nodes: Array<Standard_Types>;
};

/** aggregate fields of "standard_types" */
export type Standard_Types_Aggregate_Fields = {
  __typename?: 'standard_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Standard_Types_Max_Fields>;
  min?: Maybe<Standard_Types_Min_Fields>;
};


/** aggregate fields of "standard_types" */
export type Standard_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Standard_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "standard_types". All fields are combined with a logical 'AND'. */
export type Standard_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Standard_Types_Bool_Exp>>;
  _not?: InputMaybe<Standard_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Standard_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "standard_types" */
export enum Standard_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  PeriodTypesPkey = 'period_types_pkey'
}

export enum Standard_Types_Enum {
  FabricationOrder = 'fabrication_order',
  OffProduction = 'off_production',
  Production = 'production',
  Weekly = 'weekly'
}

/** Boolean expression to compare columns of type "standard_types_enum". All fields are combined with logical 'AND'. */
export type Standard_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Standard_Types_Enum>;
  _in?: InputMaybe<Array<Standard_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Standard_Types_Enum>;
  _nin?: InputMaybe<Array<Standard_Types_Enum>>;
};

/** input type for inserting data into table "standard_types" */
export type Standard_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Standard_Types_Max_Fields = {
  __typename?: 'standard_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Standard_Types_Min_Fields = {
  __typename?: 'standard_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "standard_types" */
export type Standard_Types_Mutation_Response = {
  __typename?: 'standard_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Standard_Types>;
};

/** on_conflict condition type for table "standard_types" */
export type Standard_Types_On_Conflict = {
  constraint: Standard_Types_Constraint;
  update_columns?: Array<Standard_Types_Update_Column>;
  where?: InputMaybe<Standard_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "standard_types". */
export type Standard_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: standard_types */
export type Standard_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "standard_types" */
export enum Standard_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "standard_types" */
export type Standard_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "standard_types" */
export type Standard_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Standard_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Standard_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "standard_types" */
export enum Standard_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Standard_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Standard_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Standard_Types_Bool_Exp;
};

/** columns and relationships of "standards" */
export type Standards = {
  __typename?: 'standards';
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int']['output'];
  date: Scalars['date']['output'];
  energy_type: Energy_Types_Enum;
  id: Scalars['Int']['output'];
  type: Standard_Types_Enum;
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "standards" */
export type Standards_Aggregate = {
  __typename?: 'standards_aggregate';
  aggregate?: Maybe<Standards_Aggregate_Fields>;
  nodes: Array<Standards>;
};

/** aggregate fields of "standards" */
export type Standards_Aggregate_Fields = {
  __typename?: 'standards_aggregate_fields';
  avg?: Maybe<Standards_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Standards_Max_Fields>;
  min?: Maybe<Standards_Min_Fields>;
  stddev?: Maybe<Standards_Stddev_Fields>;
  stddev_pop?: Maybe<Standards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Standards_Stddev_Samp_Fields>;
  sum?: Maybe<Standards_Sum_Fields>;
  var_pop?: Maybe<Standards_Var_Pop_Fields>;
  var_samp?: Maybe<Standards_Var_Samp_Fields>;
  variance?: Maybe<Standards_Variance_Fields>;
};


/** aggregate fields of "standards" */
export type Standards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Standards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Standards_Avg_Fields = {
  __typename?: 'standards_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "standards". All fields are combined with a logical 'AND'. */
export type Standards_Bool_Exp = {
  _and?: InputMaybe<Array<Standards_Bool_Exp>>;
  _not?: InputMaybe<Standards_Bool_Exp>;
  _or?: InputMaybe<Array<Standards_Bool_Exp>>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  energy_type?: InputMaybe<Energy_Types_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Standard_Types_Enum_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "standards" */
export enum Standards_Constraint {
  /** unique or primary key constraint on columns "id" */
  PeriodTypeStandardsPkey = 'period_type_standards_pkey',
  /** unique or primary key constraint on columns "energy_type", "area_id", "date", "type" */
  StandardsTypeEnergyTypeAreaIdDateKey = 'standards_type_energy_type_area_id_date_key'
}

/** input type for incrementing numeric columns in table "standards" */
export type Standards_Inc_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "standards" */
export type Standards_Insert_Input = {
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Standard_Types_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Standards_Max_Fields = {
  __typename?: 'standards_max_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Standards_Min_Fields = {
  __typename?: 'standards_min_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "standards" */
export type Standards_Mutation_Response = {
  __typename?: 'standards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Standards>;
};

/** on_conflict condition type for table "standards" */
export type Standards_On_Conflict = {
  constraint: Standards_Constraint;
  update_columns?: Array<Standards_Update_Column>;
  where?: InputMaybe<Standards_Bool_Exp>;
};

/** Ordering options when selecting data from "standards". */
export type Standards_Order_By = {
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  energy_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: standards */
export type Standards_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "standards" */
export enum Standards_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  Date = 'date',
  /** column name */
  EnergyType = 'energy_type',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "standards" */
export type Standards_Set_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Standard_Types_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Standards_Stddev_Fields = {
  __typename?: 'standards_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Standards_Stddev_Pop_Fields = {
  __typename?: 'standards_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Standards_Stddev_Samp_Fields = {
  __typename?: 'standards_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "standards" */
export type Standards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Standards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Standards_Stream_Cursor_Value_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  energy_type?: InputMaybe<Energy_Types_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Standard_Types_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Standards_Sum_Fields = {
  __typename?: 'standards_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "standards" */
export enum Standards_Update_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  Date = 'date',
  /** column name */
  EnergyType = 'energy_type',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

export type Standards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Standards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Standards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Standards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Standards_Var_Pop_Fields = {
  __typename?: 'standards_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Standards_Var_Samp_Fields = {
  __typename?: 'standards_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Standards_Variance_Fields = {
  __typename?: 'standards_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "actions" */
  actions: Array<Actions>;
  /** fetch aggregated fields from the table: "actions" */
  actions_aggregate: Actions_Aggregate;
  /** fetch data from the table: "actions" using primary key columns */
  actions_by_pk?: Maybe<Actions>;
  /** fetch data from the table in a streaming manner: "actions" */
  actions_stream: Array<Actions>;
  /** fetch data from the table: "alert_types" */
  alert_types: Array<Alert_Types>;
  /** fetch aggregated fields from the table: "alert_types" */
  alert_types_aggregate: Alert_Types_Aggregate;
  /** fetch data from the table: "alert_types" using primary key columns */
  alert_types_by_pk?: Maybe<Alert_Types>;
  /** fetch data from the table in a streaming manner: "alert_types" */
  alert_types_stream: Array<Alert_Types>;
  /** fetch data from the table: "alert_user" */
  alert_user: Array<Alert_User>;
  /** fetch aggregated fields from the table: "alert_user" */
  alert_user_aggregate: Alert_User_Aggregate;
  /** fetch data from the table: "alert_user" using primary key columns */
  alert_user_by_pk?: Maybe<Alert_User>;
  /** fetch data from the table in a streaming manner: "alert_user" */
  alert_user_stream: Array<Alert_User>;
  /** fetch data from the table: "alerts" */
  alerts: Array<Alerts>;
  /** fetch aggregated fields from the table: "alerts" */
  alerts_aggregate: Alerts_Aggregate;
  /** fetch data from the table: "alerts" using primary key columns */
  alerts_by_pk?: Maybe<Alerts>;
  /** fetch data from the table in a streaming manner: "alerts" */
  alerts_stream: Array<Alerts>;
  /** fetch data from the table: "area_types" */
  area_types: Array<Area_Types>;
  /** fetch aggregated fields from the table: "area_types" */
  area_types_aggregate: Area_Types_Aggregate;
  /** fetch data from the table: "area_types" using primary key columns */
  area_types_by_pk?: Maybe<Area_Types>;
  /** fetch data from the table in a streaming manner: "area_types" */
  area_types_stream: Array<Area_Types>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: Areas_Aggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table in a streaming manner: "areas" */
  areas_stream: Array<Areas>;
  /** fetch data from the table: "baselines" */
  baselines: Array<Baselines>;
  /** fetch aggregated fields from the table: "baselines" */
  baselines_aggregate: Baselines_Aggregate;
  /** fetch data from the table: "baselines" using primary key columns */
  baselines_by_pk?: Maybe<Baselines>;
  /** fetch data from the table in a streaming manner: "baselines" */
  baselines_stream: Array<Baselines>;
  /** fetch data from the table: "clients" */
  clients: Array<Clients>;
  /** fetch aggregated fields from the table: "clients" */
  clients_aggregate: Clients_Aggregate;
  /** fetch data from the table: "clients" using primary key columns */
  clients_by_pk?: Maybe<Clients>;
  /** fetch data from the table in a streaming manner: "clients" */
  clients_stream: Array<Clients>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table in a streaming manner: "comments" */
  comments_stream: Array<Comments>;
  /** fetch data from the table: "consumption_by_timestamp" */
  consumption_by_timestamp: Array<Consumption_By_Timestamp>;
  /** fetch aggregated fields from the table: "consumption_by_timestamp" */
  consumption_by_timestamp_aggregate: Consumption_By_Timestamp_Aggregate;
  /** fetch data from the table: "consumption_by_timestamp" using primary key columns */
  consumption_by_timestamp_by_pk?: Maybe<Consumption_By_Timestamp>;
  /** fetch data from the table in a streaming manner: "consumption_by_timestamp" */
  consumption_by_timestamp_stream: Array<Consumption_By_Timestamp>;
  /** fetch data from the table: "consumption.meter_consumption" */
  consumption_meter_consumption: Array<Consumption_Meter_Consumption>;
  /** fetch aggregated fields from the table: "consumption.meter_consumption" */
  consumption_meter_consumption_aggregate: Consumption_Meter_Consumption_Aggregate;
  /** fetch data from the table in a streaming manner: "consumption.meter_consumption" */
  consumption_meter_consumption_stream: Array<Consumption_Meter_Consumption>;
  /** fetch data from the table: "consumption_reference" */
  consumption_reference: Array<Consumption_Reference>;
  /** fetch aggregated fields from the table: "consumption_reference" */
  consumption_reference_aggregate: Consumption_Reference_Aggregate;
  /** fetch data from the table: "consumption_reference" using primary key columns */
  consumption_reference_by_pk?: Maybe<Consumption_Reference>;
  /** fetch data from the table in a streaming manner: "consumption_reference" */
  consumption_reference_stream: Array<Consumption_Reference>;
  /** An array relationship */
  consumptions: Array<Consumptions>;
  /** An aggregate relationship */
  consumptions_aggregate: Consumptions_Aggregate;
  /** fetch data from the table: "consumptions" using primary key columns */
  consumptions_by_pk?: Maybe<Consumptions>;
  /** fetch data from the table in a streaming manner: "consumptions" */
  consumptions_stream: Array<Consumptions>;
  /** An array relationship */
  contracts: Array<Contracts>;
  /** An aggregate relationship */
  contracts_aggregate: Contracts_Aggregate;
  /** fetch data from the table: "contracts" using primary key columns */
  contracts_by_pk?: Maybe<Contracts>;
  /** fetch data from the table in a streaming manner: "contracts" */
  contracts_stream: Array<Contracts>;
  /** fetch data from the table: "cron.job" */
  cron_job: Array<Cron_Job>;
  /** fetch aggregated fields from the table: "cron.job" */
  cron_job_aggregate: Cron_Job_Aggregate;
  /** fetch data from the table: "cron.job" using primary key columns */
  cron_job_by_pk?: Maybe<Cron_Job>;
  /** fetch data from the table: "cron.job_run_details" */
  cron_job_run_details: Array<Cron_Job_Run_Details>;
  /** fetch aggregated fields from the table: "cron.job_run_details" */
  cron_job_run_details_aggregate: Cron_Job_Run_Details_Aggregate;
  /** fetch data from the table: "cron.job_run_details" using primary key columns */
  cron_job_run_details_by_pk?: Maybe<Cron_Job_Run_Details>;
  /** fetch data from the table in a streaming manner: "cron.job_run_details" */
  cron_job_run_details_stream: Array<Cron_Job_Run_Details>;
  /** fetch data from the table in a streaming manner: "cron.job" */
  cron_job_stream: Array<Cron_Job>;
  /** fetch data from the table: "enedis.consumption" */
  enedis_consumption: Array<Enedis_Consumption>;
  /** fetch aggregated fields from the table: "enedis.consumption" */
  enedis_consumption_aggregate: Enedis_Consumption_Aggregate;
  /** fetch data from the table in a streaming manner: "enedis.consumption" */
  enedis_consumption_stream: Array<Enedis_Consumption>;
  /** fetch data from the table: "enedis.history_raw" */
  enedis_history_raw: Array<Enedis_History_Raw>;
  /** fetch aggregated fields from the table: "enedis.history_raw" */
  enedis_history_raw_aggregate: Enedis_History_Raw_Aggregate;
  /** fetch data from the table: "enedis.history_raw" using primary key columns */
  enedis_history_raw_by_pk?: Maybe<Enedis_History_Raw>;
  /** fetch data from the table in a streaming manner: "enedis.history_raw" */
  enedis_history_raw_stream: Array<Enedis_History_Raw>;
  /** fetch data from the table: "enedis.minutes_raw" */
  enedis_minutes_raw: Array<Enedis_Minutes_Raw>;
  /** fetch aggregated fields from the table: "enedis.minutes_raw" */
  enedis_minutes_raw_aggregate: Enedis_Minutes_Raw_Aggregate;
  /** fetch data from the table: "enedis.minutes_raw" using primary key columns */
  enedis_minutes_raw_by_pk?: Maybe<Enedis_Minutes_Raw>;
  /** fetch data from the table in a streaming manner: "enedis.minutes_raw" */
  enedis_minutes_raw_stream: Array<Enedis_Minutes_Raw>;
  /** fetch data from the table: "energy_types" */
  energy_types: Array<Energy_Types>;
  /** fetch aggregated fields from the table: "energy_types" */
  energy_types_aggregate: Energy_Types_Aggregate;
  /** fetch data from the table: "energy_types" using primary key columns */
  energy_types_by_pk?: Maybe<Energy_Types>;
  /** fetch data from the table in a streaming manner: "energy_types" */
  energy_types_stream: Array<Energy_Types>;
  /** fetch data from the table: "energy_use_types" */
  energy_use_types: Array<Energy_Use_Types>;
  /** fetch aggregated fields from the table: "energy_use_types" */
  energy_use_types_aggregate: Energy_Use_Types_Aggregate;
  /** fetch data from the table: "energy_use_types" using primary key columns */
  energy_use_types_by_pk?: Maybe<Energy_Use_Types>;
  /** fetch data from the table in a streaming manner: "energy_use_types" */
  energy_use_types_stream: Array<Energy_Use_Types>;
  /** fetch data from the table: "fabrication_order_epi" */
  fabrication_order_epi: Array<Fabrication_Order_Epi>;
  /** fetch aggregated fields from the table: "fabrication_order_epi" */
  fabrication_order_epi_aggregate: Fabrication_Order_Epi_Aggregate;
  /** fetch data from the table: "fabrication_order_epi" using primary key columns */
  fabrication_order_epi_by_pk?: Maybe<Fabrication_Order_Epi>;
  /** fetch data from the table in a streaming manner: "fabrication_order_epi" */
  fabrication_order_epi_stream: Array<Fabrication_Order_Epi>;
  /** fetch data from the table: "fabrication_order_product" */
  fabrication_order_product: Array<Fabrication_Order_Product>;
  /** fetch aggregated fields from the table: "fabrication_order_product" */
  fabrication_order_product_aggregate: Fabrication_Order_Product_Aggregate;
  /** fetch data from the table: "fabrication_order_product" using primary key columns */
  fabrication_order_product_by_pk?: Maybe<Fabrication_Order_Product>;
  /** fetch data from the table in a streaming manner: "fabrication_order_product" */
  fabrication_order_product_stream: Array<Fabrication_Order_Product>;
  /** An array relationship */
  fabrication_orders: Array<Fabrication_Orders>;
  /** An aggregate relationship */
  fabrication_orders_aggregate: Fabrication_Orders_Aggregate;
  /** fetch data from the table: "fabrication_orders" using primary key columns */
  fabrication_orders_by_pk?: Maybe<Fabrication_Orders>;
  /** fetch data from the table in a streaming manner: "fabrication_orders" */
  fabrication_orders_stream: Array<Fabrication_Orders>;
  /** execute function "get_aggregated_consumption" which returns "consumption_by_timestamp" */
  get_aggregated_consumption: Array<Consumption_By_Timestamp>;
  /** execute function "get_aggregated_consumption" and query aggregates on result of table type "consumption_by_timestamp" */
  get_aggregated_consumption_aggregate: Consumption_By_Timestamp_Aggregate;
  /** execute function "get_aggregated_consumption_from_array" which returns "consumption_by_timestamp" */
  get_aggregated_consumption_from_array: Array<Consumption_By_Timestamp>;
  /** execute function "get_aggregated_consumption_from_array" and query aggregates on result of table type "consumption_by_timestamp" */
  get_aggregated_consumption_from_array_aggregate: Consumption_By_Timestamp_Aggregate;
  /** fetch data from the table: "incident_closing_reasons" */
  incident_closing_reasons: Array<Incident_Closing_Reasons>;
  /** fetch aggregated fields from the table: "incident_closing_reasons" */
  incident_closing_reasons_aggregate: Incident_Closing_Reasons_Aggregate;
  /** fetch data from the table: "incident_closing_reasons" using primary key columns */
  incident_closing_reasons_by_pk?: Maybe<Incident_Closing_Reasons>;
  /** fetch data from the table in a streaming manner: "incident_closing_reasons" */
  incident_closing_reasons_stream: Array<Incident_Closing_Reasons>;
  /** fetch data from the table: "incident_project" */
  incident_project: Array<Incident_Project>;
  /** fetch aggregated fields from the table: "incident_project" */
  incident_project_aggregate: Incident_Project_Aggregate;
  /** fetch data from the table: "incident_project" using primary key columns */
  incident_project_by_pk?: Maybe<Incident_Project>;
  /** fetch data from the table in a streaming manner: "incident_project" */
  incident_project_stream: Array<Incident_Project>;
  /** fetch data from the table: "incident_statuses" */
  incident_statuses: Array<Incident_Statuses>;
  /** fetch aggregated fields from the table: "incident_statuses" */
  incident_statuses_aggregate: Incident_Statuses_Aggregate;
  /** fetch data from the table: "incident_statuses" using primary key columns */
  incident_statuses_by_pk?: Maybe<Incident_Statuses>;
  /** fetch data from the table in a streaming manner: "incident_statuses" */
  incident_statuses_stream: Array<Incident_Statuses>;
  /** fetch data from the table: "incident_types" */
  incident_types: Array<Incident_Types>;
  /** fetch aggregated fields from the table: "incident_types" */
  incident_types_aggregate: Incident_Types_Aggregate;
  /** fetch data from the table: "incident_types" using primary key columns */
  incident_types_by_pk?: Maybe<Incident_Types>;
  /** fetch data from the table in a streaming manner: "incident_types" */
  incident_types_stream: Array<Incident_Types>;
  /** An array relationship */
  incidents: Array<Incidents>;
  /** An aggregate relationship */
  incidents_aggregate: Incidents_Aggregate;
  /** fetch data from the table: "incidents" using primary key columns */
  incidents_by_pk?: Maybe<Incidents>;
  /** fetch data from the table in a streaming manner: "incidents" */
  incidents_stream: Array<Incidents>;
  /** fetch data from the table: "consumption.daily_consumptions" */
  meter_daily_consumptions: Array<Meter_Daily_Consumptions>;
  /** fetch aggregated fields from the table: "consumption.daily_consumptions" */
  meter_daily_consumptions_aggregate: Meter_Daily_Consumptions_Aggregate;
  /** fetch data from the table: "consumption.daily_consumptions" using primary key columns */
  meter_daily_consumptions_by_pk?: Maybe<Meter_Daily_Consumptions>;
  /** fetch data from the table in a streaming manner: "consumption.daily_consumptions" */
  meter_daily_consumptions_stream: Array<Meter_Daily_Consumptions>;
  /** An array relationship */
  meter_types: Array<Meter_Types>;
  /** An aggregate relationship */
  meter_types_aggregate: Meter_Types_Aggregate;
  /** fetch data from the table: "meter_types" using primary key columns */
  meter_types_by_pk?: Maybe<Meter_Types>;
  /** fetch data from the table in a streaming manner: "meter_types" */
  meter_types_stream: Array<Meter_Types>;
  /** An array relationship */
  meters: Array<Meters>;
  /** An aggregate relationship */
  meters_aggregate: Meters_Aggregate;
  /** fetch data from the table: "meters" using primary key columns */
  meters_by_pk?: Maybe<Meters>;
  /** fetch data from the table in a streaming manner: "meters" */
  meters_stream: Array<Meters>;
  /** execute function "mqtt.get_missing_data_grouped_by_topic" which returns "mqtt.missing_data_grouped_by_topic" */
  mqtt_get_missing_data_grouped_by_topic: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** execute function "mqtt.get_missing_data_grouped_by_topic" and query aggregates on result of table type "mqtt.missing_data_grouped_by_topic" */
  mqtt_get_missing_data_grouped_by_topic_aggregate: Mqtt_Missing_Data_Grouped_By_Topic_Aggregate;
  /** fetch data from the table: "mqtt.missing_data" */
  mqtt_missing_data: Array<Mqtt_Missing_Data>;
  /** fetch aggregated fields from the table: "mqtt.missing_data" */
  mqtt_missing_data_aggregate: Mqtt_Missing_Data_Aggregate;
  /** fetch data from the table: "mqtt.missing_data_grouped_by_topic" */
  mqtt_missing_data_grouped_by_topic: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** fetch aggregated fields from the table: "mqtt.missing_data_grouped_by_topic" */
  mqtt_missing_data_grouped_by_topic_aggregate: Mqtt_Missing_Data_Grouped_By_Topic_Aggregate;
  /** fetch data from the table: "mqtt.missing_data_grouped_by_topic" using primary key columns */
  mqtt_missing_data_grouped_by_topic_by_pk?: Maybe<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** fetch data from the table in a streaming manner: "mqtt.missing_data_grouped_by_topic" */
  mqtt_missing_data_grouped_by_topic_stream: Array<Mqtt_Missing_Data_Grouped_By_Topic>;
  /** fetch data from the table in a streaming manner: "mqtt.missing_data" */
  mqtt_missing_data_stream: Array<Mqtt_Missing_Data>;
  /** fetch data from the table: "mqtt.parsed" */
  mqtt_parsed: Array<Mqtt_Parsed>;
  /** fetch aggregated fields from the table: "mqtt.parsed" */
  mqtt_parsed_aggregate: Mqtt_Parsed_Aggregate;
  /** fetch data from the table in a streaming manner: "mqtt.parsed" */
  mqtt_parsed_stream: Array<Mqtt_Parsed>;
  /** fetch data from the table: "mqtt.pressac_meters" */
  mqtt_pressac_meters: Array<Mqtt_Pressac_Meters>;
  /** fetch aggregated fields from the table: "mqtt.pressac_meters" */
  mqtt_pressac_meters_aggregate: Mqtt_Pressac_Meters_Aggregate;
  /** fetch data from the table in a streaming manner: "mqtt.pressac_meters" */
  mqtt_pressac_meters_stream: Array<Mqtt_Pressac_Meters>;
  /** fetch data from the table: "mqtt.raw" */
  mqtt_raw: Array<Mqtt_Raw>;
  /** fetch aggregated fields from the table: "mqtt.raw" */
  mqtt_raw_aggregate: Mqtt_Raw_Aggregate;
  /** fetch data from the table: "mqtt.raw" using primary key columns */
  mqtt_raw_by_pk?: Maybe<Mqtt_Raw>;
  /** fetch data from the table: "mqtt.raw_partitioned" */
  mqtt_raw_partitioned: Array<Mqtt_Raw_Partitioned>;
  /** fetch aggregated fields from the table: "mqtt.raw_partitioned" */
  mqtt_raw_partitioned_aggregate: Mqtt_Raw_Partitioned_Aggregate;
  /** fetch data from the table in a streaming manner: "mqtt.raw_partitioned" */
  mqtt_raw_partitioned_stream: Array<Mqtt_Raw_Partitioned>;
  /** fetch data from the table in a streaming manner: "mqtt.raw" */
  mqtt_raw_stream: Array<Mqtt_Raw>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** An array relationship */
  objective_milestones: Array<Objective_Milestones>;
  /** An aggregate relationship */
  objective_milestones_aggregate: Objective_Milestones_Aggregate;
  /** fetch data from the table: "objective_milestones" using primary key columns */
  objective_milestones_by_pk?: Maybe<Objective_Milestones>;
  /** fetch data from the table in a streaming manner: "objective_milestones" */
  objective_milestones_stream: Array<Objective_Milestones>;
  /** fetch data from the table: "objective_types" */
  objective_types: Array<Objective_Types>;
  /** fetch aggregated fields from the table: "objective_types" */
  objective_types_aggregate: Objective_Types_Aggregate;
  /** fetch data from the table: "objective_types" using primary key columns */
  objective_types_by_pk?: Maybe<Objective_Types>;
  /** fetch data from the table in a streaming manner: "objective_types" */
  objective_types_stream: Array<Objective_Types>;
  /** An array relationship */
  objectives: Array<Objectives>;
  /** An aggregate relationship */
  objectives_aggregate: Objectives_Aggregate;
  /** fetch data from the table: "objectives" using primary key columns */
  objectives_by_pk?: Maybe<Objectives>;
  /** fetch data from the table in a streaming manner: "objectives" */
  objectives_stream: Array<Objectives>;
  /** fetch data from the table: "off_production_consumptions" */
  off_production_consumptions: Array<Off_Production_Consumptions>;
  /** fetch aggregated fields from the table: "off_production_consumptions" */
  off_production_consumptions_aggregate: Off_Production_Consumptions_Aggregate;
  /** fetch data from the table: "off_production_consumptions" using primary key columns */
  off_production_consumptions_by_pk?: Maybe<Off_Production_Consumptions>;
  /** fetch data from the table in a streaming manner: "off_production_consumptions" */
  off_production_consumptions_stream: Array<Off_Production_Consumptions>;
  /** fetch data from the table: "ofs_by_day" */
  ofs_by_day: Array<Ofs_By_Day>;
  /** fetch aggregated fields from the table: "ofs_by_day" */
  ofs_by_day_aggregate: Ofs_By_Day_Aggregate;
  /** fetch data from the table: "ofs_by_day" using primary key columns */
  ofs_by_day_by_pk?: Maybe<Ofs_By_Day>;
  /** fetch data from the table in a streaming manner: "ofs_by_day" */
  ofs_by_day_stream: Array<Ofs_By_Day>;
  /** An array relationship */
  production_hours: Array<Production_Hours>;
  /** An aggregate relationship */
  production_hours_aggregate: Production_Hours_Aggregate;
  /** fetch data from the table: "production_hours" using primary key columns */
  production_hours_by_pk?: Maybe<Production_Hours>;
  /** fetch data from the table in a streaming manner: "production_hours" */
  production_hours_stream: Array<Production_Hours>;
  /** fetch data from the table: "production_reporting_frequencies" */
  production_reporting_frequencies: Array<Production_Reporting_Frequencies>;
  /** fetch aggregated fields from the table: "production_reporting_frequencies" */
  production_reporting_frequencies_aggregate: Production_Reporting_Frequencies_Aggregate;
  /** fetch data from the table: "production_reporting_frequencies" using primary key columns */
  production_reporting_frequencies_by_pk?: Maybe<Production_Reporting_Frequencies>;
  /** fetch data from the table in a streaming manner: "production_reporting_frequencies" */
  production_reporting_frequencies_stream: Array<Production_Reporting_Frequencies>;
  /** An array relationship */
  productions: Array<Productions>;
  /** An aggregate relationship */
  productions_aggregate: Productions_Aggregate;
  /** fetch data from the table: "productions" using primary key columns */
  productions_by_pk?: Maybe<Productions>;
  /** fetch data from the table in a streaming manner: "productions" */
  productions_stream: Array<Productions>;
  /** An array relationship */
  products: Array<Products>;
  /** An aggregate relationship */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table in a streaming manner: "products" */
  products_stream: Array<Products>;
  /** fetch data from the table: "project_ROI_durations" */
  project_ROI_durations: Array<Project_Roi_Durations>;
  /** fetch aggregated fields from the table: "project_ROI_durations" */
  project_ROI_durations_aggregate: Project_Roi_Durations_Aggregate;
  /** fetch data from the table: "project_ROI_durations" using primary key columns */
  project_ROI_durations_by_pk?: Maybe<Project_Roi_Durations>;
  /** fetch data from the table in a streaming manner: "project_ROI_durations" */
  project_ROI_durations_stream: Array<Project_Roi_Durations>;
  /** fetch data from the table: "project_budget_ranges" */
  project_budget_ranges: Array<Project_Budget_Ranges>;
  /** fetch aggregated fields from the table: "project_budget_ranges" */
  project_budget_ranges_aggregate: Project_Budget_Ranges_Aggregate;
  /** fetch data from the table: "project_budget_ranges" using primary key columns */
  project_budget_ranges_by_pk?: Maybe<Project_Budget_Ranges>;
  /** fetch data from the table in a streaming manner: "project_budget_ranges" */
  project_budget_ranges_stream: Array<Project_Budget_Ranges>;
  /** fetch data from the table: "project_complexities" */
  project_complexities: Array<Project_Complexities>;
  /** fetch aggregated fields from the table: "project_complexities" */
  project_complexities_aggregate: Project_Complexities_Aggregate;
  /** fetch data from the table: "project_complexities" using primary key columns */
  project_complexities_by_pk?: Maybe<Project_Complexities>;
  /** fetch data from the table in a streaming manner: "project_complexities" */
  project_complexities_stream: Array<Project_Complexities>;
  /** fetch data from the table: "project_statuses" */
  project_statuses: Array<Project_Statuses>;
  /** fetch aggregated fields from the table: "project_statuses" */
  project_statuses_aggregate: Project_Statuses_Aggregate;
  /** fetch data from the table: "project_statuses" using primary key columns */
  project_statuses_by_pk?: Maybe<Project_Statuses>;
  /** fetch data from the table in a streaming manner: "project_statuses" */
  project_statuses_stream: Array<Project_Statuses>;
  /** fetch data from the table: "project_templates" */
  project_templates: Array<Project_Templates>;
  /** fetch aggregated fields from the table: "project_templates" */
  project_templates_aggregate: Project_Templates_Aggregate;
  /** fetch data from the table: "project_templates" using primary key columns */
  project_templates_by_pk?: Maybe<Project_Templates>;
  /** fetch data from the table in a streaming manner: "project_templates" */
  project_templates_stream: Array<Project_Templates>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table in a streaming manner: "projects" */
  projects_stream: Array<Projects>;
  /** An array relationship */
  sites: Array<Sites>;
  /** An aggregate relationship */
  sites_aggregate: Sites_Aggregate;
  /** fetch data from the table: "sites" using primary key columns */
  sites_by_pk?: Maybe<Sites>;
  /** fetch data from the table in a streaming manner: "sites" */
  sites_stream: Array<Sites>;
  /** fetch data from the table: "sources" */
  sources: Array<Sources>;
  /** fetch aggregated fields from the table: "sources" */
  sources_aggregate: Sources_Aggregate;
  /** fetch data from the table: "sources" using primary key columns */
  sources_by_pk?: Maybe<Sources>;
  /** fetch data from the table in a streaming manner: "sources" */
  sources_stream: Array<Sources>;
  /** fetch data from the table: "standard_types" */
  standard_types: Array<Standard_Types>;
  /** fetch aggregated fields from the table: "standard_types" */
  standard_types_aggregate: Standard_Types_Aggregate;
  /** fetch data from the table: "standard_types" using primary key columns */
  standard_types_by_pk?: Maybe<Standard_Types>;
  /** fetch data from the table in a streaming manner: "standard_types" */
  standard_types_stream: Array<Standard_Types>;
  /** fetch data from the table: "standards" */
  standards: Array<Standards>;
  /** fetch aggregated fields from the table: "standards" */
  standards_aggregate: Standards_Aggregate;
  /** fetch data from the table: "standards" using primary key columns */
  standards_by_pk?: Maybe<Standards>;
  /** fetch data from the table in a streaming manner: "standards" */
  standards_stream: Array<Standards>;
  /** fetch data from the table: "subventions" */
  subventions: Array<Subventions>;
  /** fetch aggregated fields from the table: "subventions" */
  subventions_aggregate: Subventions_Aggregate;
  /** fetch data from the table: "subventions" using primary key columns */
  subventions_by_pk?: Maybe<Subventions>;
  /** fetch data from the table in a streaming manner: "subventions" */
  subventions_stream: Array<Subventions>;
  /** An array relationship */
  tariff_schedules: Array<Tariff_Schedules>;
  /** An aggregate relationship */
  tariff_schedules_aggregate: Tariff_Schedules_Aggregate;
  /** fetch data from the table: "tariff_schedules" using primary key columns */
  tariff_schedules_by_pk?: Maybe<Tariff_Schedules>;
  /** fetch data from the table in a streaming manner: "tariff_schedules" */
  tariff_schedules_stream: Array<Tariff_Schedules>;
  /** An array relationship */
  tariffs: Array<Tariffs>;
  /** An aggregate relationship */
  tariffs_aggregate: Tariffs_Aggregate;
  /** fetch data from the table: "tariffs" using primary key columns */
  tariffs_by_pk?: Maybe<Tariffs>;
  /** fetch data from the table in a streaming manner: "tariffs" */
  tariffs_stream: Array<Tariffs>;
  /** fetch data from the table: "task_statuses" */
  task_statuses: Array<Task_Statuses>;
  /** fetch aggregated fields from the table: "task_statuses" */
  task_statuses_aggregate: Task_Statuses_Aggregate;
  /** fetch data from the table: "task_statuses" using primary key columns */
  task_statuses_by_pk?: Maybe<Task_Statuses>;
  /** fetch data from the table in a streaming manner: "task_statuses" */
  task_statuses_stream: Array<Task_Statuses>;
  /** fetch data from the table: "task_types" */
  task_types: Array<Task_Types>;
  /** fetch aggregated fields from the table: "task_types" */
  task_types_aggregate: Task_Types_Aggregate;
  /** fetch data from the table: "task_types" using primary key columns */
  task_types_by_pk?: Maybe<Task_Types>;
  /** fetch data from the table in a streaming manner: "task_types" */
  task_types_stream: Array<Task_Types>;
  /** An array relationship */
  tasks: Array<Tasks>;
  /** An aggregate relationship */
  tasks_aggregate: Tasks_Aggregate;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: Maybe<Tasks>;
  /** fetch data from the table in a streaming manner: "tasks" */
  tasks_stream: Array<Tasks>;
  /** fetch data from the table: "third_party.consumptions" */
  third_party_consumptions: Array<Third_Party_Consumptions>;
  /** fetch aggregated fields from the table: "third_party.consumptions" */
  third_party_consumptions_aggregate: Third_Party_Consumptions_Aggregate;
  /** fetch data from the table in a streaming manner: "third_party.consumptions" */
  third_party_consumptions_stream: Array<Third_Party_Consumptions>;
  /** fetch data from the table: "third_party.indexes" */
  third_party_indexes: Array<Third_Party_Indexes>;
  /** fetch aggregated fields from the table: "third_party.indexes" */
  third_party_indexes_aggregate: Third_Party_Indexes_Aggregate;
  /** fetch data from the table: "third_party.indexes" using primary key columns */
  third_party_indexes_by_pk?: Maybe<Third_Party_Indexes>;
  /** fetch data from the table in a streaming manner: "third_party.indexes" */
  third_party_indexes_stream: Array<Third_Party_Indexes>;
  /** fetch data from the table: "third_party.sftp_files" */
  third_party_sftp_files: Array<Third_Party_Sftp_Files>;
  /** fetch aggregated fields from the table: "third_party.sftp_files" */
  third_party_sftp_files_aggregate: Third_Party_Sftp_Files_Aggregate;
  /** fetch data from the table: "third_party.sftp_files" using primary key columns */
  third_party_sftp_files_by_pk?: Maybe<Third_Party_Sftp_Files>;
  /** fetch data from the table in a streaming manner: "third_party.sftp_files" */
  third_party_sftp_files_stream: Array<Third_Party_Sftp_Files>;
  /** fetch data from the table: "third_party.third_party_meters" */
  third_party_third_party_meters: Array<Third_Party_Third_Party_Meters>;
  /** fetch aggregated fields from the table: "third_party.third_party_meters" */
  third_party_third_party_meters_aggregate: Third_Party_Third_Party_Meters_Aggregate;
  /** fetch data from the table in a streaming manner: "third_party.third_party_meters" */
  third_party_third_party_meters_stream: Array<Third_Party_Third_Party_Meters>;
  /** fetch data from the table: "unit_types" */
  unit_types: Array<Unit_Types>;
  /** fetch aggregated fields from the table: "unit_types" */
  unit_types_aggregate: Unit_Types_Aggregate;
  /** fetch data from the table: "unit_types" using primary key columns */
  unit_types_by_pk?: Maybe<Unit_Types>;
  /** fetch data from the table in a streaming manner: "unit_types" */
  unit_types_stream: Array<Unit_Types>;
  /** fetch data from the table: "units" */
  units: Array<Units>;
  /** fetch aggregated fields from the table: "units" */
  units_aggregate: Units_Aggregate;
  /** fetch data from the table: "units" using primary key columns */
  units_by_pk?: Maybe<Units>;
  /** fetch data from the table in a streaming manner: "units" */
  units_stream: Array<Units>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "weather.daily_measures" */
  weather_daily_measures: Array<Weather_Daily_Measures>;
  /** fetch aggregated fields from the table: "weather.daily_measures" */
  weather_daily_measures_aggregate: Weather_Daily_Measures_Aggregate;
  /** fetch data from the table: "weather.daily_measures" using primary key columns */
  weather_daily_measures_by_pk?: Maybe<Weather_Daily_Measures>;
  /** fetch data from the table in a streaming manner: "weather.daily_measures" */
  weather_daily_measures_stream: Array<Weather_Daily_Measures>;
  /** fetch data from the table: "weather.measures" */
  weather_measures: Array<Weather_Measures>;
  /** fetch aggregated fields from the table: "weather.measures" */
  weather_measures_aggregate: Weather_Measures_Aggregate;
  /** fetch data from the table: "weather.measures" using primary key columns */
  weather_measures_by_pk?: Maybe<Weather_Measures>;
  /** fetch data from the table in a streaming manner: "weather.measures" */
  weather_measures_stream: Array<Weather_Measures>;
  /** fetch data from the table: "weather.providers" */
  weather_providers: Array<Weather_Providers>;
  /** fetch aggregated fields from the table: "weather.providers" */
  weather_providers_aggregate: Weather_Providers_Aggregate;
  /** fetch data from the table: "weather.providers" using primary key columns */
  weather_providers_by_pk?: Maybe<Weather_Providers>;
  /** fetch data from the table in a streaming manner: "weather.providers" */
  weather_providers_stream: Array<Weather_Providers>;
  /** fetch data from the table: "weather.stations" */
  weather_stations: Array<Weather_Stations>;
  /** fetch aggregated fields from the table: "weather.stations" */
  weather_stations_aggregate: Weather_Stations_Aggregate;
  /** fetch data from the table: "weather.stations" using primary key columns */
  weather_stations_by_pk?: Maybe<Weather_Stations>;
  /** fetch data from the table in a streaming manner: "weather.stations" */
  weather_stations_stream: Array<Weather_Stations>;
  /** fetch data from the table: "weekdays" */
  weekdays: Array<Weekdays>;
  /** fetch aggregated fields from the table: "weekdays" */
  weekdays_aggregate: Weekdays_Aggregate;
  /** fetch data from the table: "weekdays" using primary key columns */
  weekdays_by_pk?: Maybe<Weekdays>;
  /** fetch data from the table in a streaming manner: "weekdays" */
  weekdays_stream: Array<Weekdays>;
};


export type Subscription_RootActionsArgs = {
  distinct_on?: InputMaybe<Array<Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Actions_Order_By>>;
  where?: InputMaybe<Actions_Bool_Exp>;
};


export type Subscription_RootActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Actions_Order_By>>;
  where?: InputMaybe<Actions_Bool_Exp>;
};


export type Subscription_RootActions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootActions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Actions_Bool_Exp>;
};


export type Subscription_RootAlert_TypesArgs = {
  distinct_on?: InputMaybe<Array<Alert_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_Types_Order_By>>;
  where?: InputMaybe<Alert_Types_Bool_Exp>;
};


export type Subscription_RootAlert_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_Types_Order_By>>;
  where?: InputMaybe<Alert_Types_Bool_Exp>;
};


export type Subscription_RootAlert_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAlert_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Alert_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Alert_Types_Bool_Exp>;
};


export type Subscription_RootAlert_UserArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


export type Subscription_RootAlert_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


export type Subscription_RootAlert_User_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAlert_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Alert_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


export type Subscription_RootAlertsArgs = {
  distinct_on?: InputMaybe<Array<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Subscription_RootAlerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alerts_Order_By>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Subscription_RootAlerts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAlerts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Alerts_Stream_Cursor_Input>>;
  where?: InputMaybe<Alerts_Bool_Exp>;
};


export type Subscription_RootArea_TypesArgs = {
  distinct_on?: InputMaybe<Array<Area_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Area_Types_Order_By>>;
  where?: InputMaybe<Area_Types_Bool_Exp>;
};


export type Subscription_RootArea_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Area_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Area_Types_Order_By>>;
  where?: InputMaybe<Area_Types_Bool_Exp>;
};


export type Subscription_RootArea_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootArea_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Area_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Area_Types_Bool_Exp>;
};


export type Subscription_RootAreasArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


export type Subscription_RootAreas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Areas_Order_By>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


export type Subscription_RootAreas_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAreas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Areas_Stream_Cursor_Input>>;
  where?: InputMaybe<Areas_Bool_Exp>;
};


export type Subscription_RootBaselinesArgs = {
  distinct_on?: InputMaybe<Array<Baselines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Baselines_Order_By>>;
  where?: InputMaybe<Baselines_Bool_Exp>;
};


export type Subscription_RootBaselines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Baselines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Baselines_Order_By>>;
  where?: InputMaybe<Baselines_Bool_Exp>;
};


export type Subscription_RootBaselines_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootBaselines_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Baselines_Stream_Cursor_Input>>;
  where?: InputMaybe<Baselines_Bool_Exp>;
};


export type Subscription_RootClientsArgs = {
  distinct_on?: InputMaybe<Array<Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clients_Order_By>>;
  where?: InputMaybe<Clients_Bool_Exp>;
};


export type Subscription_RootClients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clients_Order_By>>;
  where?: InputMaybe<Clients_Bool_Exp>;
};


export type Subscription_RootClients_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootClients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clients_Stream_Cursor_Input>>;
  where?: InputMaybe<Clients_Bool_Exp>;
};


export type Subscription_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootConsumption_By_TimestampArgs = {
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootConsumption_By_Timestamp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootConsumption_By_Timestamp_By_PkArgs = {
  timestamp: Scalars['timestamp']['input'];
};


export type Subscription_RootConsumption_By_Timestamp_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consumption_By_Timestamp_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootConsumption_Meter_ConsumptionArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Meter_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Meter_Consumption_Order_By>>;
  where?: InputMaybe<Consumption_Meter_Consumption_Bool_Exp>;
};


export type Subscription_RootConsumption_Meter_Consumption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Meter_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Meter_Consumption_Order_By>>;
  where?: InputMaybe<Consumption_Meter_Consumption_Bool_Exp>;
};


export type Subscription_RootConsumption_Meter_Consumption_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consumption_Meter_Consumption_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumption_Meter_Consumption_Bool_Exp>;
};


export type Subscription_RootConsumption_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Reference_Order_By>>;
  where?: InputMaybe<Consumption_Reference_Bool_Exp>;
};


export type Subscription_RootConsumption_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_Reference_Order_By>>;
  where?: InputMaybe<Consumption_Reference_Bool_Exp>;
};


export type Subscription_RootConsumption_Reference_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootConsumption_Reference_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consumption_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumption_Reference_Bool_Exp>;
};


export type Subscription_RootConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumptions_Order_By>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


export type Subscription_RootConsumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumptions_Order_By>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


export type Subscription_RootConsumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootConsumptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consumptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumptions_Bool_Exp>;
};


export type Subscription_RootContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Subscription_RootContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Subscription_RootContracts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootContracts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contracts_Stream_Cursor_Input>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Subscription_RootCron_JobArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Order_By>>;
  where?: InputMaybe<Cron_Job_Bool_Exp>;
};


export type Subscription_RootCron_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Order_By>>;
  where?: InputMaybe<Cron_Job_Bool_Exp>;
};


export type Subscription_RootCron_Job_By_PkArgs = {
  jobid: Scalars['bigint']['input'];
};


export type Subscription_RootCron_Job_Run_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Run_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Run_Details_Order_By>>;
  where?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
};


export type Subscription_RootCron_Job_Run_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cron_Job_Run_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cron_Job_Run_Details_Order_By>>;
  where?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
};


export type Subscription_RootCron_Job_Run_Details_By_PkArgs = {
  runid: Scalars['bigint']['input'];
};


export type Subscription_RootCron_Job_Run_Details_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cron_Job_Run_Details_Stream_Cursor_Input>>;
  where?: InputMaybe<Cron_Job_Run_Details_Bool_Exp>;
};


export type Subscription_RootCron_Job_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cron_Job_Stream_Cursor_Input>>;
  where?: InputMaybe<Cron_Job_Bool_Exp>;
};


export type Subscription_RootEnedis_ConsumptionArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Consumption_Order_By>>;
  where?: InputMaybe<Enedis_Consumption_Bool_Exp>;
};


export type Subscription_RootEnedis_Consumption_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Consumption_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Consumption_Order_By>>;
  where?: InputMaybe<Enedis_Consumption_Bool_Exp>;
};


export type Subscription_RootEnedis_Consumption_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enedis_Consumption_Stream_Cursor_Input>>;
  where?: InputMaybe<Enedis_Consumption_Bool_Exp>;
};


export type Subscription_RootEnedis_History_RawArgs = {
  distinct_on?: InputMaybe<Array<Enedis_History_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_History_Raw_Order_By>>;
  where?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
};


export type Subscription_RootEnedis_History_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enedis_History_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_History_Raw_Order_By>>;
  where?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
};


export type Subscription_RootEnedis_History_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEnedis_History_Raw_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enedis_History_Raw_Stream_Cursor_Input>>;
  where?: InputMaybe<Enedis_History_Raw_Bool_Exp>;
};


export type Subscription_RootEnedis_Minutes_RawArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Minutes_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Minutes_Raw_Order_By>>;
  where?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
};


export type Subscription_RootEnedis_Minutes_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enedis_Minutes_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enedis_Minutes_Raw_Order_By>>;
  where?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
};


export type Subscription_RootEnedis_Minutes_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEnedis_Minutes_Raw_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enedis_Minutes_Raw_Stream_Cursor_Input>>;
  where?: InputMaybe<Enedis_Minutes_Raw_Bool_Exp>;
};


export type Subscription_RootEnergy_TypesArgs = {
  distinct_on?: InputMaybe<Array<Energy_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Types_Order_By>>;
  where?: InputMaybe<Energy_Types_Bool_Exp>;
};


export type Subscription_RootEnergy_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Types_Order_By>>;
  where?: InputMaybe<Energy_Types_Bool_Exp>;
};


export type Subscription_RootEnergy_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Types_Bool_Exp>;
};


export type Subscription_RootEnergy_Use_TypesArgs = {
  distinct_on?: InputMaybe<Array<Energy_Use_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Use_Types_Order_By>>;
  where?: InputMaybe<Energy_Use_Types_Bool_Exp>;
};


export type Subscription_RootEnergy_Use_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Use_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Energy_Use_Types_Order_By>>;
  where?: InputMaybe<Energy_Use_Types_Bool_Exp>;
};


export type Subscription_RootEnergy_Use_Types_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootEnergy_Use_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Energy_Use_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Energy_Use_Types_Bool_Exp>;
};


export type Subscription_RootFabrication_Order_EpiArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


export type Subscription_RootFabrication_Order_Epi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Epi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Epi_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


export type Subscription_RootFabrication_Order_Epi_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFabrication_Order_Epi_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fabrication_Order_Epi_Stream_Cursor_Input>>;
  where?: InputMaybe<Fabrication_Order_Epi_Bool_Exp>;
};


export type Subscription_RootFabrication_Order_ProductArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


export type Subscription_RootFabrication_Order_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Order_Product_Order_By>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


export type Subscription_RootFabrication_Order_Product_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFabrication_Order_Product_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fabrication_Order_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Fabrication_Order_Product_Bool_Exp>;
};


export type Subscription_RootFabrication_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Orders_Order_By>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


export type Subscription_RootFabrication_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fabrication_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fabrication_Orders_Order_By>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


export type Subscription_RootFabrication_Orders_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFabrication_Orders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fabrication_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Fabrication_Orders_Bool_Exp>;
};


export type Subscription_RootGet_Aggregated_ConsumptionArgs = {
  args: Get_Aggregated_Consumption_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootGet_Aggregated_Consumption_AggregateArgs = {
  args: Get_Aggregated_Consumption_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootGet_Aggregated_Consumption_From_ArrayArgs = {
  args: Get_Aggregated_Consumption_From_Array_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootGet_Aggregated_Consumption_From_Array_AggregateArgs = {
  args: Get_Aggregated_Consumption_From_Array_Args;
  distinct_on?: InputMaybe<Array<Consumption_By_Timestamp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consumption_By_Timestamp_Order_By>>;
  where?: InputMaybe<Consumption_By_Timestamp_Bool_Exp>;
};


export type Subscription_RootIncident_Closing_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Incident_Closing_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Closing_Reasons_Order_By>>;
  where?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
};


export type Subscription_RootIncident_Closing_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Closing_Reasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Closing_Reasons_Order_By>>;
  where?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
};


export type Subscription_RootIncident_Closing_Reasons_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootIncident_Closing_Reasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incident_Closing_Reasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Incident_Closing_Reasons_Bool_Exp>;
};


export type Subscription_RootIncident_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


export type Subscription_RootIncident_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Project_Order_By>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


export type Subscription_RootIncident_Project_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIncident_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incident_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Incident_Project_Bool_Exp>;
};


export type Subscription_RootIncident_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Incident_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Statuses_Order_By>>;
  where?: InputMaybe<Incident_Statuses_Bool_Exp>;
};


export type Subscription_RootIncident_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Statuses_Order_By>>;
  where?: InputMaybe<Incident_Statuses_Bool_Exp>;
};


export type Subscription_RootIncident_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootIncident_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incident_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Incident_Statuses_Bool_Exp>;
};


export type Subscription_RootIncident_TypesArgs = {
  distinct_on?: InputMaybe<Array<Incident_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Types_Order_By>>;
  where?: InputMaybe<Incident_Types_Bool_Exp>;
};


export type Subscription_RootIncident_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incident_Types_Order_By>>;
  where?: InputMaybe<Incident_Types_Bool_Exp>;
};


export type Subscription_RootIncident_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootIncident_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incident_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Incident_Types_Bool_Exp>;
};


export type Subscription_RootIncidentsArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


export type Subscription_RootIncidents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incidents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Incidents_Order_By>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


export type Subscription_RootIncidents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIncidents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Incidents_Stream_Cursor_Input>>;
  where?: InputMaybe<Incidents_Bool_Exp>;
};


export type Subscription_RootMeter_Daily_ConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Daily_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Daily_Consumptions_Order_By>>;
  where?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
};


export type Subscription_RootMeter_Daily_Consumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Daily_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Daily_Consumptions_Order_By>>;
  where?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
};


export type Subscription_RootMeter_Daily_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMeter_Daily_Consumptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Meter_Daily_Consumptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Meter_Daily_Consumptions_Bool_Exp>;
};


export type Subscription_RootMeter_TypesArgs = {
  distinct_on?: InputMaybe<Array<Meter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Types_Order_By>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};


export type Subscription_RootMeter_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meter_Types_Order_By>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};


export type Subscription_RootMeter_Types_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMeter_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Meter_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Meter_Types_Bool_Exp>;
};


export type Subscription_RootMetersArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


export type Subscription_RootMeters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Meters_Order_By>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


export type Subscription_RootMeters_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMeters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Meters_Stream_Cursor_Input>>;
  where?: InputMaybe<Meters_Bool_Exp>;
};


export type Subscription_RootMqtt_Get_Missing_Data_Grouped_By_TopicArgs = {
  args: Mqtt_Get_Missing_Data_Grouped_By_Topic_Args;
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Subscription_RootMqtt_Get_Missing_Data_Grouped_By_Topic_AggregateArgs = {
  args: Mqtt_Get_Missing_Data_Grouped_By_Topic_Args;
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Subscription_RootMqtt_Missing_DataArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Bool_Exp>;
};


export type Subscription_RootMqtt_Missing_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Bool_Exp>;
};


export type Subscription_RootMqtt_Missing_Data_Grouped_By_TopicArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Subscription_RootMqtt_Missing_Data_Grouped_By_Topic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Missing_Data_Grouped_By_Topic_Order_By>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Subscription_RootMqtt_Missing_Data_Grouped_By_Topic_By_PkArgs = {
  topic: Scalars['String']['input'];
};


export type Subscription_RootMqtt_Missing_Data_Grouped_By_Topic_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Stream_Cursor_Input>>;
  where?: InputMaybe<Mqtt_Missing_Data_Grouped_By_Topic_Bool_Exp>;
};


export type Subscription_RootMqtt_Missing_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mqtt_Missing_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Mqtt_Missing_Data_Bool_Exp>;
};


export type Subscription_RootMqtt_ParsedArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Parsed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Parsed_Order_By>>;
  where?: InputMaybe<Mqtt_Parsed_Bool_Exp>;
};


export type Subscription_RootMqtt_Parsed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Parsed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Parsed_Order_By>>;
  where?: InputMaybe<Mqtt_Parsed_Bool_Exp>;
};


export type Subscription_RootMqtt_Parsed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mqtt_Parsed_Stream_Cursor_Input>>;
  where?: InputMaybe<Mqtt_Parsed_Bool_Exp>;
};


export type Subscription_RootMqtt_Pressac_MetersArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Pressac_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Pressac_Meters_Order_By>>;
  where?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
};


export type Subscription_RootMqtt_Pressac_Meters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Pressac_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Pressac_Meters_Order_By>>;
  where?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
};


export type Subscription_RootMqtt_Pressac_Meters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mqtt_Pressac_Meters_Stream_Cursor_Input>>;
  where?: InputMaybe<Mqtt_Pressac_Meters_Bool_Exp>;
};


export type Subscription_RootMqtt_RawArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Bool_Exp>;
};


export type Subscription_RootMqtt_Raw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Bool_Exp>;
};


export type Subscription_RootMqtt_Raw_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMqtt_Raw_PartitionedArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Partitioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Partitioned_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Partitioned_Bool_Exp>;
};


export type Subscription_RootMqtt_Raw_Partitioned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mqtt_Raw_Partitioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mqtt_Raw_Partitioned_Order_By>>;
  where?: InputMaybe<Mqtt_Raw_Partitioned_Bool_Exp>;
};


export type Subscription_RootMqtt_Raw_Partitioned_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mqtt_Raw_Partitioned_Stream_Cursor_Input>>;
  where?: InputMaybe<Mqtt_Raw_Partitioned_Bool_Exp>;
};


export type Subscription_RootMqtt_Raw_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mqtt_Raw_Stream_Cursor_Input>>;
  where?: InputMaybe<Mqtt_Raw_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootObjective_MilestonesArgs = {
  distinct_on?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Milestones_Order_By>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};


export type Subscription_RootObjective_Milestones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objective_Milestones_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Milestones_Order_By>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};


export type Subscription_RootObjective_Milestones_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootObjective_Milestones_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Objective_Milestones_Stream_Cursor_Input>>;
  where?: InputMaybe<Objective_Milestones_Bool_Exp>;
};


export type Subscription_RootObjective_TypesArgs = {
  distinct_on?: InputMaybe<Array<Objective_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Types_Order_By>>;
  where?: InputMaybe<Objective_Types_Bool_Exp>;
};


export type Subscription_RootObjective_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objective_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Types_Order_By>>;
  where?: InputMaybe<Objective_Types_Bool_Exp>;
};


export type Subscription_RootObjective_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootObjective_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Objective_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Objective_Types_Bool_Exp>;
};


export type Subscription_RootObjectivesArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


export type Subscription_RootObjectives_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Objectives_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objectives_Order_By>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


export type Subscription_RootObjectives_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootObjectives_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Objectives_Stream_Cursor_Input>>;
  where?: InputMaybe<Objectives_Bool_Exp>;
};


export type Subscription_RootOff_Production_ConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Off_Production_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Off_Production_Consumptions_Order_By>>;
  where?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
};


export type Subscription_RootOff_Production_Consumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Off_Production_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Off_Production_Consumptions_Order_By>>;
  where?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
};


export type Subscription_RootOff_Production_Consumptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOff_Production_Consumptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Off_Production_Consumptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Off_Production_Consumptions_Bool_Exp>;
};


export type Subscription_RootOfs_By_DayArgs = {
  distinct_on?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ofs_By_Day_Order_By>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};


export type Subscription_RootOfs_By_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ofs_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ofs_By_Day_Order_By>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};


export type Subscription_RootOfs_By_Day_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOfs_By_Day_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ofs_By_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<Ofs_By_Day_Bool_Exp>;
};


export type Subscription_RootProduction_HoursArgs = {
  distinct_on?: InputMaybe<Array<Production_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Hours_Order_By>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


export type Subscription_RootProduction_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Hours_Order_By>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


export type Subscription_RootProduction_Hours_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProduction_Hours_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Production_Hours_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Hours_Bool_Exp>;
};


export type Subscription_RootProduction_Reporting_FrequenciesArgs = {
  distinct_on?: InputMaybe<Array<Production_Reporting_Frequencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Reporting_Frequencies_Order_By>>;
  where?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
};


export type Subscription_RootProduction_Reporting_Frequencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Reporting_Frequencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Production_Reporting_Frequencies_Order_By>>;
  where?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
};


export type Subscription_RootProduction_Reporting_Frequencies_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProduction_Reporting_Frequencies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Production_Reporting_Frequencies_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Reporting_Frequencies_Bool_Exp>;
};


export type Subscription_RootProductionsArgs = {
  distinct_on?: InputMaybe<Array<Productions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Productions_Order_By>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};


export type Subscription_RootProductions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Productions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Productions_Order_By>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};


export type Subscription_RootProductions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProductions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Productions_Stream_Cursor_Input>>;
  where?: InputMaybe<Productions_Bool_Exp>;
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProducts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProject_Roi_DurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Roi_Durations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Roi_Durations_Order_By>>;
  where?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
};


export type Subscription_RootProject_Roi_Durations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Roi_Durations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Roi_Durations_Order_By>>;
  where?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
};


export type Subscription_RootProject_Roi_Durations_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProject_Roi_Durations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Roi_Durations_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Roi_Durations_Bool_Exp>;
};


export type Subscription_RootProject_Budget_RangesArgs = {
  distinct_on?: InputMaybe<Array<Project_Budget_Ranges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Budget_Ranges_Order_By>>;
  where?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
};


export type Subscription_RootProject_Budget_Ranges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Budget_Ranges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Budget_Ranges_Order_By>>;
  where?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
};


export type Subscription_RootProject_Budget_Ranges_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProject_Budget_Ranges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Budget_Ranges_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Budget_Ranges_Bool_Exp>;
};


export type Subscription_RootProject_ComplexitiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Complexities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Complexities_Order_By>>;
  where?: InputMaybe<Project_Complexities_Bool_Exp>;
};


export type Subscription_RootProject_Complexities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Complexities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Complexities_Order_By>>;
  where?: InputMaybe<Project_Complexities_Bool_Exp>;
};


export type Subscription_RootProject_Complexities_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProject_Complexities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Complexities_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Complexities_Bool_Exp>;
};


export type Subscription_RootProject_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Project_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Statuses_Order_By>>;
  where?: InputMaybe<Project_Statuses_Bool_Exp>;
};


export type Subscription_RootProject_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Statuses_Order_By>>;
  where?: InputMaybe<Project_Statuses_Bool_Exp>;
};


export type Subscription_RootProject_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProject_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Statuses_Bool_Exp>;
};


export type Subscription_RootProject_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Project_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Templates_Order_By>>;
  where?: InputMaybe<Project_Templates_Bool_Exp>;
};


export type Subscription_RootProject_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Templates_Order_By>>;
  where?: InputMaybe<Project_Templates_Bool_Exp>;
};


export type Subscription_RootProject_Templates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProject_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Templates_Bool_Exp>;
};


export type Subscription_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProjects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootSitesArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


export type Subscription_RootSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


export type Subscription_RootSites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sites_Stream_Cursor_Input>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


export type Subscription_RootSourcesArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Subscription_RootSources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sources_Order_By>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Subscription_RootSources_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sources_Stream_Cursor_Input>>;
  where?: InputMaybe<Sources_Bool_Exp>;
};


export type Subscription_RootStandard_TypesArgs = {
  distinct_on?: InputMaybe<Array<Standard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standard_Types_Order_By>>;
  where?: InputMaybe<Standard_Types_Bool_Exp>;
};


export type Subscription_RootStandard_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Standard_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standard_Types_Order_By>>;
  where?: InputMaybe<Standard_Types_Bool_Exp>;
};


export type Subscription_RootStandard_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStandard_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Standard_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Standard_Types_Bool_Exp>;
};


export type Subscription_RootStandardsArgs = {
  distinct_on?: InputMaybe<Array<Standards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standards_Order_By>>;
  where?: InputMaybe<Standards_Bool_Exp>;
};


export type Subscription_RootStandards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Standards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Standards_Order_By>>;
  where?: InputMaybe<Standards_Bool_Exp>;
};


export type Subscription_RootStandards_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootStandards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Standards_Stream_Cursor_Input>>;
  where?: InputMaybe<Standards_Bool_Exp>;
};


export type Subscription_RootSubventionsArgs = {
  distinct_on?: InputMaybe<Array<Subventions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subventions_Order_By>>;
  where?: InputMaybe<Subventions_Bool_Exp>;
};


export type Subscription_RootSubventions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subventions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subventions_Order_By>>;
  where?: InputMaybe<Subventions_Bool_Exp>;
};


export type Subscription_RootSubventions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootSubventions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subventions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subventions_Bool_Exp>;
};


export type Subscription_RootTariff_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariff_Schedules_Order_By>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};


export type Subscription_RootTariff_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariff_Schedules_Order_By>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};


export type Subscription_RootTariff_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTariff_Schedules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tariff_Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};


export type Subscription_RootTariffsArgs = {
  distinct_on?: InputMaybe<Array<Tariffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariffs_Order_By>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};


export type Subscription_RootTariffs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tariffs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariffs_Order_By>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};


export type Subscription_RootTariffs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTariffs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tariffs_Stream_Cursor_Input>>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};


export type Subscription_RootTask_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Task_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Statuses_Order_By>>;
  where?: InputMaybe<Task_Statuses_Bool_Exp>;
};


export type Subscription_RootTask_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Statuses_Order_By>>;
  where?: InputMaybe<Task_Statuses_Bool_Exp>;
};


export type Subscription_RootTask_Statuses_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTask_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Statuses_Bool_Exp>;
};


export type Subscription_RootTask_TypesArgs = {
  distinct_on?: InputMaybe<Array<Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Types_Order_By>>;
  where?: InputMaybe<Task_Types_Bool_Exp>;
};


export type Subscription_RootTask_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Types_Order_By>>;
  where?: InputMaybe<Task_Types_Bool_Exp>;
};


export type Subscription_RootTask_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTask_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Types_Bool_Exp>;
};


export type Subscription_RootTasksArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tasks_Order_By>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootTasks_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTasks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tasks_Stream_Cursor_Input>>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};


export type Subscription_RootThird_Party_ConsumptionsArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Consumptions_Order_By>>;
  where?: InputMaybe<Third_Party_Consumptions_Bool_Exp>;
};


export type Subscription_RootThird_Party_Consumptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Consumptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Consumptions_Order_By>>;
  where?: InputMaybe<Third_Party_Consumptions_Bool_Exp>;
};


export type Subscription_RootThird_Party_Consumptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Consumptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Consumptions_Bool_Exp>;
};


export type Subscription_RootThird_Party_IndexesArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Indexes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Indexes_Order_By>>;
  where?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
};


export type Subscription_RootThird_Party_Indexes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Indexes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Indexes_Order_By>>;
  where?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
};


export type Subscription_RootThird_Party_Indexes_By_PkArgs = {
  source_id: Scalars['String']['input'];
};


export type Subscription_RootThird_Party_Indexes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Indexes_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
};


export type Subscription_RootThird_Party_Sftp_FilesArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Sftp_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Sftp_Files_Order_By>>;
  where?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
};


export type Subscription_RootThird_Party_Sftp_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Sftp_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Sftp_Files_Order_By>>;
  where?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
};


export type Subscription_RootThird_Party_Sftp_Files_By_PkArgs = {
  path: Scalars['String']['input'];
};


export type Subscription_RootThird_Party_Sftp_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Sftp_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
};


export type Subscription_RootThird_Party_Third_Party_MetersArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Third_Party_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Third_Party_Meters_Order_By>>;
  where?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
};


export type Subscription_RootThird_Party_Third_Party_Meters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Third_Party_Third_Party_Meters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Third_Party_Third_Party_Meters_Order_By>>;
  where?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
};


export type Subscription_RootThird_Party_Third_Party_Meters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Third_Party_Third_Party_Meters_Stream_Cursor_Input>>;
  where?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
};


export type Subscription_RootUnit_TypesArgs = {
  distinct_on?: InputMaybe<Array<Unit_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Types_Order_By>>;
  where?: InputMaybe<Unit_Types_Bool_Exp>;
};


export type Subscription_RootUnit_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unit_Types_Order_By>>;
  where?: InputMaybe<Unit_Types_Bool_Exp>;
};


export type Subscription_RootUnit_Types_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUnit_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unit_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Types_Bool_Exp>;
};


export type Subscription_RootUnitsArgs = {
  distinct_on?: InputMaybe<Array<Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Units_Order_By>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Subscription_RootUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Units_Order_By>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Subscription_RootUnits_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUnits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootWeather_Daily_MeasuresArgs = {
  distinct_on?: InputMaybe<Array<Weather_Daily_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Daily_Measures_Order_By>>;
  where?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
};


export type Subscription_RootWeather_Daily_Measures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Daily_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Daily_Measures_Order_By>>;
  where?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
};


export type Subscription_RootWeather_Daily_Measures_By_PkArgs = {
  date: Scalars['date']['input'];
  id: Scalars['Int']['input'];
  key: Scalars['String']['input'];
};


export type Subscription_RootWeather_Daily_Measures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weather_Daily_Measures_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
};


export type Subscription_RootWeather_MeasuresArgs = {
  distinct_on?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Measures_Order_By>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


export type Subscription_RootWeather_Measures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Measures_Order_By>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


export type Subscription_RootWeather_Measures_By_PkArgs = {
  id: Scalars['Int']['input'];
  timestamp: Scalars['timestamp']['input'];
};


export type Subscription_RootWeather_Measures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weather_Measures_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


export type Subscription_RootWeather_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Weather_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Providers_Order_By>>;
  where?: InputMaybe<Weather_Providers_Bool_Exp>;
};


export type Subscription_RootWeather_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Providers_Order_By>>;
  where?: InputMaybe<Weather_Providers_Bool_Exp>;
};


export type Subscription_RootWeather_Providers_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWeather_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weather_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Providers_Bool_Exp>;
};


export type Subscription_RootWeather_StationsArgs = {
  distinct_on?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Stations_Order_By>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};


export type Subscription_RootWeather_Stations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Stations_Order_By>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};


export type Subscription_RootWeather_Stations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootWeather_Stations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weather_Stations_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};


export type Subscription_RootWeekdaysArgs = {
  distinct_on?: InputMaybe<Array<Weekdays_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekdays_Order_By>>;
  where?: InputMaybe<Weekdays_Bool_Exp>;
};


export type Subscription_RootWeekdays_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekdays_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekdays_Order_By>>;
  where?: InputMaybe<Weekdays_Bool_Exp>;
};


export type Subscription_RootWeekdays_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWeekdays_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weekdays_Stream_Cursor_Input>>;
  where?: InputMaybe<Weekdays_Bool_Exp>;
};

/** columns and relationships of "subventions" */
export type Subventions = {
  __typename?: 'subventions';
  id: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "subventions" */
export type Subventions_Aggregate = {
  __typename?: 'subventions_aggregate';
  aggregate?: Maybe<Subventions_Aggregate_Fields>;
  nodes: Array<Subventions>;
};

/** aggregate fields of "subventions" */
export type Subventions_Aggregate_Fields = {
  __typename?: 'subventions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Subventions_Max_Fields>;
  min?: Maybe<Subventions_Min_Fields>;
};


/** aggregate fields of "subventions" */
export type Subventions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subventions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "subventions". All fields are combined with a logical 'AND'. */
export type Subventions_Bool_Exp = {
  _and?: InputMaybe<Array<Subventions_Bool_Exp>>;
  _not?: InputMaybe<Subventions_Bool_Exp>;
  _or?: InputMaybe<Array<Subventions_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subventions" */
export enum Subventions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubventionsPkey = 'subventions_pkey'
}

/** input type for inserting data into table "subventions" */
export type Subventions_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Subventions_Max_Fields = {
  __typename?: 'subventions_max_fields';
  id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Subventions_Min_Fields = {
  __typename?: 'subventions_min_fields';
  id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "subventions" */
export type Subventions_Mutation_Response = {
  __typename?: 'subventions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subventions>;
};

/** input type for inserting object relation for remote table "subventions" */
export type Subventions_Obj_Rel_Insert_Input = {
  data: Subventions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subventions_On_Conflict>;
};

/** on_conflict condition type for table "subventions" */
export type Subventions_On_Conflict = {
  constraint: Subventions_Constraint;
  update_columns?: Array<Subventions_Update_Column>;
  where?: InputMaybe<Subventions_Bool_Exp>;
};

/** Ordering options when selecting data from "subventions". */
export type Subventions_Order_By = {
  id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subventions */
export type Subventions_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "subventions" */
export enum Subventions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "subventions" */
export type Subventions_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "subventions" */
export type Subventions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subventions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subventions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "subventions" */
export enum Subventions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Url = 'url'
}

export type Subventions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subventions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subventions_Bool_Exp;
};

/** columns and relationships of "tariff_schedules" */
export type Tariff_Schedules = {
  __typename?: 'tariff_schedules';
  days_of_week?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  tariff: Tariffs;
  tariff_id: Scalars['Int']['output'];
  time_range?: Maybe<Array<Scalars['time']['output']>>;
};

/** aggregated selection of "tariff_schedules" */
export type Tariff_Schedules_Aggregate = {
  __typename?: 'tariff_schedules_aggregate';
  aggregate?: Maybe<Tariff_Schedules_Aggregate_Fields>;
  nodes: Array<Tariff_Schedules>;
};

export type Tariff_Schedules_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tariff_Schedules_Aggregate_Bool_Exp_Count>;
};

export type Tariff_Schedules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tariff_Schedules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tariff_schedules" */
export type Tariff_Schedules_Aggregate_Fields = {
  __typename?: 'tariff_schedules_aggregate_fields';
  avg?: Maybe<Tariff_Schedules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tariff_Schedules_Max_Fields>;
  min?: Maybe<Tariff_Schedules_Min_Fields>;
  stddev?: Maybe<Tariff_Schedules_Stddev_Fields>;
  stddev_pop?: Maybe<Tariff_Schedules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tariff_Schedules_Stddev_Samp_Fields>;
  sum?: Maybe<Tariff_Schedules_Sum_Fields>;
  var_pop?: Maybe<Tariff_Schedules_Var_Pop_Fields>;
  var_samp?: Maybe<Tariff_Schedules_Var_Samp_Fields>;
  variance?: Maybe<Tariff_Schedules_Variance_Fields>;
};


/** aggregate fields of "tariff_schedules" */
export type Tariff_Schedules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tariff_schedules" */
export type Tariff_Schedules_Aggregate_Order_By = {
  avg?: InputMaybe<Tariff_Schedules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tariff_Schedules_Max_Order_By>;
  min?: InputMaybe<Tariff_Schedules_Min_Order_By>;
  stddev?: InputMaybe<Tariff_Schedules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tariff_Schedules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tariff_Schedules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tariff_Schedules_Sum_Order_By>;
  var_pop?: InputMaybe<Tariff_Schedules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tariff_Schedules_Var_Samp_Order_By>;
  variance?: InputMaybe<Tariff_Schedules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tariff_schedules" */
export type Tariff_Schedules_Arr_Rel_Insert_Input = {
  data: Array<Tariff_Schedules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tariff_Schedules_On_Conflict>;
};

/** aggregate avg on columns */
export type Tariff_Schedules_Avg_Fields = {
  __typename?: 'tariff_schedules_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tariff_schedules". All fields are combined with a logical 'AND'. */
export type Tariff_Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Tariff_Schedules_Bool_Exp>>;
  _not?: InputMaybe<Tariff_Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Tariff_Schedules_Bool_Exp>>;
  days_of_week?: InputMaybe<Int_Array_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tariff?: InputMaybe<Tariffs_Bool_Exp>;
  tariff_id?: InputMaybe<Int_Comparison_Exp>;
  time_range?: InputMaybe<Time_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "tariff_schedules" */
export enum Tariff_Schedules_Constraint {
  /** unique or primary key constraint on columns "id" */
  TariffSchedulesPkey = 'tariff_schedules_pkey'
}

/** input type for incrementing numeric columns in table "tariff_schedules" */
export type Tariff_Schedules_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  tariff_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tariff_schedules" */
export type Tariff_Schedules_Insert_Input = {
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tariff?: InputMaybe<Tariffs_Obj_Rel_Insert_Input>;
  tariff_id?: InputMaybe<Scalars['Int']['input']>;
  time_range?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** aggregate max on columns */
export type Tariff_Schedules_Max_Fields = {
  __typename?: 'tariff_schedules_max_fields';
  days_of_week?: Maybe<Array<Scalars['Int']['output']>>;
  id?: Maybe<Scalars['Int']['output']>;
  tariff_id?: Maybe<Scalars['Int']['output']>;
  time_range?: Maybe<Array<Scalars['time']['output']>>;
};

/** order by max() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Max_Order_By = {
  days_of_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
  time_range?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tariff_Schedules_Min_Fields = {
  __typename?: 'tariff_schedules_min_fields';
  days_of_week?: Maybe<Array<Scalars['Int']['output']>>;
  id?: Maybe<Scalars['Int']['output']>;
  tariff_id?: Maybe<Scalars['Int']['output']>;
  time_range?: Maybe<Array<Scalars['time']['output']>>;
};

/** order by min() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Min_Order_By = {
  days_of_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
  time_range?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tariff_schedules" */
export type Tariff_Schedules_Mutation_Response = {
  __typename?: 'tariff_schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tariff_Schedules>;
};

/** on_conflict condition type for table "tariff_schedules" */
export type Tariff_Schedules_On_Conflict = {
  constraint: Tariff_Schedules_Constraint;
  update_columns?: Array<Tariff_Schedules_Update_Column>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};

/** Ordering options when selecting data from "tariff_schedules". */
export type Tariff_Schedules_Order_By = {
  days_of_week?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tariff?: InputMaybe<Tariffs_Order_By>;
  tariff_id?: InputMaybe<Order_By>;
  time_range?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tariff_schedules */
export type Tariff_Schedules_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "tariff_schedules" */
export enum Tariff_Schedules_Select_Column {
  /** column name */
  DaysOfWeek = 'days_of_week',
  /** column name */
  Id = 'id',
  /** column name */
  TariffId = 'tariff_id',
  /** column name */
  TimeRange = 'time_range'
}

/** input type for updating data in table "tariff_schedules" */
export type Tariff_Schedules_Set_Input = {
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tariff_id?: InputMaybe<Scalars['Int']['input']>;
  time_range?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** aggregate stddev on columns */
export type Tariff_Schedules_Stddev_Fields = {
  __typename?: 'tariff_schedules_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tariff_Schedules_Stddev_Pop_Fields = {
  __typename?: 'tariff_schedules_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tariff_Schedules_Stddev_Samp_Fields = {
  __typename?: 'tariff_schedules_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tariff_schedules" */
export type Tariff_Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tariff_Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tariff_Schedules_Stream_Cursor_Value_Input = {
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tariff_id?: InputMaybe<Scalars['Int']['input']>;
  time_range?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** aggregate sum on columns */
export type Tariff_Schedules_Sum_Fields = {
  __typename?: 'tariff_schedules_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  tariff_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** update columns of table "tariff_schedules" */
export enum Tariff_Schedules_Update_Column {
  /** column name */
  DaysOfWeek = 'days_of_week',
  /** column name */
  Id = 'id',
  /** column name */
  TariffId = 'tariff_id',
  /** column name */
  TimeRange = 'time_range'
}

export type Tariff_Schedules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tariff_Schedules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tariff_Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tariff_Schedules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tariff_Schedules_Var_Pop_Fields = {
  __typename?: 'tariff_schedules_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tariff_Schedules_Var_Samp_Fields = {
  __typename?: 'tariff_schedules_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tariff_Schedules_Variance_Fields = {
  __typename?: 'tariff_schedules_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  tariff_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tariff_schedules" */
export type Tariff_Schedules_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  tariff_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tariffs" */
export type Tariffs = {
  __typename?: 'tariffs';
  /** An object relationship */
  contract: Contracts;
  contract_id: Scalars['Int']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
  months?: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  /** An array relationship */
  tariff_schedules: Array<Tariff_Schedules>;
  /** An aggregate relationship */
  tariff_schedules_aggregate: Tariff_Schedules_Aggregate;
  updated_at: Scalars['timestamp']['output'];
  value: Scalars['numeric']['output'];
};


/** columns and relationships of "tariffs" */
export type TariffsTariff_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariff_Schedules_Order_By>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};


/** columns and relationships of "tariffs" */
export type TariffsTariff_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tariff_Schedules_Order_By>>;
  where?: InputMaybe<Tariff_Schedules_Bool_Exp>;
};

/** aggregated selection of "tariffs" */
export type Tariffs_Aggregate = {
  __typename?: 'tariffs_aggregate';
  aggregate?: Maybe<Tariffs_Aggregate_Fields>;
  nodes: Array<Tariffs>;
};

export type Tariffs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tariffs_Aggregate_Bool_Exp_Count>;
};

export type Tariffs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tariffs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tariffs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tariffs" */
export type Tariffs_Aggregate_Fields = {
  __typename?: 'tariffs_aggregate_fields';
  avg?: Maybe<Tariffs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tariffs_Max_Fields>;
  min?: Maybe<Tariffs_Min_Fields>;
  stddev?: Maybe<Tariffs_Stddev_Fields>;
  stddev_pop?: Maybe<Tariffs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tariffs_Stddev_Samp_Fields>;
  sum?: Maybe<Tariffs_Sum_Fields>;
  var_pop?: Maybe<Tariffs_Var_Pop_Fields>;
  var_samp?: Maybe<Tariffs_Var_Samp_Fields>;
  variance?: Maybe<Tariffs_Variance_Fields>;
};


/** aggregate fields of "tariffs" */
export type Tariffs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tariffs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tariffs" */
export type Tariffs_Aggregate_Order_By = {
  avg?: InputMaybe<Tariffs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tariffs_Max_Order_By>;
  min?: InputMaybe<Tariffs_Min_Order_By>;
  stddev?: InputMaybe<Tariffs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tariffs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tariffs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tariffs_Sum_Order_By>;
  var_pop?: InputMaybe<Tariffs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tariffs_Var_Samp_Order_By>;
  variance?: InputMaybe<Tariffs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tariffs" */
export type Tariffs_Arr_Rel_Insert_Input = {
  data: Array<Tariffs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tariffs_On_Conflict>;
};

/** aggregate avg on columns */
export type Tariffs_Avg_Fields = {
  __typename?: 'tariffs_avg_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tariffs" */
export type Tariffs_Avg_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tariffs". All fields are combined with a logical 'AND'. */
export type Tariffs_Bool_Exp = {
  _and?: InputMaybe<Array<Tariffs_Bool_Exp>>;
  _not?: InputMaybe<Tariffs_Bool_Exp>;
  _or?: InputMaybe<Array<Tariffs_Bool_Exp>>;
  contract?: InputMaybe<Contracts_Bool_Exp>;
  contract_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  months?: InputMaybe<Int_Array_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tariff_schedules?: InputMaybe<Tariff_Schedules_Bool_Exp>;
  tariff_schedules_aggregate?: InputMaybe<Tariff_Schedules_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "tariffs" */
export enum Tariffs_Constraint {
  /** unique or primary key constraint on columns "id" */
  TariffsPkey = 'tariffs_pkey'
}

/** input type for incrementing numeric columns in table "tariffs" */
export type Tariffs_Inc_Input = {
  contract_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "tariffs" */
export type Tariffs_Insert_Input = {
  contract?: InputMaybe<Contracts_Obj_Rel_Insert_Input>;
  contract_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tariff_schedules?: InputMaybe<Tariff_Schedules_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Tariffs_Max_Fields = {
  __typename?: 'tariffs_max_fields';
  contract_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Array<Scalars['Int']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "tariffs" */
export type Tariffs_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tariffs_Min_Fields = {
  __typename?: 'tariffs_min_fields';
  contract_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Array<Scalars['Int']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "tariffs" */
export type Tariffs_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tariffs" */
export type Tariffs_Mutation_Response = {
  __typename?: 'tariffs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tariffs>;
};

/** input type for inserting object relation for remote table "tariffs" */
export type Tariffs_Obj_Rel_Insert_Input = {
  data: Tariffs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tariffs_On_Conflict>;
};

/** on_conflict condition type for table "tariffs" */
export type Tariffs_On_Conflict = {
  constraint: Tariffs_Constraint;
  update_columns?: Array<Tariffs_Update_Column>;
  where?: InputMaybe<Tariffs_Bool_Exp>;
};

/** Ordering options when selecting data from "tariffs". */
export type Tariffs_Order_By = {
  contract?: InputMaybe<Contracts_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tariff_schedules_aggregate?: InputMaybe<Tariff_Schedules_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tariffs */
export type Tariffs_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "tariffs" */
export enum Tariffs_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Months = 'months',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "tariffs" */
export type Tariffs_Set_Input = {
  contract_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Tariffs_Stddev_Fields = {
  __typename?: 'tariffs_stddev_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tariffs" */
export type Tariffs_Stddev_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tariffs_Stddev_Pop_Fields = {
  __typename?: 'tariffs_stddev_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tariffs" */
export type Tariffs_Stddev_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tariffs_Stddev_Samp_Fields = {
  __typename?: 'tariffs_stddev_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tariffs" */
export type Tariffs_Stddev_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tariffs" */
export type Tariffs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tariffs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tariffs_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Tariffs_Sum_Fields = {
  __typename?: 'tariffs_sum_fields';
  contract_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "tariffs" */
export type Tariffs_Sum_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "tariffs" */
export enum Tariffs_Update_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Months = 'months',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Tariffs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tariffs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tariffs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tariffs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tariffs_Var_Pop_Fields = {
  __typename?: 'tariffs_var_pop_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tariffs" */
export type Tariffs_Var_Pop_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tariffs_Var_Samp_Fields = {
  __typename?: 'tariffs_var_samp_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tariffs" */
export type Tariffs_Var_Samp_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tariffs_Variance_Fields = {
  __typename?: 'tariffs_variance_fields';
  contract_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tariffs" */
export type Tariffs_Variance_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "task_statuses" */
export type Task_Statuses = {
  __typename?: 'task_statuses';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "task_statuses" */
export type Task_Statuses_Aggregate = {
  __typename?: 'task_statuses_aggregate';
  aggregate?: Maybe<Task_Statuses_Aggregate_Fields>;
  nodes: Array<Task_Statuses>;
};

/** aggregate fields of "task_statuses" */
export type Task_Statuses_Aggregate_Fields = {
  __typename?: 'task_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Statuses_Max_Fields>;
  min?: Maybe<Task_Statuses_Min_Fields>;
};


/** aggregate fields of "task_statuses" */
export type Task_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "task_statuses". All fields are combined with a logical 'AND'. */
export type Task_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Task_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Statuses_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_statuses" */
export enum Task_Statuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  TaskStatusesPkey = 'task_statuses_pkey'
}

export enum Task_Statuses_Enum {
  Done = 'done',
  InProgress = 'in_progress',
  Todo = 'todo'
}

/** Boolean expression to compare columns of type "task_statuses_enum". All fields are combined with logical 'AND'. */
export type Task_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Task_Statuses_Enum>;
  _in?: InputMaybe<Array<Task_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Task_Statuses_Enum>;
  _nin?: InputMaybe<Array<Task_Statuses_Enum>>;
};

/** input type for inserting data into table "task_statuses" */
export type Task_Statuses_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Task_Statuses_Max_Fields = {
  __typename?: 'task_statuses_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Task_Statuses_Min_Fields = {
  __typename?: 'task_statuses_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "task_statuses" */
export type Task_Statuses_Mutation_Response = {
  __typename?: 'task_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Statuses>;
};

/** on_conflict condition type for table "task_statuses" */
export type Task_Statuses_On_Conflict = {
  constraint: Task_Statuses_Constraint;
  update_columns?: Array<Task_Statuses_Update_Column>;
  where?: InputMaybe<Task_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "task_statuses". */
export type Task_Statuses_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_statuses */
export type Task_Statuses_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "task_statuses" */
export enum Task_Statuses_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "task_statuses" */
export type Task_Statuses_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "task_statuses" */
export type Task_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Statuses_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "task_statuses" */
export enum Task_Statuses_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Task_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Statuses_Bool_Exp;
};

/** columns and relationships of "task_types" */
export type Task_Types = {
  __typename?: 'task_types';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "task_types" */
export type Task_Types_Aggregate = {
  __typename?: 'task_types_aggregate';
  aggregate?: Maybe<Task_Types_Aggregate_Fields>;
  nodes: Array<Task_Types>;
};

/** aggregate fields of "task_types" */
export type Task_Types_Aggregate_Fields = {
  __typename?: 'task_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Types_Max_Fields>;
  min?: Maybe<Task_Types_Min_Fields>;
};


/** aggregate fields of "task_types" */
export type Task_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "task_types". All fields are combined with a logical 'AND'. */
export type Task_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Types_Bool_Exp>>;
  _not?: InputMaybe<Task_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "task_types" */
export enum Task_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  TaskTypesPkey = 'task_types_pkey'
}

export enum Task_Types_Enum {
  CorrectiveAction = 'corrective_action',
  Documentation = 'documentation',
  Investigation = 'investigation'
}

/** Boolean expression to compare columns of type "task_types_enum". All fields are combined with logical 'AND'. */
export type Task_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Task_Types_Enum>;
  _in?: InputMaybe<Array<Task_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Task_Types_Enum>;
  _nin?: InputMaybe<Array<Task_Types_Enum>>;
};

/** input type for inserting data into table "task_types" */
export type Task_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Task_Types_Max_Fields = {
  __typename?: 'task_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Task_Types_Min_Fields = {
  __typename?: 'task_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "task_types" */
export type Task_Types_Mutation_Response = {
  __typename?: 'task_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_Types>;
};

/** on_conflict condition type for table "task_types" */
export type Task_Types_On_Conflict = {
  constraint: Task_Types_Constraint;
  update_columns?: Array<Task_Types_Update_Column>;
  where?: InputMaybe<Task_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "task_types". */
export type Task_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task_types */
export type Task_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "task_types" */
export enum Task_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "task_types" */
export type Task_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "task_types" */
export type Task_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "task_types" */
export enum Task_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Task_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Types_Bool_Exp;
};

/** columns and relationships of "tasks" */
export type Tasks = {
  __typename?: 'tasks';
  _created_at: Scalars['timestamptz']['output'];
  _created_by: Scalars['String']['output'];
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by: Scalars['String']['output'];
  assignee_id: Scalars['String']['output'];
  deadline: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  incident: Incidents;
  incident_id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Task_Statuses_Enum;
  type: Task_Types_Enum;
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "tasks" */
export type Tasks_Aggregate = {
  __typename?: 'tasks_aggregate';
  aggregate?: Maybe<Tasks_Aggregate_Fields>;
  nodes: Array<Tasks>;
};

export type Tasks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tasks_Aggregate_Bool_Exp_Count>;
};

export type Tasks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tasks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tasks" */
export type Tasks_Aggregate_Fields = {
  __typename?: 'tasks_aggregate_fields';
  avg?: Maybe<Tasks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tasks_Max_Fields>;
  min?: Maybe<Tasks_Min_Fields>;
  stddev?: Maybe<Tasks_Stddev_Fields>;
  stddev_pop?: Maybe<Tasks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tasks_Stddev_Samp_Fields>;
  sum?: Maybe<Tasks_Sum_Fields>;
  var_pop?: Maybe<Tasks_Var_Pop_Fields>;
  var_samp?: Maybe<Tasks_Var_Samp_Fields>;
  variance?: Maybe<Tasks_Variance_Fields>;
};


/** aggregate fields of "tasks" */
export type Tasks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tasks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tasks" */
export type Tasks_Aggregate_Order_By = {
  avg?: InputMaybe<Tasks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tasks_Max_Order_By>;
  min?: InputMaybe<Tasks_Min_Order_By>;
  stddev?: InputMaybe<Tasks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tasks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tasks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tasks_Sum_Order_By>;
  var_pop?: InputMaybe<Tasks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tasks_Var_Samp_Order_By>;
  variance?: InputMaybe<Tasks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tasks" */
export type Tasks_Arr_Rel_Insert_Input = {
  data: Array<Tasks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tasks_On_Conflict>;
};

/** aggregate avg on columns */
export type Tasks_Avg_Fields = {
  __typename?: 'tasks_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tasks" */
export type Tasks_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export type Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Tasks_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Tasks_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  assignee_id?: InputMaybe<String_Comparison_Exp>;
  deadline?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incident?: InputMaybe<Incidents_Bool_Exp>;
  incident_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Task_Statuses_Enum_Comparison_Exp>;
  type?: InputMaybe<Task_Types_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "tasks" */
export enum Tasks_Constraint {
  /** unique or primary key constraint on columns "id" */
  TasksPkey = 'tasks_pkey'
}

/** input type for incrementing numeric columns in table "tasks" */
export type Tasks_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tasks" */
export type Tasks_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident?: InputMaybe<Incidents_Obj_Rel_Insert_Input>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Task_Statuses_Enum>;
  type?: InputMaybe<Task_Types_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tasks_Max_Fields = {
  __typename?: 'tasks_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  assignee_id?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tasks" */
export type Tasks_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tasks_Min_Fields = {
  __typename?: 'tasks_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  assignee_id?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tasks" */
export type Tasks_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tasks" */
export type Tasks_Mutation_Response = {
  __typename?: 'tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tasks>;
};

/** on_conflict condition type for table "tasks" */
export type Tasks_On_Conflict = {
  constraint: Tasks_Constraint;
  update_columns?: Array<Tasks_Update_Column>;
  where?: InputMaybe<Tasks_Bool_Exp>;
};

/** Ordering options when selecting data from "tasks". */
export type Tasks_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  assignee_id?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incident?: InputMaybe<Incidents_Order_By>;
  incident_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: tasks */
export type Tasks_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "tasks" */
export enum Tasks_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AssigneeId = 'assignee_id',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "tasks" */
export type Tasks_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Task_Statuses_Enum>;
  type?: InputMaybe<Task_Types_Enum>;
};

/** aggregate stddev on columns */
export type Tasks_Stddev_Fields = {
  __typename?: 'tasks_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tasks" */
export type Tasks_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tasks_Stddev_Pop_Fields = {
  __typename?: 'tasks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tasks" */
export type Tasks_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tasks_Stddev_Samp_Fields = {
  __typename?: 'tasks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tasks" */
export type Tasks_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tasks" */
export type Tasks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tasks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tasks_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  incident_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Task_Statuses_Enum>;
  type?: InputMaybe<Task_Types_Enum>;
};

/** aggregate sum on columns */
export type Tasks_Sum_Fields = {
  __typename?: 'tasks_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  incident_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tasks" */
export type Tasks_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** update columns of table "tasks" */
export enum Tasks_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  AssigneeId = 'assignee_id',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IncidentId = 'incident_id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

export type Tasks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tasks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tasks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tasks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tasks_Var_Pop_Fields = {
  __typename?: 'tasks_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tasks" */
export type Tasks_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tasks_Var_Samp_Fields = {
  __typename?: 'tasks_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tasks" */
export type Tasks_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tasks_Variance_Fields = {
  __typename?: 'tasks_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  incident_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tasks" */
export type Tasks_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  incident_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "third_party.consumptions" */
export type Third_Party_Consumptions = {
  __typename?: 'third_party_consumptions';
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  end: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  meter?: Maybe<Third_Party_Third_Party_Meters>;
  power_kw: Scalars['numeric']['output'];
  source_id: Scalars['String']['output'];
  start: Scalars['timestamp']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Scalars['String']['output'];
};

/** aggregated selection of "third_party.consumptions" */
export type Third_Party_Consumptions_Aggregate = {
  __typename?: 'third_party_consumptions_aggregate';
  aggregate?: Maybe<Third_Party_Consumptions_Aggregate_Fields>;
  nodes: Array<Third_Party_Consumptions>;
};

/** aggregate fields of "third_party.consumptions" */
export type Third_Party_Consumptions_Aggregate_Fields = {
  __typename?: 'third_party_consumptions_aggregate_fields';
  avg?: Maybe<Third_Party_Consumptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Third_Party_Consumptions_Max_Fields>;
  min?: Maybe<Third_Party_Consumptions_Min_Fields>;
  stddev?: Maybe<Third_Party_Consumptions_Stddev_Fields>;
  stddev_pop?: Maybe<Third_Party_Consumptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Third_Party_Consumptions_Stddev_Samp_Fields>;
  sum?: Maybe<Third_Party_Consumptions_Sum_Fields>;
  var_pop?: Maybe<Third_Party_Consumptions_Var_Pop_Fields>;
  var_samp?: Maybe<Third_Party_Consumptions_Var_Samp_Fields>;
  variance?: Maybe<Third_Party_Consumptions_Variance_Fields>;
};


/** aggregate fields of "third_party.consumptions" */
export type Third_Party_Consumptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Third_Party_Consumptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Third_Party_Consumptions_Avg_Fields = {
  __typename?: 'third_party_consumptions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "third_party.consumptions". All fields are combined with a logical 'AND'. */
export type Third_Party_Consumptions_Bool_Exp = {
  _and?: InputMaybe<Array<Third_Party_Consumptions_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Consumptions_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Consumptions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
  power_kw?: InputMaybe<Numeric_Comparison_Exp>;
  source_id?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "third_party.consumptions" */
export type Third_Party_Consumptions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "third_party.consumptions" */
export type Third_Party_Consumptions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter?: InputMaybe<Third_Party_Third_Party_Meters_Obj_Rel_Insert_Input>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Third_Party_Consumptions_Max_Fields = {
  __typename?: 'third_party_consumptions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  power_kw?: Maybe<Scalars['numeric']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Third_Party_Consumptions_Min_Fields = {
  __typename?: 'third_party_consumptions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  power_kw?: Maybe<Scalars['numeric']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "third_party.consumptions" */
export type Third_Party_Consumptions_Mutation_Response = {
  __typename?: 'third_party_consumptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Third_Party_Consumptions>;
};

/** Ordering options when selecting data from "third_party.consumptions". */
export type Third_Party_Consumptions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter?: InputMaybe<Third_Party_Third_Party_Meters_Order_By>;
  power_kw?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "third_party.consumptions" */
export enum Third_Party_Consumptions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  PowerKw = 'power_kw',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Start = 'start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "third_party.consumptions" */
export type Third_Party_Consumptions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Third_Party_Consumptions_Stddev_Fields = {
  __typename?: 'third_party_consumptions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Third_Party_Consumptions_Stddev_Pop_Fields = {
  __typename?: 'third_party_consumptions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Third_Party_Consumptions_Stddev_Samp_Fields = {
  __typename?: 'third_party_consumptions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "third_party_consumptions" */
export type Third_Party_Consumptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Consumptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Consumptions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  power_kw?: InputMaybe<Scalars['numeric']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Third_Party_Consumptions_Sum_Fields = {
  __typename?: 'third_party_consumptions_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  power_kw?: Maybe<Scalars['numeric']['output']>;
};

export type Third_Party_Consumptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Third_Party_Consumptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Third_Party_Consumptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Third_Party_Consumptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Third_Party_Consumptions_Var_Pop_Fields = {
  __typename?: 'third_party_consumptions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Third_Party_Consumptions_Var_Samp_Fields = {
  __typename?: 'third_party_consumptions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Third_Party_Consumptions_Variance_Fields = {
  __typename?: 'third_party_consumptions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  power_kw?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "third_party.indexes" */
export type Third_Party_Indexes = {
  __typename?: 'third_party_indexes';
  index: Scalars['bigint']['output'];
  source_id: Scalars['String']['output'];
  timestamp: Scalars['timestamp']['output'];
};

/** aggregated selection of "third_party.indexes" */
export type Third_Party_Indexes_Aggregate = {
  __typename?: 'third_party_indexes_aggregate';
  aggregate?: Maybe<Third_Party_Indexes_Aggregate_Fields>;
  nodes: Array<Third_Party_Indexes>;
};

/** aggregate fields of "third_party.indexes" */
export type Third_Party_Indexes_Aggregate_Fields = {
  __typename?: 'third_party_indexes_aggregate_fields';
  avg?: Maybe<Third_Party_Indexes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Third_Party_Indexes_Max_Fields>;
  min?: Maybe<Third_Party_Indexes_Min_Fields>;
  stddev?: Maybe<Third_Party_Indexes_Stddev_Fields>;
  stddev_pop?: Maybe<Third_Party_Indexes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Third_Party_Indexes_Stddev_Samp_Fields>;
  sum?: Maybe<Third_Party_Indexes_Sum_Fields>;
  var_pop?: Maybe<Third_Party_Indexes_Var_Pop_Fields>;
  var_samp?: Maybe<Third_Party_Indexes_Var_Samp_Fields>;
  variance?: Maybe<Third_Party_Indexes_Variance_Fields>;
};


/** aggregate fields of "third_party.indexes" */
export type Third_Party_Indexes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Third_Party_Indexes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Third_Party_Indexes_Avg_Fields = {
  __typename?: 'third_party_indexes_avg_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "third_party.indexes". All fields are combined with a logical 'AND'. */
export type Third_Party_Indexes_Bool_Exp = {
  _and?: InputMaybe<Array<Third_Party_Indexes_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Indexes_Bool_Exp>>;
  index?: InputMaybe<Bigint_Comparison_Exp>;
  source_id?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "third_party.indexes" */
export enum Third_Party_Indexes_Constraint {
  /** unique or primary key constraint on columns "source_id" */
  IndexesPkey = 'indexes_pkey'
}

/** input type for incrementing numeric columns in table "third_party.indexes" */
export type Third_Party_Indexes_Inc_Input = {
  index?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "third_party.indexes" */
export type Third_Party_Indexes_Insert_Input = {
  index?: InputMaybe<Scalars['bigint']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Third_Party_Indexes_Max_Fields = {
  __typename?: 'third_party_indexes_max_fields';
  index?: Maybe<Scalars['bigint']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Third_Party_Indexes_Min_Fields = {
  __typename?: 'third_party_indexes_min_fields';
  index?: Maybe<Scalars['bigint']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "third_party.indexes" */
export type Third_Party_Indexes_Mutation_Response = {
  __typename?: 'third_party_indexes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Third_Party_Indexes>;
};

/** on_conflict condition type for table "third_party.indexes" */
export type Third_Party_Indexes_On_Conflict = {
  constraint: Third_Party_Indexes_Constraint;
  update_columns?: Array<Third_Party_Indexes_Update_Column>;
  where?: InputMaybe<Third_Party_Indexes_Bool_Exp>;
};

/** Ordering options when selecting data from "third_party.indexes". */
export type Third_Party_Indexes_Order_By = {
  index?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: third_party.indexes */
export type Third_Party_Indexes_Pk_Columns_Input = {
  source_id: Scalars['String']['input'];
};

/** select columns of table "third_party.indexes" */
export enum Third_Party_Indexes_Select_Column {
  /** column name */
  Index = 'index',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "third_party.indexes" */
export type Third_Party_Indexes_Set_Input = {
  index?: InputMaybe<Scalars['bigint']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Third_Party_Indexes_Stddev_Fields = {
  __typename?: 'third_party_indexes_stddev_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Third_Party_Indexes_Stddev_Pop_Fields = {
  __typename?: 'third_party_indexes_stddev_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Third_Party_Indexes_Stddev_Samp_Fields = {
  __typename?: 'third_party_indexes_stddev_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "third_party_indexes" */
export type Third_Party_Indexes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Indexes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Indexes_Stream_Cursor_Value_Input = {
  index?: InputMaybe<Scalars['bigint']['input']>;
  source_id?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Third_Party_Indexes_Sum_Fields = {
  __typename?: 'third_party_indexes_sum_fields';
  index?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "third_party.indexes" */
export enum Third_Party_Indexes_Update_Column {
  /** column name */
  Index = 'index',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Timestamp = 'timestamp'
}

export type Third_Party_Indexes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Third_Party_Indexes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Third_Party_Indexes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Third_Party_Indexes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Third_Party_Indexes_Var_Pop_Fields = {
  __typename?: 'third_party_indexes_var_pop_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Third_Party_Indexes_Var_Samp_Fields = {
  __typename?: 'third_party_indexes_var_samp_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Third_Party_Indexes_Variance_Fields = {
  __typename?: 'third_party_indexes_variance_fields';
  index?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "third_party.sftp_files" */
export type Third_Party_Sftp_Files = {
  __typename?: 'third_party_sftp_files';
  path: Scalars['String']['output'];
  processed_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "third_party.sftp_files" */
export type Third_Party_Sftp_Files_Aggregate = {
  __typename?: 'third_party_sftp_files_aggregate';
  aggregate?: Maybe<Third_Party_Sftp_Files_Aggregate_Fields>;
  nodes: Array<Third_Party_Sftp_Files>;
};

/** aggregate fields of "third_party.sftp_files" */
export type Third_Party_Sftp_Files_Aggregate_Fields = {
  __typename?: 'third_party_sftp_files_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Third_Party_Sftp_Files_Max_Fields>;
  min?: Maybe<Third_Party_Sftp_Files_Min_Fields>;
};


/** aggregate fields of "third_party.sftp_files" */
export type Third_Party_Sftp_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Third_Party_Sftp_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "third_party.sftp_files". All fields are combined with a logical 'AND'. */
export type Third_Party_Sftp_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Third_Party_Sftp_Files_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Sftp_Files_Bool_Exp>>;
  path?: InputMaybe<String_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "third_party.sftp_files" */
export enum Third_Party_Sftp_Files_Constraint {
  /** unique or primary key constraint on columns "path" */
  SftpFilesPkey = 'sftp_files_pkey'
}

/** input type for inserting data into table "third_party.sftp_files" */
export type Third_Party_Sftp_Files_Insert_Input = {
  path?: InputMaybe<Scalars['String']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Third_Party_Sftp_Files_Max_Fields = {
  __typename?: 'third_party_sftp_files_max_fields';
  path?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Third_Party_Sftp_Files_Min_Fields = {
  __typename?: 'third_party_sftp_files_min_fields';
  path?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "third_party.sftp_files" */
export type Third_Party_Sftp_Files_Mutation_Response = {
  __typename?: 'third_party_sftp_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Third_Party_Sftp_Files>;
};

/** on_conflict condition type for table "third_party.sftp_files" */
export type Third_Party_Sftp_Files_On_Conflict = {
  constraint: Third_Party_Sftp_Files_Constraint;
  update_columns?: Array<Third_Party_Sftp_Files_Update_Column>;
  where?: InputMaybe<Third_Party_Sftp_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "third_party.sftp_files". */
export type Third_Party_Sftp_Files_Order_By = {
  path?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: third_party.sftp_files */
export type Third_Party_Sftp_Files_Pk_Columns_Input = {
  path: Scalars['String']['input'];
};

/** select columns of table "third_party.sftp_files" */
export enum Third_Party_Sftp_Files_Select_Column {
  /** column name */
  Path = 'path',
  /** column name */
  ProcessedAt = 'processed_at'
}

/** input type for updating data in table "third_party.sftp_files" */
export type Third_Party_Sftp_Files_Set_Input = {
  path?: InputMaybe<Scalars['String']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "third_party_sftp_files" */
export type Third_Party_Sftp_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Sftp_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Sftp_Files_Stream_Cursor_Value_Input = {
  path?: InputMaybe<Scalars['String']['input']>;
  processed_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "third_party.sftp_files" */
export enum Third_Party_Sftp_Files_Update_Column {
  /** column name */
  Path = 'path',
  /** column name */
  ProcessedAt = 'processed_at'
}

export type Third_Party_Sftp_Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Third_Party_Sftp_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Third_Party_Sftp_Files_Bool_Exp;
};

/** columns and relationships of "third_party.third_party_meters" */
export type Third_Party_Third_Party_Meters = {
  __typename?: 'third_party_third_party_meters';
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "third_party.third_party_meters" */
export type Third_Party_Third_Party_Meters_Aggregate = {
  __typename?: 'third_party_third_party_meters_aggregate';
  aggregate?: Maybe<Third_Party_Third_Party_Meters_Aggregate_Fields>;
  nodes: Array<Third_Party_Third_Party_Meters>;
};

/** aggregate fields of "third_party.third_party_meters" */
export type Third_Party_Third_Party_Meters_Aggregate_Fields = {
  __typename?: 'third_party_third_party_meters_aggregate_fields';
  avg?: Maybe<Third_Party_Third_Party_Meters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Third_Party_Third_Party_Meters_Max_Fields>;
  min?: Maybe<Third_Party_Third_Party_Meters_Min_Fields>;
  stddev?: Maybe<Third_Party_Third_Party_Meters_Stddev_Fields>;
  stddev_pop?: Maybe<Third_Party_Third_Party_Meters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Third_Party_Third_Party_Meters_Stddev_Samp_Fields>;
  sum?: Maybe<Third_Party_Third_Party_Meters_Sum_Fields>;
  var_pop?: Maybe<Third_Party_Third_Party_Meters_Var_Pop_Fields>;
  var_samp?: Maybe<Third_Party_Third_Party_Meters_Var_Samp_Fields>;
  variance?: Maybe<Third_Party_Third_Party_Meters_Variance_Fields>;
};


/** aggregate fields of "third_party.third_party_meters" */
export type Third_Party_Third_Party_Meters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Third_Party_Third_Party_Meters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Third_Party_Third_Party_Meters_Avg_Fields = {
  __typename?: 'third_party_third_party_meters_avg_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "third_party.third_party_meters". All fields are combined with a logical 'AND'. */
export type Third_Party_Third_Party_Meters_Bool_Exp = {
  _and?: InputMaybe<Array<Third_Party_Third_Party_Meters_Bool_Exp>>;
  _not?: InputMaybe<Third_Party_Third_Party_Meters_Bool_Exp>;
  _or?: InputMaybe<Array<Third_Party_Third_Party_Meters_Bool_Exp>>;
  area?: InputMaybe<Areas_Bool_Exp>;
  area_id?: InputMaybe<Int_Comparison_Exp>;
  data_source_id?: InputMaybe<String_Comparison_Exp>;
  firebase_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meter_type_id?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for inserting data into table "third_party.third_party_meters" */
export type Third_Party_Third_Party_Meters_Insert_Input = {
  area?: InputMaybe<Areas_Obj_Rel_Insert_Input>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Third_Party_Third_Party_Meters_Max_Fields = {
  __typename?: 'third_party_third_party_meters_max_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Third_Party_Third_Party_Meters_Min_Fields = {
  __typename?: 'third_party_third_party_meters_min_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  data_source_id?: Maybe<Scalars['String']['output']>;
  firebase_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** input type for inserting object relation for remote table "third_party.third_party_meters" */
export type Third_Party_Third_Party_Meters_Obj_Rel_Insert_Input = {
  data: Third_Party_Third_Party_Meters_Insert_Input;
};

/** Ordering options when selecting data from "third_party.third_party_meters". */
export type Third_Party_Third_Party_Meters_Order_By = {
  area?: InputMaybe<Areas_Order_By>;
  area_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  firebase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meter_type_id?: InputMaybe<Order_By>;
};

/** select columns of table "third_party.third_party_meters" */
export enum Third_Party_Third_Party_Meters_Select_Column {
  /** column name */
  AreaId = 'area_id',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  FirebaseId = 'firebase_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeterTypeId = 'meter_type_id'
}

/** aggregate stddev on columns */
export type Third_Party_Third_Party_Meters_Stddev_Fields = {
  __typename?: 'third_party_third_party_meters_stddev_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Third_Party_Third_Party_Meters_Stddev_Pop_Fields = {
  __typename?: 'third_party_third_party_meters_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Third_Party_Third_Party_Meters_Stddev_Samp_Fields = {
  __typename?: 'third_party_third_party_meters_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "third_party_third_party_meters" */
export type Third_Party_Third_Party_Meters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Third_Party_Third_Party_Meters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Third_Party_Third_Party_Meters_Stream_Cursor_Value_Input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  data_source_id?: InputMaybe<Scalars['String']['input']>;
  firebase_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meter_type_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Third_Party_Third_Party_Meters_Sum_Fields = {
  __typename?: 'third_party_third_party_meters_sum_fields';
  area_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  meter_type_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Third_Party_Third_Party_Meters_Var_Pop_Fields = {
  __typename?: 'third_party_third_party_meters_var_pop_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Third_Party_Third_Party_Meters_Var_Samp_Fields = {
  __typename?: 'third_party_third_party_meters_var_samp_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Third_Party_Third_Party_Meters_Variance_Fields = {
  __typename?: 'third_party_third_party_meters_variance_fields';
  area_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  meter_type_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['time']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['time']['input']>>;
  _eq?: InputMaybe<Array<Scalars['time']['input']>>;
  _gt?: InputMaybe<Array<Scalars['time']['input']>>;
  _gte?: InputMaybe<Array<Scalars['time']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['time']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['time']['input']>>;
  _lte?: InputMaybe<Array<Scalars['time']['input']>>;
  _neq?: InputMaybe<Array<Scalars['time']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['time']['input']>>>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "unit_types" */
export type Unit_Types = {
  __typename?: 'unit_types';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "unit_types" */
export type Unit_Types_Aggregate = {
  __typename?: 'unit_types_aggregate';
  aggregate?: Maybe<Unit_Types_Aggregate_Fields>;
  nodes: Array<Unit_Types>;
};

/** aggregate fields of "unit_types" */
export type Unit_Types_Aggregate_Fields = {
  __typename?: 'unit_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Unit_Types_Max_Fields>;
  min?: Maybe<Unit_Types_Min_Fields>;
};


/** aggregate fields of "unit_types" */
export type Unit_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "unit_types". All fields are combined with a logical 'AND'. */
export type Unit_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Types_Bool_Exp>>;
  _not?: InputMaybe<Unit_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit_types" */
export enum Unit_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  UnitTypesPkey = 'unit_types_pkey'
}

export enum Unit_Types_Enum {
  EnergyCost = 'energy_cost',
  Prod = 'prod'
}

/** Boolean expression to compare columns of type "unit_types_enum". All fields are combined with logical 'AND'. */
export type Unit_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Unit_Types_Enum>;
  _in?: InputMaybe<Array<Unit_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Unit_Types_Enum>;
  _nin?: InputMaybe<Array<Unit_Types_Enum>>;
};

/** input type for inserting data into table "unit_types" */
export type Unit_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Unit_Types_Max_Fields = {
  __typename?: 'unit_types_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Unit_Types_Min_Fields = {
  __typename?: 'unit_types_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "unit_types" */
export type Unit_Types_Mutation_Response = {
  __typename?: 'unit_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit_Types>;
};

/** on_conflict condition type for table "unit_types" */
export type Unit_Types_On_Conflict = {
  constraint: Unit_Types_Constraint;
  update_columns?: Array<Unit_Types_Update_Column>;
  where?: InputMaybe<Unit_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "unit_types". */
export type Unit_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit_types */
export type Unit_Types_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "unit_types" */
export enum Unit_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "unit_types" */
export type Unit_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "unit_types" */
export type Unit_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "unit_types" */
export enum Unit_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Unit_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Types_Bool_Exp;
};

/** columns and relationships of "units" */
export type Units = {
  __typename?: 'units';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  type: Unit_Types_Enum;
};

/** aggregated selection of "units" */
export type Units_Aggregate = {
  __typename?: 'units_aggregate';
  aggregate?: Maybe<Units_Aggregate_Fields>;
  nodes: Array<Units>;
};

/** aggregate fields of "units" */
export type Units_Aggregate_Fields = {
  __typename?: 'units_aggregate_fields';
  avg?: Maybe<Units_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Units_Max_Fields>;
  min?: Maybe<Units_Min_Fields>;
  stddev?: Maybe<Units_Stddev_Fields>;
  stddev_pop?: Maybe<Units_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Units_Stddev_Samp_Fields>;
  sum?: Maybe<Units_Sum_Fields>;
  var_pop?: Maybe<Units_Var_Pop_Fields>;
  var_samp?: Maybe<Units_Var_Samp_Fields>;
  variance?: Maybe<Units_Variance_Fields>;
};


/** aggregate fields of "units" */
export type Units_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Units_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Units_Avg_Fields = {
  __typename?: 'units_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "units". All fields are combined with a logical 'AND'. */
export type Units_Bool_Exp = {
  _and?: InputMaybe<Array<Units_Bool_Exp>>;
  _not?: InputMaybe<Units_Bool_Exp>;
  _or?: InputMaybe<Array<Units_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  symbol?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Unit_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "units" */
export enum Units_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnitsPkey = 'units_pkey'
}

/** input type for incrementing numeric columns in table "units" */
export type Units_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "units" */
export type Units_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Unit_Types_Enum>;
};

/** aggregate max on columns */
export type Units_Max_Fields = {
  __typename?: 'units_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Units_Min_Fields = {
  __typename?: 'units_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "units" */
export type Units_Mutation_Response = {
  __typename?: 'units_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Units>;
};

/** input type for inserting object relation for remote table "units" */
export type Units_Obj_Rel_Insert_Input = {
  data: Units_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Units_On_Conflict>;
};

/** on_conflict condition type for table "units" */
export type Units_On_Conflict = {
  constraint: Units_Constraint;
  update_columns?: Array<Units_Update_Column>;
  where?: InputMaybe<Units_Bool_Exp>;
};

/** Ordering options when selecting data from "units". */
export type Units_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  symbol?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: units */
export type Units_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "units" */
export enum Units_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Symbol = 'symbol',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "units" */
export type Units_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Unit_Types_Enum>;
};

/** aggregate stddev on columns */
export type Units_Stddev_Fields = {
  __typename?: 'units_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Units_Stddev_Pop_Fields = {
  __typename?: 'units_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Units_Stddev_Samp_Fields = {
  __typename?: 'units_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "units" */
export type Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Units_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Unit_Types_Enum>;
};

/** aggregate sum on columns */
export type Units_Sum_Fields = {
  __typename?: 'units_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "units" */
export enum Units_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Symbol = 'symbol',
  /** column name */
  Type = 'type'
}

export type Units_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Units_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Units_Set_Input>;
  /** filter the rows which have to be updated */
  where: Units_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Units_Var_Pop_Fields = {
  __typename?: 'units_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Units_Var_Samp_Fields = {
  __typename?: 'units_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Units_Variance_Fields = {
  __typename?: 'units_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Upsert_Epi_In_Table_Args = {
  fabrication_order_id?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  _created_at: Scalars['timestamptz']['output'];
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at: Scalars['timestamptz']['output'];
  _updated_by?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  alert_users: Array<Alert_User>;
  /** An aggregate relationship */
  alert_users_aggregate: Alert_User_Aggregate;
  /** An object relationship */
  client: Clients;
  client_id: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  picture_url?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  weekly_reporting: Scalars['Boolean']['output'];
};


/** columns and relationships of "users" */
export type UsersAlert_UsersArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAlert_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Alert_User_Order_By>>;
  where?: InputMaybe<Alert_User_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _created_by?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  _updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  _updated_by?: InputMaybe<String_Comparison_Exp>;
  alert_users?: InputMaybe<Alert_User_Bool_Exp>;
  alert_users_aggregate?: InputMaybe<Alert_User_Aggregate_Bool_Exp>;
  client?: InputMaybe<Clients_Bool_Exp>;
  client_id?: InputMaybe<Int_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  picture_url?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  weekly_reporting?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  client_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  alert_users?: InputMaybe<Alert_User_Arr_Rel_Insert_Input>;
  client?: InputMaybe<Clients_Obj_Rel_Insert_Input>;
  client_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  weekly_reporting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  picture_url?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  _created_at?: Maybe<Scalars['timestamptz']['output']>;
  _created_by?: Maybe<Scalars['String']['output']>;
  _updated_at?: Maybe<Scalars['timestamptz']['output']>;
  _updated_by?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  picture_url?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  _created_at?: InputMaybe<Order_By>;
  _created_by?: InputMaybe<Order_By>;
  _updated_at?: InputMaybe<Order_By>;
  _updated_by?: InputMaybe<Order_By>;
  alert_users_aggregate?: InputMaybe<Alert_User_Aggregate_Order_By>;
  client?: InputMaybe<Clients_Order_By>;
  client_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  picture_url?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  weekly_reporting?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PictureUrl = 'picture_url',
  /** column name */
  Role = 'role',
  /** column name */
  WeeklyReporting = 'weekly_reporting'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  WeeklyReporting = 'weekly_reporting'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  WeeklyReporting = 'weekly_reporting'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  weekly_reporting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  _created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _created_by?: InputMaybe<Scalars['String']['input']>;
  _updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  _updated_by?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  weekly_reporting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  client_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = '_created_at',
  /** column name */
  CreatedBy = '_created_by',
  /** column name */
  UpdatedAt = '_updated_at',
  /** column name */
  UpdatedBy = '_updated_by',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PictureUrl = 'picture_url',
  /** column name */
  Role = 'role',
  /** column name */
  WeeklyReporting = 'weekly_reporting'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  client_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  client_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "weather.daily_measures" */
export type Weather_Daily_Measures = {
  __typename?: 'weather_daily_measures';
  date: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  /** An object relationship */
  station: Weather_Stations;
  station_id: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "weather.daily_measures" */
export type Weather_Daily_Measures_Aggregate = {
  __typename?: 'weather_daily_measures_aggregate';
  aggregate?: Maybe<Weather_Daily_Measures_Aggregate_Fields>;
  nodes: Array<Weather_Daily_Measures>;
};

/** aggregate fields of "weather.daily_measures" */
export type Weather_Daily_Measures_Aggregate_Fields = {
  __typename?: 'weather_daily_measures_aggregate_fields';
  avg?: Maybe<Weather_Daily_Measures_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Weather_Daily_Measures_Max_Fields>;
  min?: Maybe<Weather_Daily_Measures_Min_Fields>;
  stddev?: Maybe<Weather_Daily_Measures_Stddev_Fields>;
  stddev_pop?: Maybe<Weather_Daily_Measures_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weather_Daily_Measures_Stddev_Samp_Fields>;
  sum?: Maybe<Weather_Daily_Measures_Sum_Fields>;
  var_pop?: Maybe<Weather_Daily_Measures_Var_Pop_Fields>;
  var_samp?: Maybe<Weather_Daily_Measures_Var_Samp_Fields>;
  variance?: Maybe<Weather_Daily_Measures_Variance_Fields>;
};


/** aggregate fields of "weather.daily_measures" */
export type Weather_Daily_Measures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Daily_Measures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Weather_Daily_Measures_Avg_Fields = {
  __typename?: 'weather_daily_measures_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "weather.daily_measures". All fields are combined with a logical 'AND'. */
export type Weather_Daily_Measures_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Daily_Measures_Bool_Exp>>;
  _not?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Daily_Measures_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  station?: InputMaybe<Weather_Stations_Bool_Exp>;
  station_id?: InputMaybe<Int_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather.daily_measures" */
export enum Weather_Daily_Measures_Constraint {
  /** unique or primary key constraint on columns "key", "id", "date" */
  DailyMeasuresPkey = 'daily_measures_pkey',
  /** unique or primary key constraint on columns "key", "station_id", "date" */
  DailyMeasuresStationIdDateKeyKey = 'daily_measures_station_id_date_key_key'
}

/** input type for incrementing numeric columns in table "weather.daily_measures" */
export type Weather_Daily_Measures_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "weather.daily_measures" */
export type Weather_Daily_Measures_Insert_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  station?: InputMaybe<Weather_Stations_Obj_Rel_Insert_Input>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Weather_Daily_Measures_Max_Fields = {
  __typename?: 'weather_daily_measures_max_fields';
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  station_id?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Weather_Daily_Measures_Min_Fields = {
  __typename?: 'weather_daily_measures_min_fields';
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  station_id?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "weather.daily_measures" */
export type Weather_Daily_Measures_Mutation_Response = {
  __typename?: 'weather_daily_measures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Daily_Measures>;
};

/** on_conflict condition type for table "weather.daily_measures" */
export type Weather_Daily_Measures_On_Conflict = {
  constraint: Weather_Daily_Measures_Constraint;
  update_columns?: Array<Weather_Daily_Measures_Update_Column>;
  where?: InputMaybe<Weather_Daily_Measures_Bool_Exp>;
};

/** Ordering options when selecting data from "weather.daily_measures". */
export type Weather_Daily_Measures_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  station?: InputMaybe<Weather_Stations_Order_By>;
  station_id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather.daily_measures */
export type Weather_Daily_Measures_Pk_Columns_Input = {
  date: Scalars['date']['input'];
  id: Scalars['Int']['input'];
  key: Scalars['String']['input'];
};

/** select columns of table "weather.daily_measures" */
export enum Weather_Daily_Measures_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  StationId = 'station_id',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "weather.daily_measures" */
export type Weather_Daily_Measures_Set_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Weather_Daily_Measures_Stddev_Fields = {
  __typename?: 'weather_daily_measures_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Weather_Daily_Measures_Stddev_Pop_Fields = {
  __typename?: 'weather_daily_measures_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Weather_Daily_Measures_Stddev_Samp_Fields = {
  __typename?: 'weather_daily_measures_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "weather_daily_measures" */
export type Weather_Daily_Measures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Daily_Measures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Daily_Measures_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Weather_Daily_Measures_Sum_Fields = {
  __typename?: 'weather_daily_measures_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  station_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "weather.daily_measures" */
export enum Weather_Daily_Measures_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  StationId = 'station_id',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

export type Weather_Daily_Measures_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weather_Daily_Measures_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Daily_Measures_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weather_Daily_Measures_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Weather_Daily_Measures_Var_Pop_Fields = {
  __typename?: 'weather_daily_measures_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Weather_Daily_Measures_Var_Samp_Fields = {
  __typename?: 'weather_daily_measures_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Weather_Daily_Measures_Variance_Fields = {
  __typename?: 'weather_daily_measures_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "weather.measures" */
export type Weather_Measures = {
  __typename?: 'weather_measures';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  /** An object relationship */
  station: Weather_Stations;
  station_id: Scalars['Int']['output'];
  timestamp: Scalars['timestamp']['output'];
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "weather.measures" */
export type Weather_Measures_Aggregate = {
  __typename?: 'weather_measures_aggregate';
  aggregate?: Maybe<Weather_Measures_Aggregate_Fields>;
  nodes: Array<Weather_Measures>;
};

export type Weather_Measures_Aggregate_Bool_Exp = {
  count?: InputMaybe<Weather_Measures_Aggregate_Bool_Exp_Count>;
};

export type Weather_Measures_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Weather_Measures_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "weather.measures" */
export type Weather_Measures_Aggregate_Fields = {
  __typename?: 'weather_measures_aggregate_fields';
  avg?: Maybe<Weather_Measures_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Weather_Measures_Max_Fields>;
  min?: Maybe<Weather_Measures_Min_Fields>;
  stddev?: Maybe<Weather_Measures_Stddev_Fields>;
  stddev_pop?: Maybe<Weather_Measures_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weather_Measures_Stddev_Samp_Fields>;
  sum?: Maybe<Weather_Measures_Sum_Fields>;
  var_pop?: Maybe<Weather_Measures_Var_Pop_Fields>;
  var_samp?: Maybe<Weather_Measures_Var_Samp_Fields>;
  variance?: Maybe<Weather_Measures_Variance_Fields>;
};


/** aggregate fields of "weather.measures" */
export type Weather_Measures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "weather.measures" */
export type Weather_Measures_Aggregate_Order_By = {
  avg?: InputMaybe<Weather_Measures_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Weather_Measures_Max_Order_By>;
  min?: InputMaybe<Weather_Measures_Min_Order_By>;
  stddev?: InputMaybe<Weather_Measures_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Weather_Measures_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Weather_Measures_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Weather_Measures_Sum_Order_By>;
  var_pop?: InputMaybe<Weather_Measures_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Weather_Measures_Var_Samp_Order_By>;
  variance?: InputMaybe<Weather_Measures_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "weather.measures" */
export type Weather_Measures_Arr_Rel_Insert_Input = {
  data: Array<Weather_Measures_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Weather_Measures_On_Conflict>;
};

/** aggregate avg on columns */
export type Weather_Measures_Avg_Fields = {
  __typename?: 'weather_measures_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "weather.measures" */
export type Weather_Measures_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "weather.measures". All fields are combined with a logical 'AND'. */
export type Weather_Measures_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Measures_Bool_Exp>>;
  _not?: InputMaybe<Weather_Measures_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Measures_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  station?: InputMaybe<Weather_Stations_Bool_Exp>;
  station_id?: InputMaybe<Int_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather.measures" */
export enum Weather_Measures_Constraint {
  /** unique or primary key constraint on columns "id", "timestamp" */
  MeasuresPkey = 'measures_pkey',
  /** unique or primary key constraint on columns "key", "station_id", "timestamp" */
  MeasuresStationIdTimestampKeyKey = 'measures_station_id_timestamp_key_key'
}

/** input type for incrementing numeric columns in table "weather.measures" */
export type Weather_Measures_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "weather.measures" */
export type Weather_Measures_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  station?: InputMaybe<Weather_Stations_Obj_Rel_Insert_Input>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Weather_Measures_Max_Fields = {
  __typename?: 'weather_measures_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  station_id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "weather.measures" */
export type Weather_Measures_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Weather_Measures_Min_Fields = {
  __typename?: 'weather_measures_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  station_id?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "weather.measures" */
export type Weather_Measures_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "weather.measures" */
export type Weather_Measures_Mutation_Response = {
  __typename?: 'weather_measures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Measures>;
};

/** on_conflict condition type for table "weather.measures" */
export type Weather_Measures_On_Conflict = {
  constraint: Weather_Measures_Constraint;
  update_columns?: Array<Weather_Measures_Update_Column>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};

/** Ordering options when selecting data from "weather.measures". */
export type Weather_Measures_Order_By = {
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  station?: InputMaybe<Weather_Stations_Order_By>;
  station_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather.measures */
export type Weather_Measures_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
  timestamp: Scalars['timestamp']['input'];
};

/** select columns of table "weather.measures" */
export enum Weather_Measures_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  StationId = 'station_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "weather.measures" */
export type Weather_Measures_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Weather_Measures_Stddev_Fields = {
  __typename?: 'weather_measures_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "weather.measures" */
export type Weather_Measures_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Weather_Measures_Stddev_Pop_Fields = {
  __typename?: 'weather_measures_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "weather.measures" */
export type Weather_Measures_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Weather_Measures_Stddev_Samp_Fields = {
  __typename?: 'weather_measures_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "weather.measures" */
export type Weather_Measures_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "weather_measures" */
export type Weather_Measures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Measures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Measures_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  station_id?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Weather_Measures_Sum_Fields = {
  __typename?: 'weather_measures_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  station_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "weather.measures" */
export type Weather_Measures_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "weather.measures" */
export enum Weather_Measures_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  StationId = 'station_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

export type Weather_Measures_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weather_Measures_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Measures_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weather_Measures_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Weather_Measures_Var_Pop_Fields = {
  __typename?: 'weather_measures_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "weather.measures" */
export type Weather_Measures_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Weather_Measures_Var_Samp_Fields = {
  __typename?: 'weather_measures_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "weather.measures" */
export type Weather_Measures_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Weather_Measures_Variance_Fields = {
  __typename?: 'weather_measures_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  station_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "weather.measures" */
export type Weather_Measures_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  station_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "weather.providers" */
export type Weather_Providers = {
  __typename?: 'weather_providers';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  stations: Array<Weather_Stations>;
  /** An aggregate relationship */
  stations_aggregate: Weather_Stations_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "weather.providers" */
export type Weather_ProvidersStationsArgs = {
  distinct_on?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Stations_Order_By>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};


/** columns and relationships of "weather.providers" */
export type Weather_ProvidersStations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Stations_Order_By>>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};

/** aggregated selection of "weather.providers" */
export type Weather_Providers_Aggregate = {
  __typename?: 'weather_providers_aggregate';
  aggregate?: Maybe<Weather_Providers_Aggregate_Fields>;
  nodes: Array<Weather_Providers>;
};

/** aggregate fields of "weather.providers" */
export type Weather_Providers_Aggregate_Fields = {
  __typename?: 'weather_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Weather_Providers_Max_Fields>;
  min?: Maybe<Weather_Providers_Min_Fields>;
};


/** aggregate fields of "weather.providers" */
export type Weather_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "weather.providers". All fields are combined with a logical 'AND'. */
export type Weather_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Providers_Bool_Exp>>;
  _not?: InputMaybe<Weather_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Providers_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  stations?: InputMaybe<Weather_Stations_Bool_Exp>;
  stations_aggregate?: InputMaybe<Weather_Stations_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather.providers" */
export enum Weather_Providers_Constraint {
  /** unique or primary key constraint on columns "value" */
  ProvidersPkey = 'providers_pkey'
}

export enum Weather_Providers_Enum {
  MeteoFrance = 'meteo_france'
}

/** Boolean expression to compare columns of type "weather_providers_enum". All fields are combined with logical 'AND'. */
export type Weather_Providers_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Weather_Providers_Enum>;
  _in?: InputMaybe<Array<Weather_Providers_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Weather_Providers_Enum>;
  _nin?: InputMaybe<Array<Weather_Providers_Enum>>;
};

/** input type for inserting data into table "weather.providers" */
export type Weather_Providers_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  stations?: InputMaybe<Weather_Stations_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Weather_Providers_Max_Fields = {
  __typename?: 'weather_providers_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Weather_Providers_Min_Fields = {
  __typename?: 'weather_providers_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "weather.providers" */
export type Weather_Providers_Mutation_Response = {
  __typename?: 'weather_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Providers>;
};

/** on_conflict condition type for table "weather.providers" */
export type Weather_Providers_On_Conflict = {
  constraint: Weather_Providers_Constraint;
  update_columns?: Array<Weather_Providers_Update_Column>;
  where?: InputMaybe<Weather_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "weather.providers". */
export type Weather_Providers_Order_By = {
  description?: InputMaybe<Order_By>;
  stations_aggregate?: InputMaybe<Weather_Stations_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather.providers */
export type Weather_Providers_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "weather.providers" */
export enum Weather_Providers_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "weather.providers" */
export type Weather_Providers_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "weather_providers" */
export type Weather_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Providers_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "weather.providers" */
export enum Weather_Providers_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

export type Weather_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weather_Providers_Bool_Exp;
};

/** list all weather stations */
export type Weather_Stations = {
  __typename?: 'weather_stations';
  altitude: Scalars['numeric']['output'];
  id: Scalars['Int']['output'];
  last_daily_measure?: Maybe<Scalars['date']['output']>;
  last_measure?: Maybe<Scalars['timestamp']['output']>;
  lat: Scalars['numeric']['output'];
  long: Scalars['numeric']['output'];
  /** An array relationship */
  measures: Array<Weather_Measures>;
  /** An aggregate relationship */
  measures_aggregate: Weather_Measures_Aggregate;
  name: Scalars['String']['output'];
  provider: Weather_Providers_Enum;
  provider_station_id: Scalars['String']['output'];
  /** An array relationship */
  sites: Array<Sites>;
  /** An aggregate relationship */
  sites_aggregate: Sites_Aggregate;
  timezone: Scalars['String']['output'];
};


/** list all weather stations */
export type Weather_StationsMeasuresArgs = {
  distinct_on?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Measures_Order_By>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


/** list all weather stations */
export type Weather_StationsMeasures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Measures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weather_Measures_Order_By>>;
  where?: InputMaybe<Weather_Measures_Bool_Exp>;
};


/** list all weather stations */
export type Weather_StationsSitesArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};


/** list all weather stations */
export type Weather_StationsSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sites_Order_By>>;
  where?: InputMaybe<Sites_Bool_Exp>;
};

/** aggregated selection of "weather.stations" */
export type Weather_Stations_Aggregate = {
  __typename?: 'weather_stations_aggregate';
  aggregate?: Maybe<Weather_Stations_Aggregate_Fields>;
  nodes: Array<Weather_Stations>;
};

export type Weather_Stations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Weather_Stations_Aggregate_Bool_Exp_Count>;
};

export type Weather_Stations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Weather_Stations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "weather.stations" */
export type Weather_Stations_Aggregate_Fields = {
  __typename?: 'weather_stations_aggregate_fields';
  avg?: Maybe<Weather_Stations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Weather_Stations_Max_Fields>;
  min?: Maybe<Weather_Stations_Min_Fields>;
  stddev?: Maybe<Weather_Stations_Stddev_Fields>;
  stddev_pop?: Maybe<Weather_Stations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weather_Stations_Stddev_Samp_Fields>;
  sum?: Maybe<Weather_Stations_Sum_Fields>;
  var_pop?: Maybe<Weather_Stations_Var_Pop_Fields>;
  var_samp?: Maybe<Weather_Stations_Var_Samp_Fields>;
  variance?: Maybe<Weather_Stations_Variance_Fields>;
};


/** aggregate fields of "weather.stations" */
export type Weather_Stations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Stations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "weather.stations" */
export type Weather_Stations_Aggregate_Order_By = {
  avg?: InputMaybe<Weather_Stations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Weather_Stations_Max_Order_By>;
  min?: InputMaybe<Weather_Stations_Min_Order_By>;
  stddev?: InputMaybe<Weather_Stations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Weather_Stations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Weather_Stations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Weather_Stations_Sum_Order_By>;
  var_pop?: InputMaybe<Weather_Stations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Weather_Stations_Var_Samp_Order_By>;
  variance?: InputMaybe<Weather_Stations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "weather.stations" */
export type Weather_Stations_Arr_Rel_Insert_Input = {
  data: Array<Weather_Stations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Weather_Stations_On_Conflict>;
};

/** aggregate avg on columns */
export type Weather_Stations_Avg_Fields = {
  __typename?: 'weather_stations_avg_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "weather.stations" */
export type Weather_Stations_Avg_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "weather.stations". All fields are combined with a logical 'AND'. */
export type Weather_Stations_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Stations_Bool_Exp>>;
  _not?: InputMaybe<Weather_Stations_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Stations_Bool_Exp>>;
  altitude?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_daily_measure?: InputMaybe<Date_Comparison_Exp>;
  last_measure?: InputMaybe<Timestamp_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  long?: InputMaybe<Numeric_Comparison_Exp>;
  measures?: InputMaybe<Weather_Measures_Bool_Exp>;
  measures_aggregate?: InputMaybe<Weather_Measures_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Weather_Providers_Enum_Comparison_Exp>;
  provider_station_id?: InputMaybe<String_Comparison_Exp>;
  sites?: InputMaybe<Sites_Bool_Exp>;
  sites_aggregate?: InputMaybe<Sites_Aggregate_Bool_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather.stations" */
export enum Weather_Stations_Constraint {
  /** unique or primary key constraint on columns "id" */
  StationsPkey = 'stations_pkey',
  /** unique or primary key constraint on columns "provider", "provider_station_id" */
  StationsProviderProviderStationIdKey = 'stations_provider_provider_station_id_key'
}

/** input type for incrementing numeric columns in table "weather.stations" */
export type Weather_Stations_Inc_Input = {
  altitude?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "weather.stations" */
export type Weather_Stations_Insert_Input = {
  altitude?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_daily_measure?: InputMaybe<Scalars['date']['input']>;
  last_measure?: InputMaybe<Scalars['timestamp']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  measures?: InputMaybe<Weather_Measures_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Weather_Providers_Enum>;
  provider_station_id?: InputMaybe<Scalars['String']['input']>;
  sites?: InputMaybe<Sites_Arr_Rel_Insert_Input>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Weather_Stations_Max_Fields = {
  __typename?: 'weather_stations_max_fields';
  altitude?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_daily_measure?: Maybe<Scalars['date']['output']>;
  last_measure?: Maybe<Scalars['timestamp']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider_station_id?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "weather.stations" */
export type Weather_Stations_Max_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_daily_measure?: InputMaybe<Order_By>;
  last_measure?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider_station_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Weather_Stations_Min_Fields = {
  __typename?: 'weather_stations_min_fields';
  altitude?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_daily_measure?: Maybe<Scalars['date']['output']>;
  last_measure?: Maybe<Scalars['timestamp']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider_station_id?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "weather.stations" */
export type Weather_Stations_Min_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_daily_measure?: InputMaybe<Order_By>;
  last_measure?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  provider_station_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "weather.stations" */
export type Weather_Stations_Mutation_Response = {
  __typename?: 'weather_stations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Stations>;
};

/** input type for inserting object relation for remote table "weather.stations" */
export type Weather_Stations_Obj_Rel_Insert_Input = {
  data: Weather_Stations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Weather_Stations_On_Conflict>;
};

/** on_conflict condition type for table "weather.stations" */
export type Weather_Stations_On_Conflict = {
  constraint: Weather_Stations_Constraint;
  update_columns?: Array<Weather_Stations_Update_Column>;
  where?: InputMaybe<Weather_Stations_Bool_Exp>;
};

/** Ordering options when selecting data from "weather.stations". */
export type Weather_Stations_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_daily_measure?: InputMaybe<Order_By>;
  last_measure?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
  measures_aggregate?: InputMaybe<Weather_Measures_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_station_id?: InputMaybe<Order_By>;
  sites_aggregate?: InputMaybe<Sites_Aggregate_Order_By>;
  timezone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather.stations */
export type Weather_Stations_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "weather.stations" */
export enum Weather_Stations_Select_Column {
  /** column name */
  Altitude = 'altitude',
  /** column name */
  Id = 'id',
  /** column name */
  LastDailyMeasure = 'last_daily_measure',
  /** column name */
  LastMeasure = 'last_measure',
  /** column name */
  Lat = 'lat',
  /** column name */
  Long = 'long',
  /** column name */
  Name = 'name',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderStationId = 'provider_station_id',
  /** column name */
  Timezone = 'timezone'
}

/** input type for updating data in table "weather.stations" */
export type Weather_Stations_Set_Input = {
  altitude?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_daily_measure?: InputMaybe<Scalars['date']['input']>;
  last_measure?: InputMaybe<Scalars['timestamp']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Weather_Providers_Enum>;
  provider_station_id?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Weather_Stations_Stddev_Fields = {
  __typename?: 'weather_stations_stddev_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "weather.stations" */
export type Weather_Stations_Stddev_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Weather_Stations_Stddev_Pop_Fields = {
  __typename?: 'weather_stations_stddev_pop_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "weather.stations" */
export type Weather_Stations_Stddev_Pop_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Weather_Stations_Stddev_Samp_Fields = {
  __typename?: 'weather_stations_stddev_samp_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "weather.stations" */
export type Weather_Stations_Stddev_Samp_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "weather_stations" */
export type Weather_Stations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Stations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Stations_Stream_Cursor_Value_Input = {
  altitude?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_daily_measure?: InputMaybe<Scalars['date']['input']>;
  last_measure?: InputMaybe<Scalars['timestamp']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  long?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Weather_Providers_Enum>;
  provider_station_id?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Weather_Stations_Sum_Fields = {
  __typename?: 'weather_stations_sum_fields';
  altitude?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  long?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "weather.stations" */
export type Weather_Stations_Sum_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** update columns of table "weather.stations" */
export enum Weather_Stations_Update_Column {
  /** column name */
  Altitude = 'altitude',
  /** column name */
  Id = 'id',
  /** column name */
  LastDailyMeasure = 'last_daily_measure',
  /** column name */
  LastMeasure = 'last_measure',
  /** column name */
  Lat = 'lat',
  /** column name */
  Long = 'long',
  /** column name */
  Name = 'name',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderStationId = 'provider_station_id',
  /** column name */
  Timezone = 'timezone'
}

export type Weather_Stations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weather_Stations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Stations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weather_Stations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Weather_Stations_Var_Pop_Fields = {
  __typename?: 'weather_stations_var_pop_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "weather.stations" */
export type Weather_Stations_Var_Pop_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Weather_Stations_Var_Samp_Fields = {
  __typename?: 'weather_stations_var_samp_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "weather.stations" */
export type Weather_Stations_Var_Samp_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Weather_Stations_Variance_Fields = {
  __typename?: 'weather_stations_variance_fields';
  altitude?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "weather.stations" */
export type Weather_Stations_Variance_Order_By = {
  altitude?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  long?: InputMaybe<Order_By>;
};

/** columns and relationships of "weekdays" */
export type Weekdays = {
  __typename?: 'weekdays';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "weekdays" */
export type Weekdays_Aggregate = {
  __typename?: 'weekdays_aggregate';
  aggregate?: Maybe<Weekdays_Aggregate_Fields>;
  nodes: Array<Weekdays>;
};

/** aggregate fields of "weekdays" */
export type Weekdays_Aggregate_Fields = {
  __typename?: 'weekdays_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Weekdays_Max_Fields>;
  min?: Maybe<Weekdays_Min_Fields>;
};


/** aggregate fields of "weekdays" */
export type Weekdays_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weekdays_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "weekdays". All fields are combined with a logical 'AND'. */
export type Weekdays_Bool_Exp = {
  _and?: InputMaybe<Array<Weekdays_Bool_Exp>>;
  _not?: InputMaybe<Weekdays_Bool_Exp>;
  _or?: InputMaybe<Array<Weekdays_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "weekdays" */
export enum Weekdays_Constraint {
  /** unique or primary key constraint on columns "value" */
  WeekdaysPkey = 'weekdays_pkey'
}

export enum Weekdays_Enum {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

/** Boolean expression to compare columns of type "weekdays_enum". All fields are combined with logical 'AND'. */
export type Weekdays_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Weekdays_Enum>;
  _in?: InputMaybe<Array<Weekdays_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Weekdays_Enum>;
  _nin?: InputMaybe<Array<Weekdays_Enum>>;
};

/** input type for inserting data into table "weekdays" */
export type Weekdays_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Weekdays_Max_Fields = {
  __typename?: 'weekdays_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Weekdays_Min_Fields = {
  __typename?: 'weekdays_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "weekdays" */
export type Weekdays_Mutation_Response = {
  __typename?: 'weekdays_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weekdays>;
};

/** on_conflict condition type for table "weekdays" */
export type Weekdays_On_Conflict = {
  constraint: Weekdays_Constraint;
  update_columns?: Array<Weekdays_Update_Column>;
  where?: InputMaybe<Weekdays_Bool_Exp>;
};

/** Ordering options when selecting data from "weekdays". */
export type Weekdays_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weekdays */
export type Weekdays_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "weekdays" */
export enum Weekdays_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "weekdays" */
export type Weekdays_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "weekdays" */
export type Weekdays_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weekdays_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weekdays_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "weekdays" */
export enum Weekdays_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Weekdays_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weekdays_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weekdays_Bool_Exp;
};

export type AdminListClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminListClientsQuery = { __typename?: 'query_root', clients: Array<{ __typename?: 'clients', id: number, name: string, slug?: string | null, firebase_id?: string | null }> };

export type AdminCreateClientMutationVariables = Exact<{
  object: Clients_Insert_Input;
}>;


export type AdminCreateClientMutation = { __typename?: 'mutation_root', insert_clients_one?: { __typename?: 'clients', id: number } | null };

export type AdminClientQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminClientQueryQuery = { __typename?: 'query_root', clients_by_pk?: { __typename?: 'clients', id: number, name: string, sites: Array<{ __typename?: 'sites', id: number, name: string, production_start_weekday: Weekdays_Enum, production_hours: Array<{ __typename?: 'production_hours', day_id: number, end: any, id: number, start: any }> }>, users: Array<{ __typename?: 'users', id: string, last_name: string, first_name: string, email: string, client_id: number, role: string, weekly_reporting: boolean }> } | null };

export type AdminUpdateClientMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  object: Clients_Set_Input;
}>;


export type AdminUpdateClientMutation = { __typename?: 'mutation_root', update_clients_by_pk?: { __typename?: 'clients', id: number, name: string } | null };

export type AdminSiteQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AdminSiteQuery = { __typename?: 'query_root', sites_by_pk?: { __typename?: 'sites', id: number, name: string, production_start_weekday: Weekdays_Enum, address?: string | null, lat?: any | null, long?: any | null, weather_station_id?: number | null, client: { __typename?: 'clients', name: string, id: number }, consumption_reference?: { __typename?: 'consumption_reference', co2: any, consumption: any, cost: any, deployment_date: any, id: number, production?: any | null, site_id: number } | null, areas: Array<{ __typename?: 'areas', name: string, parent_id?: number | null, production_reporting_frequency?: Production_Reporting_Frequencies_Enum | null, production_unit_id?: number | null, is_fabrication_order_reporting_enabled: boolean, is_production_reporting_enabled: boolean, id: number, area_type: Area_Types_Enum, fabrication_order_unit_id?: number | null, meters: Array<{ __typename?: 'meters', meter_type_id: number, data_source_id: string, id: number, area_id: number, meter_type: { __typename?: 'meter_types', energy_type: Energy_Types_Enum, name: string, id: number, step_seconds: number } }>, production_unit?: { __typename?: 'units', symbol: string } | null }> } | null };

export type AdminCreateSiteMutationVariables = Exact<{
  object: Sites_Insert_Input;
}>;


export type AdminCreateSiteMutation = { __typename?: 'mutation_root', insert_sites_one?: { __typename?: 'sites', id: number } | null };

export type AdminUpdateSiteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  object: Sites_Set_Input;
}>;


export type AdminUpdateSiteMutation = { __typename?: 'mutation_root', update_sites_by_pk?: { __typename?: 'sites', id: number } | null };

export type AdminCreateReferenceMutationVariables = Exact<{
  reference: Consumption_Reference_Insert_Input;
}>;


export type AdminCreateReferenceMutation = { __typename?: 'mutation_root', insert_consumption_reference_one?: { __typename?: 'consumption_reference', id: number } | null };

export type AdminUpdateReferenceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  reference: Consumption_Reference_Set_Input;
}>;


export type AdminUpdateReferenceMutation = { __typename?: 'mutation_root', update_consumption_reference_by_pk?: { __typename?: 'consumption_reference', id: number } | null };

export type Overview_IncidentsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  areaIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Overview_IncidentsQuery = { __typename?: 'query_root', incidents: Array<{ __typename?: 'incidents', _created_at: any, status: Incident_Statuses_Enum, type: Incident_Types_Enum, cost?: number | null }> };

export type Overview_ObjectivesQueryVariables = Exact<{
  meterIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  start: Scalars['timestamptz']['input'];
}>;


export type Overview_ObjectivesQuery = { __typename?: 'query_root', objectives: Array<{ __typename?: 'objectives', id: number, type: Objective_Types_Enum, target: any, cost_target?: any | null, start: any, name?: string | null, description?: string | null, meter_id: number, end: any, reduction_objective_in_pourcent?: any | null, reference_year?: any | null, objective_milestones: Array<{ __typename?: 'objective_milestones', timestamp: any, consumption_target: any, cost_target?: any | null, co2_target?: any | null, objective_id: number, id: number }> }> };

export type Overview_Objective_InsertMutationVariables = Exact<{
  objective: Objectives_Insert_Input;
}>;


export type Overview_Objective_InsertMutation = { __typename?: 'mutation_root', insert_objectives_one?: { __typename?: 'objectives', id: number } | null };

export type Overview_Objective_UpdateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  objective: Objectives_Insert_Input;
}>;


export type Overview_Objective_UpdateMutation = { __typename?: 'mutation_root', delete_objectives?: { __typename?: 'objectives_mutation_response', affected_rows: number } | null, insert_objectives_one?: { __typename?: 'objectives', id: number } | null };

export type OverviewConsumptionReferenceQueryVariables = Exact<{
  sitesIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type OverviewConsumptionReferenceQuery = { __typename?: 'query_root', consumption_reference: Array<{ __typename?: 'consumption_reference', id: number, co2: any, consumption: any, cost: any, deployment_date: any, production?: any | null, site_id: number }> };

export type ProductsQueryListQueryVariables = Exact<{
  site_id: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ProductsQueryListQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: number, client_product_id: string, label?: string | null, site_id: number, epi_standard?: any | null, fabrication_order_products: Array<{ __typename?: 'fabrication_order_product', fabrication_order?: { __typename?: 'fabrication_orders', id: number, start: any, end: any, quantity: any, area?: { __typename?: 'areas', name: string, id: number, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, production_unit?: { __typename?: 'units', symbol: string } | null } | null, fabrication_order_epis: Array<{ __typename?: 'fabrication_order_epi', epi: any, cost_by_quantity: any, cost: any, consumption_kwh: any, id: number, meter_id: number }> } | null }> }> };

export type ProductsQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProductsQueryQuery = { __typename?: 'query_root', products_by_pk?: { __typename?: 'products', id: number, client_product_id: string, label?: string | null, site_id: number, epi_standard?: any | null, fabrication_order_products: Array<{ __typename?: 'fabrication_order_product', fabrication_order?: { __typename?: 'fabrication_orders', id: number, start: any, end: any, quantity: any, client_fabrication_order_id?: string | null, area?: { __typename?: 'areas', name: string, id: number, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, production_unit?: { __typename?: 'units', symbol: string } | null } | null, fabrication_order_epis: Array<{ __typename?: 'fabrication_order_epi', epi: any, cost_by_quantity: any, cost: any, consumption_kwh: any, id: number, meter_id: number }> } | null }> } | null };

export type ProductUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  object: Products_Set_Input;
}>;


export type ProductUpdateOneMutation = { __typename?: 'mutation_root', update_products?: { __typename?: 'products_mutation_response', affected_rows: number } | null };

export type ConstantsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConstantsQuery = { __typename?: 'query_root', meter_types: Array<{ __typename?: 'meter_types', energy_type: Energy_Types_Enum, id: number, name: string, step_seconds: number }> };

export type AlertAnalyticTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AlertAnalyticTypeQueryQuery = { __typename?: 'query_root', alert_types: Array<{ __typename?: 'alert_types', value: string }> };

export type AlertsQueryQueryVariables = Exact<{
  site_id: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AlertsQueryQuery = { __typename?: 'query_root', alerts: Array<{ __typename?: 'alerts', id: number, params: any, type: Alert_Types_Enum, meter_id: number, name: string, _created_at: any, _updated_at: any, _created_by: string, _updated_by: string, meter?: { __typename?: 'meters', id: number, area: { __typename?: 'areas', id: number, name: string }, meter_type: { __typename?: 'meter_types', energy_type: Energy_Types_Enum } } | null, incidents: Array<{ __typename?: 'incidents', name: string }>, alert_users: Array<{ __typename?: 'alert_user', id: number, user_id: string, user: { __typename?: 'users', first_name: string, last_name: string, id: string, client_id: number, picture_url?: string | null } }> }> };

export type CreateAlertMutationVariables = Exact<{
  object: Alerts_Insert_Input;
}>;


export type CreateAlertMutation = { __typename?: 'mutation_root', insert_alerts_one?: { __typename?: 'alerts', id: number, params: any, type: Alert_Types_Enum, meter_id: number, name: string, _created_at: any, _updated_at: any, _created_by: string, _updated_by: string, meter?: { __typename?: 'meters', area: { __typename?: 'areas', id: number, name: string }, meter_type: { __typename?: 'meter_types', energy_type: Energy_Types_Enum } } | null, incidents: Array<{ __typename?: 'incidents', id: number, area_id: number, name: string, start: any, end: any }>, alert_users: Array<{ __typename?: 'alert_user', id: number, user_id: string, user: { __typename?: 'users', first_name: string, last_name: string, id: string, client_id: number, picture_url?: string | null } }> } | null };

export type UpdateAlertMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  object: Alerts_Set_Input;
}>;


export type UpdateAlertMutation = { __typename?: 'mutation_root', update_alerts?: { __typename?: 'alerts_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'alerts', id: number, params: any, type: Alert_Types_Enum, name: string, meter_id: number, _created_at: any, _updated_at: any, _created_by: string, _updated_by: string, meter?: { __typename?: 'meters', area: { __typename?: 'areas', id: number, name: string }, meter_type: { __typename?: 'meter_types', energy_type: Energy_Types_Enum } } | null, incidents: Array<{ __typename?: 'incidents', id: number, area_id: number, name: string, start: any, end: any }>, alert_users: Array<{ __typename?: 'alert_user', id: number, user_id: string, user: { __typename?: 'users', first_name: string, last_name: string, id: string, client_id: number, picture_url?: string | null } }> }> } | null };

export type CreateAlertUserMutationVariables = Exact<{
  objects: Array<Alert_User_Insert_Input> | Alert_User_Insert_Input;
}>;


export type CreateAlertUserMutation = { __typename?: 'mutation_root', insert_alert_user?: { __typename?: 'alert_user_mutation_response', affected_rows: number } | null };

export type UpdateAlertUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  objects: Array<Alert_User_Insert_Input> | Alert_User_Insert_Input;
}>;


export type UpdateAlertUserMutation = { __typename?: 'mutation_root', delete_alert_user?: { __typename?: 'alert_user_mutation_response', affected_rows: number } | null, insert_alert_user?: { __typename?: 'alert_user_mutation_response', affected_rows: number } | null };

export type DeleteAlertMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAlertMutation = { __typename?: 'mutation_root', delete_alerts_by_pk?: { __typename?: 'alerts', id: number } | null };

export type UpdateAreaMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  object: Areas_Set_Input;
}>;


export type UpdateAreaMutation = { __typename?: 'mutation_root', update_areas?: { __typename?: 'areas_mutation_response', affected_rows: number } | null };

export type CreateAreaMutationVariables = Exact<{
  object: Areas_Insert_Input;
}>;


export type CreateAreaMutation = { __typename?: 'mutation_root', insert_areas_one?: { __typename?: 'areas', id: number } | null };

export type AreasQueryQueryVariables = Exact<{
  site_id: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AreasQueryQuery = { __typename?: 'query_root', areas: Array<{ __typename?: 'areas', id: number, name: string, parent_id?: number | null, area_type: Area_Types_Enum, is_production_reporting_enabled: boolean, is_fabrication_order_reporting_enabled: boolean, fabrication_order_unit_id?: number | null, energy_use_type?: Energy_Use_Types_Enum | null, production_unit_id?: number | null, production_reporting_frequency?: Production_Reporting_Frequencies_Enum | null, site_id: number, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, productions: Array<{ __typename?: 'productions', id: number }>, production_unit?: { __typename?: 'units', symbol: string } | null, children: Array<{ __typename?: 'areas', id: number, name: string }>, parent?: { __typename?: 'areas', id: number, name: string } | null, fabrication_orders: Array<{ __typename?: 'fabrication_orders', id: number, start: any, end: any, quantity: any }>, meters: Array<{ __typename?: 'meters', id: number, meter_type: { __typename?: 'meter_types', energy_type: Energy_Types_Enum, step_seconds: number } }>, site: { __typename?: 'sites', id: number, name: string, production_start_weekday: Weekdays_Enum } }> };

export type AreaQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AreaQueryQuery = { __typename?: 'query_root', areas: Array<{ __typename?: 'areas', id: number, name: string, parent_id?: number | null, area_type: Area_Types_Enum, is_production_reporting_enabled: boolean, is_fabrication_order_reporting_enabled: boolean, site_id: number, production_unit_id?: number | null, fabrication_order_unit_id?: number | null, children: Array<{ __typename?: 'areas', id: number, name: string }>, parent?: { __typename?: 'areas', id: number, name: string } | null, site: { __typename?: 'sites', id: number, name: string }, fabrication_orders: Array<{ __typename?: 'fabrication_orders', id: number, start: any, end: any, quantity: any }>, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, production_unit?: { __typename?: 'units', symbol: string } | null }> };

export type InsertAreaMutationVariables = Exact<{
  object: Areas_Insert_Input;
}>;


export type InsertAreaMutation = { __typename?: 'mutation_root', insert_areas_one?: { __typename?: 'areas', site_id: number, name: string, id: number } | null };

export type AreaTypesQueryListQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaTypesQueryListQuery = { __typename?: 'query_root', area_types: Array<{ __typename?: 'area_types', value: string }> };

export type ClientQueryListQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientQueryListQuery = { __typename?: 'query_root', clients: Array<{ __typename?: 'clients', id: number, name: string, slug?: string | null, firebase_id?: string | null }> };

export type ClientQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ClientQueryQuery = { __typename?: 'query_root', clients: Array<{ __typename?: 'clients', id: number, name: string, slug?: string | null, firebase_id?: string | null }> };

export type UpdateClientMutationVariables = Exact<{
  object: Clients_Set_Input;
  id: Scalars['Int']['input'];
}>;


export type UpdateClientMutation = { __typename?: 'mutation_root', update_clients_by_pk?: { __typename?: 'clients', id: number, name: string, slug?: string | null, firebase_id?: string | null } | null };

export type InsertClientMutationVariables = Exact<{
  object: Clients_Insert_Input;
}>;


export type InsertClientMutation = { __typename?: 'mutation_root', insert_clients_one?: { __typename?: 'clients', id: number, name: string, slug?: string | null, firebase_id?: string | null, sites: Array<{ __typename?: 'sites', id: number, areas: Array<{ __typename?: 'areas', id: number, meters: Array<{ __typename?: 'meters', id: number }> }> }> } | null };

export type ContractQueryListQueryVariables = Exact<{
  site_id: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ContractQueryListQuery = { __typename?: 'query_root', contracts: Array<{ __typename?: 'contracts', start: any, end: any, energy_type: Energy_Types_Enum, emission_factor: any, created_at: any, contract_power: any, id: number, site_id: number, updated_at: any, tariffs: Array<{ __typename?: 'tariffs', value: any, name: string, months?: Array<number> | null, contract_id: number, id: number, tariff_schedules: Array<{ __typename?: 'tariff_schedules', id: number, days_of_week?: Array<number> | null, time_range?: Array<any> | null }> }> }> };

export type ContractMutationInsertMutationVariables = Exact<{
  object: Contracts_Insert_Input;
}>;


export type ContractMutationInsertMutation = { __typename?: 'mutation_root', insert_contracts_one?: { __typename?: 'contracts', start: any, end: any, energy_type: Energy_Types_Enum, emission_factor: any, created_at: any, contract_power: any, updated_at: any, tariffs: Array<{ __typename?: 'tariffs', value: any, name: string, months?: Array<number> | null, tariff_schedules: Array<{ __typename?: 'tariff_schedules', days_of_week?: Array<number> | null, time_range?: Array<any> | null }> }> } | null };

export type ContractMutationUpdateMutationVariables = Exact<{
  object: Contracts_Set_Input;
  id: Scalars['Int']['input'];
}>;


export type ContractMutationUpdateMutation = { __typename?: 'mutation_root', delete_tariffs?: { __typename?: 'tariffs_mutation_response', returning: Array<{ __typename?: 'tariffs', id: number }> } | null, update_contracts_by_pk?: { __typename?: 'contracts', start: any, end: any, energy_type: Energy_Types_Enum, emission_factor: any, created_at: any, contract_power: any, updated_at: any } | null };

export type TariffMutationInsertMutationVariables = Exact<{
  objects: Array<Tariffs_Insert_Input> | Tariffs_Insert_Input;
}>;


export type TariffMutationInsertMutation = { __typename?: 'mutation_root', insert_tariffs?: { __typename?: 'tariffs_mutation_response', returning: Array<{ __typename?: 'tariffs', contract_id: number, value: any, name: string, months?: Array<number> | null, tariff_schedules: Array<{ __typename?: 'tariff_schedules', days_of_week?: Array<number> | null, time_range?: Array<any> | null }> }> } | null };

export type ContractQueryByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ContractQueryByIdQuery = { __typename?: 'query_root', contracts_by_pk?: { __typename?: 'contracts', start: any, end: any, energy_type: Energy_Types_Enum, emission_factor: any, created_at: any, contract_power: any, id: number, site_id: number, updated_at: any, tariffs: Array<{ __typename?: 'tariffs', value: any, name: string, months?: Array<number> | null, contract_id: number, id: number, tariff_schedules: Array<{ __typename?: 'tariff_schedules', id: number, days_of_week?: Array<number> | null, time_range?: Array<any> | null }> }> } | null };

export type FabricationOrdersQueryListQueryVariables = Exact<{
  area_id: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['timestamp']['input']>;
  end?: InputMaybe<Scalars['timestamp']['input']>;
  meter_id: Scalars['Int']['input'];
}>;


export type FabricationOrdersQueryListQuery = { __typename?: 'query_root', fabrication_orders: Array<{ __typename?: 'fabrication_orders', start: any, quantity: any, id: number, has_up_to_date_epi: boolean, end: any, client_fabrication_order_id?: string | null, area?: { __typename?: 'areas', name: string, id: number, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, production_unit?: { __typename?: 'units', symbol: string } | null } | null, fabrication_order_products: Array<{ __typename?: 'fabrication_order_product', product?: { __typename?: 'products', client_product_id: string, id: number } | null }>, fabrication_order_epis: Array<{ __typename?: 'fabrication_order_epi', consumption_kwh: any, cost: any, cost_by_quantity: any, epi: any, id: number, meter_id: number }> }> };

export type FabricationOrdersQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FabricationOrdersQueryQuery = { __typename?: 'query_root', fabrication_orders_by_pk?: { __typename?: 'fabrication_orders', id: number, start: any, quantity: any, end: any } | null };

export type FabricationOrdersQueryByAreaQueryVariables = Exact<{
  area_id: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type FabricationOrdersQueryByAreaQuery = { __typename?: 'query_root', fabrication_orders: Array<{ __typename: 'fabrication_orders', start: any, id: number, quantity: any, end: any, client_fabrication_order_id?: string | null, area?: { __typename?: 'areas', name: string, id: number, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, production_unit?: { __typename?: 'units', symbol: string } | null } | null, fabrication_order_products: Array<{ __typename?: 'fabrication_order_product', product?: { __typename: 'products', id: number, client_product_id: string } | null }> }> };

export type FabricationOrderInsertMutationVariables = Exact<{
  fabrication_order: Fabrication_Orders_Insert_Input;
}>;


export type FabricationOrderInsertMutation = { __typename?: 'mutation_root', insert_fabrication_orders_one?: { __typename?: 'fabrication_orders', start: any, end: any, quantity: any, area_id: number } | null };

export type FabricationOrderUpdateMutationVariables = Exact<{
  fabrication_order: Fabrication_Orders_Set_Input;
  id: Scalars['Int']['input'];
}>;


export type FabricationOrderUpdateMutation = { __typename?: 'mutation_root', update_fabrication_orders_by_pk?: { __typename: 'fabrication_orders', start: any, end: any, quantity: any, area?: { __typename?: 'areas', name: string, id: number, fabrication_order_unit?: { __typename?: 'units', symbol: string } | null, production_unit?: { __typename?: 'units', symbol: string } | null } | null } | null };

export type FabricationOrderDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FabricationOrderDeleteMutation = { __typename?: 'mutation_root', delete_fabrication_orders_by_pk?: { __typename?: 'fabrication_orders', id: number } | null };

export type MetersQueryQueryVariables = Exact<{
  site_id: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type MetersQueryQuery = { __typename?: 'query_root', meters: Array<{ __typename?: 'meters', id: number, data_source_id: string, area: { __typename?: 'areas', name: string, production_reporting_frequency?: Production_Reporting_Frequencies_Enum | null, production_unit_id?: number | null, fabrication_order_unit_id?: number | null, site_id: number, id: number, parent_id?: number | null, site: { __typename?: 'sites', client_id: number }, parent?: { __typename?: 'areas', id: number, name: string } | null }, meter_type: { __typename?: 'meter_types', energy_type: Energy_Types_Enum, id: number, name: string, step_seconds: number } }> };

export type MeterTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeterTypesQueryQuery = { __typename?: 'query_root', meter_types: Array<{ __typename?: 'meter_types', energy_type: Energy_Types_Enum, id: number, name: string, step_seconds: number }> };

export type NotificationQueryQueryVariables = Exact<{
  user_id: Scalars['String']['input'];
}>;


export type NotificationQueryQuery = { __typename?: 'query_root', notifications: Array<{ __typename?: 'notifications', id: number, read: boolean, type: string, url: string, data: any, created_for: string, created_by: string, created_at: any }> };

export type NotificationSubscriptionSubscriptionVariables = Exact<{
  user_id: Scalars['String']['input'];
}>;


export type NotificationSubscriptionSubscription = { __typename?: 'subscription_root', notifications: Array<{ __typename?: 'notifications', id: number }> };

export type NotificationMutationUpdateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  object: Notifications_Set_Input;
}>;


export type NotificationMutationUpdateMutation = { __typename?: 'mutation_root', update_notifications_by_pk?: { __typename?: 'notifications', id: number } | null };

export type NotificationMutationInsertMutationVariables = Exact<{
  object: Notifications_Insert_Input;
}>;


export type NotificationMutationInsertMutation = { __typename?: 'mutation_root', insert_notifications_one?: { __typename?: 'notifications', type: string } | null };

export type InsertProductionHoursMutationVariables = Exact<{
  objects: Array<Production_Hours_Insert_Input> | Production_Hours_Insert_Input;
  siteId: Scalars['Int']['input'];
}>;


export type InsertProductionHoursMutation = { __typename?: 'mutation_root', delete_production_hours?: { __typename?: 'production_hours_mutation_response', returning: Array<{ __typename?: 'production_hours', id: number }> } | null, insert_production_hours?: { __typename?: 'production_hours_mutation_response', returning: Array<{ __typename?: 'production_hours', id: number }> } | null };

export type DeleteProductionHoursMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteProductionHoursMutation = { __typename?: 'mutation_root', delete_production_hours_by_pk?: { __typename?: 'production_hours', id: number } | null };

export type ProjectsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQueryQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: number, name: string, area_id: number, status: Project_Statuses_Enum, budget_range: Project_Budget_Ranges_Enum, time_to_ROI: Project_Roi_Durations_Enum, can_be_funded?: boolean | null, complexity?: string | null, start: any, end: any, template_id: number, content: any, area: { __typename?: 'areas', name: string }, subvention?: { __typename?: 'subventions', id: string, url?: string | null } | null }> };

export type ProjectQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProjectQueryQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', id: number, name: string, area_id: number, status: Project_Statuses_Enum, budget_range: Project_Budget_Ranges_Enum, time_to_ROI: Project_Roi_Durations_Enum, can_be_funded?: boolean | null, complexity?: string | null, start: any, end: any, template_id: number, content: any, area: { __typename?: 'areas', name: string }, subvention?: { __typename?: 'subventions', id: string, url?: string | null } | null }> };

export type UpdateProjectMutationVariables = Exact<{
  object?: InputMaybe<Projects_Set_Input>;
  id: Scalars['Int']['input'];
}>;


export type UpdateProjectMutation = { __typename?: 'mutation_root', update_projects_by_pk?: { __typename?: 'projects', id: number, name: string, area_id: number, status: Project_Statuses_Enum, budget_range: Project_Budget_Ranges_Enum, time_to_ROI: Project_Roi_Durations_Enum, can_be_funded?: boolean | null, complexity?: string | null, start: any, end: any, template_id: number, content: any, area: { __typename?: 'areas', name: string }, subvention?: { __typename?: 'subventions', id: string, url?: string | null } | null } | null };

export type InsertProjectMutationVariables = Exact<{
  object: Projects_Insert_Input;
}>;


export type InsertProjectMutation = { __typename?: 'mutation_root', insert_projects_one?: { __typename?: 'projects', id: number, name: string, area_id: number, status: Project_Statuses_Enum, budget_range: Project_Budget_Ranges_Enum, time_to_ROI: Project_Roi_Durations_Enum, can_be_funded?: boolean | null, complexity?: string | null, start: any, end: any, template_id: number, content: any, subvention?: { __typename?: 'subventions', id: string, url?: string | null } | null } | null };

export type SitesQueryQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesQueryQuery = { __typename?: 'query_root', sites: Array<{ __typename?: 'sites', client_id: number, id: number, name: string, production_start_weekday: Weekdays_Enum, weather_station_id?: number | null, production_hours: Array<{ __typename?: 'production_hours', id: number, day_id: number, end: any, start: any, created_at?: any | null, updated_at?: any | null }> }> };

export type SiteQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SiteQueryQuery = { __typename?: 'query_root', sites: Array<{ __typename?: 'sites', client_id: number, id: number, name: string, production_start_weekday: Weekdays_Enum }> };

export type UpdateSiteMutationVariables = Exact<{
  object?: InputMaybe<Sites_Set_Input>;
  id: Scalars['Int']['input'];
}>;


export type UpdateSiteMutation = { __typename?: 'mutation_root', update_sites_by_pk?: { __typename?: 'sites', client_id: number, id: number, name: string, production_hours: Array<{ __typename?: 'production_hours', id: number, day_id: number, end: any, start: any }> } | null };

export type InsertSiteMutationVariables = Exact<{
  object: Sites_Insert_Input;
}>;


export type InsertSiteMutation = { __typename?: 'mutation_root', insert_sites_one?: { __typename?: 'sites', id: number, name: string } | null };

export type UnitQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitQuery = { __typename?: 'query_root', units: Array<{ __typename?: 'units', id: number, name: string, symbol: string, type: Unit_Types_Enum }> };

export type UsersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', client_id: number, email: string, first_name: string, id: string, last_name: string, picture_url?: string | null, role: string, client: { __typename?: 'clients', name: string, id: number } }> };


export const AdminListClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminListClients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"firebase_id"}}]}}]}}]} as unknown as DocumentNode<AdminListClientsQuery, AdminListClientsQueryVariables>;
export const AdminCreateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminCreateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clients_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_clients_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminCreateClientMutation, AdminCreateClientMutationVariables>;
export const AdminClientQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminClientQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day_id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_start_weekday"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_reporting"}}]}}]}}]}}]} as unknown as DocumentNode<AdminClientQueryQuery, AdminClientQueryQueryVariables>;
export const AdminUpdateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUpdateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clients_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_clients_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminUpdateClientMutation, AdminUpdateClientMutationVariables>;
export const AdminSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_start_weekday"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}},{"kind":"Field","name":{"kind":"Name","value":"weather_station_id"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumption_reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"co2"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"deployment_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"production"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meter_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"meter_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"step_seconds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"production_reporting_frequency"}},{"kind":"Field","name":{"kind":"Name","value":"production_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_fabrication_order_reporting_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_production_reporting_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area_type"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit_id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminSiteQuery, AdminSiteQueryVariables>;
export const AdminCreateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminCreateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"sites_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_sites_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminCreateSiteMutation, AdminCreateSiteMutationVariables>;
export const AdminUpdateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUpdateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"sites_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminUpdateSiteMutation, AdminUpdateSiteMutationVariables>;
export const AdminCreateReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminCreateReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"consumption_reference_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_consumption_reference_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminCreateReferenceMutation, AdminCreateReferenceMutationVariables>;
export const AdminUpdateReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUpdateReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"consumption_reference_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_consumption_reference_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdminUpdateReferenceMutation, AdminUpdateReferenceMutationVariables>;
export const Overview_IncidentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"overview_incidents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"area_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]} as unknown as DocumentNode<Overview_IncidentsQuery, Overview_IncidentsQueryVariables>;
export const Overview_ObjectivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"overview_objectives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meterIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meter_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meterIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meter_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"energy_type"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"cost_target"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"reduction_objective_in_pourcent"}},{"kind":"Field","name":{"kind":"Name","value":"reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"objective_milestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"consumption_target"}},{"kind":"Field","name":{"kind":"Name","value":"cost_target"}},{"kind":"Field","name":{"kind":"Name","value":"co2_target"}},{"kind":"Field","name":{"kind":"Name","value":"objective_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Overview_ObjectivesQuery, Overview_ObjectivesQueryVariables>;
export const Overview_Objective_InsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"overview_objective_insert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objective"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"objectives_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_objectives_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objective"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Overview_Objective_InsertMutation, Overview_Objective_InsertMutationVariables>;
export const Overview_Objective_UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"overview_objective_update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objective"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"objectives_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_objectives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_objectives_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objective"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Overview_Objective_UpdateMutation, Overview_Objective_UpdateMutationVariables>;
export const OverviewConsumptionReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"overviewConsumptionReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sitesIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumption_reference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sitesIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"co2"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"deployment_date"}},{"kind":"Field","name":{"kind":"Name","value":"production"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}}]}}]}}]} as unknown as DocumentNode<OverviewConsumptionReferenceQuery, OverviewConsumptionReferenceQueryVariables>;
export const ProductsQueryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsQueryList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_product_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"epi_standard"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fabrication_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_epis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epi"}},{"kind":"Field","name":{"kind":"Name","value":"cost_by_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"consumption_kwh"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQueryListQuery, ProductsQueryListQueryVariables>;
export const ProductsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_product_id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"epi_standard"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fabrication_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"client_fabrication_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_epis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epi"}},{"kind":"Field","name":{"kind":"Name","value":"cost_by_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"consumption_kwh"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQueryQuery, ProductsQueryQueryVariables>;
export const ProductUpdateOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProductUpdateOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"products_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ProductUpdateOneMutation, ProductUpdateOneMutationVariables>;
export const ConstantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Constants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meter_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"step_seconds"}}]}}]}}]} as unknown as DocumentNode<ConstantsQuery, ConstantsQueryVariables>;
export const AlertAnalyticTypeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertAnalyticTypeQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alert_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<AlertAnalyticTypeQueryQuery, AlertAnalyticTypeQueryQueryVariables>;
export const AlertsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlertsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"_created_by"}},{"kind":"Field","name":{"kind":"Name","value":"_updated_by"}},{"kind":"Field","name":{"kind":"Name","value":"meter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meter_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alert_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"picture_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AlertsQueryQuery, AlertsQueryQueryVariables>;
export const CreateAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alerts_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_alerts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"_created_by"}},{"kind":"Field","name":{"kind":"Name","value":"_updated_by"}},{"kind":"Field","name":{"kind":"Name","value":"meter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meter_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alert_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"picture_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAlertMutation, CreateAlertMutationVariables>;
export const UpdateAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alerts_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}},{"kind":"Field","name":{"kind":"Name","value":"_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"_created_by"}},{"kind":"Field","name":{"kind":"Name","value":"_updated_by"}},{"kind":"Field","name":{"kind":"Name","value":"meter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meter_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alert_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"picture_url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAlertMutation, UpdateAlertMutationVariables>;
export const CreateAlertUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAlertUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alert_user_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_alert_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CreateAlertUserMutation, CreateAlertUserMutationVariables>;
export const UpdateAlertUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAlertUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"alert_user_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_alert_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alert_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_alert_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateAlertUserMutation, UpdateAlertUserMutationVariables>;
export const DeleteAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_alerts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const UpdateAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"areas_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateAreaMutation, UpdateAreaMutationVariables>;
export const CreateAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"areas_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_areas_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAreaMutation, CreateAreaMutationVariables>;
export const AreasQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AreasQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"area_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_production_reporting_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_fabrication_order_reporting_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"energy_use_type"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_reporting_frequency"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meter_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"step_seconds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_start_weekday"}}]}}]}}]}}]} as unknown as DocumentNode<AreasQueryQuery, AreasQueryQueryVariables>;
export const AreaQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AreaQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"area_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_production_reporting_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"is_fabrication_order_reporting_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_fabrication_order_reporting_enabled"}}]}}]}}]} as unknown as DocumentNode<AreaQueryQuery, AreaQueryQueryVariables>;
export const InsertAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"areas_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_areas_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertAreaMutation, InsertAreaMutationVariables>;
export const AreaTypesQueryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AreaTypesQueryList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<AreaTypesQueryListQuery, AreaTypesQueryListQueryVariables>;
export const ClientQueryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientQueryList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"firebase_id"}}]}}]}}]} as unknown as DocumentNode<ClientQueryListQuery, ClientQueryListQueryVariables>;
export const ClientQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"firebase_id"}}]}}]}}]} as unknown as DocumentNode<ClientQueryQuery, ClientQueryQueryVariables>;
export const UpdateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clients_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_clients_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"firebase_id"}}]}}]}}]} as unknown as DocumentNode<UpdateClientMutation, UpdateClientMutationVariables>;
export const InsertClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clients_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_clients_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"firebase_id"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertClientMutation, InsertClientMutationVariables>;
export const ContractQueryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractQueryList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"emission_factor"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contract_power"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"tariff_schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days_of_week"}},{"kind":"Field","name":{"kind":"Name","value":"time_range"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ContractQueryListQuery, ContractQueryListQueryVariables>;
export const ContractMutationInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractMutationInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"contracts_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_contracts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"emission_factor"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contract_power"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"tariff_schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days_of_week"}},{"kind":"Field","name":{"kind":"Name","value":"time_range"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractMutationInsertMutation, ContractMutationInsertMutationVariables>;
export const ContractMutationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContractMutationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"contracts_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_tariffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_contracts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"emission_factor"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contract_power"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ContractMutationUpdateMutation, ContractMutationUpdateMutationVariables>;
export const TariffMutationInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TariffMutationInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tariffs_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tariffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"tariff_schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days_of_week"}},{"kind":"Field","name":{"kind":"Name","value":"time_range"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TariffMutationInsertMutation, TariffMutationInsertMutationVariables>;
export const ContractQueryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractQueryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"emission_factor"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contract_power"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"tariff_schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days_of_week"}},{"kind":"Field","name":{"kind":"Name","value":"time_range"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ContractQueryByIdQuery, ContractQueryByIdQueryVariables>;
export const FabricationOrdersQueryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FabricationOrdersQueryList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meter_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fabrication_orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"has_up_to_date_epi"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"client_fabrication_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_product_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_epis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meter_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meter_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consumption_kwh"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"cost_by_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"epi"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meter_id"}}]}}]}}]}}]} as unknown as DocumentNode<FabricationOrdersQueryListQuery, FabricationOrdersQueryListQueryVariables>;
export const FabricationOrdersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FabricationOrdersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fabrication_orders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]} as unknown as DocumentNode<FabricationOrdersQueryQuery, FabricationOrdersQueryQueryVariables>;
export const FabricationOrdersQueryByAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FabricationOrdersQueryByArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fabrication_orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"client_fabrication_order_id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_product_id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FabricationOrdersQueryByAreaQuery, FabricationOrdersQueryByAreaQueryVariables>;
export const FabricationOrderInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FabricationOrderInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fabrication_order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fabrication_orders_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_fabrication_orders_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fabrication_order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}}]}}]}}]} as unknown as DocumentNode<FabricationOrderInsertMutation, FabricationOrderInsertMutationVariables>;
export const FabricationOrderUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FabricationOrderUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fabrication_order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fabrication_orders_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_fabrication_orders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fabrication_order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<FabricationOrderUpdateMutation, FabricationOrderUpdateMutationVariables>;
export const FabricationOrderDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FabricationOrderDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_fabrication_orders_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FabricationOrderDeleteMutation, FabricationOrderDeleteMutationVariables>;
export const MetersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site_id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_reporting_frequency"}},{"kind":"Field","name":{"kind":"Name","value":"production_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication_order_unit_id"}},{"kind":"Field","name":{"kind":"Name","value":"site_id"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meter_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"step_seconds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source_id"}}]}}]}}]} as unknown as DocumentNode<MetersQueryQuery, MetersQueryQueryVariables>;
export const MeterTypesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeterTypesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meter_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energy_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"step_seconds"}}]}}]}}]} as unknown as DocumentNode<MeterTypesQueryQuery, MeterTypesQueryQueryVariables>;
export const NotificationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_for"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"read"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"created_for"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<NotificationQueryQuery, NotificationQueryQueryVariables>;
export const NotificationSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NotificationSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_for"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"read"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<NotificationSubscriptionSubscription, NotificationSubscriptionSubscriptionVariables>;
export const NotificationMutationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotificationMutationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"notifications_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_notifications_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<NotificationMutationUpdateMutation, NotificationMutationUpdateMutationVariables>;
export const NotificationMutationInsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotificationMutationInsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"notifications_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_notifications_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<NotificationMutationInsertMutation, NotificationMutationInsertMutationVariables>;
export const InsertProductionHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertProductionHours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"production_hours_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_production_hours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"site_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_production_hours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"production_hours_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"start"},{"kind":"EnumValue","value":"end"},{"kind":"EnumValue","value":"day_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertProductionHoursMutation, InsertProductionHoursMutationVariables>;
export const DeleteProductionHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProductionHours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_production_hours_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProductionHoursMutation, DeleteProductionHoursMutationVariables>;
export const ProjectsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"budget_range"}},{"kind":"Field","name":{"kind":"Name","value":"time_to_ROI"}},{"kind":"Field","name":{"kind":"Name","value":"can_be_funded"}},{"kind":"Field","name":{"kind":"Name","value":"complexity"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"template_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"subvention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsQueryQuery, ProjectsQueryQueryVariables>;
export const ProjectQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"budget_range"}},{"kind":"Field","name":{"kind":"Name","value":"time_to_ROI"}},{"kind":"Field","name":{"kind":"Name","value":"can_be_funded"}},{"kind":"Field","name":{"kind":"Name","value":"complexity"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"template_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"subvention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectQueryQuery, ProjectQueryQueryVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_projects_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"budget_range"}},{"kind":"Field","name":{"kind":"Name","value":"time_to_ROI"}},{"kind":"Field","name":{"kind":"Name","value":"can_be_funded"}},{"kind":"Field","name":{"kind":"Name","value":"complexity"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"template_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"subvention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const InsertProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"projects_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_projects_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"area_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"budget_range"}},{"kind":"Field","name":{"kind":"Name","value":"time_to_ROI"}},{"kind":"Field","name":{"kind":"Name","value":"can_be_funded"}},{"kind":"Field","name":{"kind":"Name","value":"complexity"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"subvention"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<InsertProjectMutation, InsertProjectMutationVariables>;
export const SitesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"client_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"client_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"client_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_start_weekday"}},{"kind":"Field","name":{"kind":"Name","value":"weather_station_id"}},{"kind":"Field","name":{"kind":"Name","value":"production_hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"day_id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<SitesQueryQuery, SitesQueryQueryVariables>;
export const SiteQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiteQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_start_weekday"}}]}}]}}]} as unknown as DocumentNode<SiteQueryQuery, SiteQueryQueryVariables>;
export const UpdateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"sites_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"production_hours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"day_id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const InsertSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"sites_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_sites_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<InsertSiteMutation, InsertSiteMutationVariables>;
export const UnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UnitQuery, UnitQueryVariables>;
export const UsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"picture_url"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQueryQuery, UsersQueryQueryVariables>;